import * as React from 'react';
import React__default, { useState as useState$a, useCallback as useCallback$1, forwardRef, useEffect as useEffect$b, useRef } from 'react';
import styled from '@emotion/styled';
import { keyframes, css, Global } from '@emotion/react';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

var zIndexes = {
  opaqueLayer: 10,
  snackbar: 12,
  navbar: 9,
  calendarDot: 10,
  calendarToday: 10,
  tooltip: 9
};

var _templateObject$14, _templateObject2$Q, _templateObject3$D, _templateObject4$t, _templateObject5$n, _templateObject6$i, _templateObject7$b, _templateObject8$7, _templateObject9$6, _templateObject10$5, _templateObject11$5, _templateObject12$4;
var fadeIn = keyframes(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var fadeOut = keyframes(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0;\n  }\n"])));
var popInFromBottomSnackbar = keyframes(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(-50%);\n  };\n"])));
var popOutToBottomSnackbar = keyframes(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-50%);\n  }\n  100% {\n    transform: translateY(100%);\n  };\n"])));
var popInFromBottom = keyframes(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteral(["\n  0% {\n    opacity: 0;\n    transform: translateY(400px) scale(0.75);\n  }\n  75% {\n    opacity: 1;\n    transform: translateY(-16px) scale(1.0);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0px);\n  }"])));
var popOutToBottom = keyframes(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n    transform: translateY(0px) scale(1.0);\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(400px) scale(0.75);\n  }"])));
var slideUp = keyframes(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(100%);\n  }\n  100% {\n    transform: translateY(0%);\n  };\n"])));
var slideDown = keyframes(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(0%);\n  }\n  100% {\n    transform: translateY(100%);\n  };\n"])));
var foldIn = keyframes(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-100%);\n  }\n  100% {\n    transform: translateY(0%);\n  };\n"])));
var foldOut = keyframes(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(0%);\n  }\n  100% {\n    transform: translateY(-100%);\n  };\n"])));
var shining = keyframes(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteral(["\n   0% {\n    opacity: 0.3;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.5;\n  }\n"])));
var rotation = keyframes(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"])));
var transitions = {
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  popInFromBottom: popInFromBottom,
  popOutToBottom: popOutToBottom,
  slideUp: slideUp,
  slideDown: slideDown,
  foldIn: foldIn,
  foldOut: foldOut,
  popInFromBottomSnackbar: popInFromBottomSnackbar,
  popOutToBottomSnackbar: popOutToBottomSnackbar,
  shining: shining,
  rotation: rotation
};

var _templateObject$13, _templateObject2$P, _templateObject3$C;

function OpaqueLayer(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      onOpaqueLayerClick = _ref.onOpaqueLayerClick;
  return /*#__PURE__*/React.createElement(Block$A, {
    visible: visible,
    onClick: onOpaqueLayerClick
  }, children);
}

var Block$A = styled.div(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteral(["\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    z-index: ", ";\n    background: rgba(0, 0, 0, 0.3);\n    ", ";\n"])), zIndexes.opaqueLayer, function (props) {
  return props.visible ? css(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards;\n              "])), transitions.fadeIn) : css(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards;\n              "])), transitions.fadeOut);
});

var mediaQuery = function mediaQuery(minWidth) {
  return "\n  @media(min-width: ".concat(minWidth, "px)\n");
};
var media = {
  xsmall: mediaQuery(0),
  small: mediaQuery(375),
  medium: mediaQuery(430)
};

var _templateObject$12;
var useState$9 = React.useState,
    useEffect$a = React.useEffect;

function BottomSheetBase(_ref) {
  var visible = _ref.visible,
      children = _ref.children;

  var _useState = useState$9(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  useEffect$a(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 250);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(OpaqueLayer, {
    visible: visible
  }, /*#__PURE__*/React.createElement(Block$z, null, children));
}

var Block$z = styled.div(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    height: 100vh;\n    ", " {\n        width: 415px;\n    }\n    border: none;\n    background: rgba(0, 0, 0, 0.3);\n"])), media.medium);

var BrandColor = {
  BU: "#00BED6",
  LBU: "#E9F7F8",
  DimBu: "#9DABAC",
  DeepBU: "#227886",
  DarkBU: "#42484C",
  RED: "#FF5151"
};
var SupportColor = {
  C01: "#2ED1BD",
  C02: "#0CC8E3",
  C03: "#4897DA",
  C04: "#B568DE",
  Warm01: "#F07272",
  Warm02: "#F46FB7",
  Warm03: "#B568DE",
  LY: "#FEFBE5",
  GreenGr: "#5B6E70"
};
var TextColor = {
  B85: "#262626",
  B60: "#666666",
  B40: "#999999",
  B30: "#B2B2B2",
  B20: "#CCCCCC",
  B10: "#E5E5E5",
  B06: "#F0F0F0"
};
var BackGroundColor = {
  B06: "#262626",
  B05: "#F2F2F2",
  B04: "#F5F5F5",
  B03: "#F7F7F7",
  W100: "#FFFFFF",
  Blank: "#FFFFFF"
};
var palette = {
  /* gray */
  gray0: '#F8F9FA',
  gray1: '#F1F3F5',
  gray2: '#E9ECEF',
  gray3: '#DEE2E6',
  gray4: '#CED4DA',
  gray5: '#ADB5BD',
  gray6: '#868E96',
  gray7: '#495057',
  gray8: '#343A40',
  gray9: '#212529',

  /* red */
  red0: '#fff5f5',
  red1: '#ffe3e3',
  red2: '#ffc9c9',
  red3: '#ffa8a8',
  red4: '#ff8787',
  red5: '#ff6b6b',
  red6: '#fa5252',
  red7: '#f03e3e',
  red8: '#e03131'
};
var ChatColor = {
  Manager100: '#004B82',
  Manager006: 'rgba(0, 75, 130, 0.06)'
};

var _templateObject$11, _templateObject2$O, _templateObject3$B, _templateObject4$s, _templateObject5$m, _templateObject6$h, _templateObject7$a, _templateObject8$6, _templateObject9$5, _templateObject10$4, _templateObject11$4, _templateObject12$3, _templateObject13$2, _templateObject14$2, _templateObject15$2, _templateObject16$2;
// @ts-ignore:next-line
var isAndroid$2 = typeof window !== 'undefined' && !!/Android/g.exec(window.navigator.userAgent);
var fontWeight$2 = {
  regular: '400',
  'semi-bold': isAndroid$2 ? '500' : '600',
  bold: '700'
};
var TypeRule = function TypeRule(_ref) {
  var variant = _ref.variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? TextColor['B85'] : _ref$color,
      children = _ref.children,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? '1.4' : _ref$lineHeight;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Global, {
    styles: reset
  }), {
    h1: /*#__PURE__*/React.createElement(H1$2, {
      color: color,
      lineHeight: lineHeight
    }, ' ', children, ' '),
    h2: /*#__PURE__*/React.createElement(H2$2, {
      color: color,
      lineHeight: lineHeight
    }, ' ', children, ' '),
    h3: /*#__PURE__*/React.createElement(H3$2, {
      color: color,
      lineHeight: lineHeight
    }, ' ', children, ' '),
    h4: /*#__PURE__*/React.createElement(H4$2, {
      color: color,
      lineHeight: lineHeight
    }, ' ', children, ' '),
    h5: /*#__PURE__*/React.createElement(H5$2, {
      color: color,
      lineHeight: lineHeight
    }, ' ', children, ' '),
    h5_b: /*#__PURE__*/React.createElement(H5$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    b1_r: /*#__PURE__*/React.createElement(B1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    b1_sb: /*#__PURE__*/React.createElement(B1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    b1_b: /*#__PURE__*/React.createElement(B1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    b2_r: /*#__PURE__*/React.createElement(B2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    b2_sb: /*#__PURE__*/React.createElement(B2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    b2_b: /*#__PURE__*/React.createElement(B2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    b3_r: /*#__PURE__*/React.createElement(B3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    b3_sb: /*#__PURE__*/React.createElement(B3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    b3_b: /*#__PURE__*/React.createElement(B3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    b4_r: /*#__PURE__*/React.createElement(B4$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    b4_sb: /*#__PURE__*/React.createElement(B4$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    b4_b: /*#__PURE__*/React.createElement(B4$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    t1_r: /*#__PURE__*/React.createElement(T1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    t1_sb: /*#__PURE__*/React.createElement(T1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    t1_b: /*#__PURE__*/React.createElement(T1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    t2_r: /*#__PURE__*/React.createElement(T2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    t2_sb: /*#__PURE__*/React.createElement(T2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    t2_b: /*#__PURE__*/React.createElement(T2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    t3_r: /*#__PURE__*/React.createElement(T3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    t3_sb: /*#__PURE__*/React.createElement(T3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    t3_b: /*#__PURE__*/React.createElement(T3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.bold
    }, children),
    btn1_r: /*#__PURE__*/React.createElement(BTN1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    btn1_sb: /*#__PURE__*/React.createElement(BTN1$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    btn2_r: /*#__PURE__*/React.createElement(BTN2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    btn2_sb: /*#__PURE__*/React.createElement(BTN2$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children),
    btn3_r: /*#__PURE__*/React.createElement(BTN3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2.regular
    }, children),
    btn3_sb: /*#__PURE__*/React.createElement(BTN3$2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$2['semi-bold']
    }, children)
  }[variant]);
};
var H1$2 = styled.h1(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 33px;\n    font-weight: 700;\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
});
var H2$2 = styled.h2(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 30px;\n    font-weight: 700;\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
});
var H3$2 = styled.h3(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 27px;\n    font-weight: 700;\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
});
var H4$2 = styled.h4(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 25px;\n    font-weight: 700;\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
});
var H5$2 = styled.h5(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 23px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight ? props.fontWeight : 600;
});
var T1$2 = styled.h1(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 21px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var T2$2 = styled.h2(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 19px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var T3$2 = styled.h3(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var B1$2 = styled.section(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var B2$2 = styled.section(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 16px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var B3$2 = styled.section(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 15px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var B4$2 = styled.section(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 14px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var BTN1$2 = styled.section(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var BTN2$2 = styled.section(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 16px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var BTN3$2 = styled.section(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 15px;\n    font-weight: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
});
var reset = css(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteral(["\n    html,\n    body,\n    div,\n    span,\n    object,\n    iframe,\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6,\n    p,\n    pre,\n    a,\n    small,\n    strike,\n    strong,\n    b,\n    u,\n    i,\n    center,\n    dl,\n    dt,\n    dd,\n    ol,\n    ul,\n    li,\n    fieldset,\n    form,\n    label,\n    legend,\n    table,\n    caption,\n    tbody,\n    tfoot,\n    thead,\n    tr,\n    th,\n    td,\n    article,\n    aside,\n    canvas,\n    details,\n    embed,\n    footer,\n    header,\n    nav,\n    section,\n    summary,\n    time,\n    mark,\n    audio {\n        margin: 0;\n        padding: 0;\n        border: 0;\n        font-size: 100%;\n        font: inherit;\n        vertical-align: baseline;\n        font-family: ", ";\n    }\n"])), isAndroid$2 ? 'Noto Sans KR' : 'system-ui');

var _templateObject$10, _templateObject2$N, _templateObject3$A, _templateObject4$r, _templateObject5$l, _templateObject6$g;

function BottomSheet(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      title = _ref.title,
      message = _ref.message;
  return /*#__PURE__*/React.createElement(BottomSheetBase, {
    visible: visible
  }, /*#__PURE__*/React.createElement(Block$y, {
    visible: visible
  }, /*#__PURE__*/React.createElement(Header$1, null, /*#__PURE__*/React.createElement(HeaderContent, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "b3_r",
    color: TextColor.B40
  }, title))), /*#__PURE__*/React.createElement(Message$4, null, message), children));
}

var Block$y = styled.div(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteral(["\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    max-height: 100%;\n    ", " {\n        width: 415px;\n    }\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    background: ", ";\n    border-top-left-radius: 13.2px;\n    border-top-right-radius: 13.2px;\n    ", "\n"])), media.medium, BackGroundColor.W100, function (props) {
  return props.visible ? css(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.slideUp) : css(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.slideDown);
});
var Header$1 = styled.div(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteral(["\n    display: flex;\n    height: 56px;\n    background-color: ", ";\n    border-top-left-radius: 0.825rem;\n    border-top-right-radius: 0.825rem;\n"])), BackGroundColor.W100);
var HeaderContent = styled.div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteral(["\n    flex: 1;\n    display: flex;\n    justify-content: flex-start;\n    padding: 28px 24px 8px 24px;\n"])));
var Message$4 = styled.div(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 40px;\n"])));
var BottomSheet$1 = /*#__PURE__*/React.memo(BottomSheet);

var _templateObject$$, _templateObject2$M, _templateObject3$z, _templateObject4$q, _templateObject5$k;

function BottomSheetCustom(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      height = _ref.height;
  return /*#__PURE__*/React.createElement(BottomSheetBase, {
    visible: visible
  }, /*#__PURE__*/React.createElement(Block$x, {
    visible: visible,
    height: height
  }, /*#__PURE__*/React.createElement(Header, null), children));
}

var Block$x = styled.div(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteral(["\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    max-height: 100%;\n    ", " {\n        width: 415px;\n    }\n    display: flex;\n    flex-direction: column;\n    background: ", ";\n    border-top-left-radius: 13.2px;\n    border-top-right-radius: 13.2px;\n    ", "\n    ", "\n"])), media.medium, BackGroundColor.W100, function (props) {
  if (props.height) return css(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteral(["\n                height: ", ";\n            "])), props.height);
}, function (props) {
  return props.visible ? css(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.slideUp) : css(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.slideDown);
});
var Header = styled.div(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteral(["\n    height: 22px;\n    background-color: ", ";\n    border-top-left-radius: 0.825rem;\n    border-top-right-radius: 0.825rem;\n"])), BackGroundColor.W100);
var BottomSheetCustom$1 = /*#__PURE__*/React.memo(BottomSheetCustom);

var _templateObject$_, _templateObject2$L;
var WordWrapper = function WordWrapper(_ref) {
  var text = _ref.text,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 44 : _ref$maxLength,
      _ref$wrapWord = _ref.wrapWord,
      wrapWord = _ref$wrapWord === void 0 ? '수정' : _ref$wrapWord,
      onClick = _ref.onClick,
      _ref$wordWrapperPaddi = _ref.wordWrapperPadding,
      wordWrapperPadding = _ref$wordWrapperPaddi === void 0 ? "0" : _ref$wordWrapperPaddi;

  var _useState = useState$a(text.length > maxLength),
      _useState2 = _slicedToArray(_useState, 2),
      wrapped = _useState2[0],
      setWrapped = _useState2[1];

  useCallback$1(function (_) {
    setWrapped(false);
  }, []);
  return /*#__PURE__*/React.createElement(WordWrapperStyle, null, wrapped ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B60']
  }, text.substring(0, maxLength), " ..."), /*#__PURE__*/React.createElement(Block$w, {
    onClick: onClick,
    wordWrapperPadding: wordWrapperPadding
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B40']
  }, wrapWord))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B60']
  }, text), /*#__PURE__*/React.createElement(Block$w, {
    onClick: onClick,
    wordWrapperPadding: wordWrapperPadding
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B40']
  }, wrapWord))));
};
var WordWrapperStyle = styled.div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteral(["\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-wrap;\n"])));
var Block$w = styled.div(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    text-decoration: underline;\n    text-underline-offset: 3px;\n    color: ", ";\n    padding: ", ";\n"])), TextColor.B40, function (props) {
  return props.wordWrapperPadding;
});

function SvgCycleDisabledSelectedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-4.952-2.488a.75.75 0 10-1.096-1.024l-5.087 5.45-1.852-1.735a.75.75 0 00-1.026 1.094l2.4 2.25a.75.75 0 001.061-.035l5.6-6z",
    fill: "#9DABAC"
  }));
}

function SvgCycleDisabledSelectedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#9DABAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15l4 4 8-9",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgCycleDisabledUnselectedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10a9.25 9.25 0 11-18.5 0 9.25 9.25 0 0118.5 0z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }));
}

function SvgCycleDisabledUnselectedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14c0 7.318-5.932 13.25-13.25 13.25S.75 21.318.75 14 6.682.75 14 .75 27.25 6.682 27.25 14z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }));
}

function SvgCycleEnabledCheckedCircleS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14zm-14 6a6 6 0 100-12 6 6 0 000 12z",
    fill: "#00BED6"
  }));
}

function SvgCycleEnabledCheckedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-4.952-2.488a.75.75 0 10-1.096-1.024l-5.087 5.45-1.852-1.735a.75.75 0 00-1.026 1.094l2.4 2.25a.75.75 0 001.061-.035l5.6-6z",
    fill: "#00BED6"
  }));
}

function SvgCycleEnabledCheckedS28(props) {
  var _props$fill;

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14zm-7.253-3.336a1 1 0 00-1.494-1.328l-7.296 8.207-3.25-3.25a1 1 0 00-1.414 1.414l4 4a1 1 0 001.454-.043l8-9z",
    fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : "#00BED6"
  }));
}

function SvgCycleEnabledErrorS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10a9.25 9.25 0 11-18.5 0 9.25 9.25 0 0118.5 0z",
    stroke: "#FF5151",
    strokeWidth: 1.5
  }));
}

function SvgCycleEnabledErrorS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14c0 7.318-5.932 13.25-13.25 13.25S.75 21.318.75 14 6.682.75 14 .75 27.25 6.682 27.25 14z",
    stroke: "#FF5151",
    strokeWidth: 1.5
  }));
}

function SvgCycleEnabledErrorSelectedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#FF5151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15l4 4 8-9",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgCycleEnabledUnselectedFilledS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#000",
    fillOpacity: 0.06
  }));
}

function SvgCycleEnabledUnselectedFilledS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#000",
    fillOpacity: 0.06
  }));
}

function SvgCycleEnabledUnselectedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10a9.25 9.25 0 11-18.5 0 9.25 9.25 0 0118.5 0z",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }));
}

function SvgCycleEnabledUnselectedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14c0 7.318-5.932 13.25-13.25 13.25S.75 21.318.75 14 6.682.75 14 .75 27.25 6.682 27.25 14z",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }));
}

function SvgPlusInCircleS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14zm0-8a1 1 0 001-1v-4h4a1 1 0 100-2h-4V9a1 1 0 10-2 0v4H9a1 1 0 100 2h4v4a1 1 0 001 1z",
    fill: "#42484C"
  }));
}

var _templateObject$Z, _templateObject2$K, _templateObject3$y, _templateObject4$p, _templateObject5$j, _templateObject6$f, _templateObject7$9, _templateObject8$5, _templateObject9$4, _templateObject10$3, _templateObject11$3;
var BoxSingleView = function BoxSingleView(_ref) {
  var leadingIcon = _ref.leadingIcon,
      guide = _ref.guide,
      title = _ref.title,
      description = _ref.description,
      type = _ref.type,
      value = _ref.value,
      name = _ref.name,
      checked = _ref.checked,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      _ref$noBorder = _ref.noBorder,
      noBorder = _ref$noBorder === void 0 ? false : _ref$noBorder,
      _ref$plusWhenUnchecke = _ref.plusWhenUnchecked,
      plusWhenUnchecked = _ref$plusWhenUnchecke === void 0 ? false : _ref$plusWhenUnchecke,
      _ref$onWrapWordClick = _ref.onWrapWordClick,
      onWrapWordClick = _ref$onWrapWordClick === void 0 ? function () {} : _ref$onWrapWordClick,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? '12px' : _ref$padding,
      _ref$wordWrapperPaddi = _ref.wordWrapperPadding,
      wordWrapperPadding = _ref$wordWrapperPaddi === void 0 ? '0' : _ref$wordWrapperPaddi;
  return /*#__PURE__*/React.createElement(BoxSingleViewStyle, {
    noBorder: noBorder,
    padding: padding
  }, !disabled ? /*#__PURE__*/React.createElement(Enabled$1, null, /*#__PURE__*/React.createElement(SingleView, null, leadingIcon, /*#__PURE__*/React.createElement(ColumnView, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b1_r'
  }, title), description && /*#__PURE__*/React.createElement(DescStyle, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B40']
  }, description))), /*#__PURE__*/React.createElement(AlignRight$1, null, {
    radio: /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(HiddenCheckBox$3, {
      type: "radio",
      name: name,
      value: value,
      checked: checked,
      onChange: onChange,
      onClick: onClick
    }), checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledCheckedCircleS28, null) : /*#__PURE__*/React.createElement(SvgCycleEnabledUnselectedFilledS28, null)),
    checkbox: /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(HiddenCheckBox$3, {
      type: "checkbox",
      name: name,
      value: value,
      checked: checked,
      onChange: onChange,
      onClick: onClick
    }), checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledCheckedS28, null) : /*#__PURE__*/React.createElement(UncheckedIcon, {
      disabled: disabled,
      plusWhenUnchecked: plusWhenUnchecked
    })),
    text: /*#__PURE__*/React.createElement(React.Fragment, null)
  }[type])), guide && /*#__PURE__*/React.createElement(Guide$1, null, /*#__PURE__*/React.createElement(WordWrapper, {
    text: guide,
    onClick: onWrapWordClick,
    wordWrapperPadding: wordWrapperPadding
  }))) : /*#__PURE__*/React.createElement(Disabled$1, null, /*#__PURE__*/React.createElement(SingleView, null, leadingIcon, /*#__PURE__*/React.createElement(ColumnView, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b1_r'
  }, title), description && /*#__PURE__*/React.createElement(DescStyle, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B40']
  }, description))), /*#__PURE__*/React.createElement(AlignRight$1, null, {
    radio: /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(HiddenCheckBox$3, {
      type: "radio",
      name: name,
      value: value,
      checked: checked,
      readOnly: true
    }), checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledCheckedCircleS28, null) : /*#__PURE__*/React.createElement(CycleDisabledUnselected, null)),
    checkbox: /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(HiddenCheckBox$3, {
      type: "checkbox",
      name: name,
      value: value,
      checked: checked,
      readOnly: true
    }), checked ? /*#__PURE__*/React.createElement(SvgCycleDisabledSelectedS28, null) : /*#__PURE__*/React.createElement(UncheckedIcon, {
      disabled: disabled,
      plusWhenUnchecked: plusWhenUnchecked
    })),
    text: /*#__PURE__*/React.createElement(React.Fragment, null)
  }[type]))));
};

var UncheckedIcon = function UncheckedIcon(_ref2) {
  var plusWhenUnchecked = _ref2.plusWhenUnchecked,
      disabled = _ref2.disabled;

  if (disabled) {
    return /*#__PURE__*/React.createElement(CycleDisabledUnselected, null);
  }

  return plusWhenUnchecked ? /*#__PURE__*/React.createElement(SvgPlusInCircleS28, null) : /*#__PURE__*/React.createElement(SvgCycleEnabledUnselectedFilledS28, null);
};

var BoxSingleViewStyle = styled.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteral(["\n    padding: ", ";\n    border: ", ";\n    border-radius: 10px;\n    background-color: ", ";\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])), function (props) {
  return props.padding;
}, function (props) {
  return props.noBorder === true ? 'none' : "".concat(BackGroundColor['B04'], " 1px solid");
}, BackGroundColor['W100']);
var Guide$1 = styled.div(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteral(["\n    margin-top: 18px;\n    margin-left: 12px;\n    margin-bottom: 4px;\n"])));
var AlignRight$1 = styled.div(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteral(["\n    margin: auto 0 auto auto;\n"])));
var ColumnView = styled.div(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    align-items: baseline;\n    line-height: 1.5;\n    margin-left: 8px;\n"])));
var SingleView = styled.div(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));
var HiddenCheckBox$3 = styled.input(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteral(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"])));
var Enabled$1 = styled.div(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteral([""])));
var Disabled$1 = styled.div(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral(["\n    opacity: 0.4;\n    filter: grayscale(1);\n"])));
var CycleDisabledUnselected = styled.div(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral(["\n    width: 28px;\n    height: 28px;\n    background: ", ";\n    border-radius: 50%;\n"])), TextColor['B10']);
var Label = styled.label(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral(["\n    display: flex;\n"])));
var DescStyle = styled.div(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral(["\n    margin: 5px 0 0 0;\n"])));

var _templateObject$Y, _templateObject2$J, _templateObject3$x, _templateObject4$o, _templateObject5$i, _templateObject6$e, _templateObject7$8, _templateObject8$4, _templateObject9$3, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$1, _templateObject14$1, _templateObject15$1, _templateObject16$1;
// @ts-ignore:next-line
var isAndroid$1 = typeof window !== 'undefined' && !!/Android/g.exec(window.navigator.userAgent);
var fontWeight$1 = {
  regular: '400',
  'semi-bold': isAndroid$1 ? '500' : '600',
  bold: '700'
};
var LINE_HEIGHT = {
  "default": '1.4',
  m: '24px'
};
var Pretendard = function Pretendard(_ref) {
  var variant = _ref.variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? TextColor['B85'] : _ref$color,
      children = _ref.children,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? LINE_HEIGHT["default"] : _ref$lineHeight,
      opacity = _ref.opacity;
  return /*#__PURE__*/React.createElement(React.Fragment, null, {
    h1: /*#__PURE__*/React.createElement(H1$1, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h2: /*#__PURE__*/React.createElement(H2$1, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h3: /*#__PURE__*/React.createElement(H3$1, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h4: /*#__PURE__*/React.createElement(H4$1, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h5: /*#__PURE__*/React.createElement(H5$1, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h5_b: /*#__PURE__*/React.createElement(H5$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    b1_r: /*#__PURE__*/React.createElement(B1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    b1_sb: /*#__PURE__*/React.createElement(B1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    b1_b: /*#__PURE__*/React.createElement(B1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    b2_r: /*#__PURE__*/React.createElement(B2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    b2_sb: /*#__PURE__*/React.createElement(B2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    b2_b: /*#__PURE__*/React.createElement(B2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    b3_r: /*#__PURE__*/React.createElement(B3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    b3_sb: /*#__PURE__*/React.createElement(B3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    b3_b: /*#__PURE__*/React.createElement(B3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    b4_r: /*#__PURE__*/React.createElement(B4$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    b4_sb: /*#__PURE__*/React.createElement(B4$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    b4_b: /*#__PURE__*/React.createElement(B4$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    t1_r: /*#__PURE__*/React.createElement(T1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    t1_sb: /*#__PURE__*/React.createElement(T1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    t1_b: /*#__PURE__*/React.createElement(T1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    t2_r: /*#__PURE__*/React.createElement(T2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    t2_sb: /*#__PURE__*/React.createElement(T2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    t2_b: /*#__PURE__*/React.createElement(T2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    t3_r: /*#__PURE__*/React.createElement(T3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    t3_sb: /*#__PURE__*/React.createElement(T3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    t3_b: /*#__PURE__*/React.createElement(T3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.bold,
      opacity: opacity
    }, children),
    btn1_r: /*#__PURE__*/React.createElement(BTN1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    btn1_sb: /*#__PURE__*/React.createElement(BTN1$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    btn2_r: /*#__PURE__*/React.createElement(BTN2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    btn2_sb: /*#__PURE__*/React.createElement(BTN2$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children),
    btn3_r: /*#__PURE__*/React.createElement(BTN3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1.regular,
      opacity: opacity
    }, children),
    btn3_sb: /*#__PURE__*/React.createElement(BTN3$1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight$1['semi-bold'],
      opacity: opacity
    }, children)
  }[variant]);
};
var H1$1 = styled.h1(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 33px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H2$1 = styled.h2(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 30px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H3$1 = styled.h3(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 27px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H4$1 = styled.h4(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 25px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H5$1 = styled.h5(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 23px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight ? props.fontWeight : 600;
}, function (props) {
  return props.opacity;
});
var T1$1 = styled.h1(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 21px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var T2$1 = styled.h2(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 19px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var T3$1 = styled.h3(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B1$1 = styled.section(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B2$1 = styled.section(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 16px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B3$1 = styled.section(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 15px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B4$1 = styled.section(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 14px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var BTN1$1 = styled.section(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var BTN2$1 = styled.section(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 16px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var BTN3$1 = styled.section(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 15px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
css(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral([""])));

var _templateObject$X, _templateObject2$I, _templateObject3$w, _templateObject4$n;
var s14RoundPadding$1 = '11px 18px'; //(위아래, 좌우)

var s14RectPadding$1 = '14px 24px'; // const s15RoundPadding = '14px 21px';

var s15RoundPadding$1 = '13px 21px';
var s15RectPadding$1 = '10px 17px';
var s16RoundWithPadding = '14px 20px';
var s16RectWithPadding = '14px 26px';
var s16HsRoundPadding = '14px 20px';
var s16HsRectPadding = '14px 26px';
var s17RoundPadding$1 = '16px 0';
var s17RectPadding$1 = '16px 0';
var s17RoundWidth = '100px';
var s17RectWidth = '110px';
var s17RectPaddingWithSpace$1 = '17px 0';
var s17RoundPaddingWithSpace$1 = '17px 0';
var rectRadios$1 = '8px';
var roundRadios$1 = '100px';
var wholeRoundRadios$1 = '100px';

function Button$3(_ref) {
  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'bu' : _ref$color,
      type = _ref.type,
      size = _ref.size,
      children = _ref.children,
      leadingIcon = _ref.leadingIcon,
      tailingIcon = _ref.tailingIcon,
      onClick = _ref.onClick,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? '20211217' : _ref$version,
      height = _ref.height;
  return /*#__PURE__*/React.createElement(React.Fragment, null, disabled ? /*#__PURE__*/React.createElement(React.Fragment, null, color === 'ghost' ? {
    S_14: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s14RoundPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s14RectPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_15: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s15RoundPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s15RectPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_16: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s16RoundWithPadding,
        height: height,
        disabled: true,
        version: version
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s16RectWithPadding,
        height: height,
        disabled: true,
        version: version
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_16_HS: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s16HsRoundPadding,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s16HsRectPadding,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_17: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s17RoundPadding$1,
        width: s17RoundWidth,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s17RectPadding$1,
        width: s17RectWidth,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_17_WS: {
      round: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
        radius: wholeRoundRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s17RoundPaddingWithSpace$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
        radius: rectRadios$1,
        background: BackGroundColor['W100'],
        border: "1px ".concat(TextColor['B10'], " solid"),
        padding: s17RectPaddingWithSpace$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type]
  }[size] : {
    S_14: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s14RoundPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s14RectPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_15: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s15RoundPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s15RectPadding$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn3_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_16: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s16RoundWithPadding,
        height: height,
        disabled: true,
        version: version
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s16RectWithPadding,
        height: height,
        disabled: true,
        version: version
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_16_HS: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s16HsRoundPadding,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s16HsRectPadding,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn2_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_17: {
      round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: roundRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s17RoundPadding$1,
        width: s17RoundWidth,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
        radius: rectRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s17RectPadding$1,
        width: s17RectWidth,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type],
    S_17_WS: {
      round: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
        radius: wholeRoundRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s17RoundPaddingWithSpace$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
        radius: rectRadios$1,
        background: BackGroundColor['B05'],
        border: "1px ".concat(BackGroundColor['B05'], " solid"),
        padding: s17RectPaddingWithSpace$1,
        height: height,
        disabled: true
      }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
        variant: 'btn1_sb',
        color: TextColor['B20']
      }, children), tailingIcon)
    }[type]
  }[size]) : /*#__PURE__*/React.createElement(React.Fragment, null, {
    bu: {
      S_14: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s14RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s14RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_15: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s15RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s15RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_16: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s16RoundWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s16RectWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_16_HS: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s16HsRoundPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s16HsRectPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_17: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          width: s17RoundWidth,
          padding: s17RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          width: s17RectWidth,
          padding: s17RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_17_WS: {
        round: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: wholeRoundRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s17RoundPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['BU'],
          border: "1px ".concat(BrandColor['BU'], " solid"),
          padding: s17RectPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type]
    }[size],
    dim_bu: {
      S_14: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s14RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s14RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_15: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s15RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s15RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_16: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s16RoundWithPadding,
          version: version,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s16RectWithPadding,
          version: version,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_16_HS: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s16HsRoundPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s16HsRectPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_17: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          width: s17RoundWidth,
          padding: s17RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          width: s17RectWidth,
          padding: s17RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_17_WS: {
        round: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: wholeRoundRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s17RoundPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['B05'],
          border: "1px ".concat(BackGroundColor['B05'], " solid"),
          padding: s17RectPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type]
    }[size],
    dark_bu: {
      S_14: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s14RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s14RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_15: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s15RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s15RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_16: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s16RoundWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s16RectWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_16_HS: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s16HsRoundPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s16HsRectPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_17: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          width: s17RoundWidth,
          padding: s17RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          width: s17RectWidth,
          padding: s17RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_17_WS: {
        round: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: wholeRoundRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s17RoundPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BrandColor['DarkBU'],
          border: "1px ".concat(BrandColor['DarkBU'], " solid"),
          padding: s17RectPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type]
    }[size],
    ghost: {
      S_14: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s14RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s14RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_15: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s15RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s15RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_16: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s16RoundWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s16RectWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_16_HS: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s16HsRoundPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s16HsRectPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_17: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          width: s17RoundWidth,
          padding: s17RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          width: s17RectWidth,
          padding: s17RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type],
      S_17_WS: {
        round: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: wholeRoundRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s17RoundPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: BackGroundColor['W100'],
          border: "1px ".concat(TextColor['B10'], " solid"),
          padding: s17RectPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: TextColor['B85']
        }, children), tailingIcon)
      }[type]
    }[size],
    manager_100: {
      S_14: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s14RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s14RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_15: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s15RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s15RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn3_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_16: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s16RoundWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s16RectWithPadding,
          height: height,
          version: version
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_16_HS: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s16HsRoundPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s16HsRectPadding,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn2_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_17: {
        round: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: roundRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          width: s17RoundWidth,
          padding: s17RoundPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyle$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          width: s17RectWidth,
          padding: s17RectPadding$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type],
      S_17_WS: {
        round: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: wholeRoundRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s17RoundPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon),
        rect: /*#__PURE__*/React.createElement(ButtonStyleWS$1, {
          onClick: onClick,
          radius: rectRadios$1,
          background: ChatColor['Manager100'],
          border: "1px ".concat(ChatColor['Manager100'], " solid"),
          padding: s17RectPaddingWithSpace$1,
          height: height
        }, leadingIcon, /*#__PURE__*/React.createElement(Pretendard, {
          variant: 'btn1_sb',
          color: BackGroundColor['W100']
        }, children), tailingIcon)
      }[type]
    }[size]
  }[color]));
}

styled.button(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral(["\n    background: white;\n    color: ", ";\n"])), function (props) {
  return props.color;
});
var ButtonStyle$1 = styled.button(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteral(["\n    background: ", ";\n    border-radius: ", ";\n    border: ", ";\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n    height: ", ";\n    &:hover {\n        cursor: pointer;\n    }\n    z-index: inherit;\n"])), function (props) {
  return props.background;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.border;
}, function (props) {
  return props.padding;
}, function (props) {
  return props.width ? css(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteral(["\n                  width: ", ";\n              "])), props.width) : null;
}, function (props) {
  return props.height;
});
var ButtonStyleWS$1 = styled.button(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteral(["\n    background: ", ";\n    border-radius: ", ";\n    border: ", ";\n    width: 100%;\n    height: ", ";\n    justify-content: center;\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    &:hover {\n        cursor: pointer;\n    }\n"])), function (props) {
  return props.background;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.border;
}, function (props) {
  return props.height;
}, function (props) {
  return props.padding;
});

var _templateObject$W, _templateObject2$H;
var s14RoundPadding = '11px 18px';
var s14RectPadding = '11px 18px';
var s15RoundPadding = '11px 18px';
var s15RectPadding = '14px 24px';
var s16RoundPadding = '18px 26px';
var s16RectPadding = '18px 26px';
var s17RoundPadding = '19px 35px';
var s17RectPadding = '19px 56px';
var s17RectPaddingWithSpace = '17px 0';
var s17RoundPaddingWithSpace = '17px 0';
var rectRadios = '8px';
var roundRadios = '55px';
var wholeRoundRadios = '72px';

function CustomButton(_ref) {
  var backgroundColor = _ref.backgroundColor,
      fontColor = _ref.fontColor,
      borderColor = _ref.borderColor,
      type = _ref.type,
      size = _ref.size,
      children = _ref.children,
      leadingIcon = _ref.leadingIcon,
      tailingIcon = _ref.tailingIcon,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      align = _ref.align;
  return /*#__PURE__*/React.createElement(React.Fragment, null, {
    S_14: {
      round: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: roundRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s14RoundPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn3_sb',
        color: fontColor
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: rectRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s14RectPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn3_sb',
        color: fontColor
      }, children), tailingIcon)
    }[type],
    S_15: {
      round: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: roundRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s15RoundPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn3_sb',
        color: fontColor
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: rectRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s15RectPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn3_sb',
        color: fontColor
      }, children), tailingIcon)
    }[type],
    S_16: {
      round: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: roundRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s16RoundPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn2_sb',
        color: fontColor
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: rectRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s16RectPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn2_sb',
        color: fontColor
      }, children), tailingIcon)
    }[type],
    S_17: {
      round: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: roundRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s17RoundPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn1_sb',
        color: fontColor
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyle, {
        onClick: onClick,
        radius: rectRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s17RectPadding,
        disabled: disabled
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn1_sb',
        color: fontColor
      }, children), tailingIcon)
    }[type],
    S_17_WS: {
      round: /*#__PURE__*/React.createElement(ButtonStyleWS, {
        onClick: onClick,
        radius: wholeRoundRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s17RoundPaddingWithSpace,
        disabled: disabled,
        align: align
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn1_sb',
        color: fontColor
      }, children), tailingIcon),
      rect: /*#__PURE__*/React.createElement(ButtonStyleWS, {
        onClick: onClick,
        radius: rectRadios,
        background: backgroundColor,
        border: "1px ".concat(borderColor, " solid"),
        padding: s17RectPaddingWithSpace,
        disabled: disabled,
        align: align
      }, leadingIcon, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 'btn1_sb',
        color: fontColor
      }, children), tailingIcon)
    }[type]
  }[size]);
}

var ButtonStyle = styled.button(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral(["\n    background: ", ";\n    border-radius: ", ";\n    border: ", ";\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    &:hover {\n        cursor: pointer;\n    }\n"])), function (props) {
  return props.background;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.border;
}, function (props) {
  return props.padding;
});
var ButtonStyleWS = styled.button(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteral(["\n    background: ", ";\n    border-radius: ", ";\n    border: ", ";\n    width: 100%;\n    justify-content: ", ";\n    padding: ", ";\n    display: flex;\n    align-items: center;\n    &:hover {\n        cursor: pointer;\n    }\n"])), function (props) {
  return props.background;
}, function (props) {
  return props.radius;
}, function (props) {
  return props.border;
}, function (props) {
  return props.align || 'center';
}, function (props) {
  return props.padding;
});

var _templateObject$V, _templateObject2$G, _templateObject3$v;
var CheckBoxWithImg = function CheckBoxWithImg(_ref) {
  var value = _ref.value,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      label = _ref.label,
      img = _ref.img,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !disabled ? /*#__PURE__*/React.createElement(CheckBoxWithImgStyle, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox$2, {
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: onChange,
    onClick: onClick
  }), checked ? /*#__PURE__*/React.createElement(CheckBoxStyle, {
    color: BrandColor['BU']
  }, img) : /*#__PURE__*/React.createElement(CheckBoxStyle, {
    color: BackGroundColor['B05']
  }, img)), label && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '9px'
    }
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b2_r',
    color: TextColor['B85']
  }, label))) : /*#__PURE__*/React.createElement(CheckBoxWithImgStyle, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox$2, {
    type: "checkbox",
    value: value,
    checked: checked,
    readOnly: true
  }), checked ? /*#__PURE__*/React.createElement(CheckBoxStyle, {
    color: BrandColor['BU']
  }, img) : /*#__PURE__*/React.createElement(CheckBoxStyle, {
    color: BackGroundColor['B05']
  }, img)), label && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: '9px'
    }
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b2_r',
    color: TextColor['B85']
  }, label))));
};
var CheckBoxWithImgStyle = styled.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral(["\n    display: inline-flex;\n    flex-direction: column;\n    align-items: center;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])));
var CheckBoxStyle = styled.span(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteral(["\n    display: inline-flex;\n    background-color: ", ";\n    width: 68px;\n    height: 68px;\n    border-radius: 50%;\n    justify-content: center;\n    align-items: center;\n"])), function (props) {
  return props.color;
});
var HiddenCheckBox$2 = styled.input(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteral(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    clippath: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"])));

var _templateObject$U, _templateObject2$F, _templateObject3$u;
var ContentWithLabel = function ContentWithLabel(_ref) {
  var title = _ref.title,
      content = _ref.content,
      _ref$titleWidth = _ref.titleWidth,
      titleWidth = _ref$titleWidth === void 0 ? 60 : _ref$titleWidth;
  return /*#__PURE__*/React.createElement(ContentWithLabelStyle, null, /*#__PURE__*/React.createElement(Title$6, {
    width: titleWidth
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "b1_r",
    color: TextColor["B40"]
  }, title)), /*#__PURE__*/React.createElement(Content$1, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "b1_r"
  }, content)));
};
var ContentWithLabelStyle = styled.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral(["\n    width: 100%;\n    display:flex;\n"])));
var Title$6 = styled.div(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteral(["\n    width: ", "px;\n"])), function (props) {
  return props.width;
});
var Content$1 = styled.div(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteral(["\n    margin-left: 12px;\n    width: 100%;\n"])));

function Svg1CycleEnabledCheckedRedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-4.952-2.488a.75.75 0 10-1.096-1.024l-5.087 5.45-1.852-1.735a.75.75 0 00-1.026 1.094l2.4 2.25a.75.75 0 001.061-.035l5.6-6z",
    fill: "#FF5151"
  }));
}

function Svg2CycleEnabledUnselectedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10a9.25 9.25 0 11-18.5 0 9.25 9.25 0 0118.5 0z",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }));
}

function Svg3CycleDisabledSelectedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-4.952-2.488a.75.75 0 10-1.096-1.024l-5.087 5.45-1.852-1.735a.75.75 0 00-1.026 1.094l2.4 2.25a.75.75 0 001.061-.035l5.6-6z",
    fill: "#9DABAC"
  }));
}

function Svg4CycleDisabledUnselectedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10a9.25 9.25 0 11-18.5 0 9.25 9.25 0 0118.5 0z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }));
}

function Svg5CycleEnabledErrorS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10a9.25 9.25 0 11-18.5 0 9.25 9.25 0 0118.5 0z",
    stroke: "#FF5151",
    strokeWidth: 1.5
  }));
}

function Svg5CycleEnabledErrorS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14c0 7.318-5.932 13.25-13.25 13.25S.75 21.318.75 14 6.682.75 14 .75 27.25 6.682 27.25 14z",
    stroke: "#FF5151",
    strokeWidth: 1.5
  }));
}

function SvgCheckDisabledSelectedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#9DABAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15l4 4 8-9",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgCheckDisabledUnselectedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14c0 7.318-5.932 13.25-13.25 13.25S.75 21.318.75 14 6.682.75 14 .75 27.25 6.682 27.25 14z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 1.5
  }));
}

function SvgCheckEnabledCheckedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14zm-7.253-3.336a1 1 0 00-1.494-1.328l-7.296 8.207-3.25-3.25a1 1 0 00-1.414 1.414l4 4a1 1 0 001.454-.043l8-9z",
    fill: "#00BED6"
  }));
}

function SvgCheckEnabledUnselectedFilledS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#000",
    fillOpacity: 0.06
  }));
}

function SvgCheckEnabledUnselectedFilledS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#000",
    fillOpacity: 0.06
  }));
}

function SvgCheckEnabledUnselectedS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 14c0 7.318-5.932 13.25-13.25 13.25S.75 21.318.75 14 6.682.75 14 .75 27.25 6.682 27.25 14z",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }));
}

function SvgCheckboxEnabledSelectedDarkBuS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-4.952-2.488a.75.75 0 10-1.096-1.024l-5.087 5.45-1.852-1.735a.75.75 0 00-1.026 1.094l2.4 2.25a.75.75 0 001.061-.035l5.6-6z",
    fill: "#42484C"
  }));
}

function SvgCheckboxEnabledSelectedDarkBuS28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14c0 7.732-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0s14 6.268 14 14zm-7.253-3.336a1 1 0 00-1.494-1.328l-7.296 8.207-3.25-3.25a1 1 0 00-1.414 1.414l4 4a1 1 0 001.454-.043l8-9z",
    fill: "#42484C"
  }));
}

function SvgCheckboxEnabledUnselectedB06S20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10z",
    fill: "#000",
    fillOpacity: 0.06
  }));
}

function SvgCheckboxEnabledUnselectedB06S28(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z",
    fill: "#000",
    fillOpacity: 0.06
  }));
}

function SvgEnabledCheckedRedS20John(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-4.952-2.488a.75.75 0 10-1.096-1.024l-5.087 5.45-1.852-1.735a.75.75 0 00-1.026 1.094l2.4 2.25a.75.75 0 001.061-.035l5.6-6z",
    fill: "#FF5151"
  }));
}

function SvgIcCollarS56(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 57,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M55.816 26.183c0 .757-.53 1.637-1.876 2.568-1.324.915-3.29 1.77-5.785 2.498-4.981 1.456-11.907 2.367-19.589 2.367-7.681 0-14.607-.91-19.588-2.366-2.496-.73-4.46-1.584-5.785-2.499-1.347-.93-1.877-1.81-1.877-2.568 0-.757.53-1.637 1.877-2.568 1.324-.915 3.29-1.769 5.785-2.498 4.981-1.456 11.907-2.367 19.588-2.367 7.682 0 14.608.91 19.589 2.367 2.496.729 4.46 1.583 5.785 2.498 1.347.93 1.876 1.81 1.876 2.568z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.066 21.5h5.5v4.7h-5.5v-4.7zM49.566 21.5h5.5v4.7h-5.5v-4.7z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.816 17.183c0 .757-.53 1.637-1.876 2.568-1.324.915-3.29 1.77-5.785 2.498-4.981 1.456-11.907 2.367-19.589 2.367-7.681 0-14.607-.91-19.588-2.366-2.496-.73-4.46-1.584-5.785-2.499-1.347-.93-1.877-1.81-1.877-2.568 0-.757.53-1.637 1.877-2.568 1.324-.915 3.29-1.769 5.785-2.498C13.959 10.66 20.885 9.75 28.566 9.75c7.682 0 14.608.91 19.589 2.367 2.496.729 4.46 1.583 5.785 2.498 1.347.93 1.876 1.81 1.876 2.568z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M.566 17h1.5v9h-1.5zM55.066 17h1.5v9h-1.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.316,
    y: 22.75,
    width: 8.5,
    height: 3.5,
    rx: 1.25,
    fill: "#F7F7F7",
    stroke: "#F7F7F7",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.316,
    y: 23.75,
    width: 4.5,
    height: 11.5,
    rx: 1.25,
    fill: "#F7F7F7",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.066,
    cy: 28.5,
    r: 1.5,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.066,
    cy: 28.5,
    r: 1.5,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.066,
    cy: 27.5,
    r: 1.5,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.066,
    cy: 27.5,
    r: 1.5,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.566,
    cy: 34,
    r: 5.25,
    fill: "#F7F7F7",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcNoteS56(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 57,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 10.316,
    y: 5.75,
    width: 36.5,
    height: 38.5,
    rx: 1.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M15.566 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M17.066 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M22.566 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M24.066 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M28.566 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M30.066 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M34.566 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M36.066 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M40.566 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M42.066 3h1.5v5.5h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeWidth: 1.5,
    d: "M16.287 16.25h19M16.566 29.25h16M16.566 35.25h20M16.287 22.25h25"
  }));
}

function SvgIcSafetyGateS56(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 57,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 7.316,
    y: 5.75,
    width: 42.5,
    height: 36.5,
    rx: 1.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M7.135 18.25h43M24.316 8v10M24.316 33v10M24.316 20.82v9M15.316 8v10M15.316 33v10M15.316 20.82v9M33.316 8v10M33.316 33v10M33.316 20.82v9M42.316 8v10M42.316 33v10M7.135 30.25h43"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.566,
    cy: 23.703,
    r: 2,
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcReserChangeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 3a.75.75 0 00-1.5 0v1H5a2 2 0 00-2 2v13a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2h-2.25V3a.75.75 0 00-1.5 0v1h-6.5V3zM16 7.25a.75.75 0 01-.75-.75v-1h-6.5v1a.75.75 0 01-1.5 0v-1H5a.5.5 0 00-.5.5v2.5h15V6a.5.5 0 00-.5-.5h-2.25v1a.75.75 0 01-.75.75zM19.5 10h-15v9a.5.5 0 00.5.5h14a.5.5 0 00.5-.5v-9z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.928 12.53a.75.75 0 10-1.06-1.06L8.97 13.366a.75.75 0 00.53 1.28h5.25a.75.75 0 000-1.5h-3.438l.616-.616zm.394 4.836a.75.75 0 001.06 1.061l1.898-1.897a.75.75 0 00-.53-1.28H9.5a.75.75 0 000 1.5h3.438l-.616.616z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIc11S48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 16a3.25 3.25 0 013.25-3.25h19A3.25 3.25 0 0135.75 16v12.4a3.25 3.25 0 01-3.25 3.25H18.366a4.75 4.75 0 00-2.906.992l-4.807 3.718a.25.25 0 01-.403-.197V16z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.627 25.625c0 .601.317.945.88.945.56 0 .876-.339.876-.945V20.2c0-.656-.419-1.08-1.047-1.08-.36 0-.741.124-1.16.392l-.876.586c-.317.198-.478.435-.478.698 0 .354.258.612.613.612.177 0 .327-.053.607-.23l.563-.382h.022v4.829zm9.443 0c0 .601.317.945.88.945.56 0 .876-.339.876-.945V20.2c0-.656-.419-1.08-1.047-1.08-.36 0-.741.124-1.16.392l-.876.586c-.317.198-.478.435-.478.698 0 .354.258.612.613.612.177 0 .327-.053.607-.23l.563-.382h.022v4.829z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 22.5a1 1 0 100-2 1 1 0 000 2zm0 3a1 1 0 100-2 1 1 0 000 2z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcAlaramstrokeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Alaramstroke_S16_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.996 6.193A5 5 0 103 6s.043 4.01-.451 5.006c-.293.592-1.228 1.183-1.939 1.566-.191.103-.118.428.1.428H6v.004h4V13h5.292c.217 0 .29-.325.1-.428-.712-.383-1.646-.974-1.94-1.566-.428-.865-.456-4.002-.456-4.813zM6.46 13.628c-.005.045-.008.09-.008.135 0 .784.795 1.419 1.774 1.419.98 0 1.774-.635 1.774-1.42 0-.044-.003-.09-.008-.134H6.46z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.996 6.193l-1.499-.057v.056h1.5zM3 6v1.5A1.5 1.5 0 004.5 6H3zm0 0V4.5a1.5 1.5 0 00-1.5 1.516L3 6zm-.451 5.006l-1.344-.666 1.344.666zM.61 12.572l-.711-1.32.711 1.32zM6 13h1.5A1.5 1.5 0 006 11.5V13zm0 .004H4.5a1.5 1.5 0 001.5 1.5v-1.5zm4 0v1.5a1.5 1.5 0 001.5-1.5H10zM10 13v-1.5A1.5 1.5 0 008.5 13H10zm5.392-.428l-.712 1.32.712-1.32zm-1.94-1.566l1.345-.666-1.344.666zM6.46 13.628v-1.5a1.5 1.5 0 00-1.49 1.325l1.49.175zm3.532 0l1.49-.175a1.5 1.5 0 00-1.49-1.325v1.5zM11.5 6c0 .046 0 .09-.003.136l2.998.114c.003-.083.005-.166.005-.25h-3zM8 2.5A3.5 3.5 0 0111.5 6h3A6.5 6.5 0 008-.5v3zM4.5 6A3.5 3.5 0 018 2.5v-3A6.5 6.5 0 001.5 6h3zM3 7.5v-3 3zm.893 4.173c.249-.502.359-1.174.423-1.68.072-.574.116-1.214.142-1.796a43.85 43.85 0 00.041-2.162v-.037-.01-.003-.001L3 6l-1.5.016V6.025a18.766 18.766 0 01.001.152 40.13 40.13 0 01-.04 1.885 20.107 20.107 0 01-.12 1.553c-.067.525-.137.729-.135.725l2.688 1.333zm-2.571 2.22c.39-.21.873-.494 1.315-.826.403-.303.947-.772 1.256-1.394L1.205 10.34c.018-.037.014-.014-.06.063a2.66 2.66 0 01-.31.265c-.275.207-.615.41-.936.584l1.423 2.64zM.71 11.5c.776 0 1.17.6 1.258.988.089.382.003 1.055-.646 1.405l-1.423-2.641c-.84.452-.985 1.34-.854 1.91.133.575.671 1.338 1.665 1.338v-3zm5.29 0H.71v3H6v-3zm1.5 1.504V13h-3v.004h3zm2.5-1.5H6v3h4v-3zM8.5 13v.004h3V13h-3zm6.792-1.5H10v3h5.292v-3zm-.612 2.393c-.649-.35-.735-1.023-.647-1.405.09-.387.483-.988 1.259-.988v3c.993 0 1.532-.763 1.665-1.338.131-.57-.014-1.458-.854-1.91l-1.423 2.64zm-2.571-2.22c.309.622.853 1.091 1.256 1.394.442.332.925.616 1.315.826l1.423-2.641a7.668 7.668 0 01-.937-.584 2.657 2.657 0 01-.309-.265c-.074-.077-.078-.1-.06-.063l-2.688 1.333zm-.613-5.48c0 .417.007 1.439.07 2.478.032.517.079 1.063.15 1.55.064.436.17 1.004.393 1.452l2.688-1.333c.007.015-.05-.134-.113-.555-.054-.37-.094-.82-.123-1.297-.058-.949-.065-1.9-.065-2.295h-3zm-3.544 7.57c0 .013 0 .027-.002.04l-2.98-.35a2.654 2.654 0 00-.018.31h3zm.274-.081a.529.529 0 01-.317-.087c-.016-.013-.007-.01.009.02a.326.326 0 01.034.148h-3c0 1.907 1.796 2.919 3.274 2.919v-3zm.274.08c0-.062.017-.115.035-.148.015-.03.025-.032.008-.019a.529.529 0 01-.317.087v3c1.479 0 3.274-1.012 3.274-2.92h-3zm.002.041a.348.348 0 01-.002-.04h3c0-.104-.006-.207-.018-.31l-2.98.35zM6.46 15.128h3.532v-3H6.46v3z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_Alaramstroke_S16_svg__a)"
  }));
}

function SvgIcAlramS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 3a1.5 1.5 0 013 0v.174c2.867.677 5 3.252 5 6.326V12s.101 3.013.76 4.342c.371.75 1.514 1.5 2.44 2.01.285.158.173.648-.153.648H2.453c-.326 0-.438-.49-.153-.647.926-.512 2.07-1.261 2.44-2.011C5.4 15.012 5.5 12 5.5 12V9.5a6.503 6.503 0 015-6.326V3zM9.333 20A2.68 2.68 0 0012 22.333 2.68 2.68 0 0014.667 20H9.333z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcAlramstrokeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Alramstroke_S24_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 9.5a6.5 6.5 0 1113 0V12s.101 3.013.76 4.342c.371.75 1.514 1.5 2.44 2.01.285.158.173.648-.153.648H2.453c-.326 0-.438-.49-.153-.647.926-.512 2.07-1.261 2.44-2.011C5.4 15.012 5.5 12 5.5 12V9.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.5H17h1.5zm0 2.5H17v.05l1.5-.05zm.76 4.342l1.344-.666-1.344.666zm2.44 2.01l.725-1.312-.725 1.313zM12.02 19v-1.5h-.004l.005 1.5zM12 19l-.002 1.5H12V19zm-.02 0l.002-1.5h-.003V19zm-9.68-.647l-.725-1.313.725 1.313zm2.44-2.011l-1.344-.666 1.345.666zM5.5 12l1.5.05V12H5.5zM12 1.5a8 8 0 00-8 8h3a5 5 0 015-5v-3zm8 8a8 8 0 00-8-8v3a5 5 0 015 5h3zm0 2.5V9.5h-3V12h3zm-1.5 0l-1.5.05v.001l.001.001v.012a19.581 19.581 0 01.006.14l.022.385c.021.322.057.766.114 1.258.107.909.314 2.236.772 3.16l2.689-1.331c-.2-.404-.372-1.248-.481-2.178A21.91 21.91 0 0120 11.974v-.02-.005L18.5 12zm-.585 5.008c.342.689.945 1.235 1.441 1.617.531.41 1.12.766 1.618 1.04l1.45-2.625c-.427-.237-.872-.51-1.237-.791-.4-.308-.553-.513-.583-.573l-2.689 1.332zm3.06 2.658a1.163 1.163 0 01-.584-1.271c.077-.33.429-.895 1.156-.895v3c1.053 0 1.623-.81 1.766-1.424.142-.609-.005-1.549-.888-2.036l-1.45 2.626zm.572-2.166H12.02v3h9.526v-3zM12 20.5h.026l-.01-3H12v3zm-.023 0h.02l.005-3h-.02l-.005 3zm-9.524 0h9.526v-3H2.453v3zm-.878-3.46c-.882.487-1.03 1.427-.888 2.036.143.614.713 1.424 1.766 1.424v-3c.727 0 1.079.566 1.156.895.075.325.014.94-.583 1.27l-1.45-2.625zm1.821-1.364c-.03.06-.184.265-.583.572-.365.281-.81.555-1.238.792l1.45 2.626a12.985 12.985 0 001.619-1.041c.496-.383 1.1-.928 1.44-1.617l-2.688-1.332zM5.5 12L4 11.95v-.001.004a6.395 6.395 0 01-.004.108l-.019.333c-.018.285-.05.676-.1 1.104-.108.93-.28 1.774-.48 2.178l2.688 1.332c.458-.925.666-2.252.772-3.161a24.95 24.95 0 00.142-1.792v-.003-.001L5.5 12zM4 9.5V12h3V9.5H4z",
    fill: "#262626",
    mask: "url(#ic_Alramstroke_S24_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3a1.5 1.5 0 013 0v1h-3V3z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.333 20A2.68 2.68 0 0012 22.333 2.68 2.68 0 0014.667 20H9.333z",
    fill: "#262626"
  }));
}

function SvgIcArrowDropSmallB85S16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.044L8.022 11 3 6",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowFillrightincircleS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#000",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.408 12.47a.6.6 0 000-.94l-4.435-3.52a.6.6 0 00-.973.47v7.04a.6.6 0 00.973.47l4.435-3.52z",
    fill: "#fff"
  }));
}

function SvgIcArrowUpS16B85(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.956L8.022 6 3 11",
    stroke: "#000",
    strokeOpacity: 0.4,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowModalS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47 4.933a.75.75 0 101.06 1.063l3.452-3.438 3.489 3.474a.75.75 0 001.058-1.064l-4.018-4a.75.75 0 00-1.058 0L3.471 4.934zm9.06 6.134a.75.75 0 00-1.06-1.063l-3.452 3.438-3.489-3.473a.75.75 0 10-1.058 1.063l4.018 4a.75.75 0 001.058 0l3.982-3.965z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcArrowdropSmallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.044L8.022 11 3 6",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowdropS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15 5.562L8.031 12.5 1 5.5",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowfilldownSmallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.222 10.038a1 1 0 001.556 0l2.236-2.767a1 1 0 00-.778-1.628H5.764a1 1 0 00-.778 1.628l2.236 2.767z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcArrowfilldownS16(props) {
  var _props$fill, _props$fillOpacity;

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.222 12.038a1 1 0 001.556 0l3.968-4.91a1 1 0 00-.778-1.628H4.032a1 1 0 00-.778 1.629l3.968 4.909z",
    fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : "#000",
    fillOpacity: (_props$fillOpacity = props.fillOpacity) !== null && _props$fillOpacity !== void 0 ? _props$fillOpacity : 0.2
  }));
}

function SvgIcArrowfillrightSmallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.038 8.778a1 1 0 000-1.556L7.27 4.986a1 1 0 00-1.628.778v4.472a1 1 0 001.628.778l2.767-2.236z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcArrowfillrightS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.038 8.778a1 1 0 000-1.556l-4.91-3.968a1 1 0 00-1.628.778v7.936a1 1 0 001.629.778l4.909-3.968z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcArrowleftSmallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.956 3L5 7.978 10 13",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowleftS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.438 1L4.5 7.97l7 7.03",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowrightSmallS16(props) {
  var _props$stroke, _props$strokeOpacity, _props$strokeWidth;

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.044 3L11 7.978 6 13",
    stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : '#000',
    strokeOpacity: (_props$strokeOpacity = props.strokeOpacity) !== null && _props$strokeOpacity !== void 0 ? _props$strokeOpacity : 0.2,
    strokeWidth: (_props$strokeWidth = props.strokeWidth) !== null && _props$strokeWidth !== void 0 ? _props$strokeWidth : 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowrightS10(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 12,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.914 1.43L5.936 6.388l-5.022-5",
    stroke: props.arrowColor || "#000",
    strokeOpacity: props.arrowOpacity || 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowrightS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.062 1L12 7.97 5 15",
    stroke: props.arrowColor || "#000",
    strokeOpacity: props.arrowOpacity || 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowtailfillrightS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.331 7.222a1 1 0 010 1.556l-3.409 2.755a1 1 0 01-1.629-.777V9H2.897a.6.6 0 01-.6-.6v-.8a.6.6 0 01.6-.6h5.396V5.244a1 1 0 011.63-.777l3.408 2.755z",
    fill: "#C4C4C4"
  }));
}

function SvgIcArrowupSmallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 10.956L8.022 6 3 11",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcArrowupS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1 12.438L7.969 5.5l7.031 7",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcAssignS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.5c2.197 0 4 1.803 4 4s-1.803 4-4 4-4-1.803-4-4 1.803-4 4-4zm5.5 4c0-3.025-2.475-5.5-5.5-5.5s-5.5 2.475-5.5 5.5S17.975 22 21 22s5.5-2.475 5.5-5.5zM10.75 31.716c0-1.65 1.136-3.51 3.083-4.996 1.925-1.47 4.518-2.47 7.167-2.47 1.413 0 2.813.284 4.106.775a.75.75 0 00.533-1.402A13.119 13.119 0 0021 22.75c-3.01 0-5.917 1.13-8.077 2.778-2.139 1.632-3.673 3.882-3.673 6.188v1.781A2.752 2.752 0 0012 36.25v-.75l.001.75H22.5a.75.75 0 000-1.5H12.001v.75-.75c-.69 0-1.251-.56-1.251-1.253v-1.781zM31 37.5a6 6 0 100-12 6 6 0 000 12zm7.5-6a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm-4.97-.47a.75.75 0 10-1.06-1.06l-2.112 2.112-.855-.772a.75.75 0 00-1.006 1.113l1.384 1.25a.75.75 0 001.033-.026l2.616-2.617z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcBabyDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.334 8.806a.75.75 0 00-1.02.292l-2.925 5.278a.75.75 0 001.312.727l2.925-5.278a.75.75 0 00-.293-1.02zm8.283 3.533a.75.75 0 10-.71 1.322c3.065 1.646 5.415 4.537 6.418 8.033.086.3.349.515.66.54 1.553.125 2.765 1.414 2.765 2.973 0 1.517-1.147 2.778-2.64 2.96a.75.75 0 00-.638.57c-1.4 5.805-6.468 10.077-12.472 10.077s-11.071-4.272-12.472-10.078a.75.75 0 00-.638-.569c-1.493-.182-2.64-1.443-2.64-2.96 0-1.56 1.212-2.848 2.765-2.973a.75.75 0 00.66-.54c.931-3.245 3.023-5.97 5.77-7.66a.75.75 0 00-.786-1.278c-2.934 1.806-5.188 4.659-6.282 8.055-2.065.41-3.627 2.218-3.627 4.396 0 2.114 1.47 3.88 3.443 4.356 1.709 6.192 7.23 10.751 13.807 10.751s12.098-4.56 13.807-10.75c1.973-.478 3.443-2.243 3.443-4.357 0-2.178-1.562-3.987-3.627-4.396-1.183-3.67-3.72-6.706-7.006-8.472zM20.5 24.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm8.75 1.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zm-5.25 2a2 2 0 011.96 1.6 3.5 3.5 0 11-3.92 0A2 2 0 0124 28.5zm2 4.5c0-.473-.164-.907-.439-1.25-.366.457-.93.75-1.561.75a1.996 1.996 0 01-1.561-.75A2 2 0 1026 33zM24.814 9.098a.75.75 0 011.312.727L23.2 15.103a.75.75 0 01-1.312-.727l2.925-5.278zm5.02-.292a.75.75 0 00-1.02.292l-2.925 5.278a.75.75 0 001.312.727l2.925-5.278a.75.75 0 00-.293-1.02z",
    fill: "#D8D8D8"
  }));
}

function SvgIcBabyS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.262 12c3.245 1.743 5.726 4.799 6.783 8.487 1.934.155 3.455 1.762 3.455 3.72 0 1.906-1.44 3.478-3.299 3.705C35.725 34.03 30.374 38.564 24 38.564c-6.374 0-11.725-4.533-13.201-10.652-1.86-.227-3.299-1.8-3.299-3.705 0-1.958 1.52-3.565 3.455-3.72.982-3.424 3.637-6.697 6.545-8.487",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.948 8.114a.75.75 0 00-1.312-.727l-3.15 5.685a.75.75 0 001.311.727l3.151-5.685zm7.669 2.956a.75.75 0 00-.71 1.321c3.065 1.646 5.415 4.537 6.418 8.033.086.3.349.516.66.54 1.553.126 2.765 1.414 2.765 2.974 0 1.517-1.147 2.778-2.64 2.96a.75.75 0 00-.638.568c-1.4 5.806-6.468 10.079-12.472 10.079s-11.071-4.273-12.472-10.079a.75.75 0 00-.638-.568c-1.493-.182-2.64-1.443-2.64-2.96 0-1.56 1.212-2.848 2.765-2.973a.75.75 0 00.66-.541c.931-3.245 3.023-5.969 5.77-7.66a.75.75 0 00-.786-1.277c-2.934 1.806-5.188 4.658-6.282 8.054-2.065.41-3.627 2.218-3.627 4.397 0 2.113 1.47 3.878 3.443 4.355 1.709 6.192 7.23 10.752 13.807 10.752s12.098-4.56 13.807-10.752c1.973-.477 3.443-2.242 3.443-4.355 0-2.18-1.562-3.988-3.627-4.396-1.183-3.67-3.72-6.707-7.006-8.472zM20.5 23.48a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm8.75 1.75a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zm-5.25 2a2 2 0 011.96 1.6 3.5 3.5 0 11-3.92 0 2 2 0 011.96-1.6zm2 4.5c0-.473-.164-.907-.439-1.25-.366.458-.93.75-1.561.75a1.996 1.996 0 01-1.561-.75A2 2 0 1026 31.73zm.156-24.636a.75.75 0 01.292 1.02l-3.15 5.685a.75.75 0 01-1.313-.727l3.151-5.685a.75.75 0 011.02-.293zm3.792 1.02a.75.75 0 00-1.312-.727l-3.15 5.685a.75.75 0 001.311.727l3.151-5.685z",
    fill: "#262626"
  }));
}

function SvgIcBabyNoneS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.262 12c3.245 1.743 5.726 4.799 6.783 8.487 1.934.155 3.455 1.762 3.455 3.72 0 1.906-1.44 3.478-3.299 3.705C35.725 34.03 30.374 38.564 24 38.564c-6.374 0-11.725-4.533-13.201-10.652-1.86-.227-3.299-1.8-3.299-3.705 0-1.958 1.52-3.565 3.455-3.72.982-3.424 3.637-6.697 6.545-8.487",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.948 8.383a.75.75 0 00-1.312-.727l-.225.406a.75.75 0 001.312.727l.225-.406zm-1.35 2.437a.75.75 0 00-1.312-.728l-.45.813a.75.75 0 101.312.727l.45-.812zm-1.576 2.842a.75.75 0 00-1.312-.727l-.225.406a.75.75 0 001.312.727l.225-.406zm10.595-2.323a.75.75 0 10-.71 1.322c.147.079.293.16.437.246a.75.75 0 10.762-1.293 14.261 14.261 0 00-.49-.275zm-13.172 1.695a.75.75 0 00-.786-1.278c-.148.091-.294.185-.439.281a.75.75 0 00.832 1.248c.13-.086.26-.17.393-.251zm15.921.23a.75.75 0 10-.997 1.12c.25.222.492.455.725.696a.75.75 0 101.08-1.041c-.26-.27-.529-.528-.808-.776zm-18.128 1.484a.75.75 0 10-1.042-1.08c-.249.241-.49.49-.722.749a.75.75 0 001.116 1.003c.208-.232.425-.457.648-.672zm20.676 1.477a.75.75 0 00-1.256.82c.183.28.356.567.518.862a.75.75 0 101.314-.723c-.18-.328-.372-.648-.576-.96zm-22.726 1.06a.75.75 0 00-1.273-.792c-.183.293-.356.594-.518.9a.75.75 0 101.325.703c.147-.276.302-.547.466-.81zm24.414 2.46a.75.75 0 00-1.425.467c.052.16.101.32.148.482.086.3.349.515.66.54.108.009.213.023.317.043a.75.75 0 00.322-1.465l-.022-.067zm-25.79.501a.75.75 0 10-1.426-.463l-.01.03a.75.75 0 00.322 1.464c.104-.02.21-.034.317-.043a.75.75 0 00.66-.54c.044-.15.09-.3.137-.448zm-2.534 1.717a.75.75 0 10-.983-1.133c-.24.209-.459.443-.65.698a.75.75 0 001.199.901 3.02 3.02 0 01.434-.466zm30.427-1.133a.75.75 0 00-.983 1.133c.16.14.306.296.434.466a.75.75 0 001.2-.901 4.512 4.512 0 00-.651-.698zM8.267 23.89a.75.75 0 00-1.492-.16 4.495 4.495 0 00-.001.942.75.75 0 001.492-.154 2.997 2.997 0 010-.628zm32.958-.16a.75.75 0 10-1.492.16 2.979 2.979 0 01.001.628.75.75 0 101.492.154 4.485 4.485 0 00-.001-.941zm-.822 3.093a.75.75 0 00-1.215-.88c-.121.168-.26.322-.413.462a.75.75 0 001.01 1.11c.229-.21.436-.44.618-.692zm-31.591-.88a.75.75 0 00-1.215.88c.182.251.389.483.618.691a.75.75 0 101.01-1.11 3.01 3.01 0 01-.413-.46zm29.502 1.737a.75.75 0 01-.506.882l-.017.06a.75.75 0 11-1.444-.406c.044-.158.086-.318.125-.479a.75.75 0 01.638-.569c.104-.012.206-.03.306-.053a.75.75 0 01.898.565zm-27.73-.565a.75.75 0 00-.392 1.447l.017.06a.75.75 0 101.444-.406 13.581 13.581 0 01-.125-.479.75.75 0 00-.638-.569 3.006 3.006 0 01-.306-.053zm26.228 4.072a.75.75 0 10-1.347-.661c-.146.297-.302.588-.468.872a.75.75 0 101.294.758c.185-.315.359-.639.52-.969zm-24.277-.661a.75.75 0 10-1.347.661c.162.33.336.654.521.97a.75.75 0 101.294-.76 13.433 13.433 0 01-.468-.871zm22.154 3.863a.75.75 0 00-1.133-.984c-.216.249-.442.49-.676.721a.75.75 0 001.056 1.066c.26-.258.511-.526.753-.803zm-20.245-.984a.75.75 0 00-1.133.983c.242.278.493.546.753.804a.75.75 0 001.056-1.066c-.234-.231-.46-.472-.676-.721zm2.585 2.283a.75.75 0 10-.835 1.247c.305.204.618.397.939.578a.75.75 0 10.736-1.307 12.77 12.77 0 01-.84-.518zm14.777 1.247a.75.75 0 00-.835-1.247 12.77 12.77 0 01-.84.518.75.75 0 10.736 1.307c.32-.181.634-.374.94-.578zm-11.684.264a.75.75 0 00-.467 1.425c.348.114.703.215 1.062.302a.75.75 0 10.352-1.458 12.45 12.45 0 01-.947-.27zm8.223 1.425a.75.75 0 00-.466-1.425 12.45 12.45 0 01-.948.269.75.75 0 10.352 1.458c.36-.087.714-.188 1.062-.302zm-4.838-.818a.75.75 0 00-.06 1.498 14.258 14.258 0 001.105 0 .75.75 0 00-.058-1.498 12.631 12.631 0 01-.988 0zm2.649-30.441a.75.75 0 01.292 1.02l-.225.405a.75.75 0 11-1.312-.727l.225-.406a.75.75 0 011.02-.292zM24.806 9.8a.75.75 0 01.292 1.02l-.45.812a.75.75 0 01-1.312-.727l.45-.813a.75.75 0 011.02-.292zm-1.576 2.843a.75.75 0 01.292 1.02l-.225.405a.75.75 0 01-1.312-.727l.225-.406a.75.75 0 011.02-.292zm6.718-4.26a.75.75 0 00-1.312-.727l-.225.406a.75.75 0 001.312.727l.225-.406zm-1.35 2.437a.75.75 0 00-1.312-.728l-.45.813a.75.75 0 101.312.727l.45-.812zm-1.576 2.842a.75.75 0 00-1.312-.727l-.225.406a.75.75 0 001.312.727l.225-.406z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcBadgeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.634.393a.5.5 0 01.732 0l.7.752a.5.5 0 00.573.114l.934-.427a.5.5 0 01.676.28l.358.962a.5.5 0 00.487.326l1.026-.037a.5.5 0 01.518.517L13.6 3.906a.5.5 0 00.325.487l.961.358a.5.5 0 01.28.676l-.426.934a.5.5 0 00.114.574l.752.699a.5.5 0 010 .732l-.752.7a.5.5 0 00-.114.573l.427.934a.5.5 0 01-.28.676l-.962.358a.5.5 0 00-.325.487l.036 1.026a.5.5 0 01-.517.518l-1.026-.037a.5.5 0 00-.486.325l-.359.961a.5.5 0 01-.676.28l-.934-.426a.5.5 0 00-.574.114l-.699.752a.5.5 0 01-.732 0l-.7-.752a.5.5 0 00-.573-.114l-.934.427a.5.5 0 01-.676-.28l-.358-.962a.5.5 0 00-.487-.325l-1.026.036a.5.5 0 01-.517-.517l.037-1.026a.5.5 0 00-.326-.486l-.961-.359a.5.5 0 01-.28-.676l.426-.934a.5.5 0 00-.114-.574l-.752-.699a.5.5 0 010-.732l.752-.7a.5.5 0 00.114-.573l-.427-.934a.5.5 0 01.28-.676l.962-.358a.5.5 0 00.326-.487L2.363 2.88a.5.5 0 01.517-.517l1.026.037a.5.5 0 00.487-.326l.358-.961a.5.5 0 01.676-.28l.934.426a.5.5 0 00.574-.114l.699-.752z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.133 9.82a.286.286 0 00-.266 0l-1.412.742a.286.286 0 01-.414-.301l.27-1.572a.286.286 0 00-.083-.253L5.086 7.323a.286.286 0 01.158-.488l1.579-.23a.286.286 0 00.215-.155l.706-1.43a.286.286 0 01.512 0l.706 1.43a.286.286 0 00.215.156l1.579.23a.286.286 0 01.158.487L9.772 8.436a.286.286 0 00-.082.253l.27 1.572a.286.286 0 01-.415.301L8.133 9.82z",
    fill: "#fff"
  }));
}

function SvgIcBadgeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.634.393a.5.5 0 01.732 0l1.355 1.457a.5.5 0 00.574.114l1.808-.827a.5.5 0 01.677.28l.694 1.864a.5.5 0 00.487.325l1.987-.072a.5.5 0 01.518.518l-.072 1.987a.5.5 0 00.325.487l1.864.694a.5.5 0 01.28.677l-.827 1.808a.5.5 0 00.114.574l1.457 1.355a.5.5 0 010 .732l-1.456 1.355a.5.5 0 00-.115.574l.827 1.808a.5.5 0 01-.28.677l-1.864.694a.5.5 0 00-.325.487l.072 1.987a.5.5 0 01-.518.518l-1.987-.072a.5.5 0 00-.487.325l-.694 1.864a.5.5 0 01-.677.28l-1.808-.827a.5.5 0 00-.574.114l-1.355 1.457a.5.5 0 01-.732 0l-1.355-1.456a.5.5 0 00-.574-.115l-1.808.827a.5.5 0 01-.677-.28l-.694-1.864a.5.5 0 00-.487-.325l-1.987.072a.5.5 0 01-.518-.518l.072-1.987a.5.5 0 00-.325-.487l-1.864-.694a.5.5 0 01-.28-.677l.827-1.808a.5.5 0 00-.114-.574L.393 12.366a.5.5 0 010-.732l1.457-1.355a.5.5 0 00.114-.574l-.827-1.808a.5.5 0 01.28-.677l1.864-.694a.5.5 0 00.325-.487l-.072-1.987a.5.5 0 01.518-.518l1.987.072a.5.5 0 00.487-.325l.694-1.864a.5.5 0 01.677-.28l1.808.827a.5.5 0 00.574-.114L11.634.393z",
    fill: "#FFBC57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.133 15.07a.286.286 0 00-.266 0l-2.881 1.515a.286.286 0 01-.415-.302l.55-3.208a.286.286 0 00-.082-.253L6.71 10.55a.286.286 0 01.158-.487l3.221-.468a.286.286 0 00.215-.157l1.44-2.919a.286.286 0 01.513 0l1.44 2.92a.286.286 0 00.216.156l3.221.468a.286.286 0 01.159.487l-2.331 2.272a.286.286 0 00-.082.253l.55 3.209a.286.286 0 01-.415.3l-2.881-1.514z",
    fill: "#fff"
  }));
}

function SvgIcBalanceS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.5 24c0 7.456-6.044 13.5-13.5 13.5S10.5 31.456 10.5 24 16.544 10.5 24 10.5 37.5 16.544 37.5 24zM24 39c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15zm0-19.536a.748.748 0 01.725.558l1.768 6.188 1.787-6.167a.75.75 0 111.44.418l-.88 3.039h2.02c.354 0 .64.336.64.75s-.287.75-.64.75h-2.455l-1.197 4.131a.75.75 0 01-1.441-.002L24 22.945l-1.767 6.184a.75.75 0 01-1.441.002L19.595 25h-2.41c-.378 0-.685-.336-.685-.75s.307-.75.686-.75h1.974l-.88-3.04a.75.75 0 011.44-.417l1.787 6.167 1.768-6.188a.756.756 0 01.46-.51.748.748 0 01.265-.048z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcBookS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.143 0a.75.75 0 01.75.75v.75h4.214V.75a.75.75 0 011.5 0v.75H14a2 2 0 012 2V14a2 2 0 01-2 2H2a2 2 0 01-2-2V3.5a2 2 0 012-2h2.393V.75a.75.75 0 01.75-.75zm4.964 3v.607a.75.75 0 001.5 0V3H14a.5.5 0 01.5.5v2.536h-13V3.5A.5.5 0 012 3h2.393v.607a.75.75 0 101.5 0V3h4.214zM1.5 7.536h13V14a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V7.536zm9.06 2.463A.75.75 0 109.44 9L7.322 11.38l-.815-.748a.75.75 0 10-1.014 1.105L6.868 13a.75.75 0 001.068-.054L10.56 10z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcBulbReviewS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.962 15.528h-3.934a7.56 7.56 0 00-.151-.238c-.373-.562-.936-1.265-1.76-2.122-1.786-1.859-3.074-4.042-2.054-7.131 1.006-3.052 3.805-4.127 5.87-4.127 1.196 0 2.403.253 3.428.87.998.602 1.911 1.6 2.479 3.27 1.068 3.14-.905 5.978-1.985 7.133l-.167.178c-.486.518-.967 1.03-1.319 1.514-.145.2-.286.417-.407.653zm1.706.115c.286-.372.667-.779 1.125-1.267l.157-.169c1.155-1.234 3.664-4.658 2.31-8.64S14.72.41 11.934.41c-2.48 0-6.022 1.294-7.296 5.157-1.274 3.862.446 6.61 2.398 8.64.55.573.96 1.055 1.264 1.454a1 1 0 00-.501.867v3.528a1 1 0 001 1h.563c.49 1.068 1.488 1.8 2.64 1.8 1.151 0 2.149-.732 2.64-1.8h.559a1 1 0 001-1v-3.528a1 1 0 00-.533-.885zm-6.37 1.397h5.403v2.516H9.299V17.04z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcBulluet01S16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.5a1 1 0 100-2 1 1 0 000 2zm4.5 4.477a1 1 0 100-2 1 1 0 000 2zm-8-1a1 1 0 11-2 0 1 1 0 012 0zM8.045 13.5a1 1 0 100-2 1 1 0 000 2zm5-10.376a.5.5 0 00-.706 0L8.096 7.366 3.854 3.124a.5.5 0 10-.708.707L7.39 8.073l-4.243 4.243a.5.5 0 10.708.707l4.242-4.242 4.243 4.242a.5.5 0 10.707-.707L8.803 8.073l4.243-4.242a.5.5 0 000-.707z",
    fill: "#000",
    fillOpacity: 0.4
  }));
}

function SvgIcBulluet01S16R(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.5a1 1 0 100-2 1 1 0 000 2zm4.5 4.477a1 1 0 100-2 1 1 0 000 2zm-8-1a1 1 0 11-2 0 1 1 0 012 0zM8.045 13.5a1 1 0 100-2 1 1 0 000 2zm5-10.376a.5.5 0 00-.706 0L8.096 7.366 3.854 3.124a.5.5 0 10-.708.707L7.39 8.073l-4.243 4.243a.5.5 0 10.708.707l4.242-4.242 4.243 4.242a.5.5 0 10.707-.707L8.803 8.073l4.243-4.242a.5.5 0 000-.707z",
    fill: "#FF5151"
  }));
}

function SvgIcCsS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.5h.25v.19a.75.75 0 101.5 0V6.999A5.25 5.25 0 0113.25 7v2a5.252 5.252 0 01-3.53 4.962 1.248 1.248 0 00-.97-.462h-1.5a1.25 1.25 0 100 2.5h1.5c.397 0 .75-.185.98-.474A6.755 6.755 0 0014.732 9.5H15a1 1 0 001-1v-3a1 1 0 00-1-1h-.728a6.752 6.752 0 00-12.544 0H1a1 1 0 00-1 1v3a1 1 0 001 1zM5.5 7a1 1 0 100-2 1 1 0 000 2zm6-1a1 1 0 11-2 0 1 1 0 012 0zm-6 2.75a.75.75 0 01.748.694c.007.014.02.037.046.07.068.09.187.206.358.322.345.233.825.414 1.348.414.523 0 1.003-.181 1.348-.414a1.54 1.54 0 00.358-.322.513.513 0 00.046-.07.75.75 0 011.498.056c0 .372-.177.694-.35.921a3.023 3.023 0 01-.712.657c-.56.38-1.33.672-2.188.672a3.955 3.955 0 01-2.188-.672 3.024 3.024 0 01-.713-.657c-.172-.227-.349-.549-.349-.921a.75.75 0 01.75-.75z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCsS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.083 9.255a.75.75 0 10-.166 1.49 9.445 9.445 0 018.338 8.339.75.75 0 101.49-.168 10.945 10.945 0 00-9.662-9.661zm-.94 6.009a.75.75 0 00-.287 1.472 4.313 4.313 0 013.408 3.408.75.75 0 101.472-.288 5.813 5.813 0 00-4.592-4.592zm4.014 20.2a1.47 1.47 0 00-.004.103v.001a.82.82 0 01-.103.262 1.8 1.8 0 01-.35.446.883.883 0 01-.66.221 22.088 22.088 0 01-9.518-3.336l-.012-.008a21.33 21.33 0 01-6.614-6.51l-.007-.01a21.253 21.253 0 01-3.382-9.393 1.467 1.467 0 01.028-.47.452.452 0 01.09-.199c.137-.148.228-.213.315-.256.093-.047.26-.108.588-.145l.014-.002 5.359-.666a.846.846 0 01.794.704c.165 1.226.47 2.43.909 3.587l.001.004c.11.29.044.62-.186.85l-1.494 1.47a1.5 1.5 0 00-.247 1.82c.853 1.476 1.608 2.65 2.576 3.675.982 1.038 2.122 1.86 3.68 2.732a1.5 1.5 0 001.785-.24l1.492-1.47.003-.002a.887.887 0 01.92-.188l.003.001c1.173.43 2.391.73 3.631.891.438.064.73.424.732.812l-.343 5.316zm-11.442-1.039a23.588 23.588 0 0010.182 3.566 2.383 2.383 0 001.807-.602c.49-.442.952-1.174.95-1.828l.345-5.353c.03-1.18-.843-2.193-2.029-2.358a15.348 15.348 0 01-3.315-.813 2.387 2.387 0 00-2.49.523l-1.498 1.475c-2.954-1.654-4.01-2.94-5.69-5.848l1.499-1.475a2.297 2.297 0 00.53-2.45 14.718 14.718 0 01-.825-3.264c-.166-1.154-1.176-2.01-2.36-1.998l-5.464.68c-.907.104-1.386.39-1.832.871-.447.482-.57 1.187-.511 1.837a22.752 22.752 0 003.622 10.069 22.83 22.83 0 007.079 6.968z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCalendarS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9.25a.75.75 0 01.75.75v2h14.5v-2a.75.75 0 011.5 0v2H37a2 2 0 012 2v22a2 2 0 01-2 2H11a2 2 0 01-2-2V14a2 2 0 012-2h4.25v-2a.75.75 0 01.75-.75zm15.25 4.25V15a.75.75 0 001.5 0v-1.5H37a.5.5 0 01.5.5v4.5h-27V14a.5.5 0 01.5-.5h4.25V15a.75.75 0 001.5 0v-1.5h14.5zM10.5 20h27v16a.5.5 0 01-.5.5H11a.5.5 0 01-.5-.5V20zm16.03 10.53a.75.75 0 10-1.06-1.06l-2.112 2.112-.855-.772a.75.75 0 00-1.006 1.113l1.384 1.25a.75.75 0 001.033-.026l2.616-2.617zM15 23.25a.75.75 0 000 1.5h2a.75.75 0 000-1.5h-2zm15.25.75a.75.75 0 01.75-.75h2a.75.75 0 010 1.5h-2a.75.75 0 01-.75-.75zM23 23.25a.75.75 0 000 1.5h2a.75.75 0 000-1.5h-2zM30.25 31a.75.75 0 01.75-.75h2a.75.75 0 010 1.5h-2a.75.75 0 01-.75-.75zM15 30.25a.75.75 0 000 1.5h2a.75.75 0 000-1.5h-2z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33 2.323c.646.973.998 1.535 1.056 1.686.114.293.28.458.18.804-.099.346-.538 1.134-.538 1.134s-.558.716-.201 1.37c.357.655 1.143 1.51 1.975 2.38.832.87 1.883 1.796 2.527 1.805.644.01 1.407-.803 1.621-.95.215-.145.635-.165 1.03 0 .393.167 2.646 1.815 2.646 1.815s.497.385.334.824c-.164.44-.64.953-.962 1.243-.323.29-.894.692-2.57.528-.758-.075-1.55-.415-2.219-.808-1.222-.718-2.737-1.917-4.028-3.296-1.29-1.38-3.092-3.779-3.442-4.63-.351-.85-.913-1.892-.687-3.076.226-1.184.931-1.636 1.367-1.882.435-.245.835-.375 1.053-.164.218.211.725 1.015.858 1.217z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcCallS16W(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.735 2.823c.646.973.998 1.535 1.056 1.686.114.293.28.458.18.804-.099.346-.538 1.134-.538 1.134s-.558.716-.201 1.37c.357.655 1.143 1.51 1.975 2.38.832.87 1.883 1.796 2.527 1.805.644.01 1.407-.803 1.621-.95.215-.145.635-.165 1.03 0 .393.167 2.646 1.815 2.646 1.815s.497.385.334.824c-.163.44-.64.953-.962 1.243-.323.29-.895.692-2.57.528-.758-.075-1.55-.415-2.218-.808-1.223-.718-2.738-1.917-4.029-3.296-1.29-1.38-3.092-3.779-3.442-4.63-.351-.85-.913-1.892-.687-3.076.226-1.184.932-1.636 1.367-1.882.435-.245.835-.375 1.053-.164.218.211.725 1.015.858 1.217z",
    fill: "#fff"
  }));
}

function SvgIcCallS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.757 15.89c.923 1.39 1.426 2.194 1.51 2.409.162.419.4.653.257 1.148-.143.494-.77 1.62-.77 1.62s-.797 1.023-.287 1.959c.51.935 1.633 2.156 2.822 3.398 1.188 1.243 2.69 2.566 3.61 2.58.92.013 2.01-1.148 2.316-1.357.306-.209.907-.237 1.47 0s3.781 2.592 3.781 2.592.71.55.476 1.177c-.233.627-.913 1.36-1.374 1.775-.461.414-1.277.99-3.67.755-1.084-.107-2.215-.594-3.17-1.154-1.747-1.026-3.912-2.739-5.755-4.71-1.842-1.97-4.417-5.397-4.918-6.613-.5-1.215-1.303-2.704-.98-4.395.322-1.691 1.33-2.337 1.952-2.688.622-.35 1.193-.536 1.504-.234.311.302 1.036 1.45 1.226 1.738z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcCancelCalendarS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 4.75,
    width: 16.5,
    height: 15.5,
    rx: 1.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V3M16 6.5V3",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    d: "M3.25 9.25h17.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12.5l-4 4M10 12.5l4 4",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcCardS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.5H2a.5.5 0 00-.5.5v1.25h13V4a.5.5 0 00-.5-.5zm.5 4.25h-13V12a.5.5 0 00.5.5h12a.5.5 0 00.5-.5V7.75zM2 2a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H2zm3.25 8.5a.75.75 0 01-.75.75h-1a.75.75 0 010-1.5h1a.75.75 0 01.75.75z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCartStokeB85S24V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.003 7.998a3.509 3.509 0 013.497-3.26 3.509 3.509 0 013.497 3.26H9.003zm-1.503 0a5.009 5.009 0 015-4.76c2.682 0 4.87 2.11 5 4.76h4.505a1 1 0 01.993 1.126l-1.361 10.768a1 1 0 01-.993.875H4.356a1 1 0 01-.992-.875L2.002 9.124a1 1 0 01.993-1.126H7.5zM4.797 19.267L3.56 9.498H21.44l-1.235 9.769H4.797z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCheckCalendarS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.774 6.193a1.5 1.5 0 011.5-1.5h13.452a1.5 1.5 0 011.5 1.5v12.493a1.5 1.5 0 01-1.5 1.5H5.274a1.5 1.5 0 01-1.5-1.5V6.193z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.984 3.064v3.348M15.964 3.064v3.348",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.307 9.138h15.387",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.756 14.62l1.564 1.5 2.984-3.5",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcCheckS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.444l3.997 3.611L14.5 2.945",
    stroke: "#00BED6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcCheckS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 13l6.535 6L21 5",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcCircleArrowrightS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM11.332 7.282a.75.75 0 00-1.019 1.1l3.812 3.53-3.812 3.529a.75.75 0 101.02 1.1l4.405-4.08a.75.75 0 000-1.1l-4.406-4.08z",
    fill: "#00BED6"
  }));
}

function SvgIcCleanDoneB85S16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.816c.691-4.115 4.5-5.5 4.5-5.5-4.147-1.198-4.5-5.5-4.5-5.5s-.353 4.302-4.5 5.5c0 0 3.809 1.385 4.5 5.5zM10.752 7.516c.491-2.963 3.148-3.655 3.148-3.655C10.951 3 10.722.316 10.722.316h-.044S10.448 3 7.5 3.861c0 0 2.691.692 3.182 3.655h.07zM12.54 15.941c.385-2.315 2.46-2.855 2.46-2.855-2.304-.674-2.483-2.77-2.483-2.77h-.034s-.18 2.096-2.483 2.77c0 0 2.102.54 2.486 2.855h.055z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCleanDoneS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.5C5.191 10.385 9 9 9 9 4.853 7.802 4.5 3.5 4.5 3.5S4.147 7.802 0 9c0 0 3.809 1.385 4.5 5.5zM10.752 7.2c.491-2.963 3.148-3.655 3.148-3.655C10.951 2.683 10.722 0 10.722 0h-.044s-.23 2.683-3.178 3.545c0 0 2.691.692 3.182 3.655h.07zM12.54 15.625C12.926 13.31 15 12.77 15 12.77c-2.304-.674-2.483-2.77-2.483-2.77h-.034s-.18 2.096-2.483 2.77c0 0 2.102.54 2.486 2.855h.055z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCleanDoneS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.59 19c.845-4.938 5.41-6.09 5.41-6.09C7.932 11.471 7.538 7 7.538 7h-.075S7.068 11.472 2 12.91c0 0 4.625 1.152 5.47 6.09h.12zM18.065 22C18.68 18.297 22 17.431 22 17.431 18.314 16.354 18.027 13 18.027 13h-.054s-.287 3.354-3.973 4.431c0 0 3.364.866 3.978 4.569h.087zM16.065 11C16.68 7.297 20 6.431 20 6.431 16.314 5.354 16.027 2 16.027 2h-.054S15.686 5.354 12 6.431c0 0 3.364.866 3.978 4.569h.087z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCleanReviewS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_CleanReview_S24_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9 2.3a1 1 0 00-1 1V8H3.2a1 1 0 00-1 1v5.574a1 1 0 001 1h4.7v5.202a1 1 0 001 1h5.574a1 1 0 001-1v-5.202h5.201a1 1 0 001-1V9a1 1 0 00-1-1h-5.201V3.3a1 1 0 00-1-1H8.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.9 8v1.5h1.5V8H7.9zM3.2 8V6.5 8zm-1 1H.7h1.5zm0 5.574H.7h1.5zm5.7 1h1.5v-1.5H7.9v1.5zm7.574 0v-1.5h-1.5v1.5h1.5zM20.675 8v1.5V8zm-5.201 0h-1.5v1.5h1.5V8zM9.4 3.3a.5.5 0 01-.5.5v-3a2.5 2.5 0 00-2.5 2.5h3zm0 4.7V3.3h-3V8h3zM3.2 9.5h4.7v-3H3.2v3zm.5-.5a.5.5 0 01-.5.5v-3A2.5 2.5 0 00.7 9h3zm0 5.574V9h-3v5.574h3zm-.5-.5a.5.5 0 01.5.5h-3a2.5 2.5 0 002.5 2.5v-3zm4.7 0H3.2v3h4.7v-3zm1.5 6.702v-5.202h-3v5.202h3zm-.5-.5a.5.5 0 01.5.5h-3a2.5 2.5 0 002.5 2.5v-3zm5.574 0H8.9v3h5.574v-3zm-.5.5a.5.5 0 01.5-.5v3a2.5 2.5 0 002.5-2.5h-3zm0-5.202v5.202h3v-5.202h-3zm6.701-1.5h-5.201v3h5.201v-3zm-.5.5a.5.5 0 01.5-.5v3a2.5 2.5 0 002.5-2.5h-3zm0-5.574v5.574h3V9h-3zm.5.5a.5.5 0 01-.5-.5h3a2.5 2.5 0 00-2.5-2.5v3zm-5.201 0h5.201v-3h-5.201v3zm-1.5-6.2V8h3V3.3h-3zm.5.5a.5.5 0 01-.5-.5h3a2.5 2.5 0 00-2.5-2.5v3zM8.9 3.8h5.574v-3H8.9v3z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_CleanReview_S24_svg__a)"
  }));
}

function SvgIcCleaningS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.752 10.02l-9.494 9.494 1.518 1.518 9.494-9.494c.022-.022.091-.109.066-.336-.026-.232-.152-.54-.43-.819-.279-.278-.587-.404-.818-.43-.228-.025-.314.044-.337.067zm-10.555 8.433l-.014.014-1.573-1.573a.54.54 0 00-.374-.146.537.537 0 00-.372.15c-4.946 4.8-11.648 6.752-16.358 6.002a.545.545 0 00-.456.137.476.476 0 00-.147.43c.652 3.747 2.724 7.721 5.684 10.904 3.136 3.374 6.957 5.562 10.758 6.162a.525.525 0 00.564-.287l7.587-16.025a.473.473 0 00-.107-.547l-1.567-1.567.014-.015 9.494-9.494c.804-.804.642-2.27-.364-3.275-1.005-1.005-2.471-1.168-3.275-.364l-9.494 9.494zm3.633 5.782l-5.616-5.615a23.754 23.754 0 01-1.89 1.524l6.409 6.409 1.097-2.318zm-1.779 3.757l-6.991-6.991c-4.054 2.564-8.595 3.746-12.388 3.53.387 1.455.995 2.939 1.791 4.379a37.517 37.517 0 002.099-.808c1.43-.6 3.023-1.383 3.952-2.173a.75.75 0 01.972 1.142c-1.122.955-2.908 1.811-4.344 2.414-.731.307-1.396.558-1.878.732l-.014.005a22.797 22.797 0 001.752 2.359l.007-.003.006-.003.024-.01.097-.042c.086-.039.213-.096.371-.17.318-.151.761-.371 1.26-.65 1.012-.563 2.207-1.338 3.07-2.226a.75.75 0 011.075 1.046c-1.014 1.042-2.357 1.902-3.414 2.49-.535.298-1.008.534-1.35.695l-.084.04c2.67 2.735 5.772 4.52 8.814 5.173l5.173-10.929z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCompanyS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5 12.5h-9a.5.5 0 00-.5.5v2.5h10V13a.5.5 0 00-.5-.5zm2 3V13a2 2 0 00-2-2h-9a2 2 0 00-2 2v2.5H13a2 2 0 00-2 2V34a2 2 0 002 2h24a2 2 0 002-2V17.5a2 2 0 00-2-2h-5.5zm6 5.711V17.5a.5.5 0 00-.5-.5H13a.5.5 0 00-.5.5v3.711l11.786 3.511a2.5 2.5 0 001.428 0L37.5 21.211zm-25 1.565l11.358 3.384a4 4 0 002.284 0L37.5 22.776V34a.5.5 0 01-.5.5H13a.5.5 0 01-.5-.5V22.776z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCompletionS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.654 7.756a.75.75 0 00-.897-.24l-1.257.54-1.257-.54a.75.75 0 00-.897.24l-.818 1.096-1.359.16a.75.75 0 00-.656.657l-.161 1.359-1.096.818a.75.75 0 00-.24.897l.54 1.257-.54 1.257a.75.75 0 00.24.897l1.096.819.16 1.358c.017.138.07.265.15.37l-1.833 5.043a.75.75 0 00.907.978l2.33-.653 1.467 1.814a.75.75 0 001.288-.217l.755-2.083.865 2.112a.75.75 0 001.267.2l1.583-1.87 2.416.415a.75.75 0 00.813-1.043l-2.12-4.793a.748.748 0 00.087-.273l.161-1.358 1.096-.819a.75.75 0 00.24-.897L35.445 14l.54-1.257a.75.75 0 00-.24-.897l-1.096-.818-.16-1.359a.75.75 0 00-.657-.656l-1.359-.161-.818-1.096zm1.32 11.333l-.502.06-.818 1.095a.75.75 0 01-.897.24l-1.257-.54-1.257.54a.75.75 0 01-.897-.24l-.818-1.096-.414-.049-1.376 3.784 1.397-.392a.75.75 0 01.786.25l.943 1.165.965-2.662a.75.75 0 011.399-.028l1.133 2.767 1.062-1.255a.75.75 0 01.7-.254l1.459.25-1.608-3.635zm-5.437-9.081l.657-.88 1.01.433a.75.75 0 00.592 0l1.01-.434.657.88a.75.75 0 00.513.297l1.091.129.13 1.091a.75.75 0 00.296.513l.88.657-.434 1.01a.75.75 0 000 .592l.434 1.01-.88.658a.75.75 0 00-.296.512l-.13 1.092-1.091.129a.75.75 0 00-.513.296l-.657.88-1.01-.434a.75.75 0 00-.592 0l-1.01.434-.657-.88a.75.75 0 00-.513-.296l-1.091-.13-.13-1.09a.75.75 0 00-.296-.514l-.88-.657.434-1.01a.75.75 0 000-.592l-.434-1.01.88-.657a.75.75 0 00.296-.513l.13-1.091 1.091-.13a.75.75 0 00.513-.295zM10 14.75c-.69 0-1.25.56-1.25 1.25v20c0 .69.56 1.25 1.25 1.25h28c.69 0 1.25-.56 1.25-1.25V16c0-.69-.56-1.25-1.25-1.25h-.5a.75.75 0 010-1.5h.5A2.75 2.75 0 0140.75 16v20A2.75 2.75 0 0138 38.75H10A2.75 2.75 0 017.25 36V16A2.75 2.75 0 0110 13.25h11.5a.75.75 0 010 1.5H10zm4 6a.75.75 0 000 1.5h6a.75.75 0 000-1.5h-6zm-.75 5.75a.75.75 0 01.75-.75h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75zm.75 4.25a.75.75 0 000 1.5h20a.75.75 0 000-1.5H14z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCouponTypeAS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4.5a2 2 0 00-2 2V10a2 2 0 110 4v3.5a2 2 0 002 2h16a2 2 0 002-2V14a2 2 0 110-4V6.5a2 2 0 00-2-2H4zm8.132 11.018c-1.865 0-2.896-1.143-2.896-3.145v-.722c0-1.92 1.06-3.067 2.896-3.067.869 0 1.64.264 2.119.728.322.313.518.693.518.996 0 .39-.269.65-.66.65-.258 0-.449-.098-.703-.357-.366-.45-.708-.654-1.177-.654-.878 0-1.377.65-1.377 1.777v.576c0 1.201.489 1.85 1.377 1.85.474 0 .855-.204 1.202-.644.259-.268.434-.361.683-.361.396 0 .664.264.664.65 0 .385-.263.815-.688 1.132-.479.371-1.152.591-1.958.591z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcCouponTypeAS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 14.75c-.69 0-1.25.56-1.25 1.25v16c0 .69.56 1.25 1.25 1.25h17.033c.223 0 .442-.061.632-.177l1.834-1.117c.037-.023.075-.044.112-.063a.747.747 0 01-.111-.393v-.453a.75.75 0 011.5 0v.453c0 .134-.035.26-.097.369.508.23.888.735.888 1.374v.002s0 .002.002.003l.002.001h.001l.002.001h5.202c.69 0 1.25-.56 1.25-1.25V16c0-.69-.56-1.25-1.25-1.25h-5.077a.132.132 0 00-.133.132c0 .758-.473 1.314-1.071 1.533a.749.749 0 01.281.585v.453a.75.75 0 01-1.5 0V17c0-.211.087-.402.227-.538a1.617 1.617 0 01-.774-.48l-.926-1.015a.664.664 0 00-.49-.217H10.75zM8 16a2.75 2.75 0 012.75-2.75h17.536c.609 0 1.19.256 1.6.706l.925 1.015c.028.03.05.04.067.042.02.005.048.004.078-.008a.141.141 0 00.064-.047.122.122 0 00.02-.076c0-.901.731-1.632 1.633-1.632h5.077A2.75 2.75 0 0140.5 16v16a2.75 2.75 0 01-2.75 2.75H32.547a1.507 1.507 0 01-1.506-1.507v-.004l-.004-.003a.024.024 0 00-.004-.001l-.004.002-1.834 1.117a2.714 2.714 0 01-1.412.396H10.75A2.75 2.75 0 018 32V16zm23 3.422a.75.75 0 01.75.75v.906a.75.75 0 01-1.5 0v-.906a.75.75 0 01.75-.75zm0 3.625a.75.75 0 01.75.75v.906a.75.75 0 01-1.5 0v-.906a.75.75 0 01.75-.75zm0 3.625a.75.75 0 01.75.75v.906a.75.75 0 01-1.5 0v-.906a.75.75 0 01.75-.75zm-15.3 1.135c-.018-.164.034-.358.216-.586l2.965-3.727 2.607-3.41c.323-.422.703-.398.973-.2.146.106.24.247.252.41.012.165-.053.358-.223.57l-2.595 3.269-2.977 3.861c-.34.44-.727.387-.978.194a.6.6 0 01-.24-.381zm.796-3.856c-1.107 0-1.84-.773-1.84-1.94v-.21c0-1.149.75-1.922 1.875-1.922 1.12 0 1.84.756 1.84 1.922v.21c0 1.143-.767 1.94-1.875 1.94zm.018-2.906c-.31 0-.487.293-.487.82v.088c0 .522.182.832.487.832.299 0 .474-.31.474-.832v-.088c0-.521-.17-.82-.474-.82zm5.449 7.09c-1.108 0-1.84-.774-1.84-1.94v-.21c0-1.15.75-1.922 1.875-1.922 1.12 0 1.84.755 1.84 1.921v.211c0 1.143-.768 1.94-1.875 1.94zm.017-2.907c-.31 0-.486.293-.486.82v.089c0 .521.182.832.486.832.3 0 .475-.31.475-.832v-.088c0-.522-.17-.82-.474-.82z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCouponTypeBS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 7a2 2 0 012-2h11.41a2 2 0 011.209.406l1.416 1.073c.167-.843.91-1.479 1.803-1.479H20.5a2 2 0 012 2v10a2 2 0 01-2 2h-1.162a1.839 1.839 0 01-1.696-1.129c-.102.07-.21.133-.327.184l-1.727.771a2 2 0 01-.815.174H3.5a2 2 0 01-2-2V7zm4.864 8.499c-.015-.132.03-.288.171-.469l2.456-3.1 2.192-2.862c.245-.327.542-.312.757-.166.127.083.21.2.215.342.01.132-.039.283-.17.45l-2.179 2.758-2.47 3.203c-.259.337-.562.303-.762.156a.446.446 0 01-.21-.312zm.664-3.237c-.908 0-1.504-.645-1.504-1.612v-.175c0-.958.61-1.597 1.533-1.597.923 0 1.51.63 1.51 1.597v.175c0 .943-.62 1.612-1.539 1.612zm.015-2.447c-.259 0-.41.25-.41.708v.083c0 .454.156.718.41.718s.405-.264.405-.718v-.083c0-.454-.146-.708-.405-.708zm4.482 5.953c-.913 0-1.504-.645-1.504-1.612v-.176c0-.952.61-1.596 1.534-1.596.918 0 1.503.63 1.503 1.596v.176c0 .947-.62 1.611-1.533 1.611zm.015-2.447c-.264 0-.415.25-.415.708v.083c0 .454.156.718.415.718.254 0 .405-.264.405-.718v-.083c0-.454-.146-.708-.405-.708zM17.546 8a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5zm0 3a.5.5 0 01.5.5v1a.5.5 0 11-1 0v-1a.5.5 0 01.5-.5zm.5 3.5a.5.5 0 10-1 0v1a.5.5 0 001 0v-1z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcCouponTypeBS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.123 28.896c-.257.324-.332.598-.307.83.033.233.174.407.34.54.357.274.905.348 1.387-.274l4.216-5.47 3.678-4.632c.24-.3.332-.573.315-.806-.016-.232-.15-.431-.357-.58-.382-.283-.921-.316-1.378.282l-3.694 4.83-4.2 5.28zm-1.784-7.38c0 1.653 1.037 2.748 2.606 2.748s2.656-1.129 2.656-2.747v-.3c0-1.651-1.02-2.722-2.606-2.722-1.594 0-2.656 1.096-2.656 2.723v.299zm1.942-.207c0-.747.249-1.162.689-1.162.432 0 .672.423.672 1.162v.125c0 .738-.249 1.178-.672 1.178-.432 0-.689-.44-.689-1.178v-.125zm5.802 6.134c0 1.652 1.038 2.748 2.607 2.748 1.569 0 2.656-1.129 2.656-2.748v-.299c0-1.651-1.021-2.722-2.607-2.722-1.593 0-2.656 1.096-2.656 2.723v.298zm1.943-.207c0-.747.249-1.162.689-1.162.431 0 .672.423.672 1.162v.124c0 .74-.25 1.18-.672 1.18-.432 0-.69-.44-.69-1.18v-.124z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 35.25h-4.823l-1.842-.92L33 34.16l-.335.168-1.842.921H8A3.25 3.25 0 014.75 32V16A3.25 3.25 0 018 12.75h22.823l1.842.92.335.168.335-.167 1.842-.921H40A3.25 3.25 0 0143.25 16v16A3.25 3.25 0 0140 35.25z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 14v20",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 3"
  }));
}

function SvgIcCycleEnabledCheckedS20(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zm-4.952-2.488a.75.75 0 10-1.096-1.024l-5.087 5.45-1.852-1.735a.75.75 0 00-1.026 1.094l2.4 2.25a.75.75 0 001.061-.035l5.6-6z",
    fill: "#00BED6"
  }));
}

function SvgIcDatechangeS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.75 10.5a.75.75 0 00-1.5 0V12H13a2 2 0 00-2 2v21a2 2 0 002 2h14.752a8.446 8.446 0 01-.515-1.5H13a.5.5 0 01-.5-.5V20h23v5c.512 0 1.013.045 1.5.132V14a2 2 0 00-2-2h-4.25v-1.5a.75.75 0 00-1.5 0V12h-10.5v-1.5zm12.925 15.407a2 2 0 10-3.03 2.565 8.538 8.538 0 013.03-2.565zM29.25 15v-1.5h-10.5V15a.75.75 0 01-1.5 0v-1.5H13a.5.5 0 00-.5.5v4.5h23V14a.5.5 0 00-.5-.5h-4.25V15a.75.75 0 01-1.5 0zM20 27a2 2 0 11-4 0 2 2 0 014 0zm4 2a2 2 0 100-4 2 2 0 000 4z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 33.5,
    r: 7.75,
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.178 31.28a.75.75 0 10-1.06-1.06l-1.898 1.896a.75.75 0 00.53 1.28h5.216a.75.75 0 000-1.5h-3.404l.616-.616zm.36 4.837a.75.75 0 001.06 1.061l1.898-1.897a.75.75 0 00-.53-1.28H32.75a.75.75 0 100 1.5h3.405l-.617.616z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcDeleteS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM4.72 4.72a.75.75 0 000 1.06l2.22 2.221-2.22 2.22a.75.75 0 101.061 1.06l2.22-2.22 2.22 2.22a.75.75 0 101.06-1.06l-2.22-2.22 2.222-2.22a.75.75 0 00-1.061-1.061l-2.22 2.22L5.78 4.72a.75.75 0 00-1.06 0z",
    fill: "#000",
    fillOpacity: 0.4
  }));
}

function SvgIcDeliverB85S16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.818 5.09h-2.182V2.183H1.455C.655 2.182 0 2.836 0 3.636v8h1.455c0 1.208.974 2.182 2.181 2.182a2.179 2.179 0 002.182-2.182h4.364c0 1.208.974 2.182 2.182 2.182a2.179 2.179 0 002.181-2.182H16V8l-2.182-2.91zM3.636 12.728a1.09 1.09 0 01-1.09-1.09 1.09 1.09 0 112.182 0 1.09 1.09 0 01-1.092 1.09zm9.819-6.545L14.88 8h-3.244V6.182h1.819zm-1.091 6.545a1.09 1.09 0 01-1.091-1.09 1.09 1.09 0 112.182 0 1.09 1.09 0 01-1.091 1.09z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcDeliverB80S24V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.636 8.181h-2.863V4.363H3.409c-1.05 0-1.909.86-1.909 1.91v10.5h1.91a2.86 2.86 0 002.863 2.863 2.86 2.86 0 002.863-2.864h5.728a2.86 2.86 0 002.863 2.864 2.86 2.86 0 002.864-2.864H22.5V12L19.636 8.18zM6.273 18.204a1.43 1.43 0 01-1.432-1.432c0-.792.64-1.431 1.432-1.431.792 0 1.432.64 1.432 1.431a1.43 1.43 0 01-1.432 1.432zm12.886-8.59L21.03 12h-4.257V9.613h2.386zm-1.432 8.59a1.43 1.43 0 01-1.431-1.432c0-.792.639-1.431 1.431-1.431.793 0 1.432.64 1.432 1.431a1.43 1.43 0 01-1.432 1.432z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcDoIroningDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.01 12.282a.75.75 0 01.78-.718l15.303.65h.002a1.772 1.772 0 011.69 1.54l1.448 8.758 1.937 11.32A1 1 0 0139.185 35H7.78a.51.51 0 01-.468-.715A25.527 25.527 0 0130.695 19h5.437l-.83-5.016-.002-.016-.002-.016a.272.272 0 00-.26-.24h-.004l-15.307-.65a.75.75 0 01-.718-.78zm17.823 10.962l-.08-.483-.387-2.261h-5.67a24.029 24.029 0 00-18.525 8.724H37.86l-1.012-5.912a.766.766 0 01-.015-.068zm1.284 7.48h-27.09c-.616.88-1.178 1.806-1.679 2.776h29.244l-.475-2.776zM31 27a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "#D8D8D8"
  }));
}

function SvgIcDoIroningS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35 5.078a.75.75 0 01.782-.718l10.453.444h.002a1.448 1.448 0 011.38 1.254l1.043 6.313.003.015.002.015 1.384 8.014a.5.5 0 01-.493.585H1.261a.5.5 0 01-.459-.698l2.37-5.479A8 8 0 0110.515 10h9.583l-.611-3.7L9.068 5.86a.75.75 0 01-.717-.781zM20.338 11.5h-9.822a6.5 6.5 0 00-5.966 3.919l-.242.559H21.11l-.773-4.478zm1.032 5.978H3.66L2.782 19.5H21.72l-.35-2.022zm-5.893-2.385a1 1 0 100-2 1 1 0 000 2zm-2.757-1a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "#262626"
  }));
}

function SvgIcDoIroningS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.01 12.282a.75.75 0 01.78-.718l15.303.65h.002a1.772 1.772 0 011.69 1.54l1.448 8.758 1.937 11.32A1 1 0 0139.185 35H8.53a1 1 0 01-.916-1.401l2.723-6.216A14 14 0 0123.16 19h12.972l-.83-5.016-.002-.016-.002-.016a.272.272 0 00-.26-.24h-.004l-15.307-.65a.75.75 0 01-.718-.78zm17.823 10.962l-.08-.483-.387-2.261H23.16a12.5 12.5 0 00-11.45 7.485l-.542 1.239H37.86l-1.012-5.912a.766.766 0 01-.015-.068zm1.284 7.48H10.51L9.295 33.5h29.297l-.475-2.776zM29 27a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-4-1.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "#262626"
  }));
}

function SvgIcDoWashingDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 9.75,
    width: 24.5,
    height: 28.5,
    rx: 1.25,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.437s3.991-3.07 7.642-.234c1.445 1.122 2.057 1.502 3.71 1.502 1.652 0 3.648-1.16 3.648-1.16",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 28a7.25 7.25 0 11-14.5 0 7.25 7.25 0 0114.5 0z",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.701 30.363s.82 2.072 3.264 2.607",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM32 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#D8D8D8"
  }));
}

function SvgIcDoWashingS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 26,
    height: 30,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 9.75,
    width: 24.5,
    height: 28.5,
    rx: 2.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 28.437s3.991-3.07 7.642-.234c1.445 1.122 2.057 1.502 3.71 1.502 1.652 0 3.648-1.16 3.648-1.16",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.25 28a7.25 7.25 0 11-14.5 0 7.25 7.25 0 0114.5 0z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.701 30.363s.82 2.072 3.264 2.607",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM32 15a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcDot3S16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.5,
    fill: "#000",
    fillOpacity: 0.6
  }));
}

function SvgIcDowashingS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2,
    width: 18,
    height: 20,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 2.75,
    width: 16.5,
    height: 18.5,
    rx: 2.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.19 15.441a3.5 3.5 0 01-6.65-.908c.178-.085.393-.171.632-.237.67-.185 1.482-.199 2.265.39.399.3.757.561 1.158.73.427.18.853.239 1.377.239a4.11 4.11 0 001.219-.214zm.298-1.736c-.105.052-.251.12-.42.187-.37.147-.776.263-1.096.263-.404 0-.614-.045-.794-.121-.206-.087-.426-.235-.839-.546-1.267-.953-2.601-.903-3.565-.638l-.09.025a3.502 3.502 0 016.804.83zM12 19a5 5 0 100-10 5 5 0 000 10zM14.5 7a1 1 0 100-2 1 1 0 000 2zM17 7a1 1 0 100-2 1 1 0 000 2z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcDownloadS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25.75a.75.75 0 011.5 0v7.463l2.72-2.71a.75.75 0 011.06 1.064L8.546 10.53a.75.75 0 01-1.058 0l-4.018-4a.75.75 0 011.058-1.063l2.721 2.71V.75zm-6.5 13.5a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H.75z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcEditS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.591 3.755c.26.26.26.68 0 .94l-1.22 1.22-2.5-2.5 1.22-1.22c.26-.26.68-.26.94 0l1.56 1.56zM2 14v-2.5l7.372-7.372 2.5 2.5L4.5 14H2z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcEventS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.77 3.43a.25.25 0 01.46 0l1.82 4.228a1.75 1.75 0 001.446 1.05l4.584.425a.25.25 0 01.142.437l-3.459 3.038a1.75 1.75 0 00-.552 1.7l1.012 4.49a.25.25 0 01-.371.27l-3.959-2.35a1.75 1.75 0 00-1.787 0l-3.958 2.35a.25.25 0 01-.371-.27l1.012-4.49a1.75 1.75 0 00-.552-1.7l-.495.564.495-.564-3.46-3.038a.25.25 0 01.143-.437l4.584-.425a1.75 1.75 0 001.446-1.05l1.82-4.229z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcEventS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M23.77 10.43a.25.25 0 01.46 0l3.443 7.995a1.75 1.75 0 001.446 1.05l8.667.804a.25.25 0 01.142.437l-6.54 5.745a1.75 1.75 0 00-.552 1.7l1.914 8.492a.25.25 0 01-.371.27l-7.485-4.445a1.75 1.75 0 00-1.787 0l-7.486 4.445a.25.25 0 01-.371-.27l1.914-8.492a1.75 1.75 0 00-.552-1.7l-6.54-5.745a.25.25 0 01.142-.437l8.667-.804a1.75 1.75 0 001.446-1.05l3.443-7.996z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcExchangeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.033 3.03a.75.75 0 00-1.06-1.06l-4.003 4a.75.75 0 00.53 1.28h11a.75.75 0 000-1.5H4.312l2.721-2.72zm1.934 9.94a.75.75 0 101.06 1.06l4.003-4a.75.75 0 00-.53-1.28h-11a.75.75 0 100 1.5h9.188l-2.721 2.72z",
    fill: "#42484C"
  }));
}

function SvgIcFastReviewS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.716 9.625h4.575L9.698 21.489c-.059.072-.11.09-.146.096a.27.27 0 01-.166-.032.27.27 0 01-.12-.12c-.016-.034-.029-.086-.002-.175l2.387-7.726.3-.97H6.698l4.703-9.682a.25.25 0 01.225-.141h5.877c.2 0 .319.224.206.39l-3.613 5.325-.795 1.171h1.415z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcFavoriteS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 2a2 2 0 012-2h8a2 2 0 012 2v12.333a1 1 0 01-1.47.883L8.47 13.05a1 1 0 00-.94 0l-4.06 2.165A1 1 0 012 14.333V2z",
    fill: "#00BED6"
  }));
}

function SvgIcFavoriteStrokeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 2c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v12.333a.25.25 0 01-.368.22L8.824 12.39a1.75 1.75 0 00-1.648 0l-4.058 2.165a.25.25 0 01-.368-.22V2z",
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 1.5
  }));
}

function SvgIcFoodwasteS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 19s.59 1.317 1.854 1.137c2.57-.29 5.104-3.981 5.104-3.981s2.245-2.968 2.027-6.19c-.218-3.223-3.076-5.069-5.428-4.962-2.12.1-3.242 2.31-3.444 2.52a.195.195 0 00-.047.08L12 7.812l-.068-.208a.189.189 0 00-.046-.079c-.2-.208-1.32-2.421-3.441-2.519-2.354-.109-5.212 1.736-5.43 4.957-.218 3.221 2.027 6.19 2.027 6.19s2.534 3.693 5.104 3.982c1.266.18 1.835-1.137 1.835-1.137H12V19z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 12.596,
    rx: 1,
    ry: 2,
    transform: "rotate(-10 10 12.596)",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.332,
    cy: 12.596,
    rx: 1,
    ry: 2,
    transform: "rotate(10 14.332 12.596)",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7V4c0-1 .8-3 2-3",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcFriendRecommandS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12.5c2.197 0 4 1.803 4 4s-1.803 4-4 4-4-1.803-4-4 1.803-4 4-4zm5.5 4c0-3.025-2.475-5.5-5.5-5.5s-5.5 2.475-5.5 5.5S17.975 22 21 22s5.5-2.475 5.5-5.5zM10.75 31.716c0-1.65 1.136-3.51 3.083-4.996 1.925-1.47 4.518-2.47 7.167-2.47 1.413 0 2.813.284 4.106.775a.75.75 0 00.533-1.402A13.119 13.119 0 0021 22.75c-3.01 0-5.917 1.13-8.077 2.778-2.139 1.632-3.673 3.882-3.673 6.188v1.781A2.752 2.752 0 0012 36.25v-.75l.001.75H22.5a.75.75 0 000-1.5H12.001v.75-.75c-.69 0-1.251-.56-1.251-1.253v-1.781zM31 37.5a6 6 0 100-12 6 6 0 000 12zm7.5-6a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0zm-7.471-2.532a.75.75 0 00-1.058 1.064l1.503 1.494-1.493 1.433a.75.75 0 001.038 1.082l2.047-1.964a.75.75 0 00.01-1.073l-2.047-2.036z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcGiftS24V001(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.88 7.2v-.003a.024.024 0 000 .003zm-3.103-.767a1.367 1.367 0 011.71-2.134c.369.296.89.994 1.196 1.776.093.237.153.45.187.63-.287.015-.611.026-.948.025a9.303 9.303 0 01-1.488-.106 3.08 3.08 0 01-.506-.124c-.1-.035-.143-.062-.15-.067zm4.264-1.003c.384-.933 1.02-1.824 1.617-2.302a2.867 2.867 0 013.58 4.479c-1.178.942-4.852.548-5.197.508-.345.04-4.02.434-5.198-.508a2.867 2.867 0 013.58-4.48c.598.479 1.233 1.37 1.618 2.303zm1.161 1.77l-.001-.003a.024.024 0 01.001.003zm3.102-.767h.001a1.367 1.367 0 00-1.71-2.134c-.37.296-.89.994-1.197 1.776-.093.237-.153.45-.186.63.286.015.61.026.947.025a9.303 9.303 0 001.489-.106c.215-.037.383-.08.506-.124.099-.035.142-.062.15-.067z",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.329,
    y: 9.619,
    width: 15.342,
    height: 11.131,
    rx: 1.25,
    fill: "#222",
    stroke: "#222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.926 8.062c0-.69.56-1.25 1.25-1.25h15.648c.69 0 1.25.56 1.25 1.25v1.614c0 .69-.56 1.25-1.25 1.25H4.176c-.69 0-1.25-.56-1.25-1.25V8.062z",
    fill: "#222",
    stroke: "#222",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    d: "M12.224 6.23V21.5M3.579 12.342h16.842"
  }));
}

function SvgIcGuidebookS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.77 33.425l.007-17.812.431-.551c1.179-1.506 3.07-2.157 5.121-2.328 1.64-.137 3.214.05 4.233.23v18.633a20.513 20.513 0 00-4.163-.044c-1.805.177-3.867.67-5.628 1.872zm-1.5-.017l.007-17.791-.434-.56c-1.177-1.513-3.066-2.165-5.117-2.334-1.64-.135-3.215.056-4.234.237v18.634a20.456 20.456 0 014.17-.048c1.8.175 3.853.667 5.609 1.862zm2.661 1.052c3.098-1.897 7.355-1.55 9.208-1.278.476.07.923-.294.923-.776V17.205h.688a.75.75 0 01.75.75v16.575a.75.75 0 01-.807.747l-10.762-.816zm10.13-18.756h.689a2.25 2.25 0 012.25 2.25v16.575a2.25 2.25 0 01-2.42 2.243l-12.534-.95a.24.24 0 00-.038 0l-12.533.95a2.25 2.25 0 01-2.42-2.243V17.954a2.25 2.25 0 012.25-2.25h.687V12.32a.71.71 0 01.554-.702c1.728-.375 7.102-1.252 10.424 1.44.382.31.738.668 1.057 1.08.32-.41.677-.767 1.061-1.076 3.324-2.676 8.689-1.814 10.418-1.443a.71.71 0 01.556.703v3.382zm-24.069 1.5v15.201c0 .482.448.847.925.776 1.856-.276 6.124-.63 9.217 1.278l-10.773.817a.75.75 0 01-.807-.747V17.954a.75.75 0 01.75-.75h.688zm4.173.584c.781-.073 1.745-.06 3.026.238.587.137 1.052.335 1.33.567a.75.75 0 10.96-1.152c-.54-.45-1.268-.717-1.95-.876-1.448-.338-2.574-.358-3.506-.27a.75.75 0 10.14 1.493zm3.026 5.161c-1.28-.299-2.245-.31-3.026-.238a.75.75 0 11-.14-1.493c.932-.087 2.058-.067 3.506.27.682.16 1.41.426 1.95.876a.75.75 0 01-.96 1.153c-.278-.233-.744-.43-1.33-.568zm-3.026 4.686c.781-.074 1.745-.061 3.026.237.587.137 1.052.336 1.33.568a.75.75 0 10.96-1.152c-.54-.45-1.268-.717-1.95-.876-1.448-.338-2.574-.358-3.506-.27a.75.75 0 00.14 1.493zm12.699-9.609c1.28-.299 2.244-.311 3.025-.238a.75.75 0 00.14-1.493c-.931-.088-2.058-.068-3.506.27-.682.16-1.41.426-1.95.876a.75.75 0 10.96 1.152c.279-.232.744-.43 1.33-.567zm3.025 4.685c-.781-.073-1.745-.06-3.025.238-.587.137-1.052.335-1.331.568a.75.75 0 01-.96-1.153c.54-.45 1.268-.716 1.95-.876 1.448-.337 2.575-.357 3.506-.27a.75.75 0 11-.14 1.493zm-3.025 5.162c1.28-.3 2.244-.312 3.025-.238a.75.75 0 00.14-1.494c-.931-.087-2.058-.067-3.506.27-.682.16-1.41.427-1.95.877a.75.75 0 10.96 1.152c.279-.232.744-.43 1.33-.568z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcHeartReviewS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.099 11.018l.033.06c.246.437.563.884.962 1.333 1.313 1.477 4.465 4.514 6.581 6.552l.029.027.004.004v.001h.001l.004.004.859.828c.181.175.468.18.655.013l1.427-1.354-2.723-2.677a.75.75 0 111.052-1.07l2.76 2.715 1.153-1.093-2.625-2.68a.75.75 0 011.071-1.05l2.643 2.698 1.66-1.575-3.092-3.174-1.229-1.254-2.127 2.005c-.133.158-.284.3-.449.424l-.08.076-.048.014a2.764 2.764 0 01-3.478-4.264l.01-.015 2.405-2.182A4.67 4.67 0 007.145 3.67C4.558 3.55 2.37 5.544 2.25 8.113a4.621 4.621 0 00.811 2.85l.039.055zm8.575-6.638a6.17 6.17 0 00-4.46-2.208C3.805 2.014.91 4.642.75 8.042a6.121 6.121 0 001.074 3.77 9.167 9.167 0 001.15 1.596c1.368 1.539 4.598 4.649 6.69 6.662l.003.004.001.001.862.83a1.982 1.982 0 002.718.034l6.445-6.11.86-.817c1.88-1.622 2.61-3.485 2.695-5.197.088-1.755-.552-3.313-1.346-4.257-1.806-2.144-3.983-2.621-5.957-2.27-1.703.305-3.227 1.215-4.271 2.092zm4.952 5.151l3.124 3.189c1.433-1.31 1.938-2.726 2-3.98.069-1.367-.44-2.555-.996-3.216-1.429-1.696-3.05-2.025-4.545-1.759-1.54.275-2.97 1.191-3.868 2.026l-.007.007-.007.006-3.074 2.788-.056.055a1.264 1.264 0 001.59 1.95l.03-.02.03-.021a1.28 1.28 0 00.206-.195l.054-.064.061-.057 2.127-2.006 1.07-1.009.876.893.004-.004 1.38 1.417z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcHeartfillS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.073 3.302c2.86-4.672 8.982-1.537 7.77 3.757-1.185 5.18-7.77 7.92-7.77 7.92s-6.735-2.74-7.92-7.92c-1.211-5.294 5.059-8.429 7.92-3.757z",
    fill: "#FF5151"
  }));
}

function SvgIcHeartstrokeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.433 3.693l.64 1.045.64-1.045c.63-1.029 1.405-1.578 2.162-1.8a3.121 3.121 0 012.277.222c1.417.703 2.49 2.458 1.96 4.776-.533 2.331-2.305 4.175-4.046 5.468a18.317 18.317 0 01-2.997 1.798A18.727 18.727 0 015 12.354C3.219 11.06 1.416 9.217.885 6.891h0c-.528-2.307.57-4.064 2.029-4.773.734-.357 1.557-.449 2.336-.224.772.223 1.555.773 2.183 1.8z",
    stroke: "#42484C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcHomeOffS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_HomeOff_S24_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9.913a2 2 0 00-.69-1.511l-7.655-6.634a1 1 0 00-1.31 0L3.69 8.402A2 2 0 003 9.913V19a1 1 0 001 1h6v-4a2 2 0 114 0v4h6.306c.383 0 .694-.311.694-.695V9.913z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 8.402l.982-1.134-.982 1.134zm-7.655-6.634L11.673 2.9l.982-1.133zm-1.31 0L10.363.634l.982 1.133zM3.69 8.402l-.982-1.134.982 1.134zM10 20v1.5h1.5V20H10zm4 0h-1.5v1.5H14V20zm5.328-10.465a.5.5 0 01.172.378h3a3.5 3.5 0 00-1.208-2.645l-1.965 2.267zm-7.655-6.634l7.655 6.634 1.964-2.267L13.637.634l-1.965 2.267zm.655 0a.5.5 0 01-.655 0L13.636.634a2.5 2.5 0 00-3.274 0l1.965 2.267zM4.673 9.535l7.655-6.634L10.363.634 2.708 7.268l1.965 2.267zm-.173.378a.5.5 0 01.173-.378L2.708 7.268A3.5 3.5 0 001.5 9.913h3zM4.5 19V9.913h-3V19h3zm-.5-.5a.5.5 0 01.5.5h-3A2.5 2.5 0 004 21.5v-3zm6 0H4v3h6v-3zM8.5 16v4h3v-4h-3zm3.5-3.5A3.5 3.5 0 008.5 16h3a.5.5 0 01.5-.5v-3zm3.5 3.5a3.5 3.5 0 00-3.5-3.5v3a.5.5 0 01.5.5h3zm0 4v-4h-3v4h3zm4.806-1.5H14v3h6.306v-3zm-.806.805c0-.444.36-.805.806-.805v3a2.194 2.194 0 002.194-2.195h-3zm0-9.392v9.392h3V9.913h-3z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_HomeOff_S24_svg__a)"
  }));
}

function SvgIcHomeOffS24V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_HomeOff_S24_V0_1_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9.913a2 2 0 00-.69-1.511l-7.655-6.634a1 1 0 00-1.31 0L3.69 8.402A2 2 0 003 9.913V19a1 1 0 001 1h6v-4a2 2 0 114 0v4h6.306c.383 0 .694-.311.694-.695V9.913z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 8.402l.982-1.134-.982 1.134zm-7.655-6.634L11.673 2.9l.982-1.133zm-1.31 0L10.363.634l.982 1.133zM3.69 8.402l.983 1.133-.983-1.133zM10 20v1.5h1.5V20H10zm4 0h-1.5v1.5H14V20zm5.328-10.465a.5.5 0 01.172.378h3a3.5 3.5 0 00-1.208-2.645l-1.965 2.267zm-7.655-6.634l7.655 6.634 1.964-2.267L13.637.634l-1.965 2.267zm.655 0a.5.5 0 01-.655 0L13.636.634a2.5 2.5 0 00-3.274 0l1.965 2.267zM4.673 9.535l7.655-6.634L10.363.634 2.708 7.268l1.965 2.267zm-.173.378a.5.5 0 01.173-.378L2.708 7.268A3.5 3.5 0 001.5 9.913h3zM4.5 19V9.913h-3V19h3zm-.5-.5a.5.5 0 01.5.5h-3A2.5 2.5 0 004 21.5v-3zm6 0H4v3h6v-3zM8.5 16v4h3v-4h-3zm3.5-3.5A3.5 3.5 0 008.5 16h3a.5.5 0 01.5-.5v-3zm3.5 3.5a3.5 3.5 0 00-3.5-3.5v3a.5.5 0 01.5.5h3zm0 4v-4h-3v4h3zm4.806-1.5H14v3h6.306v-3zm-.806.805c0-.444.36-.805.806-.805v3a2.194 2.194 0 002.194-2.195h-3zm0-9.392v9.392h3V9.913h-3z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_HomeOff_S24_V0_1_svg__a)"
  }));
}

function SvgIcHomeOnS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.841a2 2 0 00-.602-1.43L12.7 1.885a1 1 0 00-1.398 0L3.6 9.412A2 2 0 003 10.842V19a1 1 0 001 1H20.306c.383 0 .694-.31.694-.695v-8.463zM15 16v4H9v-4a3 3 0 116 0z",
    fill: "#262626"
  }));
}

function SvgIcHouseS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17.963l10.628-9.79 11.198 10.195V36.74L13 37V17.963z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19v17a1 1 0 001 1h20a1 1 0 001-1V19",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.75 28.733c0-.82.664-1.483 1.483-1.483h3.534c.82 0 1.483.664 1.483 1.483v8.017h-6.5v-8.017z",
    stroke: "#242424",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 24L22.95 9.67a1.116 1.116 0 011.492 0L40.392 24",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcHousecleanS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.207 19.969l9.732-8.795L32 20.333v3.028H12l.207-3.392z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.156 20.9v14.142c0 1.121-.885 2.03-1.976 2.03H14.367c-1.091 0-1.976-.909-1.976-2.03V20.9",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.156 20.9v14.142c0 1.121-.885 2.03-1.976 2.03H14.367c-1.091 0-1.976-.909-1.976-2.03V20.9",
    stroke: "#242424",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.43 29.871c0-.819.663-1.482 1.482-1.482h2.723c.818 0 1.482.663 1.482 1.482v6.9H19.43v-6.9z",
    stroke: "#242424",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 25.393l14.254-12.807a1.116 1.116 0 011.492 0L37 25.393",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.082 16.5C37.85 11.356 42 10.155 42 10.155 37.392 8.659 37.035 4 37.035 4h-.069S36.608 8.658 32 10.155c0 0 4.205 1.201 4.973 6.345h.109z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.35 10.822a8.322 8.322 0 00-2.325 3.122 8.313 8.313 0 00-3.237-3.761c1.577-.904 2.53-2.186 3.096-3.335.04-.083.08-.165.116-.247.037.082.076.164.117.247.566 1.15 1.521 2.436 3.104 3.34-.275.174-.57.384-.872.634z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.115 25.5C29.19 18.299 35 16.618 35 16.618 28.55 14.522 28.048 8 28.048 8h-.096S27.45 14.522 21 16.618c0 0 5.887 1.68 6.962 8.882h.153z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.115 16.65c-.491.28-1.055.65-1.634 1.132-1.27 1.056-2.608 2.642-3.444 4.95-.844-2.31-2.198-3.897-3.483-4.953a11.372 11.372 0 00-1.66-1.134c2.425-1.237 3.85-3.116 4.674-4.79.167-.34.31-.673.432-.99.122.317.265.65.432.989.826 1.678 2.253 3.56 4.683 4.796z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcInfoFilB80S16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_InfoFil_B80_S16_V0_1_svg__clip0_4812_3061)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.684a8 8 0 1116 0 8 8 0 01-16 0zM7.44 5.45a.876.876 0 00-.26.634c0 .238.084.448.253.629.168.18.378.27.63.27a.835.835 0 00.62-.263.878.878 0 00.257-.636.882.882 0 00-.255-.637.833.833 0 00-.622-.263.84.84 0 00-.623.266zm1.392 5.408V7.809L6.5 8.187v.527h.113c.274 0 .449.05.524.147.075.098.113.27.113.515v1.482c0 .242-.037.412-.11.512-.074.1-.25.15-.527.15H6.5v.664h3v-.665c-.288 0-.47-.047-.55-.142-.078-.094-.117-.267-.117-.52z",
    fill: "#000",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_InfoFil_B80_S16_V0_1_svg__clip0_4812_3061"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .684)",
    d: "M0 0h16v16H0z"
  }))));
}

function SvgIcInfoS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a8 8 0 1116 0A8 8 0 010 8zm7.441-3.234a.876.876 0 00-.26.634c0 .239.085.449.253.63.168.18.378.27.63.27a.835.835 0 00.62-.263.878.878 0 00.257-.637.882.882 0 00-.255-.636.833.833 0 00-.622-.264.84.84 0 00-.623.266zm1.392 5.408V7.126L6.5 7.504v.527h.113c.274 0 .45.049.524.147.075.097.113.269.113.514v1.482c0 .242-.037.413-.11.512-.074.1-.25.15-.527.15H6.5v.664h3v-.664c-.288 0-.47-.048-.549-.142-.078-.095-.118-.268-.118-.52z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcInfoS16G(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a8 8 0 1116 0A8 8 0 010 8zm7.441-3.234a.876.876 0 00-.26.634c0 .239.085.449.253.63.168.18.378.27.63.27a.835.835 0 00.62-.263.878.878 0 00.257-.637.882.882 0 00-.255-.636.833.833 0 00-.622-.264.84.84 0 00-.623.266zm1.392 5.408V7.126L6.5 7.504v.527h.113c.274 0 .45.049.524.147.075.097.113.269.113.514v1.482c0 .242-.037.413-.11.512-.074.1-.25.15-.527.15H6.5v.664h3v-.664c-.288 0-.47-.048-.549-.142-.078-.095-.118-.268-.118-.52z",
    fill: "#227886"
  }));
}

function SvgIcInfoS16W100(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a8 8 0 1116 0A8 8 0 010 8zm7.441-3.234a.876.876 0 00-.26.634c0 .239.085.449.253.63.168.18.378.27.63.27a.835.835 0 00.62-.263.878.878 0 00.257-.637.882.882 0 00-.255-.636.833.833 0 00-.622-.264.84.84 0 00-.623.266zm1.392 5.408V7.126L6.5 7.504v.527h.113c.274 0 .45.049.524.147.075.097.113.269.113.514v1.482c0 .242-.037.413-.11.512-.074.1-.25.15-.527.15H6.5v.664h3v-.664c-.288 0-.47-.048-.549-.142-.078-.095-.118-.268-.118-.52z",
    fill: "#fff"
  }));
}

function SvgIcInfoS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.25 24c0 8.422-6.828 15.25-15.25 15.25S8.75 32.422 8.75 24 15.578 8.75 24 8.75 39.25 15.578 39.25 24z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.363 18.8c0-.49.173-.913.52-1.268A1.679 1.679 0 0124.126 17c.49 0 .906.176 1.245.527.34.352.51.776.51 1.273 0 .497-.171.922-.514 1.273a1.67 1.67 0 01-1.24.527 1.65 1.65 0 01-1.26-.542 1.79 1.79 0 01-.505-1.258zm3.304 3.451v6.097c0 .504.078.85.235 1.04.157.189.523.283 1.098.283V31h-6v-1.329h.226c.555 0 .906-.1 1.053-.298.148-.2.221-.54.221-1.025v-2.963c0-.491-.075-.834-.226-1.03-.15-.196-.5-.293-1.049-.293H21v-1.055l4.667-.756z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcInvestigationS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 31.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19zm6.024-.294A10.948 10.948 0 0122 33c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11c0 2.224-.66 4.293-1.794 6.024l6.87 6.87a2.25 2.25 0 11-3.182 3.182l-6.87-6.87zm1.206-.915l6.725 6.725a.75.75 0 101.06-1.061l-6.724-6.725c-.33.377-.684.731-1.061 1.06zM22.189 14a7.822 7.822 0 00-6.58 3.58c-.156.24-.078.6.163.755a.57.57 0 00.757-.167 6.719 6.719 0 015.66-3.082c1.675 0 3.2.604 4.377 1.612a.57.57 0 00.8-.028.564.564 0 00-.09-.793A7.798 7.798 0 0022.188 14zm0 2.064a.566.566 0 00-.553.543c0 .287.265.547.553.543a4.63 4.63 0 014.643 4.688 14.914 14.914 0 01-.46 3.62c-.068.276.121.59.398.659a.569.569 0 00.664-.394c.317-1.25.485-2.555.488-3.902v-.096c-.03-3.123-2.592-5.66-5.733-5.66zm-1.953.379a.542.542 0 00-.221.045 5.727 5.727 0 00-3.565 5.35 4.594 4.594 0 01-1.425 3.28.564.564 0 00-.04.79.569.569 0 00.795-.01 5.684 5.684 0 001.76-4.077v-.09a4.633 4.633 0 012.89-4.236.56.56 0 00.345-.607.562.562 0 00-.539-.445zm8.033.826a.556.556 0 00-.485.287.553.553 0 00.03.56 6.649 6.649 0 011.096 3.631v.034a17.039 17.039 0 01-.34 3.382.567.567 0 00.428.644.569.569 0 00.644-.429c.233-1.149.355-2.336.358-3.551V21.725a7.736 7.736 0 00-1.272-4.202.556.556 0 00-.46-.254zm-6.08.865c-1.995 0-3.63 1.61-3.662 3.59a.297.297 0 000 .057 6.657 6.657 0 01-.267 1.877.565.565 0 00.361.702.568.568 0 00.684-.396c.2-.68.309-1.4.312-2.143v-.09a2.562 2.562 0 012.572-2.511c.91 0 1.7.47 2.157 1.176a.57.57 0 00.759.163.566.566 0 00.16-.757 3.663 3.663 0 00-3.076-1.668zm-6.977 1.018a.56.56 0 00-.51.396 7.75 7.75 0 00-.324 2.194v.039a2.523 2.523 0 01-.3 1.199c-.161.252-.06.63.203.77.264.14.635.012.755-.26.267-.5.425-1.067.432-1.669v-.09c.004-.652.1-1.28.278-1.872.104-.329-.188-.716-.534-.707zm6.977 1.052a1.59 1.59 0 00-1.584 1.577.565.565 0 00.545.55.566.566 0 00.545-.55c0-.277.215-.492.494-.492s.494.215.494.492a10.767 10.767 0 01-.692 3.806.563.563 0 00.32.697c.267.099.6-.052.701-.318.486-1.291.756-2.687.76-4.145v-.102a1.593 1.593 0 00-1.583-1.516zm3.105 1.023a.565.565 0 00-.54.554c0 2.747-.86 5.283-2.327 7.375a.563.563 0 00.135.759c.222.151.6.098.762-.137a13.876 13.876 0 002.52-7.997.566.566 0 00-.55-.554zm-4.292 1.488a.562.562 0 00-.51.463 8.726 8.726 0 01-2.566 4.898.564.564 0 00-.04.79.57.57 0 00.795-.01 9.812 9.812 0 002.89-5.502c.058-.322-.24-.658-.569-.64zm-2.997 2.239a.555.555 0 00-.431.271 6.722 6.722 0 01-1.306 1.561.563.563 0 00-.054.771c.19.215.562.236.775.044a7.815 7.815 0 001.516-1.816.553.553 0 00.006-.568.558.558 0 00-.506-.263zm8.402 1.589a.558.558 0 00-.477.362 14.87 14.87 0 01-.642 1.498.564.564 0 00.237.748c.263.129.62 0 .74-.267.258-.52.485-1.056.687-1.606a.552.552 0 00-.071-.516.556.556 0 00-.474-.219zm-4.831.52a.555.555 0 00-.432.272 10.856 10.856 0 01-1.186 1.611.563.563 0 00.043.772c.216.19.587.164.774-.053.487-.55.926-1.144 1.306-1.776a.555.555 0 00.002-.567.557.557 0 00-.506-.259h-.001z",
    fill: "#262626"
  }));
}

function SvgIcLineCouponTypeBS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 6.5A.5.5 0 014 6h16a.5.5 0 01.5.5v2.337a3.5 3.5 0 000 6.326V17.5a.5.5 0 01-.5.5H4a.5.5 0 01-.5-.5v-2.337a3.5 3.5 0 000-6.326V6.5zm18.5 0V10a2 2 0 100 4v3.5a2 2 0 01-2 2H4a2 2 0 01-2-2V14a2 2 0 100-4V6.5a2 2 0 012-2h16a2 2 0 012 2zm-9.868 9.018c-1.865 0-2.896-1.143-2.896-3.145v-.722c0-1.92 1.06-3.067 2.896-3.067.869 0 1.64.264 2.119.728.322.313.518.693.518.996 0 .39-.269.65-.66.65-.258 0-.449-.098-.703-.357-.366-.45-.708-.654-1.177-.654-.878 0-1.377.65-1.377 1.777v.576c0 1.201.489 1.85 1.377 1.85.474 0 .855-.204 1.202-.644.259-.268.434-.361.683-.361.396 0 .664.264.664.65 0 .385-.263.815-.688 1.132-.479.371-1.152.591-1.958.591z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcListmanagerS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_Listmanager_S16_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.75 1.5a.75.75 0 000 1.5h14.5a.75.75 0 100-1.5H.75zm0 4a.75.75 0 000 1.5h14.5a.75.75 0 100-1.5H.75zM0 10.25a.75.75 0 01.75-.75h14.5a.75.75 0 110 1.5H.75a.75.75 0 01-.75-.75zm.75 3.25a.75.75 0 000 1.5h7.5a.75.75 0 000-1.5H.75z",
    fill: "#000",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_Listmanager_S16_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
}

function SvgIcLocalS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16c.214 0 .41-.108.535-.296l4.727-7.074.019-.03c.47-.846.719-1.804.719-2.77 0-.964-.248-1.92-.718-2.767l-.48-.719C11.655.854 9.905 0 8.002 0 6.096 0 4.345.855 3.197 2.346a5.85 5.85 0 00-.478.716A5.708 5.708 0 002 5.831c0 .964.249 1.921.72 2.768l4.745 7.104c.125.188.32.297.534.297zM5 6c0 1.655 1.345 3 3 3 1.654 0 3-1.346 3-3S9.655 3 8 3C6.347 3 5 4.346 5 6z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcLocalS16W(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.5c.214 0 .41-.108.535-.296l4.727-7.074.019-.03c.47-.846.719-1.804.719-2.77 0-.964-.248-1.92-.718-2.767l-.48-.719C11.655 1.354 9.905.5 8.002.5c-1.905 0-3.656.855-4.804 2.346a5.85 5.85 0 00-.478.716A5.708 5.708 0 002 6.331c0 .964.249 1.921.72 2.768l4.745 7.104c.125.188.32.297.534.297zm-3-10c0 1.655 1.345 3 3 3 1.654 0 3-1.346 3-3s-1.345-3-3-3c-1.654 0-3 1.346-3 3z",
    fill: "#fff"
  }));
}

function SvgIcLocalWS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16c.214 0 .41-.108.535-.296l4.727-7.074.019-.03c.47-.846.719-1.804.719-2.77 0-.964-.248-1.92-.718-2.767l-.48-.719C11.655.854 9.905 0 8.002 0 6.096 0 4.345.855 3.197 2.346a5.85 5.85 0 00-.478.716A5.708 5.708 0 002 5.831c0 .964.249 1.921.72 2.768l4.745 7.104c.125.188.32.297.534.297zM5 6c0 1.655 1.345 3 3 3 1.654 0 3-1.346 3-3S9.655 3 8 3C6.347 3 5 4.346 5 6z",
    fill: "#fff"
  }));
}

function SvgIcMapSearchS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.404 1.237a.6.6 0 00-.96 0l-2.1 2.8a.6.6 0 00.48.96h4.2a.6.6 0 00.48-.96l-2.1-2.8zM5.025 5h2v3.412C7.725 8.012 8.927 8 9 8h.978V6.91a.6.6 0 01.96-.48l2.8 2.1a.6.6 0 010 .96l-2.8 2.1a.6.6 0 01-.96-.48V10h-.975c-.827 0-1.583.346-1.978.754V15h-2V5z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcMatchingS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Matching_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.244 10.544c.074.212.148.427.268.525.07.056.338.118.694.2.756.176 1.909.442 2.4.943.94.957 1.322 1.548 1.358 2.583l.005.127c.03.903.1 2.882.33 3.689.138.479.344.891.497 1.159.097.17.028.395-.157.457-1.157.39-3.197.827-5.639.857-2.22.026-4.607-.536-5.565-.789-.208-.055-.286-.306-.165-.483.234-.344.504-.823.52-1.201.003-.053.004-.137.005-.249.01-1.065.045-4.607 1.637-6.243 1.19-1.225 2.95-2.424 3.613-2.021.081.106.14.275.2.446zM6 31.009v-2.933c0-2.076 3.249-5.938 9-5.938 5.751 0 9 3.862 9 5.938v2.933a1 1 0 01-1 1H7a1 1 0 01-1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.512 11.069l.95-1.16-.95 1.16zm-.268-.525l1.417-.492-1.417.492zm.962.726l-.338 1.461.338-1.461zm2.4.942l1.07-1.052-1.07 1.052zm1.358 2.583l-1.499.053 1.5-.053zm.005.127l-1.5.052 1.5-.052zm.33 3.689l-1.441.413 1.441-.413zm.497 1.159l-1.302.744 1.302-.744zm-.157.457l-.48-1.421.48 1.421zM15 21.084l.018 1.5-.018-1.5zm-5.565-.789l.383-1.45-.383 1.45zm-.165-.483l1.24.844-1.24-.844zm.52-1.201l1.499.066-1.499-.066zm.005-.249l-1.5-.014 1.5.014zm1.637-6.243l-1.076-1.046 1.076 1.045zm3.613-2.021l1.19-.913-.17-.223-.24-.146-.78 1.282zm1.417-.19a1.079 1.079 0 01.25.29l.01.021-.016-.041a5.478 5.478 0 01-.045-.126l-2.834.983c.03.09.092.271.172.444.07.152.235.482.563.75l1.9-2.32zm.082-.1a31.362 31.362 0 01-.397-.095 1.243 1.243 0 01-.036-.01l.012.004a.953.953 0 01.188.093c.038.024.091.06.151.108l-1.9 2.322c.223.182.454.266.514.288.102.038.202.067.28.089.155.042.345.086.512.124l.676-2.923zm3.132 1.352c-.508-.517-1.21-.799-1.688-.962-.527-.179-1.077-.305-1.444-.39l-.676 2.923c.39.09.793.185 1.154.308.178.06.316.118.417.17.108.056.124.08.097.054l2.14-2.103zm1.787 3.582c-.025-.717-.178-1.358-.523-1.989-.321-.586-.774-1.094-1.264-1.593l-2.14 2.103c.45.458.659.724.773.932.089.163.145.334.156.653l2.998-.106zm.005.129l-.005-.13-2.998.107.004.126 2.999-.103zm.273 3.326c-.066-.23-.134-.773-.186-1.5a51.666 51.666 0 01-.087-1.826l-2.999.103c.016.45.042 1.195.094 1.934.048.69.13 1.54.295 2.116l2.883-.827zm.357.828a3.884 3.884 0 01-.357-.828l-2.883.827c.18.632.446 1.158.636 1.49l2.604-1.489zm-.98 2.624c1.206-.407 1.478-1.754.98-2.624l-2.604 1.49c-.304-.531-.17-1.427.665-1.709l.96 2.843zm-6.1.935c2.596-.032 4.791-.494 6.1-.935l-.959-2.843c-1.004.339-2.888.75-5.177.778l.036 3zm-5.966-.839c.987.26 3.534.867 5.966.839l-.036-3c-2.01.023-4.234-.494-5.164-.74l-.766 2.901zM8.03 18.968c-.628.922-.312 2.425 1.022 2.777l.766-2.9c.918.242 1.079 1.243.692 1.811l-2.48-1.688zm.262-.424c.003-.063.013-.088.007-.068a.874.874 0 01-.045.11c-.054.116-.134.25-.224.382l2.48 1.688c.144-.212.316-.488.46-.793.132-.282.298-.707.319-1.186l-2.997-.133zm.003-.196a27.14 27.14 0 01-.003.192v.004l2.997.133c.004-.085.005-.203.006-.3l-3-.03zm2.061-7.275c-1.125 1.157-1.593 2.836-1.814 4.129-.231 1.351-.242 2.608-.247 3.146l3 .03c.005-.529.017-1.576.204-2.671.197-1.153.542-2.064 1.008-2.543l-2.15-2.091zm5.468-2.257c-.697-.424-1.438-.303-1.848-.193-.462.125-.914.35-1.31.588-.804.482-1.642 1.175-2.31 1.862l2.15 2.091c.524-.537 1.162-1.056 1.702-1.38a2.48 2.48 0 01.552-.265c.144-.039-.129.082-.494-.14l1.558-2.563zm.837 1.236c-.028-.081-.163-.525-.425-.867l-2.382 1.825a.908.908 0 01-.075-.116l-.01-.02a1.416 1.416 0 01.02.055l.018.048.02.058 2.834-.983zM4.5 28.076v2.933h3v-2.933h-3zM15 20.639c-3.223 0-5.802 1.086-7.594 2.52-.891.713-1.6 1.521-2.093 2.34-.482.799-.813 1.698-.813 2.578h3c0-.157.075-.52.382-1.029.295-.489.759-1.035 1.398-1.547 1.27-1.016 3.192-1.861 5.72-1.861v-3zm10.5 7.438c0-.88-.331-1.78-.813-2.578-.494-.819-1.202-1.627-2.093-2.34-1.792-1.434-4.371-2.52-7.594-2.52v3c2.529 0 4.45.846 5.72 1.862.64.512 1.103 1.058 1.398 1.547.307.51.382.872.382 1.03h3zm0 2.933v-2.933h-3v2.933h3zm-2.5 2.5a2.5 2.5 0 002.5-2.5h-3a.5.5 0 01.5-.5v3zm-16 0h16v-3H7v3zm-2.5-2.5a2.5 2.5 0 002.5 2.5v-3a.5.5 0 01.5.5h-3z",
    fill: "#262626",
    mask: "url(#ic_Matching_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Matching_S48_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.244 10.544c.074.212.148.427.268.525.07.056.337.118.694.2.756.176 1.908.442 2.4.943.94.957 1.322 1.548 1.358 2.583l.005.127c.03.903.1 2.882.33 3.689.138.479.344.891.497 1.159.097.17.028.395-.157.457-1.157.39-3.197.827-5.639.857-2.22.026-4.607-.536-5.565-.789-.208-.055-.286-.306-.165-.483.234-.344.504-.823.52-1.201.003-.053.004-.137.005-.249.01-1.065.045-4.607 1.637-6.243 1.19-1.225 2.95-2.424 3.613-2.021.081.106.14.275.2.446zM24 31.009v-2.933c0-2.076 3.249-5.938 9-5.938 5.751 0 9 3.862 9 5.938v2.933a1 1 0 01-1 1H25a1 1 0 01-1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33.512 11.069l.95-1.16-.95 1.16zm-.268-.525l1.417-.492-1.417.492zm.962.726l-.338 1.461.338-1.461zm2.4.942l1.07-1.052-1.07 1.052zm1.358 2.583l-1.499.053 1.5-.053zm.005.127l-1.5.052 1.5-.052zm.33 3.689l-1.441.413 1.441-.413zm.497 1.159l-1.302.744 1.302-.744zm-.157.457l-.48-1.421.48 1.421zM33 21.084l.017 1.5h.001l-.018-1.5zm-5.565-.789l.383-1.45-.383 1.45zm-.165-.483l1.24.844-1.24-.844zm.52-1.201l1.499.066-1.498-.066zm.005-.249l-1.5-.014 1.5.014zm1.637-6.243l-1.076-1.046 1.076 1.045zm3.613-2.021l1.19-.913-.17-.223-.24-.146-.78 1.282zm1.417-.19a1.079 1.079 0 01.25.29l.01.021-.016-.041a5.478 5.478 0 01-.045-.126l-2.834.983c.03.09.092.271.172.444.07.152.235.482.563.75l1.9-2.32zm.082-.1a31.362 31.362 0 01-.397-.095 1.243 1.243 0 01-.036-.01l.012.004a.953.953 0 01.188.093c.038.024.091.06.151.108l-1.9 2.322c.223.182.454.266.514.288.102.038.202.067.28.089.155.042.345.086.512.124l.676-2.923zm3.132 1.352c-.508-.517-1.21-.799-1.688-.962-.527-.179-1.077-.305-1.444-.39l-.676 2.923c.39.09.793.185 1.154.308.178.06.316.118.417.17.108.056.124.08.097.054l2.14-2.103zm1.787 3.582c-.025-.717-.178-1.358-.523-1.989-.321-.586-.773-1.094-1.264-1.593l-2.14 2.103c.45.458.659.724.773.932.089.163.145.334.156.653l2.998-.106zm.005.129l-.005-.13-2.998.107.004.126 2.999-.103zm.273 3.326c-.066-.23-.135-.773-.186-1.5a51.666 51.666 0 01-.087-1.826l-2.999.103c.016.45.042 1.195.094 1.934.048.69.13 1.54.294 2.116l2.884-.827zm.357.828a3.884 3.884 0 01-.357-.828l-2.883.827c.18.632.446 1.158.636 1.49l2.604-1.489zm-.98 2.624c1.206-.407 1.478-1.754.98-2.624l-2.604 1.49c-.304-.531-.17-1.427.665-1.709l.96 2.843zm-6.1.935c2.596-.032 4.791-.494 6.1-.935l-.959-2.843c-1.004.339-2.888.75-5.177.778l.036 3zm-5.966-.839c.987.26 3.534.867 5.965.839l-.035-3c-2.01.023-4.234-.494-5.164-.74l-.766 2.901zm-1.022-2.777c-.628.922-.312 2.425 1.022 2.777l.766-2.9c.918.242 1.079 1.243.692 1.811l-2.48-1.688zm.262-.424c.003-.063.013-.088.007-.068a.87.87 0 01-.045.11c-.054.116-.134.25-.224.382l2.48 1.688c.144-.212.316-.488.46-.793.132-.282.298-.707.319-1.186l-2.997-.133zm.003-.196l-.002.138v.042a.75.75 0 01-.001.016l2.997.133c.004-.085.005-.203.006-.3l-3-.03zm2.061-7.275c-1.126 1.157-1.593 2.836-1.814 4.129-.231 1.351-.242 2.608-.247 3.146l3 .03c.005-.529.017-1.576.204-2.671.197-1.153.542-2.064 1.008-2.543l-2.15-2.091zm5.468-2.257c-.697-.424-1.438-.303-1.847-.193-.462.125-.915.35-1.311.588-.804.482-1.642 1.175-2.31 1.862l2.15 2.091c.524-.537 1.162-1.056 1.702-1.38a2.48 2.48 0 01.552-.265c.144-.039-.129.082-.494-.14l1.558-2.563zm.837 1.236c-.028-.081-.163-.525-.425-.867l-2.382 1.825a.908.908 0 01-.075-.116l-.01-.02a1.416 1.416 0 01.02.055l.018.048.02.058 2.834-.983zM22.5 28.076v2.933h3v-2.933h-3zM33 20.639c-3.223 0-5.802 1.086-7.594 2.52-.891.713-1.6 1.521-2.093 2.34-.482.799-.813 1.698-.813 2.578h3c0-.157.075-.52.382-1.029.295-.489.759-1.035 1.398-1.547 1.27-1.016 3.191-1.861 5.72-1.861v-3zm10.5 7.438c0-.88-.331-1.78-.813-2.578-.494-.819-1.202-1.627-2.093-2.34-1.792-1.434-4.371-2.52-7.594-2.52v3c2.529 0 4.45.846 5.72 1.862.64.512 1.103 1.058 1.398 1.547.307.51.382.872.382 1.03h3zm0 2.933v-2.933h-3v2.933h3zm-2.5 2.5a2.5 2.5 0 002.5-2.5h-3a.5.5 0 01.5-.5v3zm-16 0h16v-3H25v3zm-2.5-2.5a2.5 2.5 0 002.5 2.5v-3a.5.5 0 01.5.5h-3z",
    fill: "#262626",
    mask: "url(#ic_Matching_S48_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Matching_S48_svg__c",
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 14.942,
    width: 22,
    height: 26,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 14.942h22v26H13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.244 17.467c.074.213.148.428.268.526.07.056.337.118.694.2.756.175 1.909.441 2.4.942.94.957 1.322 1.548 1.358 2.583l.005.128c.03.902.1 2.882.33 3.688.138.48.344.892.497 1.16.097.17.028.394-.157.457-1.157.39-3.197.827-5.639.856-2.22.026-4.607-.535-5.565-.788-.208-.055-.286-.306-.165-.483.234-.344.504-.823.52-1.202.003-.052.004-.136.005-.248.01-1.066.045-4.608 1.637-6.244 1.19-1.225 2.95-2.424 3.613-2.02.081.105.14.275.2.445zM15 37.932V35c0-2 3.249-5.938 9-5.938 5.751 0 9 3.938 9 5.938v2.932a1 1 0 01-1 1H16a1 1 0 01-1-1z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.244 17.467c.074.213.148.428.268.526.07.056.337.118.694.2.756.175 1.909.441 2.4.942.94.957 1.322 1.548 1.358 2.583l.005.128c.03.902.1 2.882.33 3.688.138.48.344.892.497 1.16.097.17.028.394-.157.457-1.157.39-3.197.827-5.639.856-2.22.026-4.607-.535-5.565-.788-.208-.055-.286-.306-.165-.483.234-.344.504-.823.52-1.202.003-.052.004-.136.005-.248.01-1.066.045-4.608 1.637-6.244 1.19-1.225 2.95-2.424 3.613-2.02.081.105.14.275.2.445zM15 37.932V35c0-2 3.249-5.938 9-5.938 5.751 0 9 3.938 9 5.938v2.932a1 1 0 01-1 1H16a1 1 0 01-1-1z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.512 17.992l.95-1.16-.95 1.16zm-.268-.525l1.417-.491-1.417.491zm.962.727l-.338 1.461.338-1.462zm2.4.941l1.07-1.051-1.07 1.051zm1.358 2.583l-1.499.053 1.5-.053zm.005.128l-1.5.052 1.5-.052zm.33 3.688l-1.441.414 1.441-.414zm.497 1.16l-1.302.744 1.302-.744zm-.157.457l-.48-1.421.48 1.42zM24 28.007l.017 1.5h.001l-.018-1.5zm-5.565-.788l.383-1.45-.383 1.45zm-.165-.483l1.24.844-1.24-.844zm.52-1.202l1.499.067-1.498-.067zm.005-.248l-1.5-.015 1.5.015zm1.637-6.244l-1.076-1.046 1.076 1.046zm3.613-2.02l1.19-.913-.17-.223-.24-.146-.78 1.281zm1.417-.19a1.08 1.08 0 01.25.29l.01.02-.016-.04a5.347 5.347 0 01-.045-.126l-2.834.983c.03.089.092.27.172.444.07.152.235.482.563.75l1.9-2.321zm.082-.1l-.238-.055a5.443 5.443 0 01-.195-.05c-.006-.003-.001-.001.012.003a.978.978 0 01.188.094c.038.023.091.059.151.108l-1.9 2.321c.223.182.454.267.514.289.102.038.202.067.28.088.155.043.345.086.512.125l.676-2.923zm3.132 1.352c-.508-.517-1.21-.8-1.688-.962-.527-.18-1.077-.305-1.444-.39l-.676 2.923c.39.09.793.184 1.154.307.178.06.316.118.417.17.108.057.124.081.097.054l2.14-2.102zm1.787 3.582c-.025-.717-.178-1.358-.523-1.989-.321-.586-.774-1.094-1.264-1.593l-2.14 2.102c.45.459.659.725.773.932.089.163.145.335.156.653l2.998-.105zm.005.128l-.005-.128-2.998.105.004.127 2.999-.104zm.273 3.327c-.066-.23-.134-.773-.186-1.5a51.666 51.666 0 01-.087-1.827l-2.999.104c.016.449.042 1.195.094 1.933.048.69.13 1.54.295 2.117l2.883-.827zm.357.828a3.886 3.886 0 01-.357-.828l-2.883.827c.18.632.446 1.158.636 1.49l2.604-1.489zm-.98 2.623c1.206-.406 1.478-1.753.98-2.623l-2.604 1.489c-.304-.53-.17-1.427.665-1.708l.96 2.842zm-6.1.935c2.596-.031 4.791-.493 6.1-.935l-.959-2.842c-1.004.338-2.888.75-5.177.777l.036 3zm-5.966-.838c.987.26 3.534.866 5.965.838l-.034-3c-2.01.024-4.235-.493-5.165-.739l-.766 2.9zM17.03 25.89c-.628.923-.312 2.426 1.022 2.778l.766-2.9c.918.242 1.079 1.243.692 1.811l-2.48-1.689zm.262-.423c.003-.063.013-.089.007-.069a.876.876 0 01-.045.11c-.054.116-.134.25-.224.382l2.48 1.689c.144-.212.316-.489.46-.794.132-.282.298-.706.319-1.185l-2.997-.133zm.003-.197l-.002.138v.043a.75.75 0 01-.001.015l2.997.134c.004-.085.005-.203.006-.3l-3-.03zm2.061-7.275c-1.126 1.158-1.593 2.836-1.814 4.13-.231 1.35-.242 2.608-.247 3.145l3 .03c.005-.528.017-1.575.204-2.67.197-1.154.542-2.064 1.008-2.543l-2.15-2.092zm5.468-2.256c-.697-.424-1.438-.304-1.848-.193-.461.125-.914.35-1.31.588-.804.481-1.642 1.174-2.31 1.861l2.15 2.092c.524-.538 1.162-1.056 1.702-1.38a2.48 2.48 0 01.552-.265c.144-.04-.129.082-.494-.14l1.558-2.564zm.837 1.236c-.028-.082-.163-.525-.425-.867l-2.382 1.824a.947.947 0 01-.085-.135v.002l.02.053.017.047.021.059 2.834-.983zM13.5 35v2.932h3V35h-3zM24 27.562c-3.23 0-5.81 1.11-7.598 2.551-.89.718-1.595 1.526-2.087 2.338-.478.787-.815 1.68-.815 2.55h3c0-.132.069-.481.38-.995.297-.49.763-1.04 1.405-1.557 1.274-1.028 3.194-1.887 5.715-1.887v-3zM34.5 35c0-.87-.337-1.762-.815-2.55-.492-.81-1.197-1.62-2.087-2.337-1.787-1.441-4.367-2.55-7.598-2.55v3c2.52 0 4.44.858 5.715 1.886.642.517 1.108 1.068 1.405 1.557.311.514.38.863.38.994h3zm0 2.932V35h-3v2.932h3zm-2.5 2.5a2.5 2.5 0 002.5-2.5h-3a.5.5 0 01.5-.5v3zm-16 0h16v-3H16v3zm-2.5-2.5a2.5 2.5 0 002.5 2.5v-3a.5.5 0 01.5.5h-3z",
    fill: "#F7F7F7",
    mask: "url(#ic_Matching_S48_svg__c)"
  }));
}

function SvgIcMeS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 11.5c2.678 0 4.875 2.197 4.875 4.875S26.678 21.25 24 21.25s-4.875-2.197-4.875-4.875S21.322 11.5 24 11.5zm6.375 4.875C30.375 12.869 27.506 10 24 10s-6.375 2.869-6.375 6.375S20.494 22.75 24 22.75s6.375-2.869 6.375-6.375zM12.75 35.82v-2.386c0-1.638 1.15-3.628 3.325-5.289 2.134-1.628 5.007-2.734 7.925-2.734 2.923 0 5.796 1.106 7.927 2.734 2.175 1.66 3.323 3.65 3.323 5.289v2.386a.5.5 0 01-.5.5h-21.5a.5.5 0 01-.5-.5zm-1.5-2.386v2.386a2 2 0 002 2h21.5a2 2 0 002-2v-2.386c0-4.586-6.182-9.523-12.75-9.523-6.56 0-12.75 4.937-12.75 9.523z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcMembershipS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 38.5c8.008 0 14.5-6.492 14.5-14.5S32.008 9.5 24 9.5 9.5 15.992 9.5 24 15.992 38.5 24 38.5zM40 24c0 8.837-7.163 16-16 16S8 32.837 8 24 15.163 8 24 8s16 7.163 16 16z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.34 30.078c.618 0 .962-.398.962-1.117v-8.352c0-.867-.446-1.367-1.22-1.367-.655 0-1.015.29-1.413 1.172l-2.54 5.844h-.077l-2.54-5.836c-.398-.883-.765-1.18-1.414-1.18-.757 0-1.234.516-1.234 1.367v8.352c0 .734.32 1.117.938 1.117.617 0 .96-.398.96-1.117v-6.055h.102l2.133 4.836c.328.719.61.969 1.094.969.476 0 .757-.234 1.086-.969l2.132-4.836h.102v6.055c0 .734.32 1.117.93 1.117z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 38.5c8.008 0 14.5-6.492 14.5-14.5S32.008 9.5 24 9.5 9.5 15.992 9.5 24 15.992 38.5 24 38.5zM40 24c0 8.837-7.163 16-16 16S8 32.837 8 24 15.163 8 24 8s16 7.163 16 16z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcMenuS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 3A.75.75 0 012 2.25h12a.75.75 0 010 1.5H2A.75.75 0 011.25 3zm0 5A.75.75 0 012 7.25h12a.75.75 0 010 1.5H2A.75.75 0 011.25 8zM2 12.25a.75.75 0 000 1.5h12a.75.75 0 000-1.5H2z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcMinusSmallB20S16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8.25a.75.75 0 01.75-.75h11.5a.75.75 0 010 1.5H2.25a.75.75 0 01-.75-.75z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcMinusSmallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8.25a.75.75 0 01.75-.75h11.5a.75.75 0 010 1.5H2.25a.75.75 0 01-.75-.75z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcMinusS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a1 1 0 011-1h14a1 1 0 110 2H1a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcMinusS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcMopS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9h3C21 9 22 11.5 22 13v1a5 5 0 01-5 5H9a7 7 0 01-7-7v-1a7 7 0 017-7h9a4 4 0 014 4v1h-3",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9h-7.5A2.5 2.5 0 008 11.5v0a2.5 2.5 0 002.5 2.5H16",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcMoreOffS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.5 11.5c0-1.375-1.125-2.5-2.5-2.5a2.507 2.507 0 00-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5zM23 11.5c0-1.375-1.125-2.5-2.5-2.5a2.507 2.507 0 00-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5zM6 11.5C6 10.125 4.875 9 3.5 9A2.507 2.507 0 001 11.5C1 12.875 2.125 14 3.5 14S6 12.875 6 11.5z",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcMoreOnS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 11.5c0-1.375-1.125-2.5-2.5-2.5a2.507 2.507 0 00-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5zM23 11.5c0-1.375-1.125-2.5-2.5-2.5a2.507 2.507 0 00-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5zM6 11.5C6 10.125 4.875 9 3.5 9A2.507 2.507 0 001 11.5C1 12.875 2.125 14 3.5 14S6 12.875 6 11.5z",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcMovingcleanS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 19h28.554l5.087 7.297A2 2 0 0144 27.441V36a2 2 0 01-2 2H10V19z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 19.75h27.413l4.863 6.976c.146.21.224.46.224.715V36c0 .69-.56 1.25-1.25 1.25H10.75v-17.5z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18a2 2 0 012-2h21v16H10V18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.75 18c0-.69.56-1.25 1.25-1.25h20.25v14.5h-21.5V18z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.444,
    cy: 37.875,
    rx: 4,
    ry: 4.018,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.694 37.875a3.259 3.259 0 01-3.25 3.268 3.259 3.259 0 01-3.25-3.268 3.259 3.259 0 013.25-3.268c1.792 0 3.25 1.46 3.25 3.268z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.444,
    cy: 37.875,
    rx: 4,
    ry: 4.018,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.694 37.875a3.259 3.259 0 01-3.25 3.268 3.259 3.259 0 01-3.25-3.268 3.259 3.259 0 013.25-3.268c1.792 0 3.25 1.46 3.25 3.268z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 25h5.489L43 26.5h-6V25z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.258 27c1.229-8.23 7.869-10.151 7.869-10.151C11.755 14.453 11.181 7 11.181 7h-.11s-.573 7.453-7.945 9.849c0 0 6.728 1.921 7.956 10.151h.175z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.202 16.88a12.71 12.71 0 00-2.029 1.382c-1.49 1.24-3.064 3.123-4.004 5.898-.948-2.777-2.541-4.662-4.049-5.901a12.85 12.85 0 00-2.059-1.384c2.857-1.399 4.52-3.578 5.476-5.518.237-.482.431-.95.59-1.388.158.438.352.906.59 1.388.956 1.943 2.622 4.125 5.485 5.523z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.082 14.5C20.85 9.356 25 8.155 25 8.155 20.392 6.658 20.035 2 20.035 2h-.069S19.608 6.658 15 8.155c0 0 4.205 1.201 4.973 6.345h.109z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.35 8.822a8.322 8.322 0 00-2.325 3.122 8.313 8.313 0 00-3.237-3.761c1.577-.904 2.53-2.186 3.096-3.335.04-.083.08-.165.116-.247.037.082.076.164.117.247.566 1.15 1.521 2.436 3.104 3.34-.275.174-.57.384-.872.634z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcMyreservOffS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 19.25H4.25V18c0-1.67.924-2.957 2.393-3.861C8.127 13.226 10.11 12.75 12 12.75c1.891 0 3.874.476 5.357 1.389 1.47.904 2.393 2.19 2.393 3.861v1.25zM12 2.75c2.06 0 3.75 1.69 3.75 3.75s-1.69 3.75-3.75 3.75S8.25 8.56 8.25 6.5 9.94 2.75 12 2.75z",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcMyreservOnS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 19.25H4.25V18c0-1.67.924-2.957 2.393-3.861C8.127 13.226 10.11 12.75 12 12.75c1.891 0 3.874.476 5.357 1.389 1.47.904 2.393 2.19 2.393 3.861v1.25zM12 2.75c2.06 0 3.75 1.69 3.75 3.75s-1.69 3.75-3.75 3.75S8.25 8.56 8.25 6.5 9.94 2.75 12 2.75z",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcNoticeOffS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 4.75c4.077 0 7.25 2.97 7.25 6.48v4.32a.75.75 0 01-.75.75h-13a.75.75 0 01-.75-.75v-4.32c0-3.51 3.173-6.48 7.25-6.48z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.23 12v2",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.55,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5v1",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.5c.482.1 1.104.662 1.27 1.384",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcNoticeOnS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.55,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#000",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5v1",
    stroke: "#262626",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11.23C20 7.237 16.418 4 12 4s-8 3.237-8 7.23v4.32a1.5 1.5 0 001.5 1.5h13a1.5 1.5 0 001.5-1.5v-4.32zm-3.77.02a.75.75 0 01.75.75v2a.75.75 0 01-1.5 0v-2a.75.75 0 01.75-.75zm-2.464-2.903a.75.75 0 01.887-.581c.428.089.83.354 1.138.67.316.325.591.765.71 1.28a.75.75 0 01-1.462.337 1.244 1.244 0 00-.324-.571c-.165-.17-.315-.237-.368-.248a.75.75 0 01-.581-.887z",
    fill: "#262626"
  }));
}

function SvgIcNoticeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.846 4.432l-4.564 3.95a1 1 0 01-.655.243H4.5a1 1 0 00-1 1v4.75a1 1 0 001 1h3.127a1 1 0 01.655.244l4.564 3.95a1 1 0 001.654-.757V5.188a1 1 0 00-1.654-.756z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12H23M18.5 7L21 5M18.5 17l2.5 2",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcNoticeS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 19.96v8.606a.5.5 0 00.5.5h6.349a2.5 2.5 0 011.413.437l6.596 4.52v-19.52l-6.596 4.519a2.5 2.5 0 01-1.413.438H11a.5.5 0 00-.5.5zm-1.5 0a2 2 0 012-2h6.349a1 1 0 00.565-.175l6.597-4.52c.995-.682 2.348.03 2.348 1.238v19.52c0 1.206-1.353 1.92-2.348 1.237l-6.597-4.52a1 1 0 00-.565-.174H11a2 2 0 01-2-2V19.96zm22.061-1.441a.75.75 0 011.06 0c3.178 3.177 3.196 8.32.029 11.488a.75.75 0 11-1.061-1.061c2.576-2.576 2.569-6.77-.028-9.367a.75.75 0 010-1.06zm5.266-2.98a.75.75 0 10-1.06 1.061c4.246 4.247 4.26 11.108.043 15.325a.75.75 0 001.06 1.06c4.809-4.808 4.784-12.618-.043-17.445z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcNumberingS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11zM10.32 9.525h1.304V16h1.138V8.46h-1.817l-.625 1.065z",
    fill: "#42484C"
  }));
}

function SvgIcOfficetelS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 12a2 2 0 012-2h19.652a2 2 0 012 2v26.174H12V12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12c0-.69.56-1.25 1.25-1.25h19.652c.69 0 1.25.56 1.25 1.25v25.424H12.75V12z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14.87,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.261,
    y: 14.87,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.174,
    y: 14.87,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22.174,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.261,
    y: 22.174,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.174,
    y: 22.174,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 29.478,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.261,
    y: 29.478,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.174,
    y: 29.478,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36.674,
    width: 32,
    height: 1.5,
    rx: 0.667,
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcOneCalendarS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 1a.75.75 0 00-1.5 0v.5H3a2 2 0 00-2 2V13a2 2 0 002 2h10a2 2 0 002-2V3.5a2 2 0 00-2-2h-1.75V1a.75.75 0 00-1.5 0v.5h-3.5V1zm3.5 2.5V3h-3.5v.5a.75.75 0 01-1.5 0V3H3a.5.5 0 00-.5.5v2h11v-2A.5.5 0 0013 3h-1.75v.5a.75.75 0 01-1.5 0zM13.5 7h-11v6a.5.5 0 00.5.5h10a.5.5 0 00.5-.5V7zM8 11a1 1 0 100-2 1 1 0 000 2z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcOpensourceS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11.25A2.75 2.75 0 0012.25 14v21A2.75 2.75 0 0015 37.75h5.125a.75.75 0 000-1.5H15c-.69 0-1.25-.56-1.25-1.25V14c0-.69.56-1.25 1.25-1.25h18c.69 0 1.25.56 1.25 1.25v13.179a.75.75 0 001.5 0V14A2.75 2.75 0 0033 11.25H15zM18 17a.75.75 0 000 1.5h12a.75.75 0 000-1.5H18zm0 4.5a.75.75 0 000 1.5h12a.75.75 0 000-1.5H18zm-.75 5.25A.75.75 0 0118 26h6a.75.75 0 010 1.5h-6a.75.75 0 01-.75-.75z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 31l-3 3.5 3 3.5M35 31l3 3.5-3 3.5M32 31l-2 7",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 31.25h3",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcParkingS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zM8 16A8 8 0 118 0a8 8 0 010 16zm-.787-4.984c0 .662-.352 1.043-.973 1.043-.615 0-.96-.375-.96-1.043v-5.69c0-.955.35-1.324 1.265-1.324h2.057c1.752 0 2.859 1.066 2.859 2.713 0 1.752-1.125 2.73-2.959 2.73h-1.29v1.57zm.006-5.52v2.508h.879c1.002 0 1.447-.328 1.447-1.254 0-.797-.44-1.254-1.23-1.254H7.218z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPayS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "49",
    height: "49",
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.2269 14.2028C10.0119 14.2028 9.0269 15.1877 9.0269 16.4028V33.4028C9.0269 34.6178 10.0119 35.6028 11.2269 35.6028H37.2269C38.4419 35.6028 39.4269 34.6178 39.4269 33.4028V16.4028C39.4269 15.1877 38.4419 14.2028 37.2269 14.2028H11.2269ZM10.4269 16.4028C10.4269 15.9609 10.7851 15.6028 11.2269 15.6028H37.2269C37.6687 15.6028 38.0269 15.9609 38.0269 16.4028V33.4028C38.0269 33.8446 37.6687 34.2028 37.2269 34.2028H11.2269C10.7851 34.2028 10.4269 33.8446 10.4269 33.4028V20.9829L34.068 20.9926C34.4546 20.9928 34.7681 20.6795 34.7682 20.2929C34.7684 19.9063 34.4551 19.5928 34.0685 19.5926L10.4269 19.5829V16.4028ZM27.0269 27.9028C27.0269 27.5162 27.3403 27.2028 27.7269 27.2028H33.7269C34.1135 27.2028 34.4269 27.5162 34.4269 27.9028C34.4269 28.2894 34.1135 28.6028 33.7269 28.6028H27.7269C27.3403 28.6028 27.0269 28.2894 27.0269 27.9028Z",
    fill: props.enable ? '#262626' : '#ccc'
  }));
}

function SvgIcPaymentB85S24V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.77 19.66v.003h.416c.829 0 1.501-.673 1.501-1.502v-5.042h-2.199v4.142c0 1.05.12 1.828.282 2.399zm.887 1.5h-.34a2.99 2.99 0 01-.131.003h-2.202v-.003H4.814a2.001 2.001 0 01-2.001-2.001V3.839a1 1 0 011-1.001h13.675c.552 0 1 .445 1 .997v7.784h2.699a1 1 0 011 1v5.542a3.003 3.003 0 01-2.573 2.971.43.43 0 00.043.028zm-2.669-9.107v.003a.503.503 0 00-.004.064v7.54H4.814a.501.501 0 01-.501-.501V4.338h12.675V12.053zM8 7.148a.75.75 0 000 1.5h5.532a.75.75 0 100-1.5H7.999zm-.75 4.208a.75.75 0 01.75-.75h5.532a.75.75 0 110 1.5H7.999a.75.75 0 01-.75-.75zM8 14.06a.75.75 0 000 1.5h5.532a.75.75 0 100-1.5H7.999z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPensS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.768 7.084a.788.788 0 010 1.117L17.32 9.65l-2.97-2.97 1.45-1.448a.789.789 0 011.116 0l1.852 1.852zM5 19.254v-2.97l8.757-8.757 2.969 2.97-8.757 8.756H5z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcPestsCatDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 11.024c0-1.266 1.548-1.88 2.415-.958l5.289 5.62a1 1 0 00.728.314h10.136a1 1 0 00.728-.315l5.289-5.619c.867-.921 2.415-.308 2.415.958v14.451c0 7.456-6.044 13.5-13.5 13.5s-13.5-6.044-13.5-13.5v-14.45z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 25.475V11.282l5.112 5.431a2.5 2.5 0 001.82.787h10.136a2.5 2.5 0 001.82-.787L36 11.284v14.192c0 1.045-.133 2.059-.385 3.025H32.25a.75.75 0 000 1.5h2.868a11.96 11.96 0 01-.738 1.5h-2.13a.75.75 0 000 1.5h1.098A11.977 11.977 0 0124 37.475 11.977 11.977 0 0114.652 33h1.098a.75.75 0 000-1.5h-2.13c-.28-.48-.526-.98-.738-1.5h2.868a.75.75 0 000-1.5h-3.366A12.017 12.017 0 0112 25.475zM36.723 30a13.431 13.431 0 01-.639 1.5h2.666a.75.75 0 010 1.5h-3.54A13.487 13.487 0 0124 38.975c-4.67 0-8.786-2.37-11.21-5.975H9.25a.75.75 0 010-1.5h2.666a13.431 13.431 0 01-.639-1.5H9.25a.75.75 0 010-1.5h1.59a13.543 13.543 0 01-.34-3.025v-14.45c0-1.266 1.548-1.88 2.415-.959l5.289 5.62a1 1 0 00.728.314h10.136a1 1 0 00.728-.315l5.289-5.619c.867-.921 2.415-.307 2.415.958v14.451c0 1.04-.118 2.053-.34 3.025h1.59a.75.75 0 010 1.5h-2.027zM20.5 23.25a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM29.25 25a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM24 28a.75.75 0 00-.75.75V31a.75.75 0 01-1.5 0 .75.75 0 00-1.5 0A2.25 2.25 0 0024 32.677 2.25 2.25 0 0027.75 31a.75.75 0 00-1.5 0 .75.75 0 01-1.5 0v-2.25A.75.75 0 0024 28z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.515 28.58A1 1 0 0123.33 27h1.34a1 1 0 01.814 1.58l-.67.941a1 1 0 01-1.63 0l-.669-.942z",
    fill: "#D8D8D8"
  }));
}

function SvgIcPestsCatS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 11.024c0-1.266 1.548-1.88 2.415-.958l5.289 5.62a1 1 0 00.728.314h10.136a1 1 0 00.728-.315l5.289-5.619c.867-.921 2.415-.308 2.415.958v14.451c0 7.456-6.044 13.5-13.5 13.5s-13.5-6.044-13.5-13.5v-14.45z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 25.475V11.282l5.112 5.431a2.5 2.5 0 001.82.787h10.136a2.5 2.5 0 001.82-.787L36 11.283v14.192c0 1.045-.133 2.059-.385 3.025H32.25a.75.75 0 000 1.5h2.868c-.212.52-.459 1.02-.738 1.5h-2.13a.75.75 0 000 1.5h1.098A11.977 11.977 0 0124 37.475 11.977 11.977 0 0114.652 33h1.098a.75.75 0 100-1.5h-2.13c-.28-.48-.526-.98-.738-1.5h2.868a.75.75 0 100-1.5h-3.366A12.018 12.018 0 0112 25.475zM36.723 30a13.416 13.416 0 01-.639 1.5h2.666a.75.75 0 010 1.5h-3.54A13.487 13.487 0 0124 38.975c-4.67 0-8.786-2.371-11.21-5.975H9.25a.75.75 0 110-1.5h2.666a13.416 13.416 0 01-.639-1.5H9.25a.75.75 0 110-1.5h1.59a13.543 13.543 0 01-.34-3.025V11.024c0-1.266 1.548-1.88 2.415-.958l5.289 5.62a1 1 0 00.728.314h10.136a1 1 0 00.728-.315l5.289-5.619c.867-.922 2.415-.308 2.415.958v14.451c0 1.04-.118 2.053-.34 3.025h1.59a.75.75 0 010 1.5h-2.027zM20.5 23.25a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zM29.25 25a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM24 28a.75.75 0 00-.75.75V31a.75.75 0 11-1.5 0 .75.75 0 00-1.5 0A2.25 2.25 0 0024 32.677 2.25 2.25 0 0027.75 31a.75.75 0 00-1.5 0 .75.75 0 11-1.5 0v-2.25A.75.75 0 0024 28z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.515 28.58A1 1 0 0123.33 27h1.34a1 1 0 01.814 1.58l-.67.941a1 1 0 01-1.63 0l-.669-.942z",
    fill: "#262626"
  }));
}

function SvgIcPestsDogDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.921 9.75h-9.55a9 9 0 00-7.635 4.235L7.44 20.868c-1.87 2.997.284 6.882 3.817 6.882h2.888v5.315c0 2.864 2.356 5.185 5.263 5.185.681 0 1.332-.18 1.93-.483a4.48 4.48 0 002.807.983 4.48 4.48 0 002.808-.983 4.257 4.257 0 001.929.483c2.907 0 5.263-2.322 5.263-5.185V27.75h2.887c3.533 0 5.689-3.885 3.818-6.882l-4.295-6.883a9 9 0 00-7.635-4.235z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.225 8.75a9.75 9.75 0 00-8.272 4.588L6.66 20.221c-2.183 3.497.332 8.029 4.454 8.029h2.137v2.25h-2a.75.75 0 000 1.5h2v.815c0 .062.001.123.003.185H11.25a.75.75 0 000 1.5h2.245c.737 2.462 3.048 4.25 5.768 4.25.651 0 1.27-.135 1.844-.369.83.55 1.824.869 2.893.869 1.069 0 2.064-.32 2.893-.869a4.879 4.879 0 001.844.369c2.72 0 5.03-1.788 5.768-4.25h1.745a.75.75 0 000-1.5h-1.503c.002-.062.003-.123.003-.185V32h1.5a.75.75 0 000-1.5h-1.5v-2.25h2.138c4.122 0 6.636-4.532 4.454-8.03l-4.295-6.882a9.75 9.75 0 00-8.272-4.588h-9.55zM29.75 33h3.496a4.38 4.38 0 00.004-.185V32h-3.5a.75.75 0 010-1.5h3.5V24a.75.75 0 011.5 0v2.75h2.138c2.944 0 4.74-3.238 3.18-5.735l-4.294-6.883a8.25 8.25 0 00-6.999-3.882h-9.55a8.25 8.25 0 00-7 3.882l-4.294 6.883c-1.559 2.497.237 5.735 3.182 5.735h2.137V24a.75.75 0 011.5 0v6.5h3a.75.75 0 010 1.5h-3v.815c0 .062.001.124.004.185h2.996a.75.75 0 010 1.5h-2.662a4.513 4.513 0 004.175 2.75c1.684 0 3.278-1.401 4.064-2.997a.75.75 0 011.346 0c.786 1.596 2.38 2.997 4.064 2.997a4.513 4.513 0 004.175-2.75H29.75a.75.75 0 010-1.5zM24 37.75c-.49 0-.958-.094-1.386-.264.533-.427 1-.931 1.386-1.46.386.529.853 1.033 1.386 1.46-.428.17-.896.264-1.386.264zM21.902 25a1 1 0 00-.846 1.534l2.098 3.322a1 1 0 001.691 0l2.097-3.322A1 1 0 0026.097 25h-4.195zm-2.652-3a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zm11.25-1.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z",
    fill: "#D8D8D8"
  }));
}

function SvgIcPestsDogS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.921 9.75h-9.55a9 9 0 00-7.635 4.235L7.44 20.868c-1.87 2.997.284 6.882 3.817 6.882h2.888v5.315c0 2.864 2.356 5.185 5.263 5.185.681 0 1.332-.18 1.93-.483a4.48 4.48 0 002.807.983 4.48 4.48 0 002.808-.983 4.257 4.257 0 001.929.483c2.907 0 5.263-2.322 5.263-5.185V27.75h2.887c3.533 0 5.689-3.885 3.818-6.882l-4.295-6.883a9 9 0 00-7.635-4.235z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.225 8.75a9.75 9.75 0 00-8.272 4.588L6.66 20.221c-2.183 3.497.332 8.029 4.453 8.029h2.138v2.25h-2a.75.75 0 000 1.5h2v.815c0 .062.001.123.003.185H11.25a.75.75 0 000 1.5h2.245c.737 2.462 3.048 4.25 5.768 4.25.651 0 1.27-.135 1.844-.369.83.55 1.824.869 2.893.869 1.069 0 2.064-.32 2.893-.869a4.879 4.879 0 001.844.369c2.72 0 5.03-1.788 5.768-4.25h1.745a.75.75 0 000-1.5h-1.503c.002-.062.003-.123.003-.185V32h1.5a.75.75 0 000-1.5h-1.5v-2.25h2.138c4.121 0 6.636-4.532 4.454-8.03l-4.295-6.882a9.75 9.75 0 00-8.272-4.588h-9.55zM29.75 33h3.496a4.38 4.38 0 00.004-.185V32h-3.5a.75.75 0 010-1.5h3.5V24a.75.75 0 011.5 0v2.75h2.138c2.944 0 4.74-3.238 3.18-5.735l-4.294-6.883a8.25 8.25 0 00-6.999-3.882h-9.55a8.25 8.25 0 00-7 3.882l-4.294 6.883c-1.559 2.497.237 5.735 3.181 5.735h2.138V24a.75.75 0 011.5 0v6.5h3a.75.75 0 010 1.5h-3v.815c0 .062.001.124.004.185h2.996a.75.75 0 010 1.5h-2.662a4.513 4.513 0 004.175 2.75c1.684 0 3.278-1.401 4.064-2.997a.75.75 0 011.346 0c.786 1.596 2.38 2.997 4.064 2.997a4.513 4.513 0 004.175-2.75H29.75a.75.75 0 010-1.5zM24 37.75c-.49 0-.958-.094-1.386-.264.533-.427 1-.931 1.386-1.46.386.529.853 1.033 1.386 1.46-.428.17-.896.264-1.386.264zM21.902 25a1 1 0 00-.846 1.534l2.098 3.322a1 1 0 001.691 0l2.097-3.322A1 1 0 0026.097 25h-4.195zm-2.652-3a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zm11.25-1.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPestsEtcDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.345 13.184C34.51 15.044 39 20.76 39 27.524c0 8.27-6.716 14.976-15 14.976-8.284 0-15-6.705-15-14.977 0-6.136 3.696-11.41 8.986-13.724l-.414-2.85a.517.517 0 01.771-.521l2.964 1.715-.43-5.082a.517.517 0 01.88-.411l6.588 6.534z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.554 14.513l-.266-.264-4.691-4.653.205 2.42.242 2.865-2.488-1.44-1.207-.699.122.841.164 1.132-1.048.458c-4.765 2.085-8.087 6.833-8.087 12.35C10.5 34.964 16.542 41 24 41s13.5-6.036 13.5-13.477c0-6.081-4.037-11.228-9.588-12.902l-.358-.108zm-9.86-2.728l-.002-.008-.026-.18-.094-.647a.517.517 0 01.771-.522l.567.327.157.091.006.004.651.377 1.583.916-.154-1.822-.2-2.355-.005-.07-.034-.397-.037-.438a.517.517 0 01.88-.411l.312.31.283.28.05.05 5.943 5.894C34.51 15.044 39 20.76 39 27.524c0 8.27-6.716 14.976-15 14.976-8.284 0-15-6.705-15-14.977 0-6.136 3.696-11.41 8.986-13.724l-.292-2.014zM18.75 25.5a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM31 23.75a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm-3.714 7.481L24 32.736l-3.287-1.505c.16-.374.404-.68.704-.927.586-.483 1.479-.804 2.582-.804 1.103 0 1.996.321 2.582.804.3.247.543.553.704.927zm.146 1.583l-2.887 1.323a1.306 1.306 0 01-1.088 0l-2.89-1.323c.07.26.197.568.395.918.322.57.78 1.154 1.29 1.688.51.533 1.034.98 1.46 1.282.11.077.206.14.288.191.082-.05.179-.114.288-.191.426-.302.95-.749 1.46-1.282.51-.534.968-1.118 1.29-1.688.198-.35.325-.657.394-.918zm-3.713 4.228s.007-.004.02-.008l-.012.005a.03.03 0 01-.008.003zm.542-.008l.014.005.004.002h.002a.11.11 0 01-.02-.007zM29 32.352c0 2.747-4.114 6.148-5 6.148-.886 0-5-3.401-5-6.148S21.239 28 24 28s5 1.605 5 4.352z",
    fill: "#D8D8D8"
  }));
}

function SvgIcPestsEtcS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.345 10.686C34.51 12.546 39 18.262 39 25.025c0 8.271-6.716 14.977-15 14.977-8.284 0-15-6.706-15-14.977 0-6.136 3.696-11.41 8.986-13.725l-.414-2.849a.517.517 0 01.771-.522l2.964 1.715-.43-5.082a.517.517 0 01.88-.41l6.588 6.534z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.554 12.014l-.266-.263-4.691-4.653.205 2.42.242 2.864-2.488-1.44-1.207-.698.122.84.164 1.132-1.048.459c-4.765 2.084-8.087 6.832-8.087 12.35 0 7.44 6.042 13.477 13.5 13.477s13.5-6.036 13.5-13.477c0-6.082-4.037-11.228-9.588-12.903l-.358-.108zm-9.86-2.728l-.002-.007-.026-.18-.094-.648a.517.517 0 01.771-.522l.567.328.157.091.006.004.651.376 1.583.916-.154-1.822-.2-2.354-.005-.07-.034-.397-.037-.439a.517.517 0 01.88-.41l.312.31.283.28.05.05 5.943 5.894C34.51 12.546 39 18.262 39 25.025c0 8.271-6.716 14.977-15 14.977-8.284 0-15-6.706-15-14.977 0-6.136 3.696-11.41 8.986-13.725l-.292-2.014zm1.056 13.716a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zM31 21.252a1.75 1.75 0 11-3.5 0 1.75 1.75 0 013.5 0zm-3.714 7.48L24 30.238l-3.287-1.504c.16-.375.404-.68.704-.927C22.004 27.323 22.897 27 24 27c1.103 0 1.996.322 2.582.805.3.246.543.552.704.927zm.146 1.584l-2.887 1.322a1.306 1.306 0 01-1.088 0l-2.89-1.323c.07.261.197.569.395.918.322.57.78 1.155 1.29 1.689.51.533 1.034.98 1.46 1.281.11.078.206.141.288.192a5.25 5.25 0 00.288-.192c.426-.302.95-.748 1.46-1.281.51-.534.968-1.119 1.29-1.688.198-.35.325-.657.394-.919zm-3.713 4.227l.02-.007-.012.005a.026.026 0 01-.008.002zm.542-.007l.014.005.004.001a.113.113 0 01-.018-.006zM29 29.853c0 2.747-4.114 6.148-5 6.148-.886 0-5-3.4-5-6.148 0-2.747 2.239-4.352 5-4.352s5 1.605 5 4.352z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPetsNoneDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.313 9.373a.75.75 0 011.013-.313c.206.108.396.252.564.432l.362.387a.75.75 0 01-1.095 1.025l-.363-.388a.633.633 0 00-.167-.13.75.75 0 01-.314-1.013zm23.374 0a.75.75 0 01-.314 1.014.633.633 0 00-.167.13l-.363.387a.75.75 0 11-1.096-1.025l.363-.387a2.13 2.13 0 01.564-.432.75.75 0 011.013.313zm-24.366.392a.75.75 0 01.463.955.633.633 0 00-.034.209v.502a.75.75 0 01-1.5 0v-.502c0-.246.04-.482.116-.7a.75.75 0 01.955-.464zm25.358 0a.75.75 0 01.955.463c.076.22.116.455.116.7v.503a.75.75 0 01-1.5 0v-.502a.633.633 0 00-.033-.21.75.75 0 01.462-.954zm-21.674 2.017a.75.75 0 011.06.036l.726.775a.75.75 0 11-1.096 1.025l-.725-.776a.75.75 0 01.035-1.06zm17.99 0a.75.75 0 01.035 1.06l-.725.776a.75.75 0 01-1.096-1.025l.726-.775a.75.75 0 011.06-.036zM11 13.194a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zm26 0a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zm-19.457 1.302a.75.75 0 011.06.035l.363.388a.743.743 0 01.066.061.714.714 0 01.09.006h.464a.75.75 0 010 1.5h-.464c-.068 0-.134-.003-.2-.011a.747.747 0 01-.445-.216.746.746 0 01-.461-.177c-.051-.043-.1-.09-.145-.138l-.363-.388a.75.75 0 01.035-1.06zm12.914 0a.75.75 0 01.035 1.06l-.363.388a1.716 1.716 0 01-.145.138.746.746 0 01-.461.177.747.747 0 01-.445.216 1.703 1.703 0 01-.2.011h-.464a.75.75 0 110-1.5H28.903a.714.714 0 01.065-.006.773.773 0 01.066-.061l.363-.388a.75.75 0 011.06-.035zm-9.298 1.24a.75.75 0 01.75-.75h.93a.75.75 0 010 1.5h-.93a.75.75 0 01-.75-.75zm3.253 0a.75.75 0 01.75-.75h.929a.75.75 0 010 1.5h-.93a.75.75 0 01-.75-.75zM11 16.712a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zm26 0a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zM11 20.23a.75.75 0 01.75.75v1.005a.75.75 0 11-1.5 0V20.98a.75.75 0 01.75-.75zm26 0a.75.75 0 01.75.75v1.005a.75.75 0 11-1.5 0V20.98a.75.75 0 01.75-.75zm0 3.517a.75.75 0 01.75.75V25c0 .172-.003.344-.01.514a.75.75 0 11-1.498-.055c.005-.152.008-.305.008-.46v-.502a.75.75 0 01.75-.75zm-26 0a.75.75 0 01.75.75V25c0 .154.003.307.008.46a.75.75 0 11-1.498.054c-.007-.17-.01-.342-.01-.514v-.503a.75.75 0 01.75-.75zm25.843 3.416a.75.75 0 01.576.837.75.75 0 01-.026 1.5h-.624a.75.75 0 01-1.073-.84.746.746 0 01.07-.238c.066-.229.126-.46.18-.694a.75.75 0 01.897-.565zm-25.686 0a.75.75 0 01.898.565c.053.234.113.465.18.694.035.073.06.154.07.239a.75.75 0 01-1.074.839h-.624a.75.75 0 01-.026-1.5.75.75 0 01.576-.837zm24.69 3.25a.75.75 0 01.312 1.014c-.103.194-.21.385-.322.573h.556a.75.75 0 010 1.5h-.953a.75.75 0 01-.735-.897.75.75 0 01-.33-1.085c.162-.259.315-.523.458-.794a.75.75 0 011.014-.311zm-23.694 0a.75.75 0 011.014.311c.143.271.296.535.459.793a.75.75 0 01-.33 1.086.75.75 0 01-.736.897h-.953a.75.75 0 010-1.5h.556c-.112-.188-.219-.38-.322-.573a.75.75 0 01.312-1.014zm21.887 2.88a.75.75 0 01.04 1.06c-.234.25-.476.493-.727.726a.75.75 0 11-1.021-1.099c.167-.155.33-.316.49-.48h-.715a.75.75 0 010-1.5h.953a.75.75 0 01.655 1.115c.117.03.23.089.325.177zm-18.861.207h.714a.75.75 0 000-1.5h-.953a.75.75 0 00-.655 1.115.75.75 0 00-.365 1.237c.234.252.476.494.727.727a.75.75 0 101.021-1.099c-.167-.155-.33-.316-.49-.48zm1.27 2.11a.75.75 0 011.033-.236c.258.163.523.316.793.459a.75.75 0 11-.702 1.325c-.303-.16-.6-.332-.89-.514a.75.75 0 01-.235-1.035zm15.103 0a.75.75 0 01-.235 1.034c-.29.182-.587.354-.89.514a.75.75 0 11-.702-1.325c.27-.143.535-.296.793-.459a.75.75 0 011.034.235zm-3.002 1.595a.75.75 0 01-.496.937c-.326.1-.658.19-.994.266a.75.75 0 11-.332-1.463c.299-.068.594-.147.884-.236a.75.75 0 01.938.496zm-9.1 0a.75.75 0 01.938-.496c.29.09.585.168.884.236a.75.75 0 11-.332 1.463 13.658 13.658 0 01-.994-.266.75.75 0 01-.496-.937zm3.314.758a.75.75 0 01.777-.721 12.507 12.507 0 00.918 0 .75.75 0 11.056 1.498 14.181 14.181 0 01-1.03 0 .75.75 0 01-.721-.777zM7 28.75a.75.75 0 01.75-.75h.476a.75.75 0 010 1.5H7.75a.75.75 0 01-.75-.75zm6.19 0a.75.75 0 01.75-.75h.953a.75.75 0 010 1.5h-.953a.75.75 0 01-.75-.75zm3.334 0a.75.75 0 01.75-.75h.476a.75.75 0 010 1.5h-.476a.75.75 0 01-.75-.75zM8.75 32a.75.75 0 000 1.5h.476a.75.75 0 000-1.5H8.75zm9.524 0a.75.75 0 000 1.5h.476a.75.75 0 000-1.5h-.476zM41 28.75a.75.75 0 00-.75-.75h-.476a.75.75 0 000 1.5h.476a.75.75 0 00.75-.75zm-6.19 0a.75.75 0 00-.75-.75h-.953a.75.75 0 000 1.5h.953a.75.75 0 00.75-.75zm-3.334 0a.75.75 0 00-.75-.75h-.476a.75.75 0 000 1.5h.476a.75.75 0 00.75-.75zM39.25 32a.75.75 0 010 1.5h-.476a.75.75 0 010-1.5h.476zm-9.524 0a.75.75 0 010 1.5h-.476a.75.75 0 010-1.5h.476z",
    fill: "#D8D8D8"
  }));
}

function SvgIcPlusSmallB20S16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 2.934a.75.75 0 00-1.5 0v5h-5a.75.75 0 000 1.5h5v5a.75.75 0 001.5 0v-5h5a.75.75 0 000-1.5h-5v-5z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcPlusSmallS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 2.25a.75.75 0 00-1.5 0v5h-5a.75.75 0 000 1.5h5v5a.75.75 0 001.5 0v-5h5a.75.75 0 000-1.5h-5v-5z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPlusS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1a1 1 0 00-2 0v6H1a1 1 0 000 2h6v6a1 1 0 102 0V9h6a1 1 0 100-2H9V1z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPlusS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3a1 1 0 10-2 0v8H3a1 1 0 100 2h8v8a1 1 0 102 0v-8h8a1 1 0 100-2h-8V3z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

var SvgIcPlusWS16 = function SvgIcPlusWS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.8.9A.9.9 0 1 0 7 .9v6.3H.9A.9.9 0 1 0 .9 9H7v6.1a.9.9 0 1 0 1.8 0V9h6.3a.9.9 0 1 0 0-1.8H8.8V.9Z",
    fill: "#fff"
  }));
};

function SvgIcPointS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M39.25 24c0 8.422-6.828 15.25-15.25 15.25S8.75 32.422 8.75 24 15.578 8.75 24 8.75 39.25 15.578 39.25 24z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.255 31.093c.984 0 1.54-.603 1.54-1.652v-2.486h2.041c2.904 0 4.686-1.55 4.686-4.323 0-2.607-1.754-4.296-4.528-4.296h-3.256c-1.447 0-2.004.585-2.004 2.097v9.008c0 1.058.547 1.652 1.521 1.652zm1.55-6.42v-3.97h1.735c1.252 0 1.948.723 1.948 1.985 0 1.465-.705 1.985-2.292 1.985h-1.391z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPrivacyS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.112 15.091c.037-.523.083-1.054.139-1.593 0 0 .518.323 1.457.5 1.932.361 5.643.102 10.278-4.863.33-.354.665-.732 1.004-1.135.34.403.674.781 1.005 1.135 4.636 4.97 8.358 5.224 10.295 4.86.939-.175 1.458-.497 1.458-.497.055.539.102 1.07.139 1.593.873 12.296-3.294 20.337-12.897 23.242-9.548-2.905-13.749-10.946-12.878-23.241zm1.476.408a8.54 8.54 0 002.431.043c2.456-.297 5.543-1.65 8.97-5.285 3.427 3.636 6.518 4.988 8.979 5.285a8.577 8.577 0 002.443-.044c.36 5.577-.374 10.095-2.118 13.555-1.847 3.663-4.89 6.27-9.301 7.708-4.385-1.438-7.425-4.044-9.275-7.709-1.746-3.46-2.487-7.978-2.13-13.553zm7.079 11.675v.873c0 .396.32.717.717.717h7.232a.717.717 0 00.717-.717v-.873c0-1.582-2.1-3.285-4.333-3.285-2.23 0-4.333 1.703-4.333 3.285zM24 18.834c1.192 0 2.167.974 2.167 2.166A2.173 2.173 0 0124 23.167 2.173 2.173 0 0121.833 21c0-1.192.975-2.167 2.167-2.167z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPrivatestrokeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.047 6.392c.029-.517.071-1.046.127-1.585 0 0 .53.33 1.467.406 1.368.112 3.607-.314 6.336-3.092.332-.338.67-.71 1.016-1.121.346.41.684.783 1.016 1.121 2.731 2.781 4.977 3.205 6.35 3.091.936-.077 1.466-.405 1.466-.405.056.539.098 1.067.127 1.584.463 8.24-2.437 13.636-8.959 15.609-6.485-1.973-9.406-7.368-8.946-15.608zm1.485.317c.391.031.828.029 1.306-.03 1.746-.21 3.855-1.131 6.155-3.453 2.299 2.322 4.411 3.242 6.16 3.454.481.058.921.06 1.314.029.173 3.58-.336 6.458-1.446 8.658-1.198 2.378-3.158 4.088-6.026 5.058-2.85-.97-4.808-2.68-6.01-5.059-1.11-2.2-1.624-5.078-1.453-8.657zM9 14.274v.384c0 .396.321.717.717.717h4.566a.717.717 0 00.717-.717v-.384C15 13.18 13.545 12 12 12c-1.543 0-3 1.179-3 2.274zM12 8.5c.825 0 1.5.675 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.675-1.5-1.5.675-1.5 1.5-1.5z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcQmarkStrokeB20S16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_QmarkStroke_B20_S16_V0_1_svg__clip0_4837_3601)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8.684a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm6.5 8a8 8 0 110-16 8 8 0 010 16zm-.37-6.38c-.515 0-.773-.322-.773-.743 0-.627.311-1.032 1.038-1.582l.039-.03c.494-.377.84-.64.84-1.113 0-.533-.499-.844-1.055-.844-.457 0-.809.17-1.084.528-.2.205-.358.316-.627.316-.446 0-.674-.31-.674-.668 0-.363.205-.732.527-1.014.434-.375 1.125-.615 2.04-.615 1.628 0 2.77.803 2.77 2.186 0 1.007-.603 1.494-1.312 1.986-.48.351-.709.557-.89.973-.2.352-.352.62-.838.62zm-.01 2.497c-.563 0-1.026-.364-1.026-.926 0-.563.463-.926 1.025-.926.563 0 1.02.364 1.02.926 0 .563-.457.926-1.02.926z",
    fill: "#000",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_QmarkStroke_B20_S16_V0_1_svg__clip0_4837_3601"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .684)",
    d: "M0 0h16v16H0z"
  }))));
}

function SvgIcQmarkS16(props) {
  var _props$fillOpacity;

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_Qmark_S16_svg__clip0_237_18372)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.843 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zm6.5 8a8 8 0 110-16 8 8 0 010 16zm-.37-6.379c-.515 0-.773-.322-.773-.744 0-.627.31-1.031 1.037-1.582l.04-.03c.494-.376.84-.639.84-1.113 0-.533-.499-.843-1.055-.843-.458 0-.81.17-1.084.527-.2.205-.358.316-.627.316-.446 0-.674-.31-.674-.668 0-.363.205-.732.527-1.013.434-.375 1.125-.616 2.04-.616 1.628 0 2.77.803 2.77 2.186 0 1.008-.603 1.494-1.312 1.986-.48.352-.709.557-.89.973H8.81c-.199.352-.351.621-.837.621zm-.011 2.496c-.563 0-1.025-.363-1.025-.926 0-.562.462-.925 1.025-.925.562 0 1.02.363 1.02.925 0 .563-.458.926-1.02.926z",
    fill: "#000",
    fillOpacity: (_props$fillOpacity = props.fillOpacity) !== null && _props$fillOpacity !== void 0 ? _props$fillOpacity : 0.35
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_Qmark_S16_svg__clip0_237_18372"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.343)",
    d: "M0 0h16v16H0z"
  }))));
}

function SvgIcQsmarkstrokeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zM8 16A8 8 0 118 0a8 8 0 010 16zm-.37-6.379c-.515 0-.773-.322-.773-.744 0-.627.311-1.031 1.038-1.582l.039-.03c.494-.376.84-.639.84-1.113 0-.533-.499-.843-1.055-.843-.457 0-.809.17-1.084.527-.2.205-.358.316-.627.316-.446 0-.674-.31-.674-.668 0-.363.205-.732.527-1.013.434-.375 1.125-.616 2.04-.616 1.628 0 2.77.803 2.77 2.186 0 1.008-.603 1.494-1.312 1.986-.48.352-.709.557-.89.973-.2.352-.352.621-.838.621zm-.01 2.496c-.563 0-1.026-.363-1.026-.926 0-.562.463-.925 1.025-.925.563 0 1.02.363 1.02.925 0 .563-.457.926-1.02.926z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcQuickCalendarS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0a.75.75 0 01.75.75v.75h3.5V.75a.75.75 0 011.5 0v.75H13a2 2 0 012 2V13a2 2 0 01-2 2H3a2 2 0 01-2-2V3.5a2 2 0 012-2h1.75V.75A.75.75 0 015.5 0zm4.25 3v.25a.75.75 0 001.5 0V3H13a.5.5 0 01.5.5v1.25h-11V3.5A.5.5 0 013 3h1.75v.25a.75.75 0 001.5 0V3h3.5zM2.5 6.25h11V13a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5V6.25zM9.022 8c.108 0 .172.12.113.21l-.953 1.457h1.444c.126 0 .184.158.086.24l-3.015 2.512c-.12.1-.285-.048-.2-.178l1.14-1.741H6.63a.135.135 0 01-.118-.202l1.172-2.093A.4.4 0 018.035 8h.987z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcQuickCalendarS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.25a.75.75 0 01.75.75v1h6.5V3a.75.75 0 011.5 0v1H19a2 2 0 012 2v13a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h2.25V3A.75.75 0 018 2.25zm7.25 4.25a.75.75 0 001.5 0v-1H19a.5.5 0 01.5.5v2.5h-15V6a.5.5 0 01.5-.5h2.25v1a.75.75 0 001.5 0v-1h6.5v1zM4.5 10h15v9a.5.5 0 01-.5.5H5a.5.5 0 01-.5-.5v-9zm9.153 1.5c.108 0 .173.122.112.212L12.273 13.9h2.34c.129 0 .185.161.085.241l-4.685 3.749c-.179.143-.419-.078-.291-.268l1.732-2.588H9.788a.136.136 0 01-.115-.206l1.922-3.114a.452.452 0 01.384-.214h1.674z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcQuickS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.514 1.464a.3.3 0 00-.25-.464h-3.24a1 1 0 00-.86.49L3.36 7.91a.3.3 0 00.258.454H6.91l-3.853 5.993c-.185.288.181.612.445.392l9.862-8.219a.3.3 0 00-.192-.53H8.545l2.97-4.536z",
    fill: "#FF5151"
  }));
}

function SvgIcRecyclablewasteS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.977 15.537h0c.188.354.162.756-.078 1.09h0l-.729 1.004s0 0 0 0c-.217.3-.593.495-1.002.495H14.892v-1.862l-2.763 2.763 2.763 2.764v-1.862H18.168c.973 0 1.892-.451 2.463-1.238l-.654-3.154zm0 0l-.003-.004-1.644-2.796 1.555-.913 1.674 2.843.001.001.009.015c.51.955.425 2.125-.21 3.001l-.728 1.007-.654-3.154zM6.507 9.761l.86 3.812-1.507-.951-.087-.055-.052.089-1.696 2.872h0l-.002.003c-.193.36-.168.76.075 1.096h0l.728 1.004s0 0 0 0c.216.3.592.495 1.003.495h4.055v1.803H5.829a3.032 3.032 0 01-2.463-1.24h0l-.71-.979v-.002l-.019-.026a2.847 2.847 0 01-.204-3.001l.009-.015v-.002l1.76-2.973.05-.084-.082-.052-1.474-.93 3.811-.864zM8.35 4.669h0l.002-.004C8.874 3.692 9.906 3.1 11.018 3.1h1.991c1.112 0 2.146.592 2.672 1.57h0l.002.003 1.602 2.725.052.087.086-.052 1.561-.942-.942 3.796-3.793-.943 1.456-.877.085-.05-.05-.086-1.643-2.794h0l-.009-.016c-.196-.367-.611-.618-1.079-.618h-1.99c-.471 0-.884.251-1.08.615l-.01.016-1.583 2.683-1.55-.917 1.553-2.631z",
    fill: "#000",
    fillOpacity: 0.85,
    stroke: "#fff",
    strokeWidth: 0.2
  }));
}

function SvgIcRecyclablewasteS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28.438 38.607l-3.963-3.963 3.963-3.963v2.71h5.43c.713 0 1.373-.339 1.758-.87 0 0 0 0 0 0l1.166-1.606.001-.002a1.803 1.803 0 00.137-1.943l-.003-.007-.004-.006-2.535-4.31 2.161-1.268 2.581 4.382.001.002.013.022a4.365 4.365 0 01-.322 4.598l-1.166 1.61c-.877 1.209-2.289 1.904-3.788 1.904h-5.43v2.71zm-13.37-18.562L16.3 25.51l-2.023-1.276-.304-.193-.184.31-2.712 4.596h0l-.007.012a1.792 1.792 0 00.132 1.954h.001l1.165 1.605v.002c.382.532 1.043.87 1.759.87h6.297v2.506h-6.297c-1.499 0-2.914-.7-3.788-1.907h0l-1.1-1.515v-.004l-.066-.092a4.365 4.365 0 01-.313-4.598l.012-.021 2.815-4.758.174-.293-.288-.181-1.97-1.244 5.465-1.24zm3.255-8.279l.003-.006.004-.006c.801-1.492 2.387-2.404 4.099-2.404h3.185c1.713 0 3.302.912 4.108 2.412h0l.006.012 2.565 4.36.18.304.302-.182 2.105-1.27-1.351 5.442-5.44-1.35 1.937-1.168.297-.178-.176-.299-2.626-4.468-.002-.003-.012-.02c-.35-.651-1.08-1.087-1.893-1.087H22.43c-.818 0-1.543.436-1.893 1.082l-.012.022-2.438 4.128-2.154-1.274 2.39-4.047z",
    fill: "#000",
    fillOpacity: 0.85,
    stroke: "#fff",
    strokeWidth: 0.7
  }));
}

function SvgIcRecycleS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.242 12.648a1.952 1.952 0 011.943-2.14h20.139c1.152 0 2.054.993 1.943 2.14L34.005 36.19A2 2 0 0132.015 38h-15.52a2 2 0 01-1.99-1.809l-2.263-23.543z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.989 12.576a1.202 1.202 0 011.196-1.317h20.139c.71 0 1.265.61 1.197 1.317L33.258 36.12a1.25 1.25 0 01-1.244 1.13H16.495a1.25 1.25 0 01-1.244-1.13l-2.262-23.544z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 28.509,
    height: 6.618,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 10.75,
    width: 27.009,
    height: 5.118,
    rx: 1.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.302 24.85l2.148.129 1.032-1.953-.72.413-1.084-1.729s-1.612-.018-2.606.03c-.407.02-.72.177-.857.419l-1.397 2.466 1.78 1.007 1.516-2.68.91 1.482-.722.416zm-2.61 2.311l.758.447-.985-1.958-2.209.067.713.422L19 27.933s.779 1.412 1.31 2.254c.216.345.506.54.786.54h2.834v-2.044h-3.08l.842-1.522zm4.083-1.339l1.798-.972 1.348 2.494c.132.245.099.592-.1.948-.49.867-1.36 2.224-1.36 2.224h-2.04l-.032.828-1.109-1.909 1.246-1.708-.027.788 1.74.017-1.464-2.71z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcRefreshS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.49 3.83a.5.5 0 00.466-.676L12.915.39a.5.5 0 00-.88-.107l-.517.75A7.8 7.8 0 006.036.503C1.88 1.619-.597 5.873.516 10.01c1.111 4.139 5.387 6.577 9.542 5.46 3.729-1.001 6.105-4.528 5.752-8.232a.75.75 0 10-1.494.142c.285 2.98-1.63 5.832-4.647 6.642-3.364.904-6.81-1.072-7.705-4.401-.894-3.329 1.097-6.767 4.461-7.67a6.3 6.3 0 014.229.333l-.53.768a.5.5 0 00.413.784l2.953-.007z",
    fill: "#42484C"
  }));
}

function SvgIcRefriDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 9.5h15A2.5 2.5 0 0134 12v7.083H14V12a2.5 2.5 0 012.5-2.5zM14 20.583V35a2.5 2.5 0 002.5 2.5h15A2.5 2.5 0 0034 35V20.583H14zM12.5 12a4 4 0 014-4h15a4 4 0 014 4v23a4 4 0 01-4 4h-15a4 4 0 01-4-4V12zm5.333 1.045a.75.75 0 01.75.75v2.974a.75.75 0 01-1.5 0v-2.974a.75.75 0 01.75-.75zm.843 9.814a.75.75 0 00-1.5 0v2.974a.75.75 0 101.5 0V22.86z",
    fill: "#D8D8D8"
  }));
}

function SvgIcRefriS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 0.75,
    width: 12.9,
    height: 14.5,
    rx: 2.25,
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8 6.5h12.8",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M4.15 3.75v.42M4.15 8.75v.42"
  }));
}

function SvgIcRefriS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 2.75,
    width: 16.5,
    height: 18.5,
    rx: 2.25,
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10h16",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M6.75 6.75v.9M6.75 12.75v.9"
  }));
}

function SvgIcRefriS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 13.25,
    y: 8.75,
    width: 21.5,
    height: 29.5,
    rx: 3.25,
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 19.833H35",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.833 13.795v2.974M17.926 22.859v2.974",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcRegularCalendarS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 1a.75.75 0 00-1.5 0v.5H3a2 2 0 00-2 2V13a2 2 0 002 2h10a2 2 0 002-2V3.5a2 2 0 00-2-2h-1.75V1a.75.75 0 00-1.5 0v.5h-3.5V1zm3.5 2.5V3h-3.5v.5a.75.75 0 01-1.5 0V3H3a.5.5 0 00-.5.5v2h11v-2A.5.5 0 0013 3h-1.75v.5a.75.75 0 01-1.5 0zM13.5 7h-11v6a.5.5 0 00.5.5h10a.5.5 0 00.5-.5V7zM8 11a1 1 0 100-2 1 1 0 000 2zm-2.5-1a1 1 0 11-2 0 1 1 0 012 0zm6 1a1 1 0 100-2 1 1 0 000 2z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcRegularCalendarW(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.143.5a.75.75 0 01.75.75V2h4.214v-.75a.75.75 0 011.5 0V2H14a2 2 0 012 2v10.5a2 2 0 01-2 2H2a2 2 0 01-2-2V4a2 2 0 012-2h2.393v-.75a.75.75 0 01.75-.75zm4.964 3v.607a.75.75 0 001.5 0V3.5H14a.5.5 0 01.5.5v2.536h-13V4a.5.5 0 01.5-.5h2.393v.607a.75.75 0 101.5 0V3.5h4.214zM1.5 8.036h13V14.5a.5.5 0 01-.5.5H2a.5.5 0 01-.5-.5V8.036zm9.06 2.463A.75.75 0 109.44 9.5L7.322 11.88l-.815-.748a.75.75 0 10-1.014 1.105L6.868 13.5a.75.75 0 001.068-.054L10.56 10.5z",
    fill: "#fff"
  }));
}

function SvgIcReminderOffS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12a8 8 0 11-16 0 8 8 0 0116 0zm-8 9.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19zm.728-14.017a.75.75 0 00-1.5 0v5.54l-2.93 2.213a.75.75 0 00.904 1.197l3.228-2.437a.75.75 0 00.298-.599V7.483z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcReminderOnS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.5a9.5 9.5 0 100-19 9.5 9.5 0 000 19zm-.022-14.267a.75.75 0 01.75.75v5.914a.75.75 0 01-.298.599l-3.228 2.437a.75.75 0 01-.904-1.197l2.93-2.212V7.983a.75.75 0 01.75-.75z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcReportS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 11.625V13a.5.5 0 01-.5.5h-9a.5.5 0 01-.5-.5v-1.375c0-.069.056-.125.125-.125h.625a2.5 2.5 0 002.45-2h3.6a2.5 2.5 0 002.45 2h.625c.069 0 .125.056.125.125zm-11.5 0c0-.898.727-1.625 1.625-1.625h.625a1 1 0 001-1 1 1 0 011-1h4.5a1 1 0 011 1 1 1 0 001 1h.625c.898 0 1.625.727 1.625 1.625V13a2 2 0 01-2 2h-9a2 2 0 01-2-2v-1.375zM13.75 14c0-.69.56-1.25 1.25-1.25h1a.75.75 0 000-1.5h-1A2.75 2.75 0 0012.25 14v22A2.75 2.75 0 0015 38.75h18A2.75 2.75 0 0035.75 36V14A2.75 2.75 0 0033 11.25h-1a.75.75 0 000 1.5h1c.69 0 1.25.56 1.25 1.25v22c0 .69-.56 1.25-1.25 1.25H15c-.69 0-1.25-.56-1.25-1.25V14zm10.84 7.75a.75.75 0 000 1.5h5.82a.75.75 0 000-1.5h-5.82zm-.75 7.75a.75.75 0 01.75-.75h5.82a.75.75 0 010 1.5h-5.82a.75.75 0 01-.75-.75zm-2.31-9.03a.75.75 0 010 1.06l-2.616 2.617a.75.75 0 01-1.033.026l-1.384-1.25a.75.75 0 011.006-1.113l.855.772 2.112-2.112a.75.75 0 011.06 0zm0 8.06a.75.75 0 10-1.06-1.06l-2.112 2.112-.855-.772a.75.75 0 00-1.006 1.113l1.384 1.25a.75.75 0 001.033-.026l2.616-2.617z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcReviewS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2a1 1 0 00-1 1v9a1 1 0 001 1h3.429l1.812 2.114a1 1 0 001.518 0L10.571 13H14a1 1 0 001-1V3a1 1 0 00-1-1H2zm6 4c0-.276-.138-.5-.308-.5H4.308l-.03.002C4.122 5.527 4 5.74 4 6c0 .276.138.5.308.5h3.384l.03-.002C7.878 6.473 8 6.26 8 6zm3.589 2.5c.227 0 .411.224.411.5 0 .26-.163.473-.372.498l-.04.002H4.412C4.184 9.5 4 9.276 4 9c0-.26.163-.473.372-.498l.04-.002h7.177z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcReviewS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.74 32.5a1.5 1.5 0 011.142.527L24 36.687l3.118-3.66a1.5 1.5 0 011.142-.527H36a.5.5 0 00.5-.5V14a.5.5 0 00-.5-.5H12a.5.5 0 00-.5.5v18a.5.5 0 00.5.5h7.74zM10 14a2 2 0 012-2h24a2 2 0 012 2v18a2 2 0 01-2 2h-7.74l-3.118 3.66a1.5 1.5 0 01-2.284 0L19.741 34H12a2 2 0 01-2-2V14zm5.462 11.5a.75.75 0 01.75-.75h13.576a.75.75 0 010 1.5H16.212a.75.75 0 01-.75-.75zm.66-5.75a.75.75 0 000 1.5h7.757a.75.75 0 000-1.5H16.12z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcRodmopS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.952 15.25a2 2 0 011.84-1.215h14.57a2 2 0 011.856 1.257l1.733 4.328a1 1 0 01-.928 1.372H2.014a1 1 0 01-.92-1.393l1.858-4.35z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.642 15.544a1.25 1.25 0 011.15-.759h14.57c.51 0 .97.311 1.16.786l1.733 4.328a.25.25 0 01-.232.343H2.014a.25.25 0 01-.23-.348l1.858-4.35z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.184.983a.25.25 0 01.25-.233h1.133a.25.25 0 01.249.233l.748-.052-.748.052 1.118 16.2a.25.25 0 01-.25.267h-3.368a.25.25 0 01-.25-.267l1.118-16.2z",
    fill: "#F7F7F7",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.2925 .95626 -.9199 .39217 16 15)",
    stroke: "#262626",
    d: "M0-.5h5.458"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.2925 .95626 .9199 .39217 8 15)",
    stroke: "#262626",
    d: "M0-.5h5.458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 20.75a.75.75 0 01.75-.75h20.544a.75.75 0 010 1.5H1.75a.75.75 0 01-.75-.75z",
    fill: "#262626"
  }));
}

function SvgIcRulerReviewS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.85 18.897H4.994l4.386-4.385c.035.07.082.134.142.19l1.634 1.546a.694.694 0 00.954-1.008l-1.635-1.545a.691.691 0 00-.163-.116l1.555-1.555a.7.7 0 00.071.077l1.904 1.779a.694.694 0 00.947-1.014l-1.903-1.779a.697.697 0 00-.044-.037l1.504-1.504a.705.705 0 00.038.04l1.841 1.791a.694.694 0 00.968-.994l-1.842-1.79a.659.659 0 00-.027-.026l4.524-4.524v14.854zm-.192-16.624L3.225 18.706c-.583.582-.17 1.579.654 1.579h16.433c.51 0 .925-.415.925-.925V2.927c0-.824-.996-1.237-1.58-.654z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcSchduleOffS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.385c0-.35.284-.635.635-.635h15.23c.35 0 .635.284.635.635v14.23c0 .35-.284.635-.635.635H4.385a.635.635 0 01-.635-.635V4.385z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2v3M15.75 2v3",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.25h17",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcSchduleOnS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2v3M15.75 2v3",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.385C3 3.62 3.62 3 4.385 3h15.23C20.38 3 21 3.62 21 4.385v14.23C21 19.38 20.38 20 19.615 20H4.385C3.62 20 3 19.38 3 18.615V4.385zM12 15.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm8.998-5.5H3V8.5h17.998V10z",
    fill: "#262626"
  }));
}

function SvgIcSearchS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6.5a5 5 0 11-10 0 5 5 0 0110 0zm.096 4.035a6.5 6.5 0 10-1.06 1.06l3.684 3.685a.75.75 0 001.06-1.06l-3.684-3.685z",
    fill: "#000",
    fillOpacity: 0.2
  }));
}

function SvgIcServicecoverageS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.567 2.35c.331-.331.264-.936-.15-1.35-.414-.414-1.018-.481-1.35-.15L9.624 5.293l-.913-.914a.264.264 0 00-.365.002C6.319 6.348 3.689 7.337 1.534 7.39h-.001a7.312 7.312 0 01-.316.002H1.21a6.306 6.306 0 01-.868-.075.266.266 0 00-.223.067.233.233 0 00-.072.21c.038.22.087.442.145.665l.002.01c.048.18.101.362.16.543l.008.022c.479 1.443 1.341 2.886 2.466 4.095 1.535 1.651 3.404 2.722 5.264 3.015a.257.257 0 00.276-.14l3.712-7.841a.232.232 0 00-.052-.268l-.904-.903.354-.354 4.089-4.089zM7.444 14.252a7.353 7.353 0 01-1.7-.813 4.121 4.121 0 001.797-1.523.75.75 0 00-1.248-.832c-.12.179-.247.33-.377.458l-1.506.708a.753.753 0 00-.137.014 10.357 10.357 0 01-.938-1.05c.142-.033.3-.073.467-.12.624-.178 1.474-.489 2.101-1.023a.75.75 0 00-.972-1.142c-.376.32-.97.56-1.539.722a8.27 8.27 0 01-.948.208 9.37 9.37 0 01-.47-.987C3.48 8.77 5.105 8.3 6.632 7.475l2.728 2.729-1.916 4.048zm-1.528-2.71a2.524 2.524 0 01-1.36.693 1.562 1.562 0 01-.146.015l1.506-.708zm2.024-4.88l2.102 2.102.3-.633-1.87-1.868c-.174.138-.352.271-.532.4z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcServicecoverageS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.752 10.02l-9.494 9.493 1.518 1.519 9.494-9.494c.022-.022.091-.109.066-.336-.026-.232-.152-.54-.43-.819-.279-.278-.587-.404-.818-.43-.228-.025-.314.044-.337.067zm-10.555 8.433l-.014.014-1.573-1.573a.54.54 0 00-.374-.146.537.537 0 00-.372.15c-4.946 4.8-11.648 6.752-16.358 6.002a.545.545 0 00-.456.137.476.476 0 00-.147.43c.652 3.747 2.724 7.721 5.684 10.904 3.136 3.374 6.957 5.562 10.758 6.162a.525.525 0 00.564-.287l7.587-16.025a.473.473 0 00-.107-.547l-1.567-1.567.014-.015 9.494-9.494c.804-.804.641-2.27-.364-3.275s-2.471-1.168-3.275-.364l-9.494 9.494zm3.633 5.782l-5.616-5.615a23.731 23.731 0 01-1.89 1.524l6.409 6.409 1.097-2.318zm-1.779 3.757l-6.991-6.991c-4.054 2.564-8.595 3.745-12.388 3.53.387 1.454.995 2.939 1.791 4.378a37.216 37.216 0 002.099-.807c1.43-.6 3.023-1.383 3.952-2.173a.75.75 0 11.972 1.142c-1.122.955-2.908 1.811-4.344 2.414a40.507 40.507 0 01-1.892.737 22.797 22.797 0 001.752 2.359l.007-.003.006-.003.024-.01.097-.042c.086-.039.213-.096.371-.17.318-.151.761-.371 1.26-.65 1.012-.563 2.207-1.338 3.07-2.226a.75.75 0 011.075 1.046c-1.014 1.042-2.357 1.902-3.414 2.49-.535.298-1.008.534-1.35.695l-.084.04c2.67 2.735 5.772 4.519 8.814 5.173l5.173-10.929z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.702 13.672l-.56-.35-.418.512-2.407 2.951 1.162.948 1.128-1.383c.23 1.063.786 2.216 1.899 3.324l1.058-1.063c-1.049-1.044-1.45-2.09-1.56-2.983l1.993 1.242.793-1.272-3.088-1.926zM34.917 34.312L33.41 31.53l-1.319.714.672 1.242a16.475 16.475 0 01-.4-.106c-.806-.224-1.705-.534-2.295-.808l-.634 1.36c.693.322 1.678.657 2.528.893.26.073.514.138.75.191l-1.149.997.983 1.133 2.202-1.912.454-.394-.286-.53z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcSignatureS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 14A2.75 2.75 0 0115 11.25h18A2.75 2.75 0 0135.75 14v15.179a.75.75 0 01-1.5 0V14c0-.69-.56-1.25-1.25-1.25H15c-.69 0-1.25.56-1.25 1.25v21c0 .69.56 1.25 1.25 1.25h3.125a.75.75 0 010 1.5H15A2.75 2.75 0 0112.25 35V14zm5 3.75A.75.75 0 0118 17h12a.75.75 0 010 1.5H18a.75.75 0 01-.75-.75zm0 4.5a.75.75 0 01.75-.75h12a.75.75 0 010 1.5H18a.75.75 0 01-.75-.75zM18 26a.75.75 0 000 1.5h6a.75.75 0 000-1.5h-6zm13.433 5.309c-1.188-.184-2.219.066-3.285.69-1.027.604-2.109 1.57-3.425 2.831l-.002.002a33.964 33.964 0 00-2.346 2.523 41.582 41.582 0 00-.832 1.019l-.056.07-.035.044a.75.75 0 001.034 1.083h.001a.741.741 0 00.113-.117l.06-.075.062-.078.127-.16c.16-.2.389-.482.672-.818a32.493 32.493 0 012.24-2.41c1.326-1.27 2.291-2.118 3.146-2.62.815-.477 1.5-.624 2.291-.503.421.073.603.183.654.235l.006.007h.001c.013.01.116.093-.087.579-.205.488-.603 1.085-1.105 1.823a4.664 4.664 0 00-.767 1.973c-.041.32-.042.642.014.941.055.293.176.616.423.87.08.08.184.166.325.231a1.248 1.248 0 00.464.108h.031c.022 0 .043-.001.064-.003l-.064-.748.065.748h.004l.005-.001.01-.001.022-.003a.879.879 0 00.144-.032c.071-.021.15-.052.234-.095.169-.087.367-.224.596-.44l.01-.009c.361-.352.705-.795.998-1.211.403-.546.74-.985 1.134-1.28.356-.265.754-.408 1.322-.32.104.016.175.034.221.05-.008.034-.02.075-.038.124-.048.133-.118.279-.205.458a5.458 5.458 0 00-.299.684c-.043.125-.09.29-.105.46-.01.11-.037.53.316.82a.752.752 0 00.213.122c.13.049.27.07.369.082.113.014.242.023.378.03.273.011.61.011.982.002.744-.019 1.66-.077 2.544-.167a.75.75 0 00-.154-1.492c-.847.087-1.724.142-2.428.16-.178.004-.344.006-.493.006l.015-.029.007-.014c.084-.172.19-.39.27-.613.079-.217.158-.503.139-.81a1.308 1.308 0 00-.474-.941c-.283-.237-.647-.356-1.03-.415-1.007-.155-1.804.122-2.447.602-.6.447-1.061 1.072-1.44 1.586l-.009.01-.01.015c-.214.304-.434.59-.647.824l.012-.114c.052-.403.223-.889.52-1.325l.001-.002c.473-.696.971-1.428 1.246-2.085.268-.639.451-1.527-.233-2.215-.389-.397-.96-.576-1.477-.664l-.012-.002z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 31.25h3",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcSpaceDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.057 8.463A.748.748 0 008 8.75v7a.75.75 0 001.5 0v-5.19l3.72 3.72a.75.75 0 101.06-1.06L10.56 9.5h5.19a.75.75 0 000-1.5h-7a.748.748 0 00-.529.218l-.001.002-.002.001a.748.748 0 00-.161.242zM19.75 21.212v-1.14h-5.712v1.14h5.712zm1.944 7.308c0 .852-.684 1.392-1.68 1.392-.972 0-1.668-.54-1.668-1.392 0-.816.696-1.392 1.668-1.392.996 0 1.68.576 1.68 1.392zm1.452-2.508v-6.504h-1.332v1.572H20.11v1.116h1.704v.828H20.11v1.152h1.704v1.836h1.332zm-3.048-1.704c-.396.06-.84.108-1.332.144l.24-2.604-1.26-.108-.204 2.772c-.156 0-.312 0-.468.012l-.744.012-.168-2.796-1.284.12.24 2.676-1.344-.024.096 1.164c2.052.06 4.512-.048 6.312-.3l-.084-1.068zm2.904 4.212c0-1.476-1.26-2.496-2.988-2.496s-2.976 1.02-2.976 2.496c0 1.512 1.248 2.532 2.976 2.532s2.988-1.02 2.988-2.532zm5.511-8.796v.552c0 1.788-1.632 2.868-3.372 3.324l.576 1.08c1.764-.372 3.072-1.428 3.552-2.58.516 1.14 1.836 2.184 3.564 2.556l.564-1.068c-1.752-.384-3.372-1.56-3.372-3.312v-.552h-1.512zm1.416 10.704V26.78h4.392v-1.152H24.218v1.152h4.404v3.648h1.308zM41 8.75a.747.747 0 00-.218-.529l-.002-.001-.001-.002A.748.748 0 0040.25 8h-7a.75.75 0 000 1.5h5.19l-3.72 3.72a.75.75 0 101.06 1.06l3.72-3.72v5.19a.75.75 0 001.5 0v-7zM8.057 40.537A.748.748 0 018 40.25v-7a.75.75 0 011.5 0v5.19l3.72-3.72a.75.75 0 111.06 1.06l-3.72 3.72h5.19a.75.75 0 010 1.5h-7a.748.748 0 01-.529-.218l-.001-.002-.002-.001a.747.747 0 01-.161-.242zM41 40.25a.747.747 0 01-.215.525l-.01.01a.747.747 0 01-.525.215h-7a.75.75 0 010-1.5h5.19l-3.72-3.72a.75.75 0 111.06-1.06l3.72 3.72v-5.19a.75.75 0 011.5 0v7z",
    fill: "#D8D8D8"
  }));
}

function SvgIcSpaceS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.057 8.463A.748.748 0 008 8.75v7a.75.75 0 001.5 0v-5.19l3.72 3.72a.75.75 0 101.06-1.06L10.56 9.5h5.19a.75.75 0 000-1.5h-7a.748.748 0 00-.529.218l-.001.002-.002.001a.748.748 0 00-.161.242zM19.75 21.212v-1.14h-5.712v1.14h5.712zm1.944 7.308c0 .852-.684 1.392-1.68 1.392-.972 0-1.668-.54-1.668-1.392 0-.816.696-1.392 1.668-1.392.996 0 1.68.576 1.68 1.392zm1.452-2.508v-6.504h-1.332v1.572H20.11v1.116h1.704v.828H20.11v1.152h1.704v1.836h1.332zm-3.048-1.704c-.396.06-.84.108-1.332.144l.24-2.604-1.26-.108-.204 2.772c-.156 0-.312 0-.468.012l-.744.012-.168-2.796-1.284.12.24 2.676-1.344-.024.096 1.164c2.052.06 4.512-.048 6.312-.3l-.084-1.068zm2.904 4.212c0-1.476-1.26-2.496-2.988-2.496s-2.976 1.02-2.976 2.496c0 1.512 1.248 2.532 2.976 2.532s2.988-1.02 2.988-2.532zm5.511-8.796v.552c0 1.788-1.632 2.868-3.372 3.324l.576 1.08c1.764-.372 3.072-1.428 3.552-2.58.516 1.14 1.836 2.184 3.564 2.556l.564-1.068c-1.752-.384-3.372-1.56-3.372-3.312v-.552h-1.512zm1.416 10.704V26.78h4.392v-1.152H24.218v1.152h4.404v3.648h1.308zM41 8.75a.747.747 0 00-.218-.529l-.002-.001-.001-.002A.748.748 0 0040.25 8h-7a.75.75 0 000 1.5h5.19l-3.72 3.72a.75.75 0 101.06 1.06l3.72-3.72v5.19a.75.75 0 001.5 0v-7zM8.057 40.537A.748.748 0 018 40.25v-7a.75.75 0 011.5 0v5.19l3.72-3.72a.75.75 0 111.06 1.06l-3.72 3.72h5.19a.75.75 0 010 1.5h-7a.748.748 0 01-.529-.218l-.001-.002-.002-.001a.747.747 0 01-.161-.242zM41 40.25a.747.747 0 01-.215.525l-.01.01a.747.747 0 01-.525.215h-7a.75.75 0 010-1.5h5.19l-3.72-3.72a.75.75 0 111.06-1.06l3.72 3.72v-5.19a.75.75 0 011.5 0v7z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcStandardtimeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 20.5a8.5 8.5 0 110-17 8.5 8.5 0 010 17zM2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z",
    fill: "#000",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.12 5.809a.75.75 0 01.849.637l.744 5.237 3.598 4.308a.75.75 0 11-1.151.961l-3.736-4.471a.75.75 0 01-.166-.375l-.774-5.45a.75.75 0 01.637-.847z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.266 6.441c.72.293 1.393.733 1.977 1.316a6.007 6.007 0 011.409 6.259",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcTalkS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1c4.142 0 7.5 2.681 7.5 5.988 0 3.307-3.358 5.988-7.5 5.988-.46 0-.911-.034-1.348-.097L3.61 14.953a.213.213 0 01-.285-.016.219.219 0 01-.052-.224l.707-2.669C1.888 10.982.5 9.114.5 6.988.5 3.681 3.858 1 8 1zM4.968 5.28H2.742c-.208 0-.32.17-.32.331 0 .152.083.33.32.33h.755v2.632c0 .234.137.38.358.38.222 0 .359-.146.359-.38V5.94h.754c.237 0 .322-.177.322-.329 0-.16-.113-.33-.322-.33zm1.46-.032c-.28 0-.459.218-.533.423L4.853 8.459a.428.428 0 00-.033.159c0 .188.156.335.354.335.179 0 .288-.082.345-.258l.16-.49h1.5l.156.496c.056.17.17.252.35.252a.317.317 0 00.327-.313.61.61 0 00-.04-.187L6.962 5.67c-.093-.268-.288-.422-.534-.422zm4.682 0c-.208 0-.359.15-.359.357v3.001c0 .208.145.347.36.347a.345.345 0 00.358-.347V7.63l.258-.265.942 1.298c.138.189.213.273.345.287a.54.54 0 00.057.003c.077 0 .33-.02.357-.285.02-.148-.068-.263-.173-.402l-1.022-1.352.864-.88.087-.1c.118-.13.177-.196.177-.296.004-.213-.17-.33-.343-.335a.399.399 0 00-.286.133L11.47 6.767V5.605c0-.213-.144-.357-.359-.357zm-2.365 0c-.221 0-.359.145-.359.379V8.51c0 .251.14.401.375.401H10.1a.329.329 0 00.342-.316.327.327 0 00-.084-.243.341.341 0 00-.258-.1h-.995V5.626c0-.234-.138-.379-.359-.379zm-2.314.66l.004.005.542 1.65H5.88l.54-1.65a.007.007 0 01.014 0l-.004-.005z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcTermsofUseS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.784 10.75c-.52 0-1.034.471-1.034 1.173v21.154c0 .702.515 1.173 1.034 1.173h10.521a.75.75 0 010 1.5H14.784c-1.452 0-2.534-1.25-2.534-2.673V11.923c0-1.422 1.082-2.673 2.534-2.673h18.432c1.452 0 2.534 1.25 2.534 2.673h-1.5c0-.702-.515-1.173-1.034-1.173H14.784zM35 11.923h.75V20.156a.75.75 0 01-1.5 0V11.924H35zm-17.75 4.16a.75.75 0 01.75-.75h12a.75.75 0 110 1.5H18a.75.75 0 01-.75-.75zm.75 3.75a.75.75 0 100 1.5h12a.75.75 0 000-1.5H18zm-.75 5.25a.75.75 0 01.75-.75h5a.75.75 0 110 1.5h-5a.75.75 0 01-.75-.75zM18 28.5a.75.75 0 000 1.5h3.5a.75.75 0 000-1.5H18zm8.356-2.142c.021-.516.059-1.046.112-1.59 0 0 .539.351 1.474.344 1.037-.007 2.56-.455 4.38-2.306.326-.333.662-.71 1.006-1.14.344.43.68.807 1.007 1.14 1.82 1.854 3.35 2.3 4.389 2.306.934.006 1.474-.344 1.474-.344.053.544.09 1.073.112 1.589.279 6.547-1.985 10.837-6.982 12.42-4.969-1.583-7.248-5.873-6.972-12.42zm1.491.254c-.095 2.76.304 4.971 1.118 6.66.886 1.838 2.306 3.155 4.365 3.92 2.072-.765 3.493-2.083 4.377-3.919.812-1.689 1.208-3.9 1.112-6.661a5.352 5.352 0 01-.748-.043c-1.398-.177-3.017-.913-4.743-2.648-1.727 1.735-3.343 2.471-4.739 2.648-.262.034-.51.046-.742.043zm8.38 2.554a.75.75 0 10-1.12-.998l-2.73 3.065-.874-.79a.75.75 0 00-1.006 1.114l1.435 1.296a.75.75 0 001.063-.058l3.232-3.63z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcTimeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 8a6.5 6.5 0 1013 0 6.5 6.5 0 00-13 0zM8 16A8 8 0 118 0a8 8 0 010 16zM7.194 3.483a.75.75 0 111.5 0v4.54l2.93 2.213a.75.75 0 01-.904 1.197L7.492 8.996a.75.75 0 01-.298-.599V3.483z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcTimeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12a8.5 8.5 0 1017 0 8.5 8.5 0 00-17 0zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.806-15.517a.75.75 0 011.5 0v5.54l2.93 2.213a.75.75 0 11-.904 1.197l-3.228-2.437a.75.75 0 01-.298-.599V6.483z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcTimechangeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.49 3.83a.5.5 0 00.466-.676L12.915.39a.5.5 0 00-.88-.107l-.517.75A7.8 7.8 0 006.036.503C1.88 1.619-.597 5.873.516 10.01c1.111 4.139 5.387 6.577 9.542 5.46 3.729-1.001 6.105-4.528 5.752-8.232a.75.75 0 10-1.494.142c.285 2.98-1.63 5.832-4.647 6.642-3.364.904-6.81-1.072-7.705-4.401-.894-3.329 1.097-6.767 4.461-7.67a6.3 6.3 0 014.229.333l-.53.768a.5.5 0 00.413.784l2.953-.007zM8 5.025a.75.75 0 01.75.75v2.25H11a.75.75 0 010 1.5H8a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75z",
    fill: "#42484C"
  }));
}

function SvgIcTimechangeS16Db(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.646 4.588a.5.5 0 00.466-.677L13.07 1.148a.5.5 0 00-.88-.107l-.517.75a7.8 7.8 0 00-5.481-.53C2.037 2.376-.441 6.63.672 10.768c1.111 4.138 5.387 6.577 9.542 5.46 3.729-1.002 6.105-4.528 5.751-8.233a.75.75 0 10-1.493.143c.285 2.98-1.63 5.831-4.647 6.642-3.365.904-6.81-1.073-7.705-4.402-.895-3.328 1.097-6.766 4.46-7.67a6.3 6.3 0 014.23.334l-.53.767a.5.5 0 00.413.784l2.953-.006zm-5.49 1.195a.75.75 0 01.75.75v2.25h2.25a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75v-3a.75.75 0 01.75-.75z",
    fill: "#42484C"
  }));
}

function SvgIcTimerS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.414V2.75a9.25 9.25 0 11-8.42 5.414",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.75a1.75 1.75 0 00.32-3.47L6.752 8.63l3.881 4.463c.32.4.814.657 1.367.657z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcTopbarBackActionS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.28 5.53a.75.75 0 00-1.06-1.06l-7 7a.748.748 0 000 1.06l7 7a.75.75 0 101.06-1.06l-5.72-5.72h14.69a.75.75 0 000-1.5H5.56l5.72-5.72z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcTopbarCloseActionS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.929 18.01a.75.75 0 101.06 1.061L12 13.061l6.01 6.01a.75.75 0 001.061-1.06L13.061 12l6.01-6.01a.75.75 0 10-1.06-1.061L12 10.939 5.99 4.93a.75.75 0 00-1.061 1.06L10.939 12l-6.01 6.01z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcTopbarCloseActionS24W(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.929 18.301a.75.75 0 001.06 1.06L12 13.352l6.01 6.01a.75.75 0 001.061-1.06l-6.01-6.01 6.01-6.01a.75.75 0 10-1.06-1.061L12 11.23 5.99 5.22a.75.75 0 10-1.061 1.06l6.01 6.01-6.01 6.011z",
    fill: "#fff"
  }));
}

function SvgIcTrialS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.214 13.17L31.044 10a.758.758 0 00-1.08 1.064l3.186 3.186a.758.758 0 001.064-1.08zm-10.217 2.01c1.919-1.918 3.418-2.597 5.04-2.922l2.833 2.833c-.325 1.621-1.005 3.121-2.923 5.04-1.077 1.077-1.986 1.724-2.83 2.15a8.73 8.73 0 01-1.924.69l-3.037-3.037a8.729 8.729 0 01.69-1.924c.426-.843 1.074-1.752 2.151-2.83zm-4.216 4.078c.453-1.68 1.253-3.235 3.155-5.138 1.969-1.968 3.619-2.81 5.341-3.23a2.258 2.258 0 013.827-1.952l3.17 3.171a2.258 2.258 0 01-2.054 3.809c-.286 1.146-.764 2.262-1.642 3.463l8.572 7.981a2.68 2.68 0 11-3.788 3.788l-7.956-8.546c-1.203.912-2.306 1.403-3.465 1.723a2.25 2.25 0 01-3.812 1.94l-3.184-3.182a2.25 2.25 0 011.836-3.827zm.275 1.697a.75.75 0 00-1.05 1.07l3.183 3.182a.75.75 0 001.069-1.05l-3.202-3.202zm9.495.678l7.909 8.495a1.18 1.18 0 101.667-1.668l-8.502-7.916a18.484 18.484 0 01-1.074 1.089zM25.263 33H14.737a.5.5 0 00-.487.389L13.882 35h12.236l-.368-1.611a.5.5 0 00-.487-.389zm2.394 2l-.445-1.945a2 2 0 00-1.95-1.555H14.738a2 2 0 00-1.95 1.555L12.344 35H10.87a2 2 0 00-1.933 1.485l-.602 2.258A1 1 0 009.302 40h21.396a1 1 0 00.967-1.257l-.602-2.258A2 2 0 0029.13 35h-1.473zM12 36.5h-1.13a.5.5 0 00-.483.371l-.435 1.63h20.096l-.435-1.63a.5.5 0 00-.483-.37H12z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcVacuumcleanerS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 19c0 1.191-.802 1.998-2.267 2.54-1.462.54-3.358.71-4.983.71-2.978 0-5.75-2.425-5.75-5.25 0-2.263.886-3.523 1.979-4.251 1.14-.76 2.598-.999 3.771-.999 1.36 0 3.177 1.003 4.712 2.538C13.247 15.823 14.25 17.64 14.25 19z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5l2-3c.5-1 .5-3-1-3.554-2.02-.746-4.167-1.667-5-2-1-.5-1.9-.8-1.5-2 .5-1.5 1.94-.853 3-.5 1.5.5 5.333 1.833 7.5 2.5.5.167 1.6.9 2 2.5.4 1.6 2.5 8.667 3.5 12.5",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 20,
    r: 3.25,
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 19a.25.25 0 01.25-.25h6a.25.25 0 01.25.25v2.25h-6.5V19z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcVersionS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 13.5H16a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h19a.5.5 0 00.5-.5V14a.5.5 0 00-.5-.5zM16 12a2 2 0 00-1.855 1.25H12.5A2.75 2.75 0 009.75 16v17a2.75 2.75 0 002.75 2.75h1.645A2 2 0 0016 37h19a2 2 0 002-2V14a2 2 0 00-2-2H16zm-3.5 2.75H14v19.5h-1.5c-.69 0-1.25-.56-1.25-1.25V16c0-.69.56-1.25 1.25-1.25zm11.63 7.252L22.248 28H20.42l-1.907-5.998h1.688l1.142 4.438h.062L22.53 22h1.6zm4.166 4.495c-.07.738-.677 1.59-2.07 1.59-1.319 0-2.224-.773-2.224-2.267v-.373c0-1.46.936-2.228 2.171-2.228 1.31 0 2.153.865 2.153 2.25v.47h-2.948v.158c0 .598.369.954.852.954.418 0 .73-.207.787-.554h1.279zm-2.918-1.371v.004h1.6v-.004c0-.519-.313-.9-.792-.9-.483 0-.808.381-.808.9zM30.418 28h-1.45v-4.693h1.41v.69h.067a1.087 1.087 0 011.059-.756c.197 0 .33.013.422.04v1.195c-.101-.036-.308-.053-.514-.053-.721 0-.994.417-.994 1.046V28z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcWarningS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM8 3.75a.75.75 0 01.75.75V9a.75.75 0 01-1.5 0V4.5A.75.75 0 018 3.75zm0 7a.75.75 0 01.75.75v.5a.75.75 0 01-1.5 0v-.5a.75.75 0 01.75-.75z",
    fill: "#FF5151"
  }));
}

function SvgIcWarningS16R(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM8 3.75a.75.75 0 01.75.75V9a.75.75 0 01-1.5 0V4.5A.75.75 0 018 3.75zm0 7a.75.75 0 01.75.75v.5a.75.75 0 01-1.5 0v-.5a.75.75 0 01.75-.75z",
    fill: "#FF5151"
  }));
}

function SvgIcWarningstrokeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5a6.5 6.5 0 100-13 6.5 6.5 0 000 13zM16 8A8 8 0 110 8a8 8 0 0116 0zM8 3.75a.75.75 0 01.75.75V9a.75.75 0 01-1.5 0V4.5A.75.75 0 018 3.75zm.75 7.75a.75.75 0 00-1.5 0v.5a.75.75 0 001.5 0v-.5z",
    fill: "#FF5151"
  }));
}

function SvgIcWarningstrokeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 12a8.5 8.5 0 11-17 0 8.5 8.5 0 0117 0zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm.1-15.475c.47 0 .85.38.85.85V13a.85.85 0 01-1.7 0V7.375c0-.47.38-.85.85-.85zm0 8.75c.47 0 .85.38.85.85v.4a.85.85 0 01-1.7 0v-.4c0-.47.38-.85.85-.85z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcWasteS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Waste_S24_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.776 1.57a1.39 1.39 0 00-1.67 1.724l.284 1.014.69 1.176c.05.085.107.165.17.238C8.268 6.1 6.49 7.04 5.413 8.53c-2.89 3.996-2.393 9.478-1.308 11.324.88 1.497 2.571 2.337 4.384 2.508 1.813.172 1.868.172 3.745.172s2.582-.037 3.754-.172c1.172-.134 3.075-.461 4.384-2.508 1.155-1.806 1.581-7.328-1.309-11.324-1.06-1.466-2.8-2.401-4.746-2.79.07-.08.133-.167.188-.261l.717-1.235.274-.987a1.362 1.362 0 00-1.644-1.686s-.83.43-1.6.43c-.768 0-1.477-.43-1.477-.43z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.776 1.57a1.39 1.39 0 00-1.67 1.724l.284 1.014.69 1.176c.05.085.107.165.17.238C8.268 6.1 6.49 7.04 5.413 8.53c-2.89 3.996-2.393 9.478-1.308 11.324.88 1.497 2.571 2.337 4.384 2.508 1.813.172 1.868.172 3.745.172s2.582-.037 3.754-.172c1.172-.134 3.075-.461 4.384-2.508 1.155-1.806 1.581-7.328-1.309-11.324-1.06-1.466-2.8-2.401-4.746-2.79.07-.08.133-.167.188-.261l.717-1.235.274-.987a1.362 1.362 0 00-1.644-1.686s-.83.43-1.6.43c-.768 0-1.477-.43-1.477-.43z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.106 3.294l1.444-.405-1.444.405zm1.67-1.724l.778-1.283-.196-.119-.223-.055-.36 1.457zM9.39 4.308l-1.444.404.052.187.098.168 1.294-.76zm.69 1.176l1.294-.759-1.294.76zm.17.238l.28 1.474 2.527-.482-1.664-1.962-1.144.97zM5.413 8.53L4.2 7.649l1.215.88zM4.106 19.853l1.293-.76-1.293.76zm4.384 2.508l.142-1.493-.142 1.494zm7.499 0l-.17-1.49.17 1.49zm4.384-2.508l-1.264-.808 1.264.808zM19.064 8.53l1.216-.88-1.216.88zm-4.746-2.79l-1.13-.985-1.7 1.95 2.537.506.293-1.47zm.188-.261l-1.297-.754 1.297.754zm.717-1.235l1.297.753.097-.166.051-.185-1.445-.402zm.274-.987l-1.445-.402 1.445.402zM13.853 1.57L13.488.115l-.17.042-.155.08.69 1.333zM10.55 2.89a.127.127 0 01-.027.106.127.127 0 01-.106.03l.718-2.913C8.985-.416 7.065 1.568 7.66 3.7l2.89-.81zm.284 1.013l-.284-1.014-2.889.81.285 1.013 2.888-.81zm.54.822l-.69-1.176-2.588 1.518.69 1.176 2.588-1.518zm.019.027a.192.192 0 01-.019-.027L8.786 6.243c.094.16.201.31.32.45l2.287-1.941zm-1.425-.503c-2.242.427-4.408 1.52-5.769 3.4l2.43 1.759c.793-1.095 2.182-1.885 3.9-2.212l-.56-2.947zM4.2 7.649c-1.657 2.292-2.316 4.965-2.427 7.276-.11 2.256.294 4.417 1.04 5.688l2.587-1.52c-.338-.575-.725-2.078-.63-4.023.09-1.89.628-3.958 1.861-5.662L4.199 7.65zM2.813 20.614c1.19 2.027 3.394 3.039 5.536 3.242l.283-2.987c-1.484-.14-2.665-.808-3.233-1.774l-2.586 1.519zm5.536 3.242c1.863.176 1.966.178 3.886.178v-3c-1.834 0-1.842.002-3.603-.165l-.283 2.987zm3.886.178c1.912 0 2.678-.038 3.925-.181l-.342-2.98c-1.097.125-1.74.161-3.583.161v3zm3.925-.181c1.284-.147 3.788-.55 5.477-3.19l-2.528-1.617c-.928 1.452-2.231 1.705-3.29 1.826l.34 2.98zm5.477-3.19c.818-1.28 1.214-3.478 1.096-5.728-.121-2.319-.8-4.997-2.453-7.284l-2.431 1.758c1.236 1.709 1.79 3.79 1.889 5.683.102 1.96-.292 3.428-.629 3.954l2.527 1.616zM20.28 7.65c-1.34-1.854-3.464-2.941-5.668-3.381l-.587 2.941c1.685.337 3.044 1.12 3.824 2.198l2.43-1.758zm-7.071-2.926a.197.197 0 01-.021.03l2.261 1.971a3.19 3.19 0 00.354-.494l-2.594-1.507zm.717-1.235l-.717 1.235 2.594 1.507.717-1.235-2.594-1.507zm.126-.635l-.274.987 2.89.804.274-.987-2.89-.804zm.166.17a.153.153 0 01-.132-.037.153.153 0 01-.034-.133l2.89.804c.588-2.115-1.325-4.077-3.454-3.543l.73 2.91zm-1.964.476c.632 0 1.218-.17 1.588-.301a6.436 6.436 0 00.675-.284l.016-.008.006-.003.002-.001h.001c0-.001.001-.001-.689-1.333l-.69-1.332h.001a.032.032 0 01.003-.002l.002-.001h.001l-.01.004a3.436 3.436 0 01-.32.132c-.235.084-.45.129-.586.129v3zm-1.478-1.93a308.584 308.584 0 00-.777 1.283h.002l.002.003.007.004a1.875 1.875 0 00.062.035c.036.02.084.047.141.076.115.06.273.135.465.21.365.144.931.319 1.576.319v-3c-.124 0-.297-.04-.478-.11a2.142 2.142 0 01-.232-.109c-.003-.001-.004-.002-.002 0l.004.002.004.002.002.001.001.001-.777 1.283z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_Waste_S24_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.491 12s-.21-2.221.714-3.904C10.128 6.413 11.345 6 11.345 6M16.17 12s.208-2.221-.715-3.904C14.532 6.413 13.315 6 13.315 6",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcWasteS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.635 38.676c1.477-.183 3.877-.63 5.526-3.422 1.456-2.466 1.993-10-1.65-15.452-1.809-2.708-5.19-4.087-8.652-4.087h.098c-3.463 0-6.844 1.38-8.653 4.087-3.643 5.453-3.016 12.933-1.65 15.452 1.11 2.042 3.242 3.188 5.527 3.422 2.286.234 2.355.234 4.721.234s3.255-.05 4.733-.234z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.314 34.896h0c-.593-1.093-1.089-3.438-.964-6.235.124-2.771.853-5.86 2.578-8.442 1.624-2.43 4.709-3.741 7.98-3.754 3.271.013 6.356 1.323 7.98 3.754 1.727 2.584 2.477 5.688 2.611 8.465.136 2.809-.363 5.137-.984 6.188-1.469 2.487-3.57 2.886-4.973 3.06-1.437.178-2.292.228-4.64.228h-.032c-2.31 0-2.365 0-4.612-.23-2.098-.215-3.98-1.257-4.944-3.034z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.984 22.515s-.48-2.841-2.122-4.659c-1.642-1.818-3.216-1.958-3.216-1.958",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.274 12.789a1.69 1.69 0 012.03-2.096l.104.025S27.38 10 28.35 10c.97 0 1.939.718 1.939.718l.047-.011a1.689 1.689 0 012.038 2.09l-.358 1.29-1.032 1.777a1.69 1.69 0 01-1.46.84h-2.407a1.69 1.69 0 01-1.457-.834l-.998-1.7-.387-1.381z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.853 11.322h0l.003-.002.022-.015a4.03 4.03 0 01.47-.273c.321-.159.685-.282 1.002-.282.316 0 .679.123 1 .282a4.021 4.021 0 01.467.272l.022.016.004.002h0l.283.21.344-.086.047-.012a.94.94 0 011.134 1.162l-.333 1.198-.983 1.693a.94.94 0 01-.812.467h-2.407a.94.94 0 01-.81-.463l-.949-1.617-.36-1.288a.94.94 0 011.128-1.165l.104.026.342.084.282-.209zm0 0h0z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.054 38.676c1.477-.183 3.877-.63 5.526-3.422 1.457-2.466 1.994-10-1.65-15.452-1.808-2.708-5.19-4.087-8.652-4.087h.098c-3.463 0-6.843 1.38-8.652 4.087-3.643 5.453-3.017 12.933-1.65 15.452 1.108 2.042 3.242 3.188 5.527 3.422 2.285.234 2.355.234 4.72.234 2.367 0 3.255-.05 4.733-.234z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.733 34.896h0c-.593-1.093-1.088-3.438-.964-6.235.124-2.771.853-5.86 2.578-8.442 1.624-2.43 4.709-3.741 7.98-3.754 3.272.013 6.356 1.323 7.98 3.754 1.727 2.584 2.477 5.688 2.612 8.465.136 2.809-.364 5.137-.984 6.188-1.47 2.487-3.57 2.886-4.973 3.06-1.437.178-2.293.228-4.64.228h-.033c-2.31 0-2.365 0-4.612-.23-2.098-.215-3.98-1.257-4.944-3.034z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.603 24.047s-.264-2.87.9-5.044c1.163-2.174 2.697-2.708 2.697-2.708M24.282 24.047s.263-2.87-.9-5.044c-1.164-2.174-2.698-2.708-2.698-2.708",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.348 12.789a1.69 1.69 0 012.03-2.096l.104.025S18.454 10 19.424 10c.969 0 1.938.718 1.938.718l.047-.011a1.689 1.689 0 012.038 2.09l-.358 1.29-1.032 1.777a1.69 1.69 0 01-1.46.84H18.19a1.69 1.69 0 01-1.457-.834l-.998-1.7-.387-1.381z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.927 11.322h0l.003-.002.022-.015a4.03 4.03 0 01.47-.273c.321-.159.685-.282 1.002-.282.316 0 .679.123 1 .282a4.021 4.021 0 01.468.272l.021.016.004.002h0l.283.21.344-.086.047-.012a.94.94 0 011.134 1.162l-.333 1.198-.983 1.693a.94.94 0 01-.812.467H18.19a.94.94 0 01-.81-.463l-.949-1.617-.36-1.288a.94.94 0 011.128-1.165l.104.026.342.084.282-.209zm0 0h0z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcWindowS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Window_S24_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 14,
    height: 18,
    rx: 1,
    stroke: "#262626",
    strokeWidth: 3,
    mask: "url(#ic_Window_S24_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeWidth: 1.5,
    d: "M6 6.25h13M6 18h13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.237a.25.25 0 01.302-.244L7.25 6.106v12.016l-5.206.93a.25.25 0 01-.294-.246V5.237zM22.25 5.237a.25.25 0 00-.302-.244L16.75 6.106v12.016l5.206.93a.25.25 0 00.294-.246V5.237z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11l-5-.5M17 11l5-.5",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcWindowS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 13.75,
    y: 11.25,
    width: 20.5,
    height: 25.5,
    rx: 1.25,
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M14 15.25h20M14 32.75h20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 13.302a.25.25 0 01.314-.242l7 1.867a.25.25 0 01.186.241v17.664a.25.25 0 01-.186.241l-7 1.867a.25.25 0 01-.314-.242V13.302zM40.25 13.302a.25.25 0 00-.314-.242l-7 1.867a.25.25 0 00-.186.241v17.664a.25.25 0 00.186.241l7 1.867a.25.25 0 00.314-.242V13.302z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 22l7.5.75M40.5 22l-7.5.75",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcWindowdustS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Windowdust_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 11,
    width: 27,
    height: 26,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 11,
    width: 27,
    height: 26,
    rx: 1,
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 3,
    mask: "url(#ic_Windowdust_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_Windowdust_S48_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14,
    width: 21,
    height: 14.5,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14,
    width: 21,
    height: 14.5,
    rx: 1,
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 3,
    mask: "url(#ic_Windowdust_S48_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75 32.886l2.99-2.136h26.52l2.99 2.136v4.364H7.75v-4.364z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 15v12M34 21.25H14M8 33.25h32",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcWonS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.268 8.3a.747.747 0 00-.969.433.732.732 0 00-.024.074l-1.324 4.635-1.522-4.645a.75.75 0 00-1.425.467l.732 2.236H6.357c-.473 0-.857.336-.857.75s.384.75.857.75h1.87l1.06 3.234a.75.75 0 001.434-.028L12 11.73l1.279 4.476a.75.75 0 001.434.028L15.773 13H17.7c.442 0 .8-.336.8-.75s-.358-.75-.8-.75h-1.436l.732-2.236a.75.75 0 10-1.425-.467l-1.522 4.645-1.324-4.635a.752.752 0 00-.457-.507z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcWonS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 24c0 8.008-6.492 14.5-14.5 14.5S9.5 32.008 9.5 24 15.992 9.5 24 9.5 38.5 15.992 38.5 24zM24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16zm0-20.806a.75.75 0 00-.725.558l-1.946 6.81-1.966-6.786a.75.75 0 10-1.44.417l.947 3.271H16.7c-.406 0-.735.36-.735.804 0 .444.33.803.735.803h2.637l1.278 4.412a.75.75 0 001.441-.003L24 22.674l1.945 6.806a.75.75 0 001.441.003l1.278-4.412h2.686c.379 0 .686-.36.686-.803 0-.444-.307-.804-.686-.804h-2.22l.948-3.271a.75.75 0 10-1.441-.417l-1.966 6.786-1.946-6.81a.753.753 0 00-.725-.558z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5 24c0 8.008-6.492 14.5-14.5 14.5S9.5 32.008 9.5 24 15.992 9.5 24 9.5 38.5 15.992 38.5 24zM24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16zm0-20.806a.748.748 0 00-.725.558l-1.946 6.81-1.966-6.786a.75.75 0 10-1.44.417l.947 3.271H16.7c-.406 0-.735.36-.735.804 0 .444.33.803.735.803h2.637l1.278 4.412a.75.75 0 001.441-.003L24 22.674l1.945 6.806a.75.75 0 001.441.003l1.278-4.412h2.686c.379 0 .686-.36.686-.803 0-.444-.307-.804-.686-.804h-2.22l.948-3.271a.75.75 0 10-1.441-.417l-1.966 6.786-1.946-6.81a.754.754 0 00-.725-.558z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcWonSolidB85S24V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.2 12C22.2 17.6334 17.6334 22.2 12 22.2C6.36674 22.2 1.80005 17.6334 1.80005 12C1.80005 6.36674 6.36674 1.80005 12 1.80005C17.6334 1.80005 22.2 6.36674 22.2 12ZM7.95039 9.04542C8.31201 8.90871 8.71599 9.09104 8.8527 9.45266L10.2299 13.0957L11.2053 10.0839C11.2988 9.79519 11.5678 9.5996 11.8713 9.5996C12.1748 9.5996 12.4437 9.79519 12.5372 10.0839L13.5126 13.0957L14.8898 9.45266C15.0265 9.09104 15.4305 8.90871 15.7921 9.04542C16.1537 9.18212 16.3361 9.5861 16.1994 9.94772L15.5998 11.5336H16.8956C17.2822 11.5336 17.5956 11.847 17.5956 12.2336C17.5956 12.6202 17.2822 12.9336 16.8956 12.9336H15.0706L14.1164 15.4577C14.0112 15.7358 13.7419 15.9172 13.4447 15.91C13.1475 15.9028 12.8872 15.7087 12.7956 15.4259L11.8713 12.5716L10.9469 15.4259C10.8553 15.7087 10.595 15.9028 10.2978 15.91C10.0006 15.9172 9.73129 15.7358 9.62616 15.4577L8.67195 12.9336H7.10002C6.71343 12.9336 6.40002 12.6202 6.40002 12.2336C6.40002 11.847 6.71343 11.5336 7.10002 11.5336H8.14269L7.54315 9.94772C7.40644 9.5861 7.58877 9.18212 7.95039 9.04542Z",
    fill: "#333333"
  }));
}

function SvgIcWonSolidDarkBuS24V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-13.75a.747.747 0 01.725.557l1.324 4.635 1.522-4.645a.75.75 0 111.425.467l-.732 2.236H17.7c.442 0 .8.336.8.75s-.358.75-.8.75h-1.928l-1.06 3.234a.75.75 0 01-1.433-.028L12 11.73l-1.279 4.476a.75.75 0 01-1.434.028L8.227 13h-1.87c-.473 0-.857-.336-.857-.75s.384-.75.857-.75h1.38l-.733-2.236a.75.75 0 111.425-.467l1.522 4.645 1.324-4.635a.732.732 0 01.195-.337c.139-.14.33-.22.53-.22z",
    fill: "#42484C"
  }));
}

function SvgIcWorkTimeDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16c-.4-1.2-1.167-5.167-1.5-7h22v1c0 .5-1 4.5-1.5 5.5S31 20 30 21.5s-1.5 2-1.5 3 1.5 2 2.5 3.5 3 4.5 3.5 6c.4 1.2.5 3.833.5 5H13v-1.5c0-3.5 2.5-8 3.5-9.5s2.5-3 3-4-.5-1.5-1-2.5-3.5-4-4-5.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.774 8.012a.774.774 0 000 1.547h.509c.17 2.916 1.25 6.232 2.84 8.75.593.94 1.25 1.772 1.816 2.49.245.31.474.6.673.868.699.939 1.059 1.63 1.059 2.333 0 .635-.39 1.163-1.325 2.24l-.082.095c-.878 1.011-2.038 2.347-3.092 4.432-1.789 3.539-1.928 6.193-1.922 7.674h-.476a.774.774 0 100 1.547h24.452a.774.774 0 000-1.547h-.476c.006-1.48-.133-4.135-1.922-7.674-1.054-2.085-2.214-3.42-3.092-4.432l-.082-.095c-.935-1.077-1.325-1.605-1.325-2.24 0-.704.36-1.394 1.059-2.333.199-.268.427-.557.673-.868.566-.718 1.223-1.55 1.816-2.49 1.59-2.518 2.67-5.834 2.84-8.75h.51a.774.774 0 000-1.547H11.773zm4.617 9.497c-1.45-2.296-2.436-5.328-2.605-7.95h20.428c-.17 2.622-1.156 5.654-2.605 7.95-.552.873-1.12 1.592-1.664 2.28-.26.33-.515.653-.76.982-.717.964-1.356 1.999-1.356 3.229 0 1.274.826 2.226 1.645 3.169l.047.054.072.083c.869 1.001 1.927 2.22 2.896 4.138 1.633 3.228 1.766 5.604 1.76 6.997H13.75c-.005-1.393.129-3.769 1.76-6.997.97-1.918 2.028-3.137 2.897-4.138l.072-.083.047-.054c.82-.944 1.645-1.895 1.645-3.17 0-1.23-.639-2.264-1.355-3.228-.246-.33-.5-.652-.761-.982-.544-.688-1.112-1.407-1.664-2.28zm3.895 1.175c-.485-.506-1.216-1.387-1.662-1.936a.297.297 0 01.231-.484h10.29c.251 0 .39.29.231.484-.446.549-1.178 1.43-1.662 1.936-1.488 1.556-2.72 3.318-2.72 5.843 0 2.4.165 7.37 1.36 8.491.465.438 1.673.767 2.871 1.094 1.15.314 2.293.626 2.763 1.029.413.353.458 1.237.485 1.77.008.154.014.278.027.353h-17c.013-.075.02-.2.027-.353.028-.533.072-1.417.485-1.77.47-.403 1.613-.715 2.763-1.029 1.198-.327 2.406-.656 2.872-1.094 1.194-1.121 1.359-6.091 1.359-8.49 0-2.526-1.232-4.288-2.72-5.844z",
    fill: "#D8D8D8"
  }));
}

function SvgIcWorkTimeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.255 3.5v.75c0 1.684.66 3.39 1.628 4.822.437.647 1.026 1.181 1.488 1.6l.236.215c.258.24.443.428.563.595.118.162.128.242.128.271v.003c-.001.002-.003.01-.01.024a.75.75 0 01-.117.161c-.143.161-.348.334-.652.588l-.048.04c-.628.527-1.485 1.262-2.126 2.445-.604 1.116-.883 2.015-1.006 2.736-.101.597-.092 1.069-.086 1.354l.002.146V20h13.49v-.75l.002-.146a6.82 6.82 0 00-.086-1.354c-.123-.721-.402-1.62-1.006-2.736-.64-1.183-1.498-1.918-2.125-2.444l-.049-.04c-.303-.255-.509-.428-.652-.589a.748.748 0 01-.116-.16.133.133 0 01-.01-.025v-.003c0-.029.01-.109.127-.271.12-.167.305-.355.564-.595.073-.068.152-.14.236-.215.461-.419 1.05-.953 1.488-1.6.968-1.431 1.627-3.138 1.627-4.822V3.5H5.255z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 5h12v3H6z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_WorkTime_S24_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 4.25,
    y: 2.5,
    width: 16,
    height: 19,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.25 2.5h16v19h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.005 3.5h-.75v.75c0 1.684.66 3.39 1.628 4.822l.228.337c.356.522.625.917.821 1.284.225.418.318.733.318 1.06 0 .242-.087.453-.44.967l-.193.277a19.162 19.162 0 00-1.272 2.018c-.604 1.115-.883 2.014-1.006 2.735-.101.597-.092 1.069-.086 1.354l.002.146V20H12v-1.5H6.76c.009-.148.026-.312.058-.499.093-.544.313-1.288.846-2.272.445-.822.839-1.383 1.17-1.855l.213-.305c.36-.525.703-1.073.703-1.816 0-.657-.2-1.22-.497-1.77-.237-.442-.56-.917-.915-1.438l-.213-.313C7.436 7.212 6.964 6.087 6.81 5H12V3.5H6.005zm11.99 0h.75v.75c0 1.684-.66 3.39-1.627 4.822l-.23.34c-.355.52-.623.915-.82 1.28-.225.419-.318.734-.318 1.061 0 .242.087.453.44.967l.193.277c.334.475.782 1.112 1.272 2.018.604 1.115.883 2.014 1.006 2.735a6.82 6.82 0 01.086 1.354l-.002.146V20H12v-1.5h5.24a4.669 4.669 0 00-.058-.499c-.092-.544-.313-1.288-.846-2.272a17.443 17.443 0 00-1.17-1.856 38.18 38.18 0 01-.212-.304c-.361-.524-.704-1.073-.704-1.816 0-.657.2-1.22.497-1.77.237-.442.56-.916.914-1.437l.214-.314c.69-1.02 1.162-2.145 1.316-3.232H12V3.5h5.994z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.005 3.5h-.75v.75c0 1.684.66 3.39 1.628 4.822l.228.337c.356.522.625.917.821 1.284.225.418.318.733.318 1.06 0 .242-.087.453-.44.967l-.193.277a19.162 19.162 0 00-1.272 2.018c-.604 1.115-.883 2.014-1.006 2.735-.101.597-.092 1.069-.086 1.354l.002.146V20H12v-1.5H6.76c.009-.148.026-.312.058-.499.093-.544.313-1.288.846-2.272.445-.822.839-1.383 1.17-1.855l.213-.305c.36-.525.703-1.073.703-1.816 0-.657-.2-1.22-.497-1.77-.237-.442-.56-.917-.915-1.438l-.213-.313C7.436 7.212 6.964 6.087 6.81 5H12V3.5H6.005zm11.99 0h.75v.75c0 1.684-.66 3.39-1.627 4.822l-.23.34c-.355.52-.623.915-.82 1.28-.225.419-.318.734-.318 1.061 0 .242.087.453.44.967l.193.277c.334.475.782 1.112 1.272 2.018.604 1.115.883 2.014 1.006 2.735a6.82 6.82 0 01.086 1.354l-.002.146V20H12v-1.5h5.24a4.669 4.669 0 00-.058-.499c-.092-.544-.313-1.288-.846-2.272a17.443 17.443 0 00-1.17-1.856 38.18 38.18 0 01-.212-.304c-.361-.524-.704-1.073-.704-1.816 0-.657.2-1.22.497-1.77.237-.442.56-.916.914-1.437l.214-.314c.69-1.02 1.162-2.145 1.316-3.232H12V3.5h5.994z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.255 3.5v-1h-1v1h1zm1.628 5.572l-.828.56.828-.56zm.228.337l-.827.562.827-.562zm.821 1.284l-.88.473.88-.473zm-.121 2.027l-.825-.567.825.567zm-.194.277l-.818-.575.818.575zm-1.272 2.018l-.88-.477.88.476zM5.34 17.75l-.986-.168.986.168zm-.086 1.354l-1 .02 1-.02zm.002.896h-1v1h1v-1zM12 20v1h1v-1h-1zm0-1.5h1v-1h-1v1zm-5.24 0l-.998-.062-.066 1.062H6.76v-1zm.058-.499l.986.168-.986-.168zm.846-2.272l.88.476-.88-.476zm1.17-1.855l.82.574.005-.008-.824-.566zm0 0l-.818-.575-.005.008.824.566zm.213-.305l-.824-.566.824.566zm.206-3.587l-.88.474.88-.474zm-.915-1.437l-.832.554.005.008.827-.562zm0 0l.832-.555-.002-.002-.83.557zm0 0l.83-.557-.004-.006-.826.562zm-.213-.313l-.828.56.828-.56zM6.81 5V4H5.658l.162 1.14.99-.14zM12 5v1h1V5h-1zm0-1.5h1v-1h-1v1zm6.745 0h1v-1h-1v1zm-1.627 5.572l-.829-.56.829.56zm-.23.34l.826.561-.826-.562zm-.82 1.28l-.88-.473.88.474zm.122 2.028l.824-.567-.824.567zm.193.277l.821-.572-.003-.004-.818.576zm0 0l.832-.555-.005-.008-.006-.008-.82.57zm0 0l-.832.554.007.01.007.01.818-.574zm1.272 2.018l-.879.476.88-.476zm1.006 2.735l-.986.168.986-.168zm.086 1.354l-1-.02v.02h1zm0 0l1 .02v-.02h-1zm-.002.896v1h1v-1h-1zM12 20h-1v1h1v-1zm0-1.5v-1h-1v1h1zm5.24 0v1h1.065l-.066-1.062-.998.062zm-.058-.499l-.985.168.985-.168zm-.846-2.272l-.879.476.88-.476zm-1.17-1.856l-.833.555.007.01.007.01.818-.575zm0 0l.832-.554-.007-.01-.007-.01-.819.574zm-.212-.304l.824-.566-.824.566zm-.207-3.587l.88.474-.88-.474zm.914-1.436l.827.563.016-.024.015-.024-.858-.515zm0 0l-.826-.562-.016.023-.015.025.857.514zm.214-.314l-.828-.56.828.56zM17.191 5l.99.14.161-1.14h-1.151v1zM12 5h-1v1h1V5zm0-1.5v-1h-1v1h1zm-6.746 1h.75v-2h-.75v2zm1-.25V3.5h-2v.75h2zm1.456 4.262c-.889-1.315-1.456-2.83-1.456-4.262h-2c0 1.935.752 3.834 1.8 5.382l1.656-1.12zm.227.334l-.227-.334-1.656 1.12.23.34 1.653-1.126zm.875 1.373c-.227-.422-.53-.865-.875-1.373L6.284 9.971c.366.537.6.885.767 1.195l1.762-.947zm.437 1.534c0-.547-.165-1.027-.437-1.534l-1.762.947c.178.33.199.48.199.587h2zm-.615 1.533c.355-.517.615-.955.615-1.533h-2v-.011l.004-.023c.004-.016.006-.015-.004.008a3.13 3.13 0 01-.264.426l1.649 1.133zm-.2.286c.07-.098.137-.195.2-.286l-1.649-1.133-.187.27 1.636 1.15zm-1.21 1.919c.46-.852.88-1.45 1.21-1.919L6.8 12.422c-.338.48-.814 1.157-1.333 2.116l1.758.953zm-.9 2.427c.103-.604.343-1.4.9-2.427l-1.76-.953c-.65 1.203-.969 2.205-1.112 3.044l1.972.335zm-.072 1.166a5.837 5.837 0 01.072-1.166l-1.972-.336c-.118.695-.106 1.244-.1 1.543l2-.041zm.002.166c0-.054 0-.114-.002-.166l-2 .04c.002.06.002.097.002.126h2zm0 .75v-.75h-2V20h2zm-.25-1h-.75v2h.75v-2zM12 19H6.005v2H12v-2zm-1-.5V20h2v-1.5h-2zm-4.24 1H12v-2H6.76v2zm-.928-1.666c-.038.223-.06.422-.07.604l1.996.124c.007-.115.02-.243.046-.393l-1.972-.335zm.953-2.581c-.58 1.071-.84 1.918-.953 2.58l1.972.336c.073-.427.254-1.067.74-1.964l-1.76-.952zm1.231-1.954c-.336.478-.757 1.078-1.231 1.954l1.758.952c.417-.768.782-1.29 1.11-1.757L8.016 13.3zm-.005.008l1.648 1.133-1.648-1.133zm.212-.304l-.207.296 1.637 1.149.218-.312-1.648-1.133zm.527-1.25c0 .41-.173.735-.527 1.25l1.648 1.133c.367-.534.879-1.306.879-2.383h-2zm-.377-1.297c.248.462.377.86.377 1.297h2c0-.877-.272-1.605-.616-2.244l-1.761.947zM7.51 9.107c.364.535.654.963.862 1.349l1.761-.947c-.267-.497-.623-1.018-.97-1.527L7.511 9.107zM7.506 9.1L9.17 7.99 7.506 9.1zm.001.002l1.661-1.113L7.508 9.1zm-.21-.309l.214.315 1.653-1.125a118.9 118.9 0 01-.21-.31l-1.657 1.12zM5.82 5.14c.179 1.266.72 2.533 1.477 3.652l1.657-1.12C8.332 6.752 7.928 5.768 7.8 4.86l-1.98.28zM12 4H6.81v2H12V4zm-1-.5V5h2V3.5h-2zm-4.995 1H12v-2H6.005v2zm12.74-2h-.75v2h.75v-2zm1 1.75V3.5h-2v.75h2zm-1.8 5.382c1.048-1.548 1.8-3.447 1.8-5.382h-2c0 1.433-.567 2.947-1.456 4.262l1.657 1.12zm-.23.341l.23-.34-1.656-1.121-.228.337 1.653 1.124zm-.766 1.193c.166-.31.4-.656.765-1.193L16.061 8.85c-.345.506-.647.949-.874 1.37l1.762.947zm-.199.587c0-.107.021-.257.199-.587l-1.762-.947c-.272.507-.437.987-.437 1.534h2zm.264.4a3.125 3.125 0 01-.264-.427c-.01-.023-.008-.023-.004-.008a.214.214 0 01.004.035h-2c0 .578.26 1.016.616 1.533l1.648-1.133zm.187.268c-.07-.1-.132-.187-.187-.268l-1.648 1.133c.062.091.13.188.199.286l1.636-1.15zm.003.005l-1.642 1.142 1.642-1.142zm.011.016l-1.664 1.11 1.664-1.11zm1.32 2.096c-.52-.96-.996-1.636-1.334-2.116l-1.636 1.15c.33.47.75 1.067 1.211 1.919l1.759-.953zm1.112 3.044c-.143-.839-.461-1.841-1.112-3.044l-1.759.953c.557 1.028.797 1.823.9 2.427l1.971-.336zm.1 1.543c.006-.299.018-.848-.1-1.543l-1.972.335c.085.5.078.893.072 1.167l2 .04zm0-.02h-2 2zm-.002.145c0-.029 0-.066.002-.125l-2-.041-.002.166h2zm0 .75v-.75h-2V20h2zm-1.75 1h.75v-2h-.75v2zM12 21h5.995v-2H12v2zm-1-2.5V20h2v-1.5h-2zm6.24-1H12v2h5.24v-2zm-1.043.669c.025.15.038.278.046.393l1.996-.124a5.655 5.655 0 00-.07-.604l-1.972.335zm-.74-1.964c.486.897.667 1.537.74 1.964l1.971-.335c-.112-.663-.372-1.51-.952-2.581l-1.759.952zm-1.11-1.757c.328.467.694.988 1.11 1.757l1.759-.952c-.475-.876-.896-1.476-1.232-1.954l-1.637 1.149zm-.014-.02l1.665-1.11-1.665 1.11zm-.204-.292l.218.312 1.637-1.15-.206-.295-1.649 1.133zm-.879-2.383c0 1.077.512 1.849.88 2.383l1.648-1.133c-.355-.515-.528-.84-.528-1.25h-2zm.616-2.245c-.343.64-.616 1.368-.616 2.245h2c0-.437.129-.835.377-1.297l-1.76-.948zm.969-1.524c-.346.508-.702 1.028-.969 1.524l1.761.948c.208-.386.498-.813.861-1.347l-1.653-1.125zm-.031.048l1.715 1.029-1.715-1.03zm.243-.36l-.212.312 1.653 1.125.215-.317-1.656-1.12zM16.2 4.86c-.129.908-.533 1.893-1.154 2.812l1.656 1.12c.757-1.119 1.299-2.386 1.478-3.652l-1.98-.28zM12 6h5.19V4H12v2zm-1-2.5V5h2V3.5h-2zm6.994-1H12v2h5.995v-2z",
    fill: "#fff",
    mask: "url(#ic_WorkTime_S24_svg__a)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 18.5,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.5,
    width: 16,
    height: 1.5,
    rx: 0.75,
    fill: "#262626"
  }));
}

function SvgIcWorkTimeS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 16c-.4-1.2-1.167-5.167-1.5-7h22v1c0 .5-1 4.5-1.5 5.5S31 20 30 21.5s-1.5 2-1.5 3 1.5 2 2.5 3.5 3 4.5 3.5 6c.4 1.2.5 3.833.5 5H13v-1.5c0-3.5 2.5-8 3.5-9.5s2.5-3 3-4-.5-1.5-1-2.5-3.5-4-4-5.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.774 8.012a.774.774 0 000 1.547h.509c.17 2.916 1.25 6.232 2.84 8.75.752 1.192 1.762 2.175 2.61 3 .157.152.309.3.452.442.476.473.857.882 1.12 1.272.259.384.366.696.366.977 0 .236-.1.498-.406.868-.296.356-.709.727-1.24 1.205h-.001l-.113.1c-1.144 1.03-2.63 2.4-3.739 4.594-1.789 3.539-1.928 6.193-1.922 7.674h-.476a.774.774 0 100 1.547h24.452a.774.774 0 000-1.547h-.476c.006-1.48-.133-4.135-1.922-7.674-1.11-2.194-2.595-3.564-3.74-4.593l-.112-.101c-.532-.478-.945-.849-1.24-1.205-.306-.37-.407-.632-.407-.868 0-.281.107-.593.367-.977.262-.39.643-.8 1.119-1.272.143-.142.294-.289.45-.442h.002c.848-.826 1.858-1.808 2.61-3 1.59-2.518 2.67-5.834 2.84-8.75h.51a.774.774 0 000-1.547H11.773zm4.617 9.497c-1.45-2.296-2.436-5.328-2.605-7.95h20.428c-.17 2.622-1.156 5.654-2.605 7.95-.649 1.027-1.51 1.867-2.359 2.695-.165.16-.33.322-.492.483-.482.479-.955.976-1.306 1.497-.355.527-.623 1.13-.623 1.816 0 .73.337 1.324.752 1.825.37.446.866.891 1.367 1.34l.138.125c1.124 1.01 2.428 2.225 3.403 4.154 1.633 3.228 1.766 5.604 1.76 6.997H13.75c-.005-1.393.129-3.769 1.76-6.997.976-1.93 2.28-3.144 3.404-4.154l.138-.125c.502-.449.997-.894 1.367-1.34.415-.5.752-1.095.752-1.825 0-.686-.268-1.289-.623-1.816-.351-.52-.824-1.018-1.306-1.497-.162-.162-.327-.322-.492-.483-.849-.828-1.71-1.668-2.359-2.695zm3.895 1.175c-.398-.415-.963-1.085-1.4-1.615a.492.492 0 01.384-.805h9.46c.418 0 .65.482.383.805-.436.53-1 1.2-1.4 1.615-1.487 1.556-2.719 3.318-2.719 5.843 0 2.4.86 7.491 2.506 8.473.663.395 1.279.634 1.843.853.836.325 1.56.606 2.157 1.288.867.99.938 1.607.98 1.972.006.056.012.106.02.15h-17c.008-.044.014-.094.02-.15.042-.365.113-.983.98-1.972.597-.681 1.32-.962 2.157-1.288.564-.219 1.18-.458 1.843-.853 1.647-.982 2.506-6.073 2.506-8.473 0-2.525-1.232-4.287-2.72-5.843z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcWorkdetailS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75 1.5a.75.75 0 000 1.5h11.5a.75.75 0 000-1.5H2.75zm0 4a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM2 10.25a.75.75 0 01.75-.75h11.5a.75.75 0 010 1.5H2.75a.75.75 0 01-.75-.75zm.75 3.25a.75.75 0 000 1.5h4.5a.75.75 0 000-1.5h-4.5z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcWorklistOffS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10a7.25 7.25 0 11-14.5 0 7.25 7.25 0 0114.5 0z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.811 16.011a.85.85 0 111.202-1.202l4.045 4.045a.85.85 0 01-1.202 1.202L14.81 16.01z",
    fill: "#262626"
  }));
}

function SvgIcWorklistOnS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10a6.25 6.25 0 11-12.5 0 6.25 6.25 0 0112.5 0z",
    stroke: "#262626",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.401 15.601a.85.85 0 011.202-1.202l4.455 4.455a.85.85 0 01-1.202 1.202L14.4 15.6z",
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcZoominReviewS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 11a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-.357 5.126a8 8 0 10-1.065 1.057l4.253 4.252a.75.75 0 001.06-1.06l-4.248-4.25z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcZoominS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 11a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0zm-.357 5.126a8 8 0 10-1.065 1.057l4.253 4.252a.75.75 0 001.06-1.06l-4.248-4.25zM11 7.25a.75.75 0 01.75.75v2.25H14a.75.75 0 010 1.5h-2.25V14a.75.75 0 01-1.5 0v-2.25H8a.75.75 0 010-1.5h2.25V8a.75.75 0 01.75-.75z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcAfternoonS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_afternoon_S24_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 .25a.75.75 0 01.75.75v2.5a.75.75 0 01-1.5 0V1A.75.75 0 0112 .25zm0 19.5a.75.75 0 01.75.75V23a.75.75 0 01-1.5 0v-2.5a.75.75 0 01.75-.75zm8.5-8.5a.75.75 0 000 1.5H23a.75.75 0 000-1.5h-2.5zM.25 12a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5H1A.75.75 0 01.25 12zm18.29 5.48a.75.75 0 10-1.06 1.06l1.768 1.769a.75.75 0 001.06-1.061l-1.767-1.768zM3.693 3.692a.75.75 0 011.06 0L6.52 5.459A.75.75 0 015.46 6.52L3.691 4.752a.75.75 0 010-1.06zM17.48 5.459a.75.75 0 001.06 1.06l1.768-1.767a.75.75 0 00-1.06-1.06L17.48 5.458zM3.692 20.31a.75.75 0 010-1.061l1.767-1.768a.75.75 0 111.06 1.06l-1.767 1.768a.75.75 0 01-1.06 0zM16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM12 18a6 6 0 100-12 6 6 0 000 12z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 .25a.75.75 0 01.75.75v2.5a.75.75 0 01-1.5 0V1A.75.75 0 0112 .25zm0 19.5a.75.75 0 01.75.75V23a.75.75 0 01-1.5 0v-2.5a.75.75 0 01.75-.75zm8.5-8.5a.75.75 0 000 1.5H23a.75.75 0 000-1.5h-2.5zM.25 12a.75.75 0 01.75-.75h2.5a.75.75 0 010 1.5H1A.75.75 0 01.25 12zm18.29 5.48a.75.75 0 10-1.06 1.06l1.768 1.769a.75.75 0 001.06-1.061l-1.767-1.768zM3.693 3.692a.75.75 0 011.06 0L6.52 5.459A.75.75 0 015.46 6.52L3.691 4.752a.75.75 0 010-1.06zM17.48 5.459a.75.75 0 001.06 1.06l1.768-1.767a.75.75 0 00-1.06-1.06L17.48 5.458zM3.692 20.31a.75.75 0 010-1.061l1.767-1.768a.75.75 0 111.06 1.06l-1.767 1.768a.75.75 0 01-1.06 0zM16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM12 18a6 6 0 100-12 6 6 0 000 12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.48 17.48l1.06 1.06-1.06-1.06zm1.06 0l-1.06 1.06 1.06-1.06zm-1.06 1.06l-1.06 1.061 1.06-1.06zm1.768 1.769l-1.06 1.06 1.06-1.06zm1.06-1.061l1.061-1.06-1.06 1.06zM4.752 3.692l1.06-1.061-1.06 1.06zM6.52 6.52l1.06 1.06-1.06-1.06zm-1.06 0L4.398 7.58l1.06-1.06zM3.691 4.752L2.63 5.812l1.06-1.06zm13.788.707L16.42 4.4l1.06 1.06zm1.06 1.06l-1.06-1.06 1.06 1.06zm1.768-1.767l-1.06-1.06 1.06 1.06zm0-1.06l-1.06 1.06 1.06-1.06zm-1.06 0l-1.06-1.061 1.06 1.06zM3.692 19.247l-1.061-1.06 1.06 1.06zm0 1.06l1.06-1.06-1.06 1.06zm1.767-2.828L4.4 16.42l1.06 1.06zm1.06 0l1.062-1.06-1.061 1.06zm0 1.06l1.062 1.061-1.061-1.06zm-1.767 1.768l-1.06-1.06 1.06 1.06zM14.25 1A2.25 2.25 0 0012-1.25v3a.75.75 0 01-.75-.75h3zm0 2.5V1h-3v2.5h3zM12 5.75a2.25 2.25 0 002.25-2.25h-3a.75.75 0 01.75-.75v3zM9.75 3.5A2.25 2.25 0 0012 5.75v-3a.75.75 0 01.75.75h-3zm0-2.5v2.5h3V1h-3zM12-1.25A2.25 2.25 0 009.75 1h3a.75.75 0 01-.75.75v-3zm2.25 21.75A2.25 2.25 0 0012 18.25v3a.75.75 0 01-.75-.75h3zm0 2.5v-2.5h-3V23h3zM12 25.25A2.25 2.25 0 0014.25 23h-3a.75.75 0 01.75-.75v3zM9.75 23A2.25 2.25 0 0012 25.25v-3a.75.75 0 01.75.75h-3zm0-2.5V23h3v-2.5h-3zM12 18.25a2.25 2.25 0 00-2.25 2.25h3a.75.75 0 01-.75.75v-3zM21.25 12a.75.75 0 01-.75.75v-3A2.25 2.25 0 0018.25 12h3zm-.75-.75a.75.75 0 01.75.75h-3a2.25 2.25 0 002.25 2.25v-3zm2.5 0h-2.5v3H23v-3zm-.75.75a.75.75 0 01.75-.75v3A2.25 2.25 0 0025.25 12h-3zm.75.75a.75.75 0 01-.75-.75h3A2.25 2.25 0 0023 9.75v3zm-2.5 0H23v-3h-2.5v3zM1 9.75A2.25 2.25 0 00-1.25 12h3a.75.75 0 01-.75.75v-3zm2.5 0H1v3h2.5v-3zM5.75 12A2.25 2.25 0 003.5 9.75v3a.75.75 0 01-.75-.75h3zM3.5 14.25A2.25 2.25 0 005.75 12h-3a.75.75 0 01.75-.75v3zm-2.5 0h2.5v-3H1v3zM-1.25 12A2.25 2.25 0 001 14.25v-3a.75.75 0 01.75.75h-3zm19.79 6.54a.75.75 0 01-1.06 0l2.121-2.12a2.25 2.25 0 00-3.182 0l2.122 2.12zm0-1.06a.75.75 0 010 1.06l-2.12-2.12a2.25 2.25 0 000 3.181l2.12-2.12zm1.768 1.768l-1.767-1.768-2.122 2.121 1.768 1.768 2.121-2.121zm-1.06 0a.75.75 0 011.06 0l-2.12 2.121a2.25 2.25 0 003.181 0l-2.121-2.121zm0 1.06a.75.75 0 010-1.06l2.121 2.121a2.25 2.25 0 000-3.182l-2.121 2.122zm-1.768-1.767l1.768 1.768 2.121-2.122-1.768-1.768-2.12 2.122zM5.813 2.63a2.25 2.25 0 00-3.182 0l2.121 2.121a.75.75 0 01-1.06 0l2.12-2.121zM7.58 4.399L5.813 2.63 3.692 4.752 5.459 6.52l2.122-2.121zm0 3.182a2.25 2.25 0 000-3.182L5.459 6.52a.75.75 0 010-1.06l2.122 2.12zm-3.182 0a2.25 2.25 0 003.182 0L5.459 5.459a.75.75 0 011.06 0L4.4 7.581zM2.63 5.813L4.399 7.58l2.12-2.122-1.767-1.767-2.121 2.12zm0-3.182a2.25 2.25 0 000 3.182l2.121-2.121a.75.75 0 010 1.06L2.631 2.631zm15.91 2.828a.75.75 0 010 1.06L16.419 4.4a2.25 2.25 0 000 3.182l2.122-2.122zm-1.06 0a.75.75 0 011.06 0l-2.122 2.122a2.25 2.25 0 003.182 0l-2.12-2.122zm1.767-1.768L17.48 5.46l2.121 2.122 1.768-1.768-2.121-2.122zm0 1.061a.75.75 0 010-1.06l2.121 2.12a2.25 2.25 0 000-3.181l-2.121 2.121zm1.06 0a.75.75 0 01-1.06 0l2.121-2.121a2.25 2.25 0 00-3.182 0l2.121 2.121zM18.541 6.52l1.767-1.768-2.12-2.121-1.769 1.768 2.122 2.12zM2.63 18.187a2.25 2.25 0 000 3.182l2.121-2.121a.75.75 0 010 1.06l-2.121-2.12zm1.768-1.768L2.63 18.187l2.121 2.121 1.768-1.767-2.121-2.122zm3.182 0a2.25 2.25 0 00-3.182 0l2.12 2.122a.75.75 0 01-1.06 0l2.122-2.122zm0 3.182a2.25 2.25 0 000-3.182l-2.122 2.122a.75.75 0 010-1.061l2.122 2.121zM5.813 21.37l1.768-1.768-2.122-2.121-1.767 1.768 2.12 2.121zm-3.182 0a2.25 2.25 0 003.182 0l-2.121-2.121a.75.75 0 011.06 0l-2.121 2.121zM12 18a6 6 0 006-6h-3a3 3 0 01-3 3v3zm-6-6a6 6 0 006 6v-3a3 3 0 01-3-3H6zm6-6a6 6 0 00-6 6h3a3 3 0 013-3V6zm6 6a6 6 0 00-6-6v3a3 3 0 013 3h3zm-1.5 0a4.5 4.5 0 01-4.5 4.5v3a7.5 7.5 0 007.5-7.5h-3zM12 7.5a4.5 4.5 0 014.5 4.5h3A7.5 7.5 0 0012 4.5v3zM7.5 12A4.5 4.5 0 0112 7.5v-3A7.5 7.5 0 004.5 12h3zm4.5 4.5A4.5 4.5 0 017.5 12h-3a7.5 7.5 0 007.5 7.5v-3z",
    fill: "#000",
    fillOpacity: 0.8,
    mask: "url(#ic_afternoon_S24_svg__a)"
  }));
}

function SvgIcAmountS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 5.75,
    y: 2.75,
    width: 14.5,
    height: 14.5,
    rx: 1.25,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.75,
    y: 5.75,
    width: 14.5,
    height: 14.5,
    rx: 1.25,
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.911 17H9.5v-5.44l-1.685.523v-1.148l2.945-1.054h.151V17z",
    fill: "#000"
  }));
}

function SvgIcAptDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.576 21.435c0-.69.56-1.25 1.25-1.25h13.74c.69 0 1.25.56 1.25 1.25V38.51h-16.24V21.435z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 23.608,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 28.304,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 33,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 37.696,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.696,
    y: 28.304,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.696,
    y: 33,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.696,
    y: 23.608,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_aptDim_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 20.305,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 20.305,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_aptDim_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_aptDim_S48_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 26.913,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 26.913,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_aptDim_S48_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.185 11c0-.69.56-1.25 1.25-1.25h16.87c.69 0 1.25.56 1.25 1.25v27.51h-19.37V11z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 14.217,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 18.913,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 23.609,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 28.304,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 18.913,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 23.608,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 28.304,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 14.217,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_aptDim_S48_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.696,
    y: 34.044,
    width: 8.348,
    height: 5.217,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.696,
    y: 34.044,
    width: 8.348,
    height: 5.217,
    rx: 1,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_aptDim_S48_svg__c)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 37.76,
    width: 33.391,
    height: 1.5,
    rx: 0.75,
    fill: "#D8D8D8"
  }));
}

function SvgIcAptS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.826 21.435a2 2 0 012-2h13.74a2 2 0 012 2V39.26h-17.74V21.435z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.576 21.435c0-.69.56-1.25 1.25-1.25h13.74c.69 0 1.25.56 1.25 1.25V38.51h-16.24V21.435z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 23.608,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 28.304,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 33,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.348,
    y: 37.696,
    width: 5.217,
    height: 1.043,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.696,
    y: 28.304,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.696,
    y: 33,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.696,
    y: 23.608,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_apt_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 20.305,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 20.305,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_apt_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_apt_S48_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 26.913,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.609,
    y: 26.913,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_apt_S48_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.435 11a2 2 0 012-2h16.87a2 2 0 012 2v28.26h-20.87V11z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.185 11c0-.69.56-1.25 1.25-1.25h16.87c.69 0 1.25.56 1.25 1.25v27.51h-19.37V11z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 14.217,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 18.913,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 23.609,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.087,
    y: 28.304,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 18.913,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 23.608,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 28.304,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.435,
    y: 14.217,
    width: 5.217,
    height: 1.5,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_apt_S48_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.696,
    y: 34.044,
    width: 8.348,
    height: 5.217,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.696,
    y: 34.044,
    width: 8.348,
    height: 5.217,
    rx: 1,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_apt_S48_svg__c)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 37.76,
    width: 33.391,
    height: 1.5,
    rx: 0.75,
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcArrowDownincircleS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM4.46 7.843a.75.75 0 011.06-.02l1.73 1.664V5.025a.75.75 0 111.5 0v4.462l1.73-1.665a.75.75 0 011.04 1.081l-3 2.887a.75.75 0 01-1.04 0l-3-2.887a.75.75 0 01-.02-1.06z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcArrowDownincircleS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM7.78 12.938a1 1 0 011.413-.027L11 14.65V8a1 1 0 112 0v6.65l1.807-1.74a1 1 0 011.386 1.442l-3.5 3.368a1 1 0 01-1.386 0l-3.5-3.368a1 1 0 01-.028-1.414z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcArrowUpincircleS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-11.54.432a.75.75 0 001.06.02l1.73-1.664v4.462a.75.75 0 001.5 0V6.788l1.73 1.665a.75.75 0 001.04-1.081l-3-2.887a.75.75 0 00-1.04 0l-3 2.887a.75.75 0 00-.02 1.06z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcArrowUpincircleS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM7.78 12.062a1 1 0 001.413.027L11 10.35V17a1 1 0 102 0v-6.65l1.807 1.739a1 1 0 001.386-1.441l-3.5-3.369a1 1 0 00-1.386 0l-3.5 3.369a1 1 0 00-.028 1.414z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcArrowRightW100(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.899 13.725a.75.75 0 101.055 1.065l6.32-6.257a.75.75 0 000-1.066l-6.32-6.257A.75.75 0 109.9 2.276l5.104 5.054H1.166a.67.67 0 100 1.34h13.837L9.9 13.725z",
    fill: "#fff"
  }));
}

function SvgIcBalconyDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 13A3.25 3.25 0 0117 9.75h14.4A3.25 3.25 0 0134.65 13v24.25h-20.9V13z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_balconyDim_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 25h30v12.565a1 1 0 01-1 1H10a1 1 0 01-1-1V25z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 25h30v12.565a1 1 0 01-1 1H10a1 1 0 01-1-1V25z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_balconyDim_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M23 9.913h1.5v16.174H23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 25.75a.75.75 0 01.75-.75h32.5a.75.75 0 010 1.5H7.75a.75.75 0 01-.75-.75z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M17.174 26h1.5v11.826h-1.5zM13 26h1.5v11.826H13zM21.348 26h1.5v11.826h-1.5zM25.522 26h1.5v11.826h-1.5zM29.696 26h1.5v11.826h-1.5zM34 26h1.5v11.826H34z"
  }));
}

function SvgIcBalconyS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 2.75h13.5v16.5H5.25V2.75z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12.75h19.5v7.5H2.25v-7.5z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M11.25 2h1.5v11h-1.5zM6.5 12H8v9H6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M11.25 12h1.5v9h-1.5zM16 12h1.5v9H16z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeWidth: 1.5,
    d: "M8.53 4.53l-2 2M9.53 6.53l-3 3"
  }));
}

function SvgIcBalconyS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.75h20.5v23.5h-20.5v-23.5z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 24.75h28.5v11.5H9.75v-11.5z",
    fill: "#fff",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M23.25 10h1.5v15.714h-1.5zM16.143 24h1.5v13h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#262626",
    d: "M23.25 24h1.5v13h-1.5zM30.714 24h1.5v13h-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#262626",
    strokeWidth: 1.5,
    d: "M18.816 13.387l-2.857 2.858M20.245 16.245l-4.286 4.285"
  }));
}

function SvgIcBedroomDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 24.849a2 2 0 00-2 2v5.613a2 2 0 002 2H10.995c.466 0 .887-.172 1.184-.448l.008-.003 1.68-1.773a2 2 0 011.452-.624h10.537a2 2 0 011.456.63l1.52 1.614c.048.06.1.115.158.167l.041.044.016.006a1.75 1.75 0 001.174.387h.97a2 2 0 002-2v-5.613a2 2 0 00-2-2H10z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.936 34.462l.023-.75h-.023v.75zm1.243-.448l-.277-.697-.131.052-.104.096.512.549zm.008-.003l.277.697.154-.061.114-.12-.545-.516zm1.68-1.773l-.544-.516.544.516zm13.445.005l.546-.514-.546.514zm1.52 1.615l.585-.47-.018-.023-.02-.021-.547.514zm.158.167l.546-.514-.02-.02-.02-.02-.506.554zm.041.044l-.546.514.123.13.168.061.255-.705zm.016.006l.478-.579-.1-.083-.123-.044-.255.706zm1.174.387v-.75h-.024l.024.75zM8.75 26.849c0-.69.56-1.25 1.25-1.25v-1.5a2.75 2.75 0 00-2.75 2.75h1.5zm0 5.613v-5.613h-1.5v5.613h1.5zm1.25 1.25c-.69 0-1.25-.56-1.25-1.25h-1.5a2.75 2.75 0 002.75 2.75v-1.5zm.936 0H10v1.5h.936v-1.5zm.059 0h-.036l-.046 1.5h.082v-1.5zm.672-.247a.987.987 0 01-.672.248v1.5c.65 0 1.255-.24 1.695-.65l-1.023-1.098zm.243-.151l-.008.003.554 1.394.008-.003-.554-1.394zm1.413-1.592l-1.68 1.773 1.089 1.032 1.68-1.773-1.089-1.032zm1.996-.858a2.75 2.75 0 00-1.996.858l1.089 1.032a1.25 1.25 0 01.907-.39v-1.5zm10.537 0H15.319v1.5h10.537v-1.5zm2.002.865a2.75 2.75 0 00-2.002-.865v1.5c.344 0 .674.143.91.393l1.092-1.028zm1.52 1.615l-1.52-1.615-1.092 1.028 1.52 1.615 1.092-1.028zm-1.13.984c.072.09.152.174.237.252l1.01-1.109a.749.749 0 01-.078-.083l-1.169.94zm1.33-.773l-.042-.044-1.092 1.029.041.043 1.092-1.028zm-.276-.186l-.016-.005-.51 1.41.016.006.51-1.41zm-.733 1.284c.429.354.991.56 1.593.56v-1.5a1 1 0 01-.637-.217l-.956 1.157zm1.593.56c.027 0 .055 0 .082-.002l-.047-1.499h-.035v1.5zm1.03-1.501h-.971v1.5h.97v-1.5zm1.25-1.25c0 .69-.56 1.25-1.25 1.25v1.5a2.75 2.75 0 002.75-2.75h-1.5zm0-5.613v5.613h1.5v-5.613h-1.5zm-1.25-1.25c.69 0 1.25.56 1.25 1.25h1.5a2.75 2.75 0 00-2.75-2.75v1.5zm-21.192 0h21.192v-1.5H10v1.5z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.03 17.877c-3.441 0-8.78.7-8.78 4.172v2.8h18.691v-2.8c0-3.472-5.054-4.172-8.495-4.172H20.03z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.064 34.481h5.088",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.608 18.511v15.264",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.907 13.938a.25.25 0 01.242-.188h2.918a.25.25 0 01.242.188l.891 3.512a.25.25 0 01-.242.312h-4.7a.25.25 0 01-.242-.312l.89-3.511z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }));
}

function SvgIcBedroomS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.933 34.462l.024-.75h-.024v.75zm1.246-.448l-.277-.697-.131.052-.104.096.512.549zm.008-.004l.277.697.154-.06.114-.12-.545-.517zm1.68-1.772l-.544-.516.544.516zm13.445.005l.546-.514-.546.514zm1.52 1.614l.585-.47-.019-.023-.02-.02-.546.513zm.159.169l.546-.514-.02-.021-.021-.02-.505.555zm.04.043l-.546.514.123.13.168.061.255-.705zm.016.005l.477-.578-.1-.083-.123-.044-.254.705zm1.177.388v-.75h-.025l.025.75zM8.75 26.849c0-.69.56-1.25 1.25-1.25v-1.5a2.75 2.75 0 00-2.75 2.75h1.5zm0 5.613v-5.613h-1.5v5.613h1.5zm1.25 1.25c-.69 0-1.25-.56-1.25-1.25h-1.5a2.75 2.75 0 002.75 2.75v-1.5zm.933 0H10v1.5h.933v-1.5zm.062 0h-.038l-.049 1.5h.087v-1.5zm.673-.247a.987.987 0 01-.673.247v1.5c.65 0 1.255-.24 1.695-.65l-1.022-1.097zm.242-.152l-.008.004.554 1.394.008-.004-.554-1.394zm1.413-1.59l-1.68 1.771 1.089 1.032 1.68-1.772-1.089-1.032zm1.996-.859a2.75 2.75 0 00-1.996.858l1.089 1.032a1.25 1.25 0 01.907-.39v-1.5zm10.537 0H15.319v1.5h10.537v-1.5zm2.002.865a2.75 2.75 0 00-2.002-.865v1.5c.344 0 .674.142.91.393l1.092-1.028zm1.52 1.614l-1.52-1.614-1.092 1.028 1.52 1.614 1.092-1.028zm-1.13.984c.072.09.152.175.238.254l1.01-1.11a.742.742 0 01-.08-.083l-1.169.939zm1.33-.773l-.041-.042-1.092 1.028.04.043 1.092-1.029zm-.277-.185l-.015-.006-.51 1.411.016.006.51-1.411zm-.732 1.283c.428.355.99.56 1.593.56v-1.5a1 1 0 01-.637-.216l-.956 1.156zm1.593.56h.086l-.049-1.5h-.037v1.5zm1.03-1.5h-.968v1.5h.968v-1.5zm1.25-1.25c0 .69-.56 1.25-1.25 1.25v1.5a2.75 2.75 0 002.75-2.75h-1.5zm0-5.613v5.613h1.5v-5.613h-1.5zm-1.25-1.25c.69 0 1.25.56 1.25 1.25h1.5a2.75 2.75 0 00-2.75-2.75v1.5zm-21.192 0h21.192v-1.5H10v1.5z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20.03 17.877c-3.441 0-8.78.7-8.78 4.172v2.8h18.691v-2.8c0-3.472-5.054-4.172-8.495-4.172H20.03z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.456 34.481h5.088",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 18.511v15.264",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.883 13.934a.25.25 0 01.241-.184h3.752a.25.25 0 01.24.184l1.1 4a.25.25 0 01-.241.316h-5.95a.25.25 0 01-.241-.316l1.1-4z",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcBundleS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.791 2.871c.863.863.864 2.317-.066 3.248L9.94 8.903c-.93.931-2.384.93-3.248.067a.75.75 0 10-1.06 1.06c1.48 1.48 3.884 1.42 5.37-.066l2.783-2.784c1.486-1.486 1.546-3.89.067-5.37-1.48-1.48-3.884-1.419-5.37.067l-1.011 1.01A.75.75 0 008.53 3.95l1.012-1.012c.93-.93 2.385-.93 3.248-.066zm-10.31 10.31c-.863-.864-.864-2.318.067-3.25l2.784-2.783c.931-.931 2.385-.93 3.249-.067a.75.75 0 001.06-1.06c-1.48-1.48-3.884-1.42-5.37.066L1.488 8.871c-1.485 1.486-1.546 3.89-.066 5.37s3.884 1.42 5.37-.066l1.01-1.012a.75.75 0 00-1.06-1.06l-1.011 1.01c-.93.932-2.385.93-3.248.067z",
    fill: "#42484C"
  }));
}

function SvgIcBusS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 3a2 2 0 00-2 2v14a1.5 1.5 0 003 0h11a1.5 1.5 0 003 0V5a2 2 0 00-2-2h-13zm2 3a2 2 0 00-2 2v1a2 2 0 002 2h9a2 2 0 002-2V8a2 2 0 00-2-2h-9zm1 9a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm8.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcCarS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.308 4a2 2 0 00-1.832 1.198L2.5 12v6.5a1.5 1.5 0 003 0h13a1.5 1.5 0 003 0V12l-2.513-6.702A2 2 0 0017.114 4H7.308zm-.312 2.621A1 1 0 017.92 6h8.598a1 1 0 01.953.697l1.113 3.5a1 1 0 01-.953 1.303H6.49a1 1 0 01-.926-1.379l1.432-3.5zM8 15a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm11 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcCctvDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.854c0-.876.878-1.48 1.696-1.167l3.587 1.37v5.277l-3.587 1.37a1.25 1.25 0 01-1.696-1.167v-5.683z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.967 13c0-.69.56-1.25 1.25-1.25h21.044c.69 0 1.25.56 1.25 1.25v13.74c0 .69-.56 1.25-1.25 1.25H16.217c-.69 0-1.25-.56-1.25-1.25V13z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 29.087v5.061a1.2 1.2 0 001.2 1.2h10.54",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.478 32.74v5.217",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.163 27.956a3.163 3.163 0 11-6.326 0 3.163 3.163 0 016.326 0z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.565 17.087a1.565 1.565 0 100-3.13 1.565 1.565 0 000 3.13z",
    fill: "#D8D8D8"
  }));
}

function SvgIcCctvS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 16.854a2 2 0 012.714-1.868l4.069 1.555v6.31l-4.069 1.554A2 2 0 019 22.537v-5.683z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 16.854c0-.876.878-1.48 1.696-1.167l3.587 1.37v5.277l-3.587 1.37a1.25 1.25 0 01-1.696-1.167v-5.683z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.217 13a2 2 0 012-2h21.044a2 2 0 012 2v13.74a2 2 0 01-2 2H16.217a2 2 0 01-2-2V13z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.967 13c0-.69.56-1.25 1.25-1.25h21.044c.69 0 1.25.56 1.25 1.25v13.74c0 .69-.56 1.25-1.25 1.25H16.217c-.69 0-1.25-.56-1.25-1.25V13zM27 29.087v5.061a1.2 1.2 0 001.2 1.2h10.54",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.478 32.74v5.217",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 31.87a3.913 3.913 0 100-7.826 3.913 3.913 0 000 7.825z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.163 27.956a3.163 3.163 0 11-6.326 0 3.163 3.163 0 016.326 0z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.565 17.087a1.565 1.565 0 100-3.13 1.565 1.565 0 000 3.13z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCctvNoneS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17.124a2 2 0 012.864-1.803l4.636 2.22v4.31l-4.636 2.22A2 2 0 019 22.267v-5.143z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14a2 2 0 012-2h19a2 2 0 012 2v12a2 2 0 01-2 2H17a2 2 0 01-2-2V14z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 29.087v4.261a2 2 0 002 2h9.2M38.26 32.74v5.217",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 31.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }));
}

function SvgIcCheckincircleS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zm3.499-10.56a.75.75 0 01.061 1.059l-3.936 4.42a.75.75 0 01-1.068.054L4.493 9.08a.75.75 0 011.014-1.105l1.503 1.38L10.44 5.5a.75.75 0 011.059-.061z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCheckincircleS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm5.747-15.335a1 1 0 00-1.494-1.33l-5.885 6.61-2.692-2.471a1 1 0 00-1.352 1.473l3.439 3.158a1 1 0 001.423-.072l6.56-7.368z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCleanerS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.915 1c1.566 0 2.717 1.475 2.717 3.054l-1.93 1.786h-3.687S9.78 3.73 6 3.73V1h8.915z",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M17.322 23h-6.826a.671.671 0 01-.678-.664v-10.76c0-1.63 1.212-3.223 2.875-3.223h2.432c1.663 0 2.875 1.594 2.875 3.224v10.759a.671.671 0 01-.678.664zM11.943 8.336h3.761V5.839h-3.76v2.497z",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.315 4.76c-.186 1.418-1.186 2.73-3.231 3.716",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcCleaninglabS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 10.75,
    width: 26.5,
    height: 26.5,
    rx: 1.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 24,
    width: 8,
    height: 4,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 30,
    width: 16,
    height: 4,
    rx: 0.5,
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCommaEnd(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.478 13C10.872 12.235 13 9.235 13 5.53V0H7.708v5.647h2.876c0 2.823-1.093 4.53-3.106 5.117V13zM0 13c3.451-.765 5.522-3.765 5.522-7.47V0H.23v5.647h2.876c0 2.823-1.093 4.53-3.106 5.117V13z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcCommaStart(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.522 0C2.128.765 0 3.765 0 7.47V13h5.292V7.353H2.416c0-2.824 1.093-4.53 3.106-5.118V0zM13 0C9.549.765 7.478 3.765 7.478 7.47V13h5.292V7.353H9.894c0-2.824 1.093-4.53 3.106-5.118V0z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcDuplexS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 18L24 8l12 10v19H12V18z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17v19a1 1 0 001 1h22a1 1 0 001-1V17",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34 25h9.931v4H24v4h5v3.5M8.5 20L24 7.5 40 20M36 25h3",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 18,
    r: 3.25,
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcDuplexNoneS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5l12-10 12 10V37H12V17.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20v16a1 1 0 001 1h22a1 1 0 001-1V20",
    stroke: "#262626",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.34 25h9.931v4H24v4h5v3.5",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 20L24 7.5 40 20",
    stroke: "#262626",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 25h3",
    stroke: "#262626",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeDasharray: "1 2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.1,
    cy: 17.5,
    r: 3.5,
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.6"
  }));
}

function SvgIcEvaluationS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.634.393a.5.5 0 01.732 0l1.519 1.633a.5.5 0 00.574.114l2.027-.927a.5.5 0 01.677.28l.778 2.09a.5.5 0 00.486.324l2.228-.08a.5.5 0 01.518.518l-.08 2.228a.5.5 0 00.325.486l2.089.778a.5.5 0 01.28.677l-.927 2.027a.5.5 0 00.114.574l1.633 1.519a.5.5 0 010 .732l-1.633 1.519a.5.5 0 00-.114.574l.927 2.027a.5.5 0 01-.28.677l-2.09.778a.5.5 0 00-.324.486l.08 2.228a.5.5 0 01-.518.518l-2.228-.08a.5.5 0 00-.486.325l-.778 2.089a.5.5 0 01-.677.28l-2.027-.927a.5.5 0 00-.574.114l-1.519 1.633a.5.5 0 01-.732 0l-1.519-1.633a.5.5 0 00-.574-.114l-2.027.927a.5.5 0 01-.677-.28l-.778-2.09a.5.5 0 00-.486-.324l-2.228.08a.5.5 0 01-.518-.518l.08-2.228a.5.5 0 00-.325-.486l-2.089-.778a.5.5 0 01-.28-.677l.927-2.027a.5.5 0 00-.114-.574L.393 13.366a.5.5 0 010-.732l1.633-1.519a.5.5 0 00.114-.574l-.927-2.027a.5.5 0 01.28-.677l2.09-.778a.5.5 0 00.324-.486l-.08-2.228a.5.5 0 01.518-.518l2.228.08a.5.5 0 00.486-.325l.778-2.089a.5.5 0 01.677-.28l2.027.927a.5.5 0 00.574-.114L12.634.393z",
    fill: "#00BED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.133 16.57a.286.286 0 00-.266 0l-2.881 1.515a.286.286 0 01-.415-.302l.55-3.208a.286.286 0 00-.082-.253L7.71 12.05a.286.286 0 01.158-.487l3.221-.469a.285.285 0 00.215-.156l1.44-2.919a.286.286 0 01.513 0l1.44 2.92a.285.285 0 00.216.155l3.221.469a.286.286 0 01.159.487l-2.331 2.272a.286.286 0 00-.082.253l.55 3.209a.286.286 0 01-.415.3l-2.881-1.514z",
    fill: "#fff"
  }));
}

function SvgIcEvaluationS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 15.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.064 21.017c2.503-4.088 7.859-1.345 6.799 3.287-1.038 4.533-6.8 6.93-6.8 6.93s-5.892-2.397-6.929-6.93c-1.06-4.632 4.426-7.375 6.93-3.287z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcFingerS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    d: "M20.06 4.75v1.5M28.75 14.75h1.5M9.75 14.75h1.5M26 8.939l1.061-1.06M12.061 7.879l1.06 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14h4v9.5l2.5-.5 2 1 3 .5.5 1.5h3.5l.5 4-.5 7.5L30 41l-4 1-4-1-3.5-1.5-1.5-2-1-1.5-4.5-8.5 1.5-2 2 .5 2.5 3.5.5-3.5V14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_finger_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.021 13a2.75 2.75 0 00-2.75 2.75V28l-1.126-1.912a2.764 2.764 0 00-4.78 2.775l3 5.251a.788.788 0 00.023.039l.009.013c.215.328.44.75.695 1.23 1.344 2.526 3.554 6.68 9.828 7.35l.04.004H25c5.814 0 9.742-4.257 9.771-7.988v-7.451a2.75 2.75 0 00-4.124-2.382 2.751 2.751 0 00-4.184-1.445 2.75 2.75 0 00-3.692-1.184v-6.55a2.75 2.75 0 00-2.75-2.75zm-4.36 20.358c.28.429.55.926.838 1.46 1.364 2.52 3.161 5.842 8.54 6.432 5.117-.02 8.214-3.744 8.232-6.505v-7.434a1.25 1.25 0 00-2.5 0v1.439a.75.75 0 01-1.5 0v-3a1.25 1.25 0 10-2.5 0v2a.75.75 0 01-1.5 0v-3a1.25 1.25 0 10-2.5 0v2a.75.75 0 01-1.5 0v-11a1.25 1.25 0 10-2.5 0v14.982a.75.75 0 01-1.396.399l-2.523-4.28a1.263 1.263 0 00-2.185 1.267l2.994 5.24z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.021 13a2.75 2.75 0 00-2.75 2.75V28l-1.126-1.912a2.764 2.764 0 00-4.78 2.775l3 5.251a.788.788 0 00.023.039l.009.013c.215.328.44.75.695 1.23 1.344 2.526 3.554 6.68 9.828 7.35l.04.004H25c5.814 0 9.742-4.257 9.771-7.988v-7.451a2.75 2.75 0 00-4.124-2.382 2.751 2.751 0 00-4.184-1.445 2.75 2.75 0 00-3.692-1.184v-6.55a2.75 2.75 0 00-2.75-2.75zm-4.36 20.358c.28.429.55.926.838 1.46 1.364 2.52 3.161 5.842 8.54 6.432 5.117-.02 8.214-3.744 8.232-6.505v-7.434a1.25 1.25 0 00-2.5 0v1.439a.75.75 0 01-1.5 0v-3a1.25 1.25 0 10-2.5 0v2a.75.75 0 01-1.5 0v-3a1.25 1.25 0 10-2.5 0v2a.75.75 0 01-1.5 0v-11a1.25 1.25 0 10-2.5 0v14.982a.75.75 0 01-1.396.399l-2.523-4.28a1.263 1.263 0 00-2.185 1.267l2.994 5.24z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.271 28l-1.292.762A1.5 1.5 0 0018.77 28h-1.5zm-1.126-1.912l1.292-.761-1.292.761zm-3.763-.99l-.75-1.299.75 1.3zm-1.017 3.765l-1.303.744 1.303-.744zm3 5.251l1.311-.73-.008-.014-1.302.744zm.023.039l1.267-.804-.001-.002-1.266.806zm.009.013l1.254-.823-.005-.007-1.249.83zm.695 1.23l-1.325.704 1.325-.705zm9.828 7.35l-.159 1.491.16-1.491zm.04.004l-.16 1.492c.054.005.107.008.16.008v-1.5zm9.811-7.988l-1.5-.012 1.5.012zm0-.012l1.5.012v-.012h-1.5zm0-7.439h1.5-1.5zm-2.083-2.667l.364-1.455-.364 1.455zm-2.041.285l-1.432.447a1.5 1.5 0 002.183.851l-.751-1.298zm-4.184-1.445l-1.331.691a1.5 1.5 0 002.182.544l-.851-1.235zM22.771 22.3h-1.5a1.5 1.5 0 002.183 1.335l-.683-1.335zm-7.11 11.058l-1.302.745.046.076 1.256-.82zm.838 1.46l-1.32.713 1.32-.713zm8.54 6.432l-.163 1.491c.056.006.113.01.17.009l-.006-1.5zm8.232-6.505l-1.5-.012v.002l1.5.01zm0-.002l1.5.012v-.012h-1.5zm0-7.432h1.5-1.5zm-.947-1.212l.364-1.455-.364 1.455zm-13.553 4.633h-1.5v.035l1.5-.035zm-.369.664l-.762-1.292.762 1.292zm-1.027-.265l-1.292.761 1.292-.761zm-2.523-4.28l1.293-.762-1.293.761zm-1.72-.454l.75 1.3-.75-1.3zm-.465 1.721l-1.302.745 1.302-.745zm6.104-12.368c0-.69.56-1.25 1.25-1.25v-3a4.25 4.25 0 00-4.25 4.25h3zm0 12.25V15.75h-3V28h3zm-3.919-1.15l1.127 1.912 2.585-1.524-1.127-1.911-2.585 1.523zm-1.72-.453a1.263 1.263 0 011.72.453l2.585-1.523a4.264 4.264 0 00-5.805-1.528l1.5 2.598zm-.465 1.721a1.263 1.263 0 01.465-1.72l-1.5-2.599a4.263 4.263 0 00-1.57 5.808l2.605-1.489zm3 5.252l-3-5.252-2.605 1.489 3.001 5.251 2.605-1.488zm-.013-.023a.704.704 0 01.022.037l-2.62 1.46c.02.038.043.076.067.114l2.53-1.61zm-.008-.011a.607.607 0 01.009.013l-2.533 1.607.026.04 2.498-1.66zm.77 1.355c-.244-.46-.504-.95-.765-1.348l-2.508 1.646c.169.257.358.61.624 1.11l2.649-1.408zm8.664 6.563c-2.797-.298-4.612-1.354-5.886-2.572-1.31-1.251-2.101-2.72-2.778-3.991L13.767 36.1c.668 1.255 1.654 3.127 3.354 4.751 1.735 1.659 4.162 3.015 7.64 3.386l.319-2.983zm.04.005l-.04-.005-.319 2.983.04.005.318-2.983zM25 41.25h-.04v3H25v-3zm8.271-6.5c-.022 2.764-3.13 6.5-8.271 6.5v3c6.487 0 11.234-4.779 11.271-9.476l-3-.023zm0-.012v.012l3 .024v-.012l-3-.024zm0-7.427v7.439h3v-7.439h-3zm-.947-1.212c.557.139.947.639.947 1.212h3a4.25 4.25 0 00-3.219-4.122l-.728 2.91zm-.926.128a1.23 1.23 0 01.926-.128l.728-2.91a4.23 4.23 0 00-3.157.442l1.503 2.596zM28.021 24.5c.558 0 1.035.367 1.194.876l2.863-.894a4.251 4.251 0 00-4.057-2.982v3zm-.707.219c.2-.138.442-.219.707-.219v-3c-.892 0-1.724.276-2.409.748l1.702 2.471zM24.021 23.5c.48 0 .9.27 1.111.675l2.662-1.383a4.25 4.25 0 00-3.773-2.292v3zm-.567.136c.169-.087.36-.136.567-.136v-3c-.693 0-1.351.167-1.933.464l1.366 2.672zm-2.183-7.886v6.55h3v-6.55h-3zm-1.25-1.25c.69 0 1.25.56 1.25 1.25h3a4.25 4.25 0 00-4.25-4.25v3zm-5.616 19.679c.24.366.478.805.775 1.352l2.638-1.427c-.281-.52-.58-1.076-.9-1.566l-2.513 1.64zm.775 1.352c.671 1.242 1.563 2.91 3.054 4.318 1.534 1.447 3.634 2.562 6.642 2.892l.327-2.982c-2.371-.26-3.86-1.101-4.91-2.092-1.093-1.032-1.782-2.284-2.475-3.563L15.18 35.53zm9.865 7.219c5.796-.022 9.702-4.276 9.726-7.995l-3-.02c-.012 1.803-2.3 4.998-6.737 5.015l.011 3zm9.726-7.993v-.002l-3-.024v.002l3 .024zm0-.014v-7.432h-3v7.432h3zm0-7.432a2.75 2.75 0 00-2.083-2.667l-.727 2.91a.25.25 0 01-.19-.242h3zm-2.083-2.667a2.75 2.75 0 00-3.417 2.668h3a.25.25 0 01-.31.242l.727-2.91zm-3.417 2.668v.438h3v-.439h-3zm0 .438v1h3v-1h-3zm0 1a.75.75 0 01.75-.75v3a2.25 2.25 0 002.25-2.25h-3zm.75-.75a.75.75 0 01.75.75h-3a2.25 2.25 0 002.25 2.25v-3zm.75.75v-1h-3v1h3zm0-1v-.439h-3v.439h3zm0-.439V25.75h-3v1.561h3zm0-1.561a2.75 2.75 0 00-2.75-2.75v3a.25.25 0 01-.25-.25h3zM28.021 23a2.75 2.75 0 00-2.75 2.75h3a.25.25 0 01-.25.25v-3zm-2.75 2.75v1h3v-1h-3zm0 1v1h3v-1h-3zm0 1a.75.75 0 01.75-.75v3a2.25 2.25 0 002.25-2.25h-3zm.75-.75a.75.75 0 01.75.75h-3a2.25 2.25 0 002.25 2.25v-3zm.75.75v-1h-3v1h3zm0-1v-1h-3v1h3zm0-1v-1h-3v1h3zm0-1a2.75 2.75 0 00-2.75-2.75v3a.25.25 0 01-.25-.25h3zM24.021 22a2.75 2.75 0 00-2.75 2.75h3a.25.25 0 01-.25.25v-3zm-2.75 2.75v.667h3v-.667h-3zm0 .667v1.333h3v-1.333h-3zm0 1.333a.75.75 0 01.75-.75v3a2.25 2.25 0 002.25-2.25h-3zm.75-.75a.75.75 0 01.75.75h-3a2.25 2.25 0 002.25 2.25v-3zm.75.75v-1.333h-3v1.333h3zm0-1.333v-.667h-3v.667h3zm0-.667v-9h-3v9h3zm0-9a2.75 2.75 0 00-2.75-2.75v3a.25.25 0 01-.25-.25h3zM20.021 13a2.75 2.75 0 00-2.75 2.75h3a.25.25 0 01-.25.25v-3zm-2.75 2.75v14.982h3V15.75h-3zm0 15.017a.75.75 0 01.37-.663l1.523 2.584a2.25 2.25 0 001.107-1.99l-3 .069zm.37-.663a.75.75 0 011.027.265l-2.585 1.523a2.25 2.25 0 003.08.796l-1.523-2.584zm1.027.265l-2.523-4.28-2.585 1.523 2.523 4.28 2.585-1.523zm-2.523-4.28a2.764 2.764 0 00-3.763-.99l1.5 2.597a.237.237 0 01-.322-.084l2.585-1.523zm-3.763-.99a2.764 2.764 0 00-1.017 3.764l2.604-1.489a.237.237 0 01-.087.322l-1.5-2.598zm-1.017 3.764l2.994 5.24 2.605-1.489-2.995-5.24-2.604 1.489z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_finger_S48_svg__a)"
  }));
}

function SvgIcFoodwastDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.407 18.629a.298.298 0 01-.163-.178.179.179 0 01.024-.166c.98-1.385 2.879-3.693 5.062-4.595 1.49-.615 2.904-.44 4.2-.069.483.138.926.295 1.357.449l.478.168c.542.187 1.138.375 1.675.375.539 0 .992-.15 1.392-.33.196-.09.39-.19.57-.285l.047-.024c.17-.09.332-.175.507-.259.719-.345 1.633-.664 3.185-.53 1.557.135 2.857.445 4.126 1.209 1.233.742 2.49 1.945 3.922 3.95-2.132.491-3.923 1.144-5.184 2.356-1.355 1.302-1.988 3.136-1.988 5.72 0 2.115.994 3.686 2.216 4.802 1.21 1.103 2.667 1.787 3.704 2.176a.36.36 0 01.215.214c.025.073.012.124-.026.17-1.658 1.974-5.66 5.809-11.668 5.809-7.33 0-11.085-3.024-12.857-5.806a10.745 10.745 0 00-.042-.066s0 0 0 0c.086-.021.194-.048.294-.078l-.212-.719.212.72c2.738-.809 5.979-3.77 5.979-7.736 0-1.947-1.35-3.546-2.774-4.709-1.454-1.187-3.167-2.07-4.251-2.568zm.467 15.174l-.004.002.004-.002z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.272 18.663s1.925-.886 3.737-.426 4.388 2.606 4.388 2.606 1.297-2.606 3.9-2.606c2.605 0 4.316 2.606 4.316 2.606s2.802-4.762 8.18-2.18",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.304 33.748s2.635 2.35 4.515 1.567c1.88-.784 3.328-2.03 3.582-2.673.254-.644 1.514 3.012 4.293 2.673 2.779-.34 4.093-2.673 4.093-2.673s2.459 3.375 4.875 2.673c2.416-.703 3.164-1.567 3.164-1.567",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.913 24.74v3.651M22.217 24.74v3.651M17 7.001s5.738-.093 6.794 6.733",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcFoodwastS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 37s1.048 2.341 3.297 2.02c4.568-.513 9.073-7.077 9.073-7.077s3.99-5.275 3.604-11.005c-.387-5.73-5.47-9.01-9.65-8.82-3.768.178-5.763 4.106-6.124 4.48a.347.347 0 00-.083.143l-.117.37-.12-.37a.336.336 0 00-.083-.14c-.354-.37-2.346-4.305-6.117-4.479-4.184-.193-9.266 3.087-9.654 8.813C7.64 26.66 11.63 31.94 11.63 31.94s4.505 6.564 9.073 7.077c2.253.32 3.264-2.02 3.264-2.02H24V37z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.444,
    cy: 25.615,
    rx: 1.778,
    ry: 3.556,
    transform: "rotate(-10 20.444 25.615)",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.146,
    cy: 25.615,
    rx: 1.778,
    ry: 3.556,
    transform: "rotate(10 28.146 25.615)",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 15.667v-3.334C24 10.556 25.422 7 27.556 7",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcFriendrecomcodeS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.88 15.956a.75.75 0 10-1.442-.412l-4.602 16.108a.75.75 0 101.442.413l4.603-16.109zm-9.738-.775a.75.75 0 00-1.058.081l-6.903 8.054a.75.75 0 000 .977l6.903 8.054a.75.75 0 001.139-.977l-6.485-7.566 6.485-7.566a.75.75 0 00-.081-1.057zm13.433 0a.75.75 0 011.058.081l6.903 8.054a.75.75 0 010 .977l-6.904 8.054a.75.75 0 01-1.138-.977l6.485-7.566-6.485-7.566a.75.75 0 01.08-1.057z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcGloveS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.682 11.075V7.198c0-.569.565-.94 1.212-.94.606 0 1.106.422 1.106.94V21.5H9.515v-5.068l-2.07-4.58a.916.916 0 01.414-1.254.96.96 0 011.268.44",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.344 4.7c.006-.571.568-.944 1.212-.944.606 0 1.106.428 1.106.952v14.465H7.177v-5.126l-2.07-4.632a.931.931 0 01.414-1.268.956.956 0 011.268.444l1.022 1.598v-.964l.013-4.872c0-.617.465-.952 1.142-.952.619 0 .993.386 1.031.868v-.817c0-.52.503-.952 1.121-.952.642 0 1.053.431 1.053.952 0-.52.517-.952 1.135-.952.574 0 1.045.438 1.045.959l-.007 1.24z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.344 4.708c0-.576.565-.952 1.212-.952.606 0 1.106.428 1.106.952v14.465H7.177v-5.126l-2.07-4.632a.931.931 0 01.414-1.268.956.956 0 011.268.444l1.022 1.598v-.964l.013-4.872c0-.617.465-.952 1.142-.952.654 0 1.035.431 1.035.952m4.343.355v3.92m0-3.92l.007-1.25c0-.52-.472-.958-1.045-.958-.618 0-1.135.431-1.135.952m0 0v5.177m0-5.177c0-.52-.41-.952-1.053-.952-.618 0-1.12.431-1.12.952v5.177",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcHomeS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 8.209a2 2 0 00-.602-1.43L8.7 1.695a1 1 0 00-1.398 0L2.1 6.78a2 2 0 00-.601 1.43v5.38a1 1 0 001 1H13.806c.383 0 .694-.31.694-.694V8.21zm-4.333 3.492v2.888H5.833v-2.888a2.167 2.167 0 114.334 0z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcHomeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.672v8.805c0 .384-.31.695-.694.695H4.694A.694.694 0 014 19.477v-8.805l6.586-6.586a2 2 0 012.828 0L20 10.672zm-5 9.5v-2.5a3 3 0 00-6 0v2.5h6z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcHouseDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.796 18.963l10.832-9.79 11.198 10.195v3.371h-22.26l.23-3.776z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.696 19.956v15.97c0 1.265-1.075 2.291-2.4 2.291h-19.2c-1.326 0-2.4-1.026-2.4-2.292V19.957",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.696 19.956v15.97c0 1.265-1.075 2.291-2.4 2.291h-19.2c-1.326 0-2.4-1.026-2.4-2.292V19.957",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.272 30.797c0-.818.664-1.482 1.482-1.482h3.883c.819 0 1.483.664 1.483 1.482v7.453h-6.848v-7.453z",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 24.652L22.932 9.716a1.116 1.116 0 011.527 0l15.932 14.936",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

function SvgIcKitchenDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 25.991,
    y: 10.79,
    width: 12.792,
    height: 26.759,
    rx: 1.25,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 25.732,
    width: 12.508,
    height: 11.818,
    rx: 1.25,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.717 28.88h13.778",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.868 23.446h4.109M17.031 23.445h4.11",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.589v-.935l4.024-3.316a1.75 1.75 0 00.637-1.35V11a.25.25 0 01.25-.25h2.686a.25.25 0 01.25.25v1.987c0 .523.234 1.018.637 1.35l4.024 3.318v.934H9.75z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.742 23.483v2.899M28.742 31.016v2.898",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcKitchenS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 25.991,
    y: 10.79,
    width: 12.792,
    height: 26.759,
    rx: 1.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.75,
    y: 25.732,
    width: 12.508,
    height: 11.818,
    rx: 1.25,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.717 28.88h13.778",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.868 23.446h4.109M17.031 23.445h4.11",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.589v-.935l4.024-3.316a1.75 1.75 0 00.637-1.35V11a.25.25 0 01.25-.25h2.686a.25.25 0 01.25.25v1.987c0 .523.234 1.018.637 1.35l4.024 3.318v.934H9.75z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.742 23.483v2.899M28.742 31.016v2.898",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcLivingroomDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 11.482,
    y: 14.75,
    width: 25.106,
    height: 10.378,
    rx: 2.25,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.945 21.206a.91.91 0 100-1.821.91.91 0 000 1.821zM18.928 21.206a.91.91 0 100-1.821.91.91 0 000 1.821z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.956 14.99v10.057",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21.227c0-.69.56-1.25 1.25-1.25h3.185a1.25 1.25 0 011.18.836l.948 2.707a2.75 2.75 0 002.595 1.841h12.256a2.75 2.75 0 002.596-1.84l.948-2.708a1.25 1.25 0 011.18-.836h3.184c.69 0 1.25.56 1.25 1.25V32.43c0 .69-.56 1.25-1.25 1.25h-.377a1.25 1.25 0 01-.952-.44l-.689-.81a2.75 2.75 0 00-2.094-.967H14.284a2.75 2.75 0 00-2.318 1.27l-.235.37a1.25 1.25 0 01-1.054.577H10c-.69 0-1.25-.56-1.25-1.25V21.227z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }));
}

function SvgIcLivingroomS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_livingroom_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.732 14a3 3 0 00-3 3v2.227H10a2 2 0 00-2 2V32.43a2 2 0 002 2h.677a2 2 0 001.686-.924l.236-.369a2 2 0 011.685-.924H33.96a2 2 0 011.523.704l.689.81a2 2 0 001.523.703h.377a2 2 0 002-2V21.227a2 2 0 00-2-2h-.734V17a3 3 0 00-3-3H13.732z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.732 19.227v1.5h1.5v-1.5h-1.5zm1.631 14.28l1.264.806-1.264-.807zm.236-.37l-1.265-.807 1.264.807zm22.884-.22l1.143-.972-1.143.972zm.689.81l-1.142.971 1.142-.972zm1.166-14.5h-1.5v1.5h1.5v-1.5zM12.232 17a1.5 1.5 0 011.5-1.5v-3a4.5 4.5 0 00-4.5 4.5h3zm0 2.227V17h-3v2.227h3zM10 20.727h.732v-3H10v3zm-.5.5a.5.5 0 01.5-.5v-3a3.5 3.5 0 00-3.5 3.5h3zm0 11.203V21.227h-3V32.43h3zm.5.5a.5.5 0 01-.5-.5h-3a3.5 3.5 0 003.5 3.5v-3zm.677 0H10v3h.677v-3zm.421-.23a.5.5 0 01-.421.23v3a3.5 3.5 0 002.95-1.617L11.098 32.7zm.236-.37l-.236.37 2.53 1.613.235-.369-2.529-1.614zm2.95-1.617a3.5 3.5 0 00-2.95 1.617l2.529 1.614a.5.5 0 01.421-.231v-3zm19.676 0H14.284v3H33.96v-3zm2.666 1.232a3.5 3.5 0 00-2.666-1.232v3a.5.5 0 01.38.176l2.286-1.944zm.688.81l-.688-.81-2.285 1.944.689.81 2.284-1.945zm.381.175a.5.5 0 01-.38-.176l-2.285 1.944a3.5 3.5 0 002.665 1.232v-3zm.377 0h-.377v3h.377v-3zm.5-.5a.5.5 0 01-.5.5v3a3.5 3.5 0 003.5-3.5h-3zm0-11.203V32.43h3V21.227h-3zm-.5-.5a.5.5 0 01.5.5h3a3.5 3.5 0 00-3.5-3.5v3zm-.734 0h.734v-3h-.734v3zM35.838 17v2.227h3V17h-3zm-1.5-1.5a1.5 1.5 0 011.5 1.5h3a4.5 4.5 0 00-4.5-4.5v3zm-20.606 0h20.606v-3H13.732v3z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_livingroom_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.945 21.206a.91.91 0 100-1.821.91.91 0 000 1.821zM18.928 21.206a.91.91 0 100-1.821.91.91 0 000 1.821z",
    fill: "#000",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.956 14.99v10.057",
    stroke: "#262626",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 21.227c0-.69.56-1.25 1.25-1.25h3.185a1.25 1.25 0 011.18.836l.948 2.707a2.75 2.75 0 002.595 1.841h12.256a2.75 2.75 0 002.596-1.84l.948-2.708a1.25 1.25 0 011.18-.836h3.184c.69 0 1.25.56 1.25 1.25V32.43c0 .69-.56 1.25-1.25 1.25h-.377a1.25 1.25 0 01-.952-.44l-.689-.81a2.75 2.75 0 00-2.094-.967H14.284a2.75 2.75 0 00-2.318 1.27l-.235.37a1.25 1.25 0 01-1.054.577H10c-.69 0-1.25-.56-1.25-1.25V21.227z",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcMembershipFirstGradeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFBE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.19 17.27c.601 0 .948-.382.948-1.033V8.5c0-.652-.354-1.034-.956-1.034-.609 0-.955.382-.955 1.034v7.738c0 .651.354 1.034.963 1.034z",
    fill: "#FFF292"
  }));
}

function SvgIcMembershipForthGradeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#7B79E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22 17.368c.582 0 .917-.369.917-.998V8.9c0-.63-.342-.998-.923-.998-.588 0-.923.369-.923.998v7.471c0 .63.342.998.93.998zm5.689-2.14h-.089l-2.044-6.432c-.191-.629-.492-.916-.97-.916-.534 0-.923.342-.923.834 0 .192.054.458.15.738l2.304 6.631c.3.896.745 1.285 1.517 1.285.759 0 1.19-.382 1.49-1.285l2.311-6.63a2.83 2.83 0 00.144-.746c0-.492-.383-.827-.91-.827-.492 0-.772.267-.963.916l-2.017 6.433z",
    fill: "#D9CCFF"
  }));
}

function SvgIcMembershipSecondGradeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#00BED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.19 17.07c.601 0 .948-.381.948-1.033V8.3c0-.652-.354-1.034-.956-1.034-.608 0-.955.382-.955 1.034v7.738c0 .652.354 1.034.963 1.034zm3.964 0c.602 0 .95-.381.95-1.033V8.3c0-.652-.355-1.034-.957-1.034-.609 0-.956.382-.956 1.034v7.738c0 .652.354 1.034.963 1.034z",
    fill: "#B8F3FC"
  }));
}

function SvgIcMembershipThirdGradeS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F07272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99 17.47c.601 0 .948-.382.948-1.033V8.698c0-.65-.354-1.033-.956-1.033-.608 0-.955.382-.955 1.033v7.739c0 .651.354 1.034.963 1.034zm3.094 0c.602 0 .95-.382.95-1.033V8.698c0-.65-.355-1.033-.957-1.033-.609 0-.956.382-.956 1.033v7.739c0 .651.354 1.034.963 1.034zm3.095 0c.602 0 .949-.382.949-1.033V8.698c0-.65-.354-1.033-.956-1.033-.609 0-.956.382-.956 1.033v7.739c0 .651.354 1.034.963 1.034z",
    fill: "#F6D0BE"
  }));
}

function SvgIcMemoS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.5c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v11.496c0 .303-.11.597-.311.825l-1.706 1.94-1.674 1.634a1.25 1.25 0 01-.873.355H5c-.69 0-1.25-.56-1.25-1.25v-15z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.121 8h7.758M8.121 12h7.758M8.06 16h3.88",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 21v-5h5",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcMorningS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.25a.75.75 0 01.75.75v2.5a.75.75 0 01-1.5 0V3a.75.75 0 01.75-.75zm5.875 1.574a.75.75 0 01.274 1.025L16.9 7.014a.75.75 0 11-1.299-.75l1.25-2.165a.75.75 0 011.025-.275zM2.849 7.851a.75.75 0 00-.75 1.299l2.165 1.25a.75.75 0 00.75-1.3L2.849 7.85zm19.327.274a.75.75 0 01-.275 1.024l-2.165 1.25a.75.75 0 01-.75-1.299l2.165-1.25a.75.75 0 011.025.275zM7.149 4.099a.75.75 0 00-1.299.75L7.1 7.014a.75.75 0 001.3-.75L7.15 4.099zM5.812 13.5a6.187 6.187 0 1112.375 0h3.563a.75.75 0 010 1.5H2.25a.75.75 0 010-1.5h3.563zm1.375 0h9.625a4.812 4.812 0 10-9.625 0zM4.5 17.75a.75.75 0 01.75-.75h13.5a.75.75 0 010 1.5H5.25a.75.75 0 01-.75-.75zm4.75 2.75a.75.75 0 000 1.5h5.5a.75.75 0 000-1.5h-5.5z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcNightDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M34.45 32.755c-2.494 2.764-6.086 4.495-10.078 4.495-7.549 0-13.622-5.725-13.622-13.287 0-5.71 3.085-10.56 7.859-12.644-.653 1.43-1.414 3.657-1.64 6.16-.292 3.236.309 7.015 3.298 10.072 4.867 4.976 11.138 5.446 14.182 5.204z",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.684 16.5l-2.31 1.236.442-2.618-1.87-1.854 2.583-.382 1.155-2.382 1.155 2.382 2.583.382-1.869 1.854.441 2.618-2.31-1.236z",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3 22.51l-.26-.537-.675-1.392-.675 1.392-.26.536-.577.085-1.482.22 1.064 1.055.425.421-.101.599-.254 1.507 1.347-.721.513-.275.512.275 1.347.72-.253-1.506-.101-.599.425-.421 1.063-1.055-1.482-.22-.576-.085z",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }));
}

function SvgIcNightS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M34.45 32.755c-2.494 2.764-6.086 4.495-10.078 4.495-7.549 0-13.622-5.725-13.622-13.287 0-5.71 3.085-10.56 7.859-12.644-.653 1.43-1.414 3.657-1.64 6.16-.292 3.236.309 7.015 3.298 10.072 4.867 4.976 11.138 5.446 14.182 5.204z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M27.684 16.5l-2.31 1.236.442-2.618-1.87-1.854 2.583-.382 1.155-2.382 1.155 2.382 2.583.382-1.869 1.854.441 2.618-2.31-1.236z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3 22.51l-.26-.537-.675-1.392-.675 1.392-.26.536-.577.085-1.482.22 1.064 1.055.425.421-.101.599-.254 1.507 1.347-.721.513-.275.512.275 1.347.72-.253-1.506-.101-.599.425-.421 1.063-1.055-1.482-.22-.576-.085z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }));
}

function SvgIcOfficetelDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12c0-.69.56-1.25 1.25-1.25h19.652c.69 0 1.25.56 1.25 1.25v25.424H12.75V12z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14.87,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.261,
    y: 14.87,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.174,
    y: 14.87,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22.174,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.261,
    y: 22.174,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.174,
    y: 22.174,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 29.478,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.261,
    y: 29.478,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.174,
    y: 29.478,
    width: 1.5,
    height: 4.174,
    rx: 0.5,
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 36.674,
    width: 32,
    height: 1.5,
    rx: 0.667,
    fill: "#D8D8D8"
  }));
}

function SvgIcOrderS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.498 9H3.805V2.473L1.783 3.1V1.723L5.316.457h.182V9zM7.732 23H1.885v-1.16l2.76-2.942c.378-.414.658-.775.837-1.084.184-.308.276-.601.276-.878 0-.38-.096-.676-.287-.891-.192-.219-.465-.328-.82-.328-.383 0-.686.133-.909.398-.219.262-.328.608-.328 1.037h-1.7c0-.52.124-.994.37-1.424.25-.43.602-.765 1.055-1.007.453-.246.966-.37 1.54-.37.88 0 1.561.211 2.046.633.488.422.732 1.018.732 1.787 0 .422-.11.852-.328 1.29-.219.437-.594.947-1.125 1.529l-1.94 2.045h3.668V23z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.261 3.177a.75.75 0 00-.75.75v13.346l-3.326-3.326a.75.75 0 00-1.06 1.06l4.596 4.597c.149.149.345.222.54.22a.747.747 0 00.54-.22l4.597-4.597a.75.75 0 10-1.06-1.06l-3.327 3.326V3.927a.75.75 0 00-.75-.75z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcParkingDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 24c0 8.56-6.94 15.5-15.5 15.5-8.56 0-15.5-6.94-15.5-15.5 0-8.56 6.94-15.5 15.5-15.5 8.56 0 15.5 6.94 15.5 15.5zM24 41c9.389 0 17-7.611 17-17S33.389 7 24 7 7 14.611 7 24s7.611 17 17 17zm.078-17.039a.5.5 0 01-.5-.5v-2.51a.5.5 0 01.5-.5h.687c1.315 0 1.972.584 1.972 1.755 0 1.17-.657 1.755-1.972 1.755h-.687zm-2 7.619a1.5 1.5 0 001.5-1.5v-3.168h2.118c1.546 0 2.73-.411 3.552-1.233.821-.821 1.232-1.98 1.232-3.473 0-1.494-.41-2.652-1.232-3.473-.822-.822-2.006-1.233-3.552-1.233H21.5A1.5 1.5 0 0020 19v11.08a1.5 1.5 0 001.5 1.5h.578z",
    fill: "#D8D8D8"
  }));
}

function SvgIcParkingS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.25 24c0 8.422-6.828 15.25-15.25 15.25S8.75 32.422 8.75 24 15.578 8.75 24 8.75 39.25 15.578 39.25 24z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.078 23.461a.5.5 0 00.5.5h.687c1.315 0 1.972-.585 1.972-1.755s-.657-1.756-1.972-1.756h-.687a.5.5 0 00-.5.5v2.511zm0 6.619a1.5 1.5 0 01-1.5 1.5H21a1.5 1.5 0 01-1.5-1.5V19a1.5 1.5 0 011.5-1.5h4.196c1.546 0 2.73.41 3.552 1.233.821.821 1.232 1.979 1.232 3.473 0 1.494-.41 2.652-1.232 3.473-.822.822-2.006 1.233-3.552 1.233h-2.118v3.168z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcParkingIdontS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24.005 39.38c8.491 0 15.375-6.884 15.375-15.375S32.496 8.63 24.005 8.63 8.63 15.513 8.63 24.005c0 8.491 6.884 15.375 15.375 15.375z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.54 26.37c0 .702.429 1.24 1.288 1.24.81 0 1.065-.45 1.397-1.036.302-.693.683-1.035 1.484-1.62 1.182-.821 2.188-1.632 2.188-3.311 0-2.305-1.905-3.643-4.62-3.643-1.523 0-2.675.4-3.398 1.025-.537.47-.879 1.084-.879 1.69 0 .596.38 1.113 1.123 1.113.45 0 .713-.185 1.045-.527.459-.596 1.045-.88 1.807-.88.927 0 1.757.518 1.757 1.407 0 .81-.605 1.25-1.464 1.904-1.211.918-1.729 1.592-1.729 2.637zm-.44 3.857c0 .937.771 1.543 1.709 1.543.937 0 1.699-.606 1.699-1.543 0-.938-.762-1.543-1.7-1.543-.937 0-1.708.605-1.708 1.543z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }));
}

function SvgIcParkingNoneS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M24 39.38c8.491 0 15.375-6.884 15.375-15.375S32.491 8.63 24 8.63 8.625 15.513 8.625 24.005c0 8.491 6.884 15.375 15.375 15.375z",
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "1 2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.383 19.117l-.53.53.53-.53zm0 6.297l-.53-.53.53.53zm-5.14 1.117v-.75h-.75v.75h.75zm.994-3.424a.75.75 0 000 1.5v-1.5zm-.41 1.5a.75.75 0 000-1.5v1.5zm-.028-1.494a.75.75 0 10-.333 1.463l.333-1.463zm-1.274.521a.75.75 0 001.463-.332l-1.463.332zm1.469-.589a.75.75 0 10-1.5 0h1.5zm-1.5-1.559a.75.75 0 001.5 0h-1.5zm1.494-.257a.75.75 0 00-1.463-.332l1.463.332zm-.522-1.273a.75.75 0 00.333 1.462l-.333-1.462zm.36 1.468a.75.75 0 000-1.5v1.5zm.411-1.5a.75.75 0 100 1.5v-1.5zm.387 1.517a.75.75 0 00.174-1.49l-.174 1.49zm2.192.309a.75.75 0 10-1.48.25l1.48-.25zm-1.48.78a.75.75 0 001.48.252l-1.48-.251zm-.538 2.05a.75.75 0 10-.174-1.49l.174 1.49zm-.158-7.33a.75.75 0 000 1.5v-1.5zm-2.617 1.5a.75.75 0 000-1.5v1.5zM21 17.306a.75.75 0 00.332 1.463L21 17.306zm-.231 2.026A.75.75 0 1019.306 19l1.463.332zm-1.519.633a.75.75 0 001.5 0h-1.5zm1.5 2.325a.75.75 0 00-1.5 0h1.5zm-1.5.93a.75.75 0 001.5 0h-1.5zm1.5 2.324a.75.75 0 00-1.5 0h1.5zm-1.5.93a.75.75 0 001.5 0h-1.5zm1.5 2.324a.75.75 0 00-1.5 0h1.5zm-1.444.966a.75.75 0 101.463-.333l-1.463.333zm2.026.23A.75.75 0 0021 31.458l.332-1.462zm.203 1.52a.75.75 0 100-1.5v1.5zm.174-1.5a.75.75 0 100 1.5v-1.5zm.535 1.443a.75.75 0 00-.332-1.462l.332 1.462zm.231-2.026a.75.75 0 101.463.333l-1.463-.333zm1.519-.558a.75.75 0 00-1.5 0h1.5zm-1.5-1.951a.75.75 0 101.5 0h-1.5zm1.024.36a.75.75 0 000-1.5v1.5zm1.372-1.5a.75.75 0 000 1.5v-1.5zm.825 1.481a.75.75 0 00-.103-1.497l.103 1.497zm1.844-2.126a.75.75 0 10.89 1.206l-.89-1.206zm1.745.357a.75.75 0 10-1.2-.9l1.2.9zm-.57-2.792a.75.75 0 101.497.108l-1.496-.108zm1.497-.98a.75.75 0 00-1.496.108l1.496-.108zm-2.128-1.785a.75.75 0 101.201-.9l-1.2.9zm.347-1.749a.75.75 0 10-.891 1.207l.89-1.207zm-2.838.577a.75.75 0 10.103-1.497l-.103 1.497zm-1.292 4.342h-.083v1.5h.083v-1.5zm-.494 0h-.082v1.5h.082v-1.5zm-.082 0c.018 0 .037.002.055.006l-.333 1.463c.09.02.183.03.278.03v-1.5zm.244.195a.247.247 0 01.006.055h-1.5c0 .094.01.187.031.277l1.463-.332zm.006.055v-.312h-1.5v.312h1.5zm0-1.87v-.313h-1.5v.312h1.5zm0-.313a.247.247 0 01-.006.055l-1.463-.332c-.02.09-.031.183-.031.277h1.5zm-.195.244a.248.248 0 01-.055.006v-1.5c-.095 0-.188.011-.278.032l.333 1.462zm-.055.006h.082v-1.5h-.082v1.5zm.493 0h.083v-1.5h-.083v1.5zm.083 0c.113 0 .214.006.304.017l.174-1.49a4.1 4.1 0 00-.478-.027v1.5zm1.017.577c.013.074.02.162.02.265h1.5c0-.176-.013-.349-.041-.516l-1.48.25zm.02.265c0 .102-.007.19-.02.265l1.479.25c.028-.167.041-.34.041-.515h-1.5zm-.733.824c-.09.011-.191.017-.304.017v1.5c.164 0 .324-.009.478-.027l-.174-1.49zm.54-5.84h-.524v1.5h.524v-1.5zm-3.14 0H21.5v1.5h.523v-1.5zm-.524 0c-.171 0-.339.02-.5.056l.332 1.463a.755.755 0 01.168-.019v-1.5zM19.306 19c-.037.161-.056.329-.056.5h1.5c0-.058.006-.114.019-.168L19.306 19zm-.056.5v.465h1.5V19.5h-1.5zm0 2.79v.93h1.5v-.93h-1.5zm0 3.254v.93h1.5v-.93h-1.5zm0 3.254v.465h1.5v-.465h-1.5zm0 .465c0 .171.02.339.056.5l1.463-.332a.754.754 0 01-.019-.168h-1.5zM21 31.457c.161.037.329.056.5.056v-1.5a.755.755 0 01-.168-.018L21 31.457zm.5.056h.035v-1.5H21.5v1.5zm.21 0h.034v-1.5h-.035v1.5zm.034 0c.171 0 .338-.019.5-.056l-.332-1.462a.755.755 0 01-.168.018v1.5zm2.194-1.75c.037-.161.056-.329.056-.5h-1.5a.754.754 0 01-.019.168l1.463.333zm.056-.5v-.39h-1.5v.39h1.5zm0-2.341v-.39h-1.5v.39h1.5zm-.75.36h.274v-1.5h-.274v1.5zm1.646 0h.274v-1.5h-.274v1.5zm.274 0c.187 0 .371-.007.551-.019l-.103-1.497c-.144.01-.293.016-.448.016v1.5zm3.286-.939c.164-.121.319-.254.463-.398l-1.06-1.061c-.092.091-.19.176-.294.253l.89 1.206zm.463-.398c.141-.142.272-.292.391-.451l-1.2-.9c-.077.103-.16.2-.252.29l1.061 1.06zm1.318-3.135c.013-.178.019-.36.019-.544h-1.5c0 .15-.005.296-.015.436l1.496.108zm.019-.544c0-.185-.006-.367-.02-.544l-1.495.108c.01.14.015.285.015.436h1.5zm-.946-3.228c-.12-.16-.25-.31-.39-.451l-1.062 1.06c.091.091.175.188.251.29l1.201-.9zm-.39-.451a4.093 4.093 0 00-.464-.399l-.891 1.207c.104.077.202.161.293.253l1.061-1.061zm-3.199-1.319a8.013 8.013 0 00-.551-.018v1.5c.155 0 .304.005.448.015l.103-1.497z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPetsNoneS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 10.956c0-1.228 1.503-1.821 2.342-.925l5.076 5.428a.963.963 0 00.704.305h9.756c.267 0 .522-.11.704-.305l5.076-5.428c.839-.896 2.342-.303 2.342.925v14.071c0 7.18-5.82 13-13 13s-13-5.82-13-13V10.956z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.313 9.4a.75.75 0 011.013-.313c.206.108.396.252.564.432l.362.388a.75.75 0 01-1.095 1.024l-.363-.387a.633.633 0 00-.167-.13.75.75 0 01-.314-1.013zm23.374 0a.75.75 0 01-.314 1.014.633.633 0 00-.167.13l-.363.387a.75.75 0 11-1.096-1.024l.363-.388c.168-.18.358-.324.564-.432a.75.75 0 011.013.314zm-24.366.393a.75.75 0 01.463.954.633.633 0 00-.034.209v.503a.75.75 0 11-1.5 0v-.503c0-.246.04-.481.116-.7a.75.75 0 01.955-.463zm25.358 0a.75.75 0 01.955.462c.076.22.116.455.116.701v.503a.75.75 0 11-1.5 0v-.503a.633.633 0 00-.033-.209.75.75 0 01.462-.954zM15.005 11.81a.75.75 0 011.06.035l.726.775a.75.75 0 11-1.096 1.025l-.725-.775a.75.75 0 01.035-1.06zm17.99 0a.75.75 0 01.035 1.06l-.725.775a.75.75 0 01-1.096-1.025l.726-.775a.75.75 0 011.06-.035zM11 13.22a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zm26 0a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zm-19.457 1.302a.75.75 0 011.06.036l.363.387a.771.771 0 01.066.061.794.794 0 01.09.007h.464a.75.75 0 010 1.5h-.464c-.068 0-.134-.004-.2-.012a.747.747 0 01-.445-.216.747.747 0 01-.461-.177c-.051-.043-.1-.089-.145-.138l-.363-.388a.75.75 0 01.035-1.06zm12.914 0a.75.75 0 01.035 1.06l-.363.388a1.716 1.716 0 01-.145.138.747.747 0 01-.461.177.747.747 0 01-.445.216 1.724 1.724 0 01-.2.012h-.464a.75.75 0 010-1.5h.464c.009 0 .017 0 .025-.002a.794.794 0 01.065-.004.771.771 0 01.066-.062l.363-.387a.75.75 0 011.06-.036zm-9.298 1.24a.75.75 0 01.75-.75h.93a.75.75 0 010 1.5h-.93a.75.75 0 01-.75-.75zm3.253 0a.75.75 0 01.75-.75h.929a.75.75 0 010 1.5h-.93a.75.75 0 01-.75-.75zM11 16.74a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0V17.49a.75.75 0 01.75-.75zm26 0a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0V17.49a.75.75 0 01.75-.75zm-26 3.518a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zm26 0a.75.75 0 01.75.75v1.005a.75.75 0 01-1.5 0v-1.005a.75.75 0 01.75-.75zm0 3.518a.75.75 0 01.75.75v.502c0 .172-.003.344-.01.515a.75.75 0 11-1.498-.055c.005-.153.008-.306.008-.46v-.502a.75.75 0 01.75-.75zm-26 0a.75.75 0 01.75.75v.502c0 .154.003.307.008.46a.75.75 0 11-1.498.055c-.007-.171-.01-.343-.01-.515v-.502a.75.75 0 01.75-.75zm25.843 3.415a.75.75 0 01.576.837.75.75 0 01-.026 1.5h-.624a.75.75 0 01-1.073-.839.744.744 0 01.07-.24c.066-.228.126-.46.18-.693a.75.75 0 01.897-.565zm-25.686 0a.75.75 0 01.898.565c.053.234.113.465.179.694.036.073.06.154.07.24a.75.75 0 01-1.073.838h-.624a.75.75 0 01-.026-1.5.75.75 0 01.576-.837zm24.69 3.25a.75.75 0 01.312 1.014c-.103.194-.21.385-.322.573h.556a.75.75 0 010 1.5h-.953a.75.75 0 01-.735-.897.75.75 0 01-.33-1.085c.162-.258.315-.523.458-.793a.75.75 0 011.014-.312zm-23.694 0a.75.75 0 011.014.312c.143.27.296.535.459.793a.75.75 0 01-.33 1.085.748.748 0 01-.736.897h-.953a.75.75 0 010-1.5h.556c-.112-.188-.219-.38-.322-.573a.75.75 0 01.312-1.014zm21.887 2.88a.75.75 0 01.04 1.06c-.234.251-.476.493-.727.727a.75.75 0 01-1.021-1.1c.167-.155.33-.315.49-.48h-.715a.75.75 0 010-1.5h.953a.75.75 0 01.655 1.115c.117.03.23.09.325.178zm-18.861.207h.714a.75.75 0 000-1.5h-.953a.75.75 0 00-.655 1.115.75.75 0 00-.365 1.237c.234.252.476.495.727.728a.75.75 0 001.021-1.1 12.31 12.31 0 01-.49-.48zm1.27 2.11a.75.75 0 011.033-.236c.258.163.523.316.793.46a.75.75 0 01-.702 1.325c-.303-.161-.6-.333-.89-.515a.75.75 0 01-.235-1.034zm15.103 0a.75.75 0 01-.235 1.034c-.29.182-.587.354-.89.515a.75.75 0 01-.702-1.326c.27-.143.535-.296.793-.459a.75.75 0 011.034.236zm-3.002 1.595a.75.75 0 01-.496.938c-.326.1-.658.189-.994.265a.75.75 0 01-.332-1.462c.299-.068.594-.147.884-.237a.75.75 0 01.938.496zm-9.1 0a.75.75 0 01.938-.496c.29.09.585.169.884.237a.75.75 0 11-.332 1.462 13.659 13.659 0 01-.994-.265.75.75 0 01-.496-.938zm3.314.759a.75.75 0 01.777-.722 12.507 12.507 0 00.918 0 .75.75 0 01.056 1.499 13.957 13.957 0 01-1.03 0 .75.75 0 01-.721-.777zM7 28.777a.75.75 0 01.75-.75h.476a.75.75 0 010 1.5H7.75a.75.75 0 01-.75-.75zm6.19 0a.75.75 0 01.75-.75h.953a.75.75 0 010 1.5h-.953a.75.75 0 01-.75-.75zm3.334 0a.75.75 0 01.75-.75h.476a.75.75 0 010 1.5h-.476a.75.75 0 01-.75-.75zm-7.774 3.25a.75.75 0 000 1.5h.476a.75.75 0 000-1.5H8.75zm9.524 0a.75.75 0 000 1.5h.476a.75.75 0 000-1.5h-.476zM41 28.777a.75.75 0 00-.75-.75h-.476a.75.75 0 000 1.5h.476a.75.75 0 00.75-.75zm-6.19 0a.75.75 0 00-.75-.75h-.953a.75.75 0 000 1.5h.953a.75.75 0 00.75-.75zm-3.334 0a.75.75 0 00-.75-.75h-.476a.75.75 0 000 1.5h.476a.75.75 0 00.75-.75zm7.774 3.25a.75.75 0 010 1.5h-.476a.75.75 0 010-1.5h.476zm-9.524 0a.75.75 0 010 1.5h-.476a.75.75 0 010-1.5h.476z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPlusincircleS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zm0-6a1 1 0 001-1v-4h4a1 1 0 100-2h-4V7a1 1 0 10-2 0v4H7a1 1 0 100 2h4v4a1 1 0 001 1z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcPwdS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.75 15a6.25 6.25 0 1112.5 0v8h-12.5v-8z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 22a4 4 0 014-4h18a4 4 0 014 4v13a4 4 0 01-4 4H15a4 4 0 01-4-4V22z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 22A3.25 3.25 0 0115 18.75h18A3.25 3.25 0 0136.25 22v13A3.25 3.25 0 0133 38.25H15A3.25 3.25 0 0111.75 35V22z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.258 31.61l-.223-1.644 1.313 1.007.727-1.243-1.524-.619 1.524-.637-.733-1.262-1.288.969.216-1.594h-1.46l.21 1.613-1.293-.982L16 28.474l1.51.637-1.504.625.72 1.237 1.333-1-.242 1.638h1.44zM24.72 31.61l-.223-1.644 1.314 1.007.726-1.243-1.523-.619 1.523-.637-.733-1.262-1.288.969.217-1.594h-1.46l.21 1.613-1.294-.982-.726 1.256 1.51.637-1.504.625.72 1.237 1.333-1-.242 1.638h1.44zM30.183 31.61l-.223-1.644 1.313 1.007L32 29.73l-1.524-.619L32 28.474l-.733-1.262-1.288.969.217-1.594h-1.46l.21 1.613-1.294-.982-.727 1.256 1.511.637-1.504.625.72 1.237 1.332-1-.242 1.638h1.441z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcRecycleDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.989 12.576a1.202 1.202 0 011.196-1.317h20.139c.71 0 1.265.61 1.197 1.317L33.258 36.12a1.25 1.25 0 01-1.244 1.13H16.495a1.25 1.25 0 01-1.244-1.13l-2.262-23.544z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.75,
    y: 10.75,
    width: 27.009,
    height: 5.118,
    rx: 1.25,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.695 24.95l2.215.132 1.064-2.014-.742.425-1.118-1.782s-1.663-.02-2.689.03c-.419.02-.742.183-.883.432L21.1 24.717l1.836 1.038 1.565-2.763.94 1.528-.746.43zm-2.692 2.383l.781.46-1.016-2.018-2.278.068.735.436-1 1.85s.804 1.457 1.35 2.326c.225.355.524.556.812.556h2.924v-2.108h-3.177l.869-1.57zm4.211-1.381l1.855-1.003 1.39 2.573c.136.252.102.61-.104.978a61.398 61.398 0 01-1.401 2.294H25.85l-.034.854-1.144-1.97 1.285-1.76-.027.812 1.793.017-1.509-2.795z",
    fill: "#D8D8D8"
  }));
}

function SvgIcScrubberS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_scrubber_S24_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91 4.269c-.99.503-1.656 1.584-1.656 2.842v9.778c0 1.258.667 2.34 1.632 2.842.529.277 1.15.327 1.747.201 4.345-.905 8.69-.855 13.242.026.39.075.988.05 1.356-.076 1.172-.402 2.023-1.584 2.023-2.993V7.111c0-1.409-.85-2.616-2.023-2.993-.368-.126-.966-.151-1.333-.076-4.575.906-8.92.931-13.242.026a2.637 2.637 0 00-1.747.2zm-.156 12.073c.043.026.087.05.132.074.529.276 1.15.327 1.747.201 4.345-.905 8.69-.855 13.242.025.39.076.988.05 1.356-.075a2.78 2.78 0 00.523-.243v.565c0 .81-.482 1.392-1.008 1.573 0 0-.023.008-.072.016a1.735 1.735 0 01-.19.02 1.55 1.55 0 01-.325-.013c-4.723-.913-9.27-.972-13.832-.021h-.003c-.325.07-.579.024-.743-.062l-.002-.001c-.438-.228-.825-.777-.825-1.512v-.547z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91 4.269c-.99.503-1.656 1.584-1.656 2.842v9.778c0 1.258.667 2.34 1.632 2.842.529.277 1.15.327 1.747.201 4.345-.905 8.69-.855 13.242.026.39.075.988.05 1.356-.076 1.172-.402 2.023-1.584 2.023-2.993V7.111c0-1.409-.85-2.616-2.023-2.993-.368-.126-.966-.151-1.333-.076-4.575.906-8.92.931-13.242.026a2.637 2.637 0 00-1.747.2zm-.156 12.073c.043.026.087.05.132.074.529.276 1.15.327 1.747.201 4.345-.905 8.69-.855 13.242.025.39.076.988.05 1.356-.075a2.78 2.78 0 00.523-.243v.565c0 .81-.482 1.392-1.008 1.573 0 0-.023.008-.072.016a1.735 1.735 0 01-.19.02 1.55 1.55 0 01-.325-.013c-4.723-.913-9.27-.972-13.832-.021h-.003c-.325.07-.579.024-.743-.062l-.002-.001c-.438-.228-.825-.777-.825-1.512v-.547z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91 4.269l-.673-1.341-.008.004.68 1.337zM3.885 19.73l.695-1.329-.002-.001-.693 1.33zm1.747.201l-.306-1.468h-.003l.31 1.469zm13.242.026l-.285 1.472.285-1.472zm1.356-.076l.485 1.42.002-.001-.487-1.419zm0-15.764l-.485 1.42.013.004.012.004.46-1.428zm-1.333-.076l.29 1.472.011-.002-.301-1.47zm-13.242.026l-.32 1.465.013.003.307-1.468zm-1.77 12.348l.695-1.33H4.58l-.693 1.33zm-.132-.074l.765-1.29-2.265-1.343v2.633h1.5zm1.88.275l-.307-1.468h-.003l.31 1.468zm13.24.025l-.284 1.473.285-1.473zm1.357-.075l.485 1.42.002-.002-.487-1.418zm.523-.243h1.5v-2.642l-2.269 1.354.769 1.288zm-1.008 2.138l.324 1.465.084-.018.083-.029-.49-1.418zm-.072.016l-.245-1.48.245 1.48zm-.19.02l-.077-1.499.077 1.498zm-.325-.013l-.285 1.473.285-1.473zm-13.832-.021l-.306-1.468H5.02l.308 1.468zm-.003 0l-.308-1.467.308 1.468zm-.743-.062l.696-1.329-.003-.001-.693 1.33zm-.002-.001l-.693 1.33.693-1.33zm-.825-11.29c0-.73.382-1.275.835-1.505L3.23 2.932C1.705 3.707.754 5.326.754 7.11h3zm0 3.315V7.111h-3v3.315h3zm-3 0v3.148h3v-3.148h-3zm0 3.148v3.315h3v-3.315h-3zm0 3.315c0 1.781.946 3.395 2.44 4.173L4.578 18.4c-.438-.228-.825-.777-.825-1.512h-3zM3.19 21.06c.894.468 1.881.523 2.751.34l-.618-2.935c-.325.068-.579.023-.743-.063l-1.39 2.658zm2.748.34c4.128-.86 8.27-.817 12.65.03l.57-2.945c-4.723-.913-9.27-.972-13.832-.021l.612 2.937zm12.651.03c.61.118 1.477.093 2.126-.128l-.97-2.84c.005-.001-.017.007-.072.016a1.735 1.735 0 01-.19.02 1.55 1.55 0 01-.325-.013l-.569 2.945zm2.128-.13c1.818-.623 3.036-2.404 3.036-4.41h-3c0 .81-.483 1.393-1.01 1.573l.974 2.838zm3.036-4.41v-3.316h-3v3.315h3zm0-3.316v-3.148h-3v3.148h3zm-3-6.463v3.315h3V7.111h-3zm-.983-1.565c.484.155.983.733.983 1.565h3c0-1.985-1.203-3.822-3.064-4.421l-.919 2.856zm-.572-.034l.026-.004.067-.006a1.844 1.844 0 01.381.02c.056.01.078.017.073.015l.97-2.838a4.055 4.055 0 00-1.074-.192 4.259 4.259 0 00-1.046.066l.603 2.939zm-13.85.024c4.535.95 9.085.919 13.84-.022l-.583-2.943c-4.394.87-8.534.889-12.642.028l-.615 2.937zm-.768.074a1.14 1.14 0 01.755-.077l.64-2.93a4.137 4.137 0 00-2.74.325L4.582 5.61zm-.002 9.476l-.06-.034-1.53 2.58c.067.04.135.078.204.114l1.386-2.66zm.745.063c-.325.069-.579.023-.743-.062l-1.39 2.658c.894.468 1.881.523 2.751.34l-.618-2.936zm13.835.02c-4.723-.913-9.27-.971-13.832-.02l.612 2.937c4.128-.86 8.27-.818 12.65.029l.57-2.945zm.587-.022c.005-.002-.017.006-.072.015a1.708 1.708 0 01-.19.02 1.55 1.55 0 01-.325-.013l-.569 2.946c.61.118 1.477.093 2.126-.129l-.97-2.839zm.24-.111a1.283 1.283 0 01-.242.112l.974 2.837c.283-.097.552-.223.805-.373l-1.538-2.576zm2.268 1.853v-.565h-3v.565h3zm-2.017 2.991c1.163-.402 2.017-1.578 2.017-2.99h-3c0 .1-.028.15-.04.169-.008.01-.013.014-.01.012a.187.187 0 01.052-.026l.98 2.835zm-.318.078a2.47 2.47 0 00.206-.044l.02-.006h.003c.001 0 0 0 0 0l-.011.003a.832.832 0 01-.067.016l-.647-2.93c-.007.003-.014.004-.02.005a1.748 1.748 0 01-.03.008l-.017.004-.008.002-.003.001h-.002.002l.014-.003a.887.887 0 01.07-.016l.49 2.96zm-.358.037c.122-.006.244-.018.358-.037l-.49-2.96c.006-.001.006 0 0 0a.44.44 0 01-.022.001l.154 2.996zm-.686-.037c.195.037.442.05.686.037L19.407 17a.485.485 0 01-.046 0l.01.002a.546.546 0 01.072.011l-.568 2.946zm-13.242-.025c4.345-.906 8.69-.856 13.241.024l.57-2.945C14.549 16.066 9.8 16 5.02 16.995l.612 2.938zm0 0l.003-.001-.617-2.936h-.003l.617 2.937zm-1.747-.202c.526.275 1.145.328 1.747.201l-.617-2.935c-.05.01.062-.028.26.076l-1.39 2.658zm0 0l.003.002 1.385-2.661-.002-.001-1.386 2.66zM2.254 16.89c0 1.262.67 2.341 1.632 2.842l1.386-2.66a.227.227 0 01.038.024s-.006-.006-.015-.02a.362.362 0 01-.041-.186h-3zm0-.547v.547h3v-.547h-3z",
    fill: "#252525",
    mask: "url(#ic_scrubber_S24_svg__a)"
  }));
}

function SvgIcSettingFaqS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 16a3.25 3.25 0 013.25-3.25h19A3.25 3.25 0 0135.75 16v12.4a3.25 3.25 0 01-3.25 3.25H18.366a4.75 4.75 0 00-2.906.992l-4.807 3.718a.25.25 0 01-.403-.197V16z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.867 23.836c0 .562.344.992 1.031.992.649 0 .852-.36 1.118-.828.242-.555.547-.828 1.187-1.297.945-.656 1.75-1.305 1.75-2.648 0-1.844-1.523-2.914-3.695-2.914-1.219 0-2.14.32-2.719.82-.43.375-.703.867-.703 1.352 0 .476.305.89.898.89.36 0 .57-.148.836-.422.367-.476.836-.703 1.446-.703.742 0 1.406.414 1.406 1.125 0 .649-.485 1-1.172 1.524-.969.734-1.383 1.273-1.383 2.109zm-.351 3.086c0 .75.617 1.234 1.367 1.234s1.36-.484 1.36-1.234-.61-1.235-1.36-1.235c-.75 0-1.367.485-1.367 1.235z",
    fill: "#000"
  }));
}

function SvgIcShirtDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.567 12.864v5.184H17.744v-5.183h12.823z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.492 17.084c0-.69.56-1.25 1.25-1.25h7.685c.102 0 .203.012.302.037l1.764.44c.435.108.89.108 1.326 0l1.782-.44c.098-.025.2-.037.3-.037h7.667c.69 0 1.25.56 1.25 1.25V36c0 .69-.56 1.25-1.25 1.25H13.742c-.69 0-1.25-.56-1.25-1.25V17.084z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.956 13.024a.225.225 0 01.31-.126L23.556 16l-2.57 4.08a.225.225 0 01-.343.045l-4.684-4.33.998-2.771zM31.355 13.024a.225.225 0 00-.311-.126L24.756 16l2.569 4.08c.075.119.24.14.343.045l4.684-4.33-.997-2.771z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.176 16.225V37.74",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D8D8D8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.377 37.739c.359-1.925 2.3-2.375 2.3-2.375-2.155-.56-2.323-2.302-2.323-2.302h-.031S7.155 34.803 5 35.364c0 0 1.967.45 2.326 2.375h.05zM39.878 16.693c.323-1.732 2.07-2.136 2.07-2.136-1.94-.504-2.09-2.073-2.09-2.073h-.029s-.15 1.569-2.09 2.073c0 0 1.77.404 2.093 2.136h.046zM35.93 12.483c.574-3.08 3.68-3.798 3.68-3.798C36.162 7.789 35.894 5 35.894 5h-.051s-.269 2.789-3.717 3.685c0 0 3.147.719 3.722 3.798h.081z"
  })));
}

function SvgIcShirtS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.994 18.798h14.323v-6.683H16.994v6.683z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.567 12.864v5.184H17.744v-5.183h12.823z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.742 17.084a2 2 0 012-2h7.685c.163 0 .325.02.483.06l1.764.439a2 2 0 00.965 0l1.782-.44c.157-.04.318-.06.48-.06h7.667a2 2 0 012 2V36a2 2 0 01-2 2H13.742a2 2 0 01-2-2V17.084z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.492 17.084c0-.69.56-1.25 1.25-1.25h7.685c.102 0 .203.012.302.037l1.764.44c.435.108.89.108 1.326 0l1.782-.44c.098-.025.2-.037.3-.037h7.667c.69 0 1.25.56 1.25 1.25V36c0 .69-.56 1.25-1.25 1.25H13.742c-.69 0-1.25-.56-1.25-1.25V17.084z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.599 12.226a.975.975 0 00-1.35.544l-1.165 3.239 5.05 4.666a.975.975 0 001.486-.196l3.012-4.784-7.034-3.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.956 13.024a.225.225 0 01.31-.126L23.555 16l-2.569 4.08a.225.225 0 01-.343.045l-4.684-4.33.998-2.771z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.712 12.226a.975.975 0 011.348.544l1.166 3.239-5.049 4.666a.975.975 0 01-1.487-.196l-3.012-4.784 7.034-3.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.355 13.024a.225.225 0 00-.311-.126L24.756 16l2.569 4.08c.075.119.24.14.343.045l4.684-4.33-.997-2.771z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.176 16.225V37.74",
    stroke: "#262626",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.377 37.739c.359-1.925 2.3-2.375 2.3-2.375-2.155-.56-2.323-2.302-2.323-2.302h-.031S7.155 34.803 5 35.364c0 0 1.967.45 2.326 2.375h.05zM39.878 16.693c.323-1.732 2.07-2.136 2.07-2.136-1.94-.504-2.09-2.073-2.09-2.073h-.029s-.15 1.569-2.09 2.073c0 0 1.77.404 2.093 2.136h.046zM35.93 12.483c.574-3.08 3.68-3.798 3.68-3.798C36.162 7.789 35.894 5 35.894 5h-.051s-.269 2.789-3.716 3.685c0 0 3.146.719 3.721 3.798h.081z"
  })));
}

function SvgIcStayathomeS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 18.5v18h26v-18L24 9l-13 9.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18v18a1 1 0 001 1h24a1 1 0 001-1V18",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21.219l16.349-11.75c.389-.28.913-.28 1.302 0L41 21.218",
    stroke: "#242424",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 20a2.633 2.633 0 012.625 2.625A2.633 2.633 0 0124 25.25a2.633 2.633 0 01-2.625-2.625A2.633 2.633 0 0124 20zm-4.5 10.319V29.02c0-1.618 2.185-3.36 4.5-3.36 2.318 0 4.5 1.742 4.5 3.36v1.299a1 1 0 01-1 1h-7a1 1 0 01-1-1z",
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcSubwayS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2a2 2 0 012-2h8a2 2 0 012 2v2H2V2zm0 3h12v5c0 .664-.324 1.253-.822 1.617l1.445 3.176a.5.5 0 01-.91.414L13.163 14H2.848l-.561 1.21a.5.5 0 01-.908-.42l1.465-3.159A1.997 1.997 0 012 10V5zm1.31 8h9.399l-.462-1.015c-.081.01-.163.015-.247.015H4c-.075 0-.148-.004-.22-.012L3.31 13zm2.19-3a1 1 0 100-2 1 1 0 000 2zm5 0a1 1 0 100-2 1 1 0 000 2z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcToiletDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.051 39.172l1.309-8.028h6.686l1.308 8.028a.338.338 0 01-.333.298h-8.637a.338.338 0 01-.333-.298z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.825 39.483H30.58",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_toiletDim_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.005 19.6h-8.072a.77.77 0 00-.302.078 2.223 2.223 0 00-1.56 1.59.767.767 0 00-.07.312l.004.11a2.261 2.261 0 00.026.512c.139 2.153.67 5.384 2.642 7.655 2.341 2.698 5.639 2.943 6.76 2.943.108 0 .196-.002.261-.005a2.99 2.99 0 01.26 0c.065.003.153.005.261.005 1.123 0 4.423-.245 6.764-2.943 1.972-2.271 2.504-5.504 2.642-7.656a2.258 2.258 0 00.026-.51l.005-.11a.767.767 0 00-.071-.314 2.224 2.224 0 00-1.56-1.589.772.772 0 00-.302-.078h-7.714z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.005 19.6h-8.072a.77.77 0 00-.302.078 2.223 2.223 0 00-1.56 1.59.767.767 0 00-.07.312l.004.11a2.261 2.261 0 00.026.512c.139 2.153.67 5.384 2.642 7.655 2.341 2.698 5.639 2.943 6.76 2.943.108 0 .196-.002.261-.005a2.99 2.99 0 01.26 0c.065.003.153.005.261.005 1.123 0 4.423-.245 6.764-2.943 1.972-2.271 2.504-5.504 2.642-7.656a2.258 2.258 0 00.026-.51l.005-.11a.767.767 0 00-.071-.314 2.224 2.224 0 00-1.56-1.589.772.772 0 00-.302-.078h-7.714z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.631 19.678l.395 1.447.11-.03.105-.047-.61-1.37zm-1.56 1.59l1.384.577.042-.1.027-.104-1.453-.373zm-.07.312l-1.5.054v.004l1.5-.058zm.004.11l1.497.09.004-.074-.003-.074-1.498.057zm.026.512l1.497-.096-.005-.077-.012-.076-1.48.249zm2.642 7.655l1.133-.983-1.133.983zm7.021 2.938l.062 1.499h.003l-.065-1.499zm.26 0l-.065 1.499h.004l.061-1.499zm7.025-2.938l-1.132-.983 1.132.983zm2.642-7.656l-1.48-.248-.012.076-.005.076 1.497.096zm.026-.51l-1.498-.062-.004.076.005.076 1.497-.09zm.005-.11l-1.5-.055 1.5.054zm-.071-.314l-1.453.374.027.104.042.1 1.384-.578zm-1.56-1.589l-.61 1.37.105.047.11.03.396-1.447zM16.212 21.1h7.794v-3h-7.794v3zm-.278 0h.278v-3h-.278v3zm.308-.052a.465.465 0 01-.072.024.94.94 0 01-.236.028v-3c-.381 0-.703.114-.912.207l1.22 2.741zm-.717.593a.724.724 0 01.502-.516l-.79-2.894a3.724 3.724 0 00-2.618 2.664l2.905.746zm-.025-.114a.936.936 0 01-.02.242.495.495 0 01-.024.076l-2.769-1.154a2.254 2.254 0 00-.185.943l2.998-.107zm.004.105l-.004-.11-2.998.116.005.109 2.997-.115zm-.003.196c0-.017 0-.032.002-.048l-2.995-.182a3.8 3.8 0 00-.007.23h3zm.01.125a.749.749 0 01-.01-.125h-3c0 .21.018.419.052.623l2.959-.498zm2.296 6.92c-1.633-1.88-2.144-4.684-2.278-6.767l-2.994.192c.143 2.223.696 5.882 3.006 8.543l2.266-1.967zm5.627 2.427c-.987 0-3.722-.23-5.627-2.426L15.54 30.84c2.777 3.2 6.638 3.46 7.893 3.46v-3zm.2-.004a4.84 4.84 0 01-.2.004v3c.13 0 .238-.003.323-.006l-.123-2.998zm.191-.003c-.06 0-.126 0-.195.004l.13 2.997.065-.002v-3zm.195.004a4.473 4.473 0 00-.195-.005v3c.025 0 .046 0 .065.002l.13-2.997zm.197.003c-.088 0-.156-.002-.2-.004l-.123 2.998c.085.003.193.006.322.006v-3zm5.63-2.426c-1.905 2.195-4.641 2.426-5.63 2.426v3c1.256 0 5.119-.26 7.896-3.46l-2.265-1.966zm2.278-6.77c-.134 2.084-.644 4.889-2.277 6.77l2.265 1.967c2.31-2.662 2.863-6.322 3.006-8.544l-2.994-.192zm2.976.344c.034-.203.051-.41.051-.62h-3a.755.755 0 01-.01.125l2.96.495zm.051-.62c0-.077-.002-.153-.006-.229l-2.995.182.002.047h3zm-2.998-.302l-.004.103 2.997.122.005-.117-2.998-.108zm.044.319a.483.483 0 01-.023-.076.94.94 0 01-.021-.243l2.998.108a2.254 2.254 0 00-.186-.945l-2.768 1.156zm2.836-.952a3.724 3.724 0 00-2.615-2.662l-.792 2.894c.239.065.437.262.502.516l2.905-.748zm-3.314.207a.941.941 0 01-.237-.028.465.465 0 01-.07-.024l1.22-2.74a2.257 2.257 0 00-.913-.208v3zm-7.714 0h7.714v-3h-7.714v3z",
    fill: "#D8D8D8",
    mask: "url(#ic_toiletDim_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.244 10.797a1.75 1.75 0 011.724-2.047h11.063a1.75 1.75 0 011.725 2.048l-1.632 9.452h-11.25l-1.63-9.453z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 23.491h17.686",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.995 12.054h2.947",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcToiletS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.978 11.12H5.954l-.72 4.338c0 .3.246.542.55.542h4.365a.545.545 0 00.548-.542l-.72-4.337z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03 15.25l.56-3.38h2.752l.56 3.38H6.03z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.491 2.915A2.5 2.5 0 014.957 0h6.086a2.5 2.5 0 012.465 2.916L12.82 7H3.18l-.688-4.085z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.23 2.79A1.75 1.75 0 014.958.75h6.086a1.75 1.75 0 011.726 2.041l-.584 3.459H3.814L3.23 2.79z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.887 9.353A3 3 0 013.764 5.5h8.404a3 3 0 012.876 3.853l-1.76 5.931a1 1 0 01-.958.716h-8.72a1 1 0 01-.96-.716L.887 9.353z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.607 9.14a2.25 2.25 0 012.157-2.89h8.404a2.25 2.25 0 012.157 2.89l-1.76 5.931a.25.25 0 01-.24.179h-8.72a.25.25 0 01-.24-.179L1.608 9.14z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.8 9.5h12",
    stroke: "#262626",
    strokeWidth: 1.5
  }));
}

function SvgIcToiletS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.051 30.394H19.95l-1.45 8.734c0 .603.496 1.092 1.106 1.092h8.79c.61 0 1.105-.489 1.105-1.092l-1.449-8.734z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.253 39.172l1.331-8.028h6.832l1.331 8.028a.35.35 0 01-.352.298h-8.79a.35.35 0 01-.352-.298z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 39.483h14",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_toilet_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.182 19.6h-8.215a.796.796 0 00-.307.078 2.242 2.242 0 00-1.588 1.59.757.757 0 00-.072.312l.005.11a2.189 2.189 0 00.027.512c.14 2.153.682 5.384 2.688 7.655 2.383 2.698 5.74 2.943 6.88 2.943.11 0 .2-.002.266-.005a3.103 3.103 0 01.264 0c.067.003.156.005.267.005 1.142 0 4.5-.245 6.883-2.943 2.007-2.27 2.548-5.503 2.688-7.656a2.216 2.216 0 00.027-.51l.005-.11a.757.757 0 00-.072-.314 2.243 2.243 0 00-1.586-1.589.798.798 0 00-.309-.078h-7.85z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.182 19.6h-8.215a.796.796 0 00-.307.078 2.242 2.242 0 00-1.588 1.59.757.757 0 00-.072.312l.005.11a2.189 2.189 0 00.027.512c.14 2.153.682 5.384 2.688 7.655 2.383 2.698 5.74 2.943 6.88 2.943.11 0 .2-.002.266-.005a3.103 3.103 0 01.264 0c.067.003.156.005.267.005 1.142 0 4.5-.245 6.883-2.943 2.007-2.27 2.548-5.503 2.688-7.656a2.216 2.216 0 00.027-.51l.005-.11a.757.757 0 00-.072-.314 2.243 2.243 0 00-1.586-1.589.798.798 0 00-.309-.078h-7.85z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66 19.678l.389 1.448.108-.029.104-.045-.601-1.374zm-1.588 1.59l1.38.586.043-.1.028-.107-1.451-.379zM14 21.58l-1.499.055v.004l1.5-.059zm.005.11l1.497.092.004-.076-.003-.075-1.498.058zm.027.512l1.497-.098-.005-.078-.013-.077-1.48.253zm2.688 7.655l1.124-.993-1.124.993zm7.146 2.938l.06 1.499h.004l-.064-1.499zm.264 0l-.063 1.499h.003l.06-1.499zm7.15-2.938l-1.124-.993 1.124.993zm2.688-7.656l-1.479-.252-.012.077-.006.077 1.497.098zm.027-.51l-1.498-.063-.004.077.005.077 1.497-.092zm.005-.11l-1.5-.056 1.5.055zm-.072-.314l-1.451.38.027.106.043.1 1.38-.586zm-1.586-1.589l-.602 1.374.103.045.109.03.39-1.449zM16.25 21.1h7.932v-3H16.25v3zm-.283 0h.283v-3h-.283v3zm.293-.048s-.024.01-.065.021a.924.924 0 01-.228.027v-3a2.28 2.28 0 00-.908.203l1.202 2.75zm-.737.595a.742.742 0 01.526-.52l-.778-2.898a3.742 3.742 0 00-2.65 2.66l2.902.758zm-.024-.121a.945.945 0 01-.022.248.494.494 0 01-.024.08l-2.762-1.171c-.093.219-.204.555-.19.952l2.998-.11zm.004.105l-.004-.11-2.998.118.005.109 2.997-.117zm-.003.197c0-.016 0-.031.002-.046l-2.995-.186a3.774 3.774 0 00-.007.232h3zm.01.121a.721.721 0 01-.01-.121h-3c0 .212.018.422.053.627l2.957-.506zm2.334 6.915c-1.66-1.88-2.18-4.68-2.315-6.76l-2.994.196c.146 2.226.71 5.89 3.061 8.55l2.248-1.986zM23.6 31.3c-1.013 0-3.81-.233-5.756-2.436l-2.248 1.986c2.82 3.193 6.735 3.45 8.004 3.45v-3zm.206-.004a5.335 5.335 0 01-.206.004v3c.13 0 .24-.003.326-.006l-.12-2.998zm.192-.003a4.69 4.69 0 00-.196.004l.128 2.997.068-.002v-3zm.196.004a4.682 4.682 0 00-.196-.005v3c.026 0 .049 0 .069.002l.127-2.997zm.203.003c-.09 0-.16-.002-.206-.004l-.121 2.998c.086.003.196.006.326.006v-3zm5.759-2.436c-1.946 2.203-4.744 2.436-5.76 2.436v3c1.27 0 5.188-.257 8.008-3.45l-2.248-1.986zm2.315-6.76c-.135 2.078-.653 4.88-2.315 6.76l2.248 1.986c2.352-2.661 2.916-6.325 3.061-8.552l-2.994-.195zm2.976.349c.035-.204.053-.413.053-.625h-3a.714.714 0 01-.01.121l2.957.504zm.053-.625c0-.077-.003-.154-.007-.23l-2.995.184.002.046h3zm-3-.303l-.003.103 2.997.124.005-.117-2.998-.11zm.047.329c-.002-.005-.013-.032-.024-.08a.95.95 0 01-.022-.25l2.998.111a2.242 2.242 0 00-.191-.955l-2.76 1.174zm2.832-.968a3.743 3.743 0 00-2.647-2.656l-.78 2.897c.261.07.46.276.525.52l2.902-.76zm-3.346.214a.918.918 0 01-.228-.027c-.042-.01-.064-.02-.066-.02l1.205-2.749a2.282 2.282 0 00-.91-.204v3zm-7.85 0h7.85v-3h-7.85v3z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#ic_toilet_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.005 10.925A2.5 2.5 0 0118.468 8h11.063a2.5 2.5 0 012.464 2.925L30.255 21H17.743l-1.738-10.075z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.744 10.797a1.75 1.75 0 011.724-2.047h11.063a1.75 1.75 0 011.725 2.048l-1.632 9.452h-11.25l-1.63-9.453zM15 23.491h17.686",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.054h2.948",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcTrashDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.314 34.896h0c-.593-1.093-1.089-3.438-.964-6.235.124-2.771.853-5.86 2.578-8.442 1.624-2.43 4.709-3.741 7.98-3.754 3.271.013 6.356 1.323 7.98 3.754 1.727 2.584 2.477 5.688 2.611 8.465.136 2.809-.363 5.137-.984 6.188-1.469 2.487-3.57 2.886-4.973 3.06-1.437.178-2.292.228-4.64.228h-.032c-2.31 0-2.365 0-4.612-.23-2.098-.215-3.98-1.257-4.944-3.034z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.984 22.515s-.48-2.841-2.122-4.659c-1.642-1.818-3.216-1.958-3.216-1.958",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.853 11.322h0l.003-.002.022-.015a4.03 4.03 0 01.47-.273c.321-.159.685-.282 1.002-.282.316 0 .679.123 1 .282a4.021 4.021 0 01.467.272l.022.016.004.002h0l.283.21.344-.086.047-.012a.94.94 0 011.134 1.162l-.333 1.198-.983 1.693a.94.94 0 01-.812.467h-2.407a.94.94 0 01-.81-.463l-.949-1.617-.36-1.288a.94.94 0 011.128-1.165l.104.026.342.084.282-.209zm0 0h0zM9.733 34.896h0c-.593-1.093-1.088-3.438-.964-6.235.124-2.771.853-5.86 2.578-8.442 1.624-2.43 4.709-3.741 7.98-3.754 3.272.013 6.356 1.323 7.98 3.754 1.727 2.584 2.477 5.688 2.612 8.465.136 2.809-.364 5.137-.984 6.188-1.47 2.487-3.57 2.886-4.973 3.06-1.437.178-2.293.228-4.64.228h-.033c-2.31 0-2.365 0-4.612-.23-2.098-.215-3.98-1.257-4.944-3.034z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.603 24.047s-.264-2.87.9-5.044c1.163-2.174 2.697-2.708 2.697-2.708M24.282 24.047s.263-2.87-.9-5.044c-1.164-2.174-2.698-2.708-2.698-2.708",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.927 11.322h0l.003-.002.022-.015a4.03 4.03 0 01.47-.273c.321-.159.685-.282 1.002-.282.316 0 .679.123 1 .282a4.021 4.021 0 01.468.272l.021.016.004.002h0l.283.21.344-.086.047-.012a.94.94 0 011.134 1.162l-.333 1.198-.983 1.693a.94.94 0 01-.812.467H18.19a.94.94 0 01-.81-.463l-.949-1.617-.36-1.288a.94.94 0 011.128-1.165l.104.026.342.084.282-.209zm0 0h0z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }));
}

function SvgIcUserS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1c1.65 0 3 1.35 3 3S9.65 7 8 7 5 5.65 5 4s1.35-3 3-3zM2 13.302v-1.018c0-2.008 2.913-4.17 6-4.17 3.09 0 6 2.162 6 4.17v1.018a1 1 0 01-1 1H3a1 1 0 01-1-1z",
    fill: "#00BED6"
  }));
}

function SvgIcVillaDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__c)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667,
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__e)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.348,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667
  })), /*#__PURE__*/React.createElement("rect", {
    x: 26.348,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667,
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 19.435,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 19.435,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__g)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 26.044,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 26.044,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.185 12.043c0-.69.56-1.25 1.25-1.25H33.39c.69 0 1.25.56 1.25 1.25v25.424H13.185V12.044z",
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.044,
    y: 33.348,
    width: 9.739,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.044,
    y: 33.348,
    width: 9.739,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__i)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__j)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 27.826,
    height: 4.522,
    rx: 1.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 27.826,
    height: 4.522,
    rx: 1.333,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__k)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__l)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__m)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villaDim_S48_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_villaDim_S48_svg__n)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 37,
    width: 31,
    height: 1.5,
    rx: 0.667,
    fill: "#D8D8D8"
  }));
}

function SvgIcVillaS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 17.696,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__b)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__c)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.391,
    y: 24.304,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__d)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__e)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.348,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667
  })), /*#__PURE__*/React.createElement("rect", {
    x: 26.348,
    y: 30.913,
    width: 3.478,
    height: 4.87,
    rx: 0.667,
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 19.435,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 19.435,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__g)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 26.044,
    width: 3.478,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 22.522,
    y: 26.044,
    width: 3.478,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.435 12.043a2 2 0 012-2H33.39a2 2 0 012 2v26.174H12.435V12.044z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.185 12.043c0-.69.56-1.25 1.25-1.25H33.39c.69 0 1.25.56 1.25 1.25v25.424H13.185V12.044z",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.044,
    y: 33.348,
    width: 9.739,
    height: 4.87,
    rx: 0.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 19.044,
    y: 33.348,
    width: 9.739,
    height: 4.87,
    rx: 0.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__i)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__j)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 27.826,
    height: 4.522,
    rx: 1.333
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 27.826,
    height: 4.522,
    rx: 1.333,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__k)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 17,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__l)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 17.304,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__m)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_villa_S48_svg__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.652,
    y: 25,
    width: 4.87,
    height: 4.87,
    rx: 0.5,
    fill: "#fff",
    stroke: "#000",
    strokeOpacity: 0.85,
    strokeWidth: 3,
    mask: "url(#ic_villa_S48_svg__n)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 37,
    width: 31,
    height: 1.5,
    rx: 0.667,
    fill: "#000",
    fillOpacity: 0.85
  }));
}

function SvgIcWalkS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.98 3.5a2 2 0 11-4 0 2 2 0 014 0zM4.5 13.002h2.015l.754-3.499L9.771 8.5 6.515 22.498h1.99l2.257-7.475 2.24 1.98v5.495h1.995v-6.993L12.514 13l.466-3.016 2.482 2.534h4.011v-1.953h-3.006L12.98 6.472l-2.492-.497L5.48 8.5l-.98 4.502z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIcWindowDimS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ic_windowDim_S48_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 33.231,
    height: 27,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 11,
    width: 33.231,
    height: 27,
    rx: 1,
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_windowDim_S48_svg__a)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ic_windowDim_S48_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.323,
    y: 14.116,
    width: 27,
    height: 20.769,
    rx: 1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 10.323,
    y: 14.116,
    width: 27,
    height: 20.769,
    rx: 1,
    stroke: "#D8D8D8",
    strokeWidth: 3,
    mask: "url(#ic_windowDim_S48_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M22.508 14.323h1.662v19.731h-1.662z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.634 22.577a.5.5 0 01.5-.5h.539v4.154h-.538a.5.5 0 01-.5-.5v-3.154zM24.135 22.077h.538a.5.5 0 01.5.5v3.154a.5.5 0 01-.5.5h-.538v-4.154z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.167 29.088l-2.553 2.553M18.746 25.07l-5.422 5.423M30.314 17.801l-2.553 2.553M34.085 19.496l-5.422 5.422",
    stroke: "#D8D8D8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }));
}

function SvgIcWorkS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 6a2 2 0 00-2-2H6a2 2 0 00-2 2v14h5v-2a3 3 0 116 0v2h5V6zM8 8a.5.5 0 000 1h8a.5.5 0 000-1H8zm-.5 3.5A.5.5 0 018 11h8a.5.5 0 010 1H8a.5.5 0 01-.5-.5z",
    fill: "#000",
    fillOpacity: 0.8
  }));
}

function SvgIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_home_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.913a2 2 0 00-.69-1.511l-7.655-6.634a1 1 0 00-1.31 0L3.69 9.402A2 2 0 003 10.913V20a1 1 0 001 1h6v-4a2 2 0 114 0v4h6.306c.383 0 .694-.311.694-.695v-9.392z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.31 9.402l.982-1.134-.982 1.134zm-7.655-6.634L11.673 3.9l.982-1.133zm-1.31 0l-.982-1.134.982 1.134zM3.69 9.402l-.982-1.134.982 1.134zM10 21v1.5h1.5V21H10zm4 0h-1.5v1.5H14V21zm5.328-10.465a.5.5 0 01.172.378h3a3.5 3.5 0 00-1.208-2.645l-1.965 2.267zm-7.655-6.634l7.655 6.634 1.964-2.267-7.655-6.634-1.965 2.267zm.655 0a.5.5 0 01-.655 0l1.964-2.267a2.5 2.5 0 00-3.274 0l1.965 2.267zm-7.655 6.634l7.655-6.634-1.965-2.267-7.655 6.634 1.965 2.267zm-.173.378a.5.5 0 01.173-.378L2.708 8.268A3.5 3.5 0 001.5 10.913h3zM4.5 20v-9.087h-3V20h3zm-.5-.5a.5.5 0 01.5.5h-3A2.5 2.5 0 004 22.5v-3zm6 0H4v3h6v-3zM8.5 17v4h3v-4h-3zm3.5-3.5A3.5 3.5 0 008.5 17h3a.5.5 0 01.5-.5v-3zm3.5 3.5a3.5 3.5 0 00-3.5-3.5v3a.5.5 0 01.5.5h3zm0 4v-4h-3v4h3zm4.806-1.5H14v3h6.306v-3zm-.806.805c0-.444.36-.805.806-.805v3a2.194 2.194 0 002.194-2.195h-3zm0-9.392v9.392h3v-9.392h-3z",
    fill: "#000",
    fillOpacity: 0.85,
    mask: "url(#icon_home_svg__a)"
  }));
}

function SvgIcCancelS16(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.71967 4.71967C4.42678 5.01256 4.42678 5.48744 4.71967 5.78033L6.94045 8.00112L4.7204 10.2212C4.42751 10.5141 4.42751 10.9889 4.7204 11.2818C5.0133 11.5747 5.48817 11.5747 5.78106 11.2818L8.00111 9.06178L10.2212 11.2818C10.514 11.5747 10.9889 11.5747 11.2818 11.2818C11.5747 10.9889 11.5747 10.5141 11.2818 10.2212L9.06177 8.00112L11.2825 5.78033C11.5754 5.48744 11.5754 5.01256 11.2825 4.71967C10.9897 4.42678 10.5148 4.42678 10.2219 4.71967L8.00111 6.94045L5.78033 4.71967C5.48744 4.42678 5.01256 4.42678 4.71967 4.71967Z",
    fill: "black",
    "fill-opacity": "0.4"
  }));
}

function SvgIcTopbarCloseActionS16(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.2279 12.6333C4.02245 12.8388 4.02245 13.1719 4.2279 13.3773C4.43335 13.5828 4.76645 13.5828 4.9719 13.3773L9.18784 9.16136L13.4038 13.3773C13.6093 13.5828 13.9424 13.5828 14.1478 13.3773C14.3533 13.1719 14.3533 12.8388 14.1478 12.6333L9.93184 8.41736L14.1479 4.20131C14.3533 3.99586 14.3533 3.66276 14.1479 3.45731C13.9424 3.25186 13.6093 3.25186 13.4039 3.45731L9.18784 7.67336L4.97182 3.45734C4.76637 3.25189 4.43327 3.25189 4.22782 3.45734C4.02237 3.66279 4.02237 3.99589 4.22782 4.20134L8.44384 8.41736L4.2279 12.6333Z",
    fill: "black",
    "fill-opacity": "0.4"
  }));
}

function SvgIcMyPageS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "12.0879",
    cy: "12",
    r: "9.3",
    stroke: "#262626",
    "stroke-width": "1.4"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: 'multiply'
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2854_24391",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "2",
    y: "2",
    width: "21",
    height: "20"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12.0879",
    cy: "12",
    r: "10",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2854_24391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8124 9.95221C15.8124 7.91561 14.149 6.25221 12.1124 6.25221V7.65221C13.3758 7.65221 14.4124 8.68881 14.4124 9.95221H15.8124ZM12.1124 13.6522C14.149 13.6522 15.8124 11.9888 15.8124 9.95221H14.4124C14.4124 11.2156 13.3758 12.2522 12.1124 12.2522V13.6522ZM8.41243 9.95221C8.41243 11.9888 10.0758 13.6522 12.1124 13.6522V12.2522C10.849 12.2522 9.81243 11.2156 9.81243 9.95221H8.41243ZM12.1124 6.25221C10.0758 6.25221 8.41243 7.91561 8.41243 9.95221H9.81243C9.81243 8.68881 10.849 7.65221 12.1124 7.65221V6.25221ZM4.50447 19.6849V21H5.90447V19.6849H4.50447ZM12.0877 14.2017C10.1614 14.2017 8.30061 14.873 6.91277 15.8588C5.55232 16.8251 4.50447 18.2046 4.50447 19.6849H5.90447C5.90447 18.8617 6.52763 17.8496 7.72348 17.0002C8.89195 16.1702 10.4727 15.6017 12.0877 15.6017V14.2017ZM19.6709 19.6849C19.6709 18.2049 18.6245 16.8254 17.2644 15.8589C15.8769 14.873 14.016 14.2017 12.0877 14.2017V15.6017C13.705 15.6017 15.2857 16.1703 16.4534 17.0001C17.6484 17.8493 18.2709 18.8613 18.2709 19.6849H19.6709ZM19.6709 21V19.6849H18.2709V21H19.6709ZM17.9709 22.7C18.9097 22.7 19.6709 21.9389 19.6709 21H18.2709C18.2709 21.1657 18.1365 21.3 17.9709 21.3V22.7ZM6.20447 22.7H17.9709V21.3H6.20447V22.7ZM4.50447 21C4.50447 21.9389 5.26558 22.7 6.20447 22.7V21.3C6.03878 21.3 5.90447 21.1657 5.90447 21H4.50447Z",
    fill: "#262626"
  }))));
}

function SvgIcDeliverFillS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.14835 7.86835C6.16196 7.82752 6.20017 7.79998 6.24322 7.79998H9.75667C9.79971 7.79998 9.83793 7.82752 9.85154 7.86835L10.2954 9.19998H5.70447L6.14835 7.86835Z",
    stroke: "#262626",
    "stroke-width": "1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.44371 5.8705C4.59331 5.48633 4.96332 5.23334 5.37558 5.23336L10.6244 5.2335C11.0367 5.23351 11.4066 5.48648 11.5562 5.87061L13.0652 9.74532C13.1102 9.86101 13.1334 9.98407 13.1334 10.1082V14.1609C13.1334 14.9005 12.5338 15.5 11.7942 15.5C11.0547 15.5 10.4551 14.9005 10.4551 14.1609H5.54496C5.54496 14.9005 4.94541 15.5 4.20583 15.5C3.46625 15.5 2.8667 14.9005 2.8667 14.1609V10.1082C2.8667 9.98406 2.88981 9.86101 2.93486 9.74534L4.44371 5.8705Z",
    stroke: "#262626",
    "stroke-width": "1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7037 12.7H14C14.5523 12.7 15 12.2523 15 11.7V2.5C15 1.94772 14.5523 1.5 14 1.5H2C1.44772 1.5 1 1.94771 1 2.5V11.7C1 12.2523 1.44772 12.7 2 12.7H2.2963",
    stroke: "#262626",
    "stroke-width": "1.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2511 1.81299H14.5925V12.2507H13.193V8.66686L11.7935 5.08298H8.0003H4.6257L2.9384 8.66686V12.2507H1.2511V1.81299Z",
    fill: "#262626"
  }));
}

function SvgIcInfoFilS16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5ZM8 7.3C8.3866 7.3 8.7 7.6134 8.7 8V11.5C8.7 11.8866 8.3866 12.2 8 12.2C7.6134 12.2 7.3 11.8866 7.3 11.5V8C7.3 7.6134 7.6134 7.3 8 7.3ZM9 5.50001C9 6.05229 8.55229 6.5 8 6.5C7.44772 6.5 7 6.05229 7 5.50001C7 4.94773 7.44772 4.5 8 4.5C8.55229 4.5 9 4.94773 9 5.50001Z",
    fill: "black",
    "fill-opacity": "0.8"
  }));
}

function SvgIcCouponTypeAFillS24(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M22.4 8.27596C22.4 8.6619 22.0834 8.96689 21.7082 9.05696C21.1781 9.18418 20.6882 9.45483 20.2955 9.84533C19.7363 10.4015 19.4194 11.1557 19.4136 11.9441C19.4155 12.7343 19.731 13.4915 20.2908 14.0496C20.6839 14.4415 21.175 14.7127 21.7064 14.8395C22.0824 14.9293 22.4 15.2346 22.4 15.6212V17.41C22.4 18.2384 21.7284 18.91 20.9 18.91H2.5C1.67157 18.91 1 18.2384 1 17.41V6.5C1 5.67157 1.67157 5 2.5 5H20.9C21.7284 5 22.4 5.67157 22.4 6.5V8.27596ZM7.44646 9.56828C7.18784 9.28092 7.21114 8.83832 7.4985 8.5797C7.78585 8.32108 8.22846 8.34437 8.48708 8.63173L13.6386 14.3556C13.8972 14.643 13.8739 15.0856 13.5866 15.3442C13.2992 15.6028 12.8566 15.5795 12.598 15.2922L7.44646 9.56828ZM6.90005 14.3657C6.90005 15.0284 7.43731 15.5657 8.10005 15.5657C8.76279 15.5657 9.30005 15.0284 9.30005 14.3657C9.30005 13.7029 8.76279 13.1657 8.10005 13.1657C7.43731 13.1657 6.90005 13.7029 6.90005 14.3657ZM13.1 11.0657C12.4373 11.0657 11.9 10.5284 11.9 9.86567C11.9 9.20292 12.4373 8.66568 13.1 8.66568C13.7628 8.66568 14.3 9.20292 14.3 9.86567C14.3 10.5284 13.7628 11.0657 13.1 11.0657Z",
    fill: "#333333"
  }));
}

function SvgIcDeliverFillS24V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.25347 2.44714C3.03844 2.44714 2.05347 3.43212 2.05347 4.64714V16.9518C2.05347 17.8751 2.62222 18.6656 3.42849 18.9919V19.9258C3.42849 21.4179 4.70392 22.5526 6.18196 22.5526C7.41827 22.5526 8.51282 21.7587 8.83777 20.6258H15.1625C15.4874 21.7587 16.582 22.5526 17.8183 22.5526C19.2963 22.5526 20.5718 21.4179 20.5718 19.9258V18.9919C21.3779 18.6655 21.9466 17.8751 21.9466 16.9518V4.64714C21.9466 3.43212 20.9617 2.44714 19.7466 2.44714H4.25347ZM7.30509 7.96309C7.34231 7.87292 7.45406 7.78055 7.61548 7.78055H16.3848C16.5462 7.78055 16.6579 7.87292 16.6952 7.96309L19.1718 13.9631V19.9258C19.1718 20.562 18.6084 21.1526 17.8183 21.1526C17.0281 21.1526 16.4648 20.562 16.4648 19.9258C16.4648 19.5392 16.1514 19.2258 15.7648 19.2258H8.23543C7.84883 19.2258 7.53543 19.5392 7.53543 19.9258C7.53543 20.562 6.97211 21.1526 6.18196 21.1526C5.3918 21.1526 4.82849 20.562 4.82849 19.9258V13.9631L7.30509 7.96309ZM8.82608 9.19061C8.40666 9.19061 8.0318 9.45234 7.8873 9.84609L7.07238 12.0667C6.83287 12.7193 7.31595 13.4112 8.01116 13.4112H15.989C16.6842 13.4112 17.1673 12.7193 16.9278 12.0667L16.1128 9.84609C15.9683 9.45234 15.5935 9.19061 15.1741 9.19061H8.82608Z",
    fill: "#262626"
  }));
}

function SvgIcDeliverS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "49",
    height: "49",
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.7269 11.2604C10.5119 11.2604 9.52689 12.2454 9.52689 13.4604V34.4604C9.52689 35.6755 10.5119 36.6604 11.7269 36.6604H12.5269V38.0909C12.5269 40.0623 14.125 41.6604 16.0965 41.6604C17.8287 41.6604 19.2716 40.4272 19.5973 38.7909H28.8565C29.1822 40.4272 30.6251 41.6604 32.3573 41.6604C34.3287 41.6604 35.9269 40.0623 35.9269 38.0909V36.6604H36.7269C37.9419 36.6604 38.9269 35.6755 38.9269 34.4604V13.4604C38.9269 12.2454 37.9419 11.2604 36.7269 11.2604H11.7269ZM35.9269 35.2604H36.7269C37.1687 35.2604 37.5269 34.9023 37.5269 34.4604V13.4604C37.5269 13.0186 37.1687 12.6604 36.7269 12.6604H11.7269C11.2851 12.6604 10.9269 13.0186 10.9269 13.4604V34.4604C10.9269 34.9023 11.2851 35.2604 11.7269 35.2604H12.5269V29.0039V28.8731L12.5741 28.7511L16.109 19.6242C16.4273 18.8022 17.2182 18.2604 18.0997 18.2604H30.3541C31.2356 18.2604 32.0264 18.8022 32.3448 19.6242L35.8796 28.7511L35.9269 28.8731V29.0039V35.2604ZM18.0997 19.6604C17.7963 19.6604 17.5241 19.8469 17.4145 20.1298L13.9269 29.1347V38.0909C13.9269 39.2891 14.8982 40.2604 16.0965 40.2604C17.1656 40.2604 18.0554 39.4864 18.2335 38.468C18.3265 37.9361 18.7789 37.3909 19.466 37.3909H28.9878C29.6749 37.3909 30.1273 37.9361 30.2203 38.468C30.3984 39.4864 31.2882 40.2604 32.3573 40.2604C33.5555 40.2604 34.5269 39.2891 34.5269 38.0909V29.1347L31.0393 20.1298C30.9297 19.8469 30.6575 19.6604 30.3541 19.6604H18.0997ZM19.4774 23.3604L18.2584 26.5604H30.1954L28.9764 23.3604H19.4774ZM19.2018 21.9604C18.7868 21.9604 18.415 22.2167 18.2673 22.6044L16.7435 26.6044C16.4941 27.259 16.9775 27.9604 17.6779 27.9604H30.7758C31.4762 27.9604 31.9597 27.259 31.7103 26.6044L30.1865 22.6044C30.0388 22.2167 29.667 21.9604 29.252 21.9604H19.2018Z",
    fill: props.enable ? '#262626' : '#ccc'
  }));
}

function SvgIcBoxS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "49",
    height: "49",
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.1321 10.9601C10.917 10.9601 9.93205 11.9451 9.93205 13.1601V35.1601C9.93205 36.3752 10.917 37.3601 12.1321 37.3601H36.1321C37.3471 37.3601 38.3321 36.3752 38.3321 35.1601V13.1601C38.3321 11.9451 37.3471 10.9601 36.1321 10.9601H12.1321ZM11.3321 13.1601C11.3321 12.7183 11.6902 12.3601 12.1321 12.3601H18.9618V21.0502C18.9618 21.2907 19.0853 21.5143 19.2888 21.6425C19.4923 21.7706 19.7474 21.7854 19.9643 21.6815L23.9618 19.7663L27.9594 21.6815C28.1763 21.7854 28.4314 21.7706 28.6349 21.6425C28.8384 21.5143 28.9618 21.2907 28.9618 21.0502V12.3601H36.1321C36.5739 12.3601 36.9321 12.7183 36.9321 13.1601V35.1601C36.9321 35.602 36.5739 35.9601 36.1321 35.9601H12.1321C11.6902 35.9601 11.3321 35.602 11.3321 35.1601V13.1601ZM27.5618 12.3601H20.3618V19.9386L23.6594 18.3589C23.8506 18.2673 24.0731 18.2673 24.2643 18.3589L27.5618 19.9386V12.3601Z",
    fill: props.enable ? '#262626' : '#ccc'
  }));
}

function SvgIcGiftS48(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "49",
    height: "49",
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M20.9769 12.6604C20.3006 12.6604 19.6519 12.929 19.1737 13.4073C18.6955 13.8855 18.4268 14.5341 18.4268 15.2104C18.4268 15.8867 18.6955 16.5353 19.1737 17.0136C19.6519 17.4918 20.3006 17.7605 20.9769 17.7605V17.7692H23.5268V15.2192H23.5269H24.9268H24.9269V17.7692H27.4769V17.7605C28.1532 17.7605 28.8018 17.4918 29.28 17.0136C29.7582 16.5353 30.0269 15.8867 30.0269 15.2104C30.0269 14.5341 29.7582 13.8855 29.28 13.4073C28.8018 12.929 28.1532 12.6604 27.4769 12.6604C26.8006 12.6604 26.1519 12.929 25.6737 13.4073C25.1994 13.8816 24.9312 14.5235 24.9269 15.1938L24.9269 15.2104H24.9268H23.5269H23.5268L23.5269 15.1938C23.5225 14.5235 23.2543 13.8816 22.78 13.4073C22.3018 12.929 21.6532 12.6604 20.9769 12.6604ZM35.2269 17.9745H30.2986C31.0214 17.2367 31.4269 16.2445 31.4269 15.2104C31.4269 14.1628 31.0107 13.1581 30.27 12.4173C29.5292 11.6766 28.5245 11.2604 27.4769 11.2604C26.4293 11.2604 25.4245 11.6765 24.6838 12.4173C24.5141 12.587 24.3614 12.7706 24.2269 12.9653C24.0923 12.7706 23.9397 12.587 23.77 12.4173C23.0292 11.6766 22.0245 11.2604 20.9769 11.2604C19.9293 11.2604 18.9245 11.6765 18.1838 12.4173C17.443 13.1581 17.0268 14.1628 17.0268 15.2104C17.0268 16.2444 17.4322 17.2366 18.1551 17.9745H13.2269C12.0119 17.9745 11.0269 18.9595 11.0269 20.1745V23.1745C11.0269 24.3221 11.9056 25.2645 13.0269 25.3656V37.4604C13.0269 38.6755 14.0119 39.6604 15.2269 39.6604H33.2269C34.4419 39.6604 35.4269 38.6755 35.4269 37.4604V25.3656C36.5482 25.2645 37.4269 24.3221 37.4269 23.1745V20.1745C37.4269 18.9595 36.4419 17.9745 35.2269 17.9745ZM34.0269 25.3745H14.4269V37.4604C14.4269 37.9023 14.7851 38.2604 15.2269 38.2604H33.2269C33.6687 38.2604 34.0269 37.9023 34.0269 37.4604V25.3745ZM12.4269 20.1745C12.4269 19.7327 12.7851 19.3745 13.2269 19.3745H35.2269C35.6687 19.3745 36.0269 19.7327 36.0269 20.1745V23.1745C36.0269 23.6164 35.6687 23.9745 35.2269 23.9745H13.2269C12.7851 23.9745 12.4269 23.6164 12.4269 23.1745V20.1745Z",
    fill: props.enable ? '#262626' : '#ccc'
  }));
}

function SvgIcUserFillS16V01(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8 1.00012C9.65 1.00012 11 2.35012 11 4.00012C11 5.65012 9.65 7.00012 8 7.00012C6.35 7.00012 5 5.65012 5 4.00012C5 2.35012 6.35 1.00012 8 1.00012ZM2 13.5021V12.284C2 10.2761 4.9132 8.11462 8 8.11462C11.0907 8.11462 14 10.2761 14 12.284V13.5021C14 13.944 13.6418 14.3021 13.2 14.3021H2.8C2.35817 14.3021 2 13.944 2 13.5021Z",
    fill: "#333333"
  }));
}

function IcSmallCircleS16(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: "8",
    cy: "8",
    r: "1.5",
    fill: props.color || '#42484C'
  }));
}

var _templateObject$T, _templateObject2$E, _templateObject3$t, _templateObject4$m, _templateObject5$h;
var Counter = function Counter(_ref) {
  var title = _ref.title,
      value = _ref.value,
      handler = _ref.handler,
      _ref$floor = _ref.floor,
      floor = _ref$floor === void 0 ? 0 : _ref$floor,
      _ref$ceil = _ref.ceil,
      ceil = _ref$ceil === void 0 ? 99 : _ref$ceil,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 38 : _ref$size;
  //    const handleDog = useCallback( (fn) => handleState('dog_count', fn()), []);
  var increaseFunction = useCallback$1(function () {
    handler(function (s) {
      if (ceil != undefined && ceil <= s) {
        return s;
      }

      return s + 1;
    });
  }, [handler]);
  var decreaseFunction = useCallback$1(function () {
    handler(function (s) {
      if (floor != undefined && s <= floor) {
        return s;
      }

      return s - 1;
    });
  }, [handler]);
  return /*#__PURE__*/React.createElement(CounterStyle$2, null, /*#__PURE__*/React.createElement(CounterTitle$1, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'b1_r'
  }, title)), /*#__PURE__*/React.createElement(CounterMain$2, null, /*#__PURE__*/React.createElement(HandleButton$2, {
    onClick: decreaseFunction,
    size: size
  }, value > floor ? /*#__PURE__*/React.createElement(SvgIcMinusSmallS16, null) : /*#__PURE__*/React.createElement(SvgIcMinusSmallB20S16V01, null)), /*#__PURE__*/React.createElement(Value$2, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 't2_b'
  }, value)), /*#__PURE__*/React.createElement(HandleButton$2, {
    onClick: increaseFunction,
    size: size
  }, value < ceil ? /*#__PURE__*/React.createElement(SvgIcPlusSmallS16, null) : /*#__PURE__*/React.createElement(SvgIcPlusSmallB20S16V01, null))));
};
var CounterStyle$2 = styled.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])));
var HandleButton$2 = styled.div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral(["\n    width: ", "px;\n    height:  ", "px;\n    border-radius: 50%;\n    background-color: ", ";\n    align-items: center;\n    justify-content: center;\n    display: flex;\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, BackGroundColor['B05']);
var CounterMain$2 = styled.div(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));
var CounterTitle$1 = styled.div(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral(["\n    margin-right: auto;\n"])));
var Value$2 = styled.section(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteral(["\n    width: 25px;\n    text-align: center;\n    margin: 0 6px; \n"])));

var _templateObject$S, _templateObject2$D, _templateObject3$s, _templateObject4$l, _templateObject5$g, _templateObject6$d, _templateObject7$7, _templateObject8$3, _templateObject9$2;
var CounterCommerce = function CounterCommerce(_ref) {
  var title = _ref.title,
      price = _ref.price,
      originalPrice = _ref.originalPrice,
      value = _ref.value,
      handler = _ref.handler,
      _ref$floor = _ref.floor,
      floor = _ref$floor === void 0 ? 0 : _ref$floor,
      _ref$ceil = _ref.ceil,
      ceil = _ref$ceil === void 0 ? 99 : _ref$ceil,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 38 : _ref$size;
  var increaseFunction = useCallback$1(function () {
    handler(function (s) {
      if (ceil != undefined && ceil <= s) {
        return s;
      }

      return s + 1;
    });
  }, [handler]);
  var decreaseFunction = useCallback$1(function () {
    handler(function (s) {
      if (floor != undefined && s <= floor) {
        return s;
      }

      return s - 1;
    });
  }, [handler]);
  return /*#__PURE__*/React.createElement(CounterStyle$1, null, /*#__PURE__*/React.createElement(CounterTitle, null, /*#__PURE__*/React.createElement(Title$5, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'b1_sb'
  }, title)), /*#__PURE__*/React.createElement(PriceContainer, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'b4_r'
  }, /*#__PURE__*/React.createElement(Price, null, price.toLocaleString('en'), "\uC6D0")), originalPrice && /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'b4_r'
  }, /*#__PURE__*/React.createElement(OriginalPrice, null, originalPrice.toLocaleString('en'), "\uC6D0")))), /*#__PURE__*/React.createElement(CounterMain$1, null, /*#__PURE__*/React.createElement(HandleButton$1, {
    onClick: decreaseFunction,
    size: size
  }, value > floor ? /*#__PURE__*/React.createElement(SvgIcMinusSmallS16, null) : /*#__PURE__*/React.createElement(SvgIcMinusSmallB20S16V01, null)), /*#__PURE__*/React.createElement(Value$1, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 't3_b'
  }, value)), /*#__PURE__*/React.createElement(HandleButton$1, {
    onClick: increaseFunction,
    size: size
  }, value < ceil ? /*#__PURE__*/React.createElement(SvgIcPlusSmallS16, null) : /*#__PURE__*/React.createElement(SvgIcPlusSmallB20S16V01, null))));
};
var CounterStyle$1 = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral(["\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])));
var HandleButton$1 = styled.div(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral(["\n    width: ", "px;\n    height:  ", "px;\n    border-radius: 50%;\n    background-color: ", ";\n    align-items: center;\n    justify-content: center;\n    display: flex;\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, BackGroundColor['B05']);
var CounterMain$1 = styled.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n"])));
var CounterTitle = styled.div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral(["\n    margin-right: auto;\n    \n"])));
var Value$1 = styled.section(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral(["\n    width: 25px;\n    text-align: center;\n    margin: 0 9px; \n"])));
var Title$5 = styled.div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteral(["\n    color: rgba(0,0,0,0.85);\n    margin-bottom: 4px;\n"])));
var Price = styled.div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), TextColor.B60);
var OriginalPrice = styled.div(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral(["\n    text-decoration-line: line-through;\n    color: ", ";\n"])), TextColor.B30);
var PriceContainer = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    width: 100%;\n"])));

var _templateObject$R, _templateObject2$C, _templateObject3$r, _templateObject4$k, _templateObject5$f;
var CounterWithNoTitle = function CounterWithNoTitle(_ref) {
  var value = _ref.value,
      handler = _ref.handler,
      _ref$floor = _ref.floor,
      floor = _ref$floor === void 0 ? 0 : _ref$floor,
      _ref$ceil = _ref.ceil,
      ceil = _ref$ceil === void 0 ? 99 : _ref$ceil,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 38 : _ref$size,
      _ref$callback = _ref.callback,
      callback = _ref$callback === void 0 ? function () {} : _ref$callback;
  var increaseFunction = useCallback$1(function () {
    handler(function (s) {
      if (ceil != undefined && ceil <= s) {
        return s;
      }

      return s + 1;
    });
    callback();
  }, [handler, callback]);
  var decreaseFunction = useCallback$1(function () {
    handler(function (s) {
      if (floor != undefined && s <= floor) {
        return s;
      }

      return s - 1;
    });
    callback();
  }, [handler, callback]);
  return /*#__PURE__*/React.createElement(CounterStyle, null, /*#__PURE__*/React.createElement(CounterMain, null, /*#__PURE__*/React.createElement(HandleButton, {
    onClick: decreaseFunction,
    size: size
  }, value > floor ? /*#__PURE__*/React.createElement(SvgIcMinusSmallS16, null) : /*#__PURE__*/React.createElement(SvgIcMinusSmallB20S16V01, null)), /*#__PURE__*/React.createElement(Value, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 't3_b'
  }, value)), /*#__PURE__*/React.createElement(HandleButton, {
    onClick: increaseFunction,
    size: size
  }, value < ceil ? /*#__PURE__*/React.createElement(SvgIcPlusSmallS16, null) : /*#__PURE__*/React.createElement(SvgIcPlusSmallB20S16V01, null))));
};
var CounterStyle = styled.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral(["\n  width: 100%;\n  align-items: center;\n  display: flex;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n"])));
var HandleButton = styled.div(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  background-color: ", ";\n  align-items: center;\n  justify-content: center;\n  display: flex;\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, BackGroundColor['B05']);
var CounterMain = styled.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
styled.div(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral(["\n  margin-right: auto;\n"])));
var Value = styled.section(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral(["\n  width: 36px;\n  text-align: center;\n  margin: 0 6px;\n"])));

function useBeforeunload() {
  var beforeunloadEvent = useCallback$1(function (e) {
    e.returnValue = '';
    return;
  }, []);
  return [beforeunloadEvent];
}

var _templateObject$Q;

function DropDownWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Block$v, null, children);
}

var Block$v = styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.3);\n    display: flex;\n    flex-direction: column;\n    ", " {\n        width: 415px;\n    }\n"])), media.medium);

var _templateObject$P, _templateObject2$B, _templateObject3$q;

function DropDownContentWrapper(_ref) {
  var children = _ref.children,
      visible = _ref.visible;
  return /*#__PURE__*/React.createElement(Block$u, {
    visible: visible
  }, children);
}

var Block$u = styled.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: ", ";\n  ", "\n"])), BackGroundColor.W100, function (props) {
  return props.visible ? css(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral(["\n          animation: ", " 0.2s forwards ease-in-out;\n        "])), transitions.foldIn) : css(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral(["\n          animation: ", " 0.25s forwards ease-in-out;\n        "])), transitions.foldOut);
});

var useState$8 = React.useState,
    useEffect$9 = React.useEffect,
    memo$9 = React.memo;

function DropDown(_ref) {
  var children = _ref.children,
      visible = _ref.visible;

  var _useState = useState$8(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var _useBeforeunload = useBeforeunload(),
      _useBeforeunload2 = _slicedToArray(_useBeforeunload, 1),
      beforeunloadEvent = _useBeforeunload2[0];

  useEffect$9(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 250);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible]);
  useEffect$9(function () {
    if (closed) {
      window.removeEventListener('beforeunload', beforeunloadEvent);
      return;
    }

    window.addEventListener('beforeunload', beforeunloadEvent);
    return function () {
      window.removeEventListener('beforeunload', beforeunloadEvent);
    };
  }, [closed]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(OpaqueLayer, {
    visible: visible
  }, /*#__PURE__*/React.createElement(DropDownWrapper, null, /*#__PURE__*/React.createElement(DropDownContentWrapper, {
    visible: visible
  }, children)));
}

var DropDown$1 = memo$9(DropDown);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _templateObject$O;

var _excluded$1 = ["children", "align", "borderRadius", "padding", "required"];

var GrayBox = function GrayBox(_ref) {
  var children = _ref.children,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align,
      _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? '10px' : _ref$borderRadius,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? '2% 4%' : _ref$padding,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(Block$t, Object.assign({}, props, {
    align: align,
    borderRadius: borderRadius,
    padding: padding,
    required: required
  }), children);
};

var Block$t = styled.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: ", ";\n  border-radius:", ";\n  text-align: ", ";\n  ", "  \n"])), BackGroundColor["B03"], function (props) {
  return props.padding;
}, function (props) {
  return props.borderRadius;
}, function (props) {
  return props.align;
}, function (props) {
  return props.required && 'border: 2px solid #FF5151;';
});

var _templateObject$N, _templateObject2$A, _templateObject3$p, _templateObject4$j, _templateObject5$e, _templateObject6$c, _templateObject7$6;
var Input = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var placeHolder = _ref.placeHolder,
      validationString = _ref.validationString,
      onChange = _ref.onChange,
      value = _ref.value,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 45 : _ref$height,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      width = _ref.width,
      type = _ref.type,
      inputMode = _ref.inputMode,
      fontFamily = _ref.fontFamily,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? TextColor['B85'] : _ref$color,
      _ref$searchIcon = _ref.searchIcon,
      searchIcon = _ref$searchIcon === void 0 ? false : _ref$searchIcon,
      onKeyPress = _ref.onKeyPress;
  return /*#__PURE__*/React.createElement(Wrapper$1, {
    width: width
  }, /*#__PURE__*/React.createElement(Flex, {
    searchIcon: searchIcon
  }, /*#__PURE__*/React.createElement(InputStyle, {
    placeholder: placeHolder,
    onChange: onChange,
    onKeyPress: onKeyPress,
    value: value,
    ref: ref,
    fontFamily: fontFamily,
    color: color,
    height: height,
    readOnly: readOnly,
    invalid: invalid,
    type: type,
    inputMode: inputMode
  }), searchIcon && /*#__PURE__*/React.createElement(SearchIconWrapper$1, null, /*#__PURE__*/React.createElement(SvgIcSearchS16, null))), validationString && /*#__PURE__*/React.createElement(ValidMargin, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'b4_r',
    color: BrandColor['RED']
  }, validationString)));
});
var InputStyle = styled.input(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral(["\n    width: 100%;\n    height: ", "px;\n    flex: 1;\n    padding: 3px 15px;\n    margin: 0;\n    background: ", ";\n    border-radius: 8px;\n    font-size: 17px;\n    font-weight: 400;\n    border: ", ";\n    outline: none;\n    font-family: ", ";\n    color: ", ";\n    -webkit-box-shadow: none;\n    -moz-box-shadow: none;\n    box-shadow: none;\n    line-height: 1.4;\n    caret-color: ", ";\n"])), function (props) {
  return props.height;
}, BackGroundColor['B03'], function (props) {
  return props.invalid ? '1px solid #FF5151' : 'none';
}, function (props) {
  return props.fontFamily ? props.fontFamily : 'system-ui';
}, function (props) {
  return props.color;
}, BrandColor['BU']);
var ValidMargin = styled.div(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral(["\n    margin: 8px 0 0 0;\n"])));
var Flex = styled.div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral(["\n    display: flex;\n    ", "\n"])), function (props) {
  if (props.searchIcon) return css(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral(["\n                position: relative;\n                justify-content: space-between;\n                align-items: center;\n            "])));
});
var Wrapper$1 = styled.div(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral(["\n    ", "\n"])), function (props) {
  if (props.width) return css(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteral(["\n                width: ", ";\n            "])), props.width);
});
var SearchIconWrapper$1 = styled.div(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 16px;\n  height: 16px;\n  margin-right: 16px;\n  right:0;\n"])));

var _templateObject$M, _templateObject2$z;
var useCallback = React.useCallback;

function LifelabCalendarHeader(props) {
  var colorSelector = useCallback(function (yoil) {
    return yoil === '일' ? BrandColor.RED : TextColor.B60;
  }, []);
  return /*#__PURE__*/React.createElement(Block$s, null, ['일', '월', '화', '수', '목', '금', '토'].map(function (v) {
    return /*#__PURE__*/React.createElement(YoilBlock, {
      key: v
    }, /*#__PURE__*/React.createElement(TypeRule, {
      variant: "b3_r",
      color: colorSelector(v)
    }, v));
  }));
}

var Block$s = styled.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral(["\n    /* position: sticky;\n    position: -webkit-sticky;\n    top: 0;\n    left: 0; */\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: center;\n    box-sizing: border-box;\n    padding: 0 0.5rem;\n    margin-top: 1rem;\n    border-bottom: 1px solid ", ";\n"])), TextColor.B10);
var YoilBlock = styled.div(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral(["\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1rem 0;\n"])));

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function createDateFormat(_ref) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  return "".concat(year, "-").concat(month, "-").concat(day);
}
function getYoil(date) {
  return date.getDay();
}
function fillZero(value) {
  return value < 10 ? "0".concat(value) : "".concat(value);
}
function getUniqueDates(dates) {
  var result = new Set();

  for (var i = 0; i < dates.length; i++) {
    var splitDate = dates[i].split(' ')[0];

    if (!result.has(splitDate)) {
      result.add(splitDate);
    }
  }

  return result;
}
function getToday() {
  var day = new Date();
  var year = day.getFullYear();
  var month = fillZero(day.getMonth() + 1);
  var date = fillZero(day.getDate());
  return "".concat(year, "-").concat(month, "-").concat(date);
}
function processMonth(date) {
  var year = date.getFullYear();
  var month = date.getMonth();
  return {
    thisYear: year,
    thisMonth: month + 1,
    thisMonthLastDate: new Date(year, month + 1, 0)
  };
}

function createResultFullDates(startIndex, fullDates) {
  if (!startIndex) return fullDates;
  var fakeObj = {
    day: '',
    formatDate: '',
    today: false,
    available: false,
    color: ''
  };
  var fakeArray = Array.from({
    length: startIndex
  }).map(function (_, i) {
    return _objectSpread2(_objectSpread2({}, fakeObj), {}, {
      formatDate: "fake_".concat(i)
    });
  });
  var fullDatesResult = fullDates !== null && fullDates !== void 0 ? fullDates : [];
  return [].concat(_toConsumableArray(fakeArray), _toConsumableArray(fullDatesResult));
}

function osDateParser(date) {
  return date.length === 16 ? "".concat(date, ":00").replace(/-/g, '/') : "".concat(date.replace(/-/g, '/'));
}

function parseDates(dates) {
  var firstMonthResult = {
    startIndex: 0,
    yearMonth: '',
    fullDates: null
  };
  var secondMonthResult = {
    startIndex: 0,
    yearMonth: '',
    fullDates: []
  };
  var firstFullDate = [];
  var secondFullDate = null;
  var today = getToday();
  var uniqueDates = getUniqueDates(dates);
  var startDate = dates.length ? osDateParser(dates[0]) : today;
  var endDate = dates.length ? osDateParser(dates[dates.length - 1]) : today;
  var convertStartDate = new Date(startDate);
  var convertEndDate = new Date(endDate);

  var _processMonth = processMonth(convertStartDate),
      thisYear = _processMonth.thisYear,
      thisMonth = _processMonth.thisMonth,
      thisMonthLastDate = _processMonth.thisMonthLastDate;

  var thisMonthFormat = fillZero(thisMonth);
  var endMonthFormat = null;

  var _processMonth2 = processMonth(convertEndDate),
      endYear = _processMonth2.thisYear,
      endMonth = _processMonth2.thisMonth,
      endMonthLastDate = _processMonth2.thisMonthLastDate;

  for (var i = 1; i <= thisMonthLastDate.getDate(); i++) {
    var day = fillZero(i);
    var formatDate = createDateFormat({
      year: thisYear,
      month: thisMonthFormat,
      day: day
    });
    var dateObj = new Date(formatDate);
    var yoil = getYoil(dateObj);

    if (i === 1) {
      firstMonthResult.startIndex = yoil;
      firstMonthResult.yearMonth = "".concat(thisYear, ".").concat(thisMonth);
    }

    var available = uniqueDates.has(formatDate);
    var sunday = yoil === 0;
    var color = '';

    if (available) {
      if (sunday) {
        color = BrandColor.RED;
      }

      if (!sunday) {
        color = TextColor.B85;
      }
    }

    if (!available) {
      if (sunday) {
        color = 'rgba(255, 81, 81, 0.2)';
      }

      if (!sunday) {
        color = TextColor.B20;
      }
    }

    firstFullDate.push({
      day: "".concat(i),
      formatDate: formatDate,
      today: today === formatDate,
      available: available,
      color: color
    });
  } // 두번째 달이 필요할 경우


  if ("".concat(thisYear, "-").concat(thisMonth) !== "".concat(endYear, "-").concat(endMonth)) {
    secondFullDate = [];
    endMonthFormat = fillZero(endMonth);

    for (var _i = 1; _i <= endMonthLastDate.getDate(); _i++) {
      var _day = fillZero(_i);

      var _formatDate = createDateFormat({
        year: endYear,
        month: endMonthFormat,
        day: _day
      });

      var _dateObj = new Date(_formatDate);

      var _yoil = getYoil(_dateObj);

      if (_i === 1) {
        secondMonthResult.startIndex = _yoil;
        secondMonthResult.yearMonth = "".concat(endYear, ".").concat(endMonth);
      }

      var _available = uniqueDates.has(_formatDate);

      var _sunday = _yoil === 0;

      var _color = '';

      if (_available) {
        if (_sunday) {
          _color = BrandColor.RED;
        }

        if (!_sunday) {
          _color = TextColor.B85;
        }
      }

      if (!_available) {
        if (_sunday) {
          _color = 'rgba(255, 81, 81, 0.2)';
        }

        if (!_sunday) {
          _color = TextColor.B20;
        }
      }

      secondFullDate.push({
        day: "".concat(_i),
        formatDate: _formatDate,
        today: today === _formatDate,
        available: _available,
        color: _color
      });
    }
  }

  firstMonthResult.fullDates = createResultFullDates(firstMonthResult.startIndex, firstFullDate);
  secondMonthResult.fullDates = createResultFullDates(secondMonthResult.startIndex, secondFullDate);
  return {
    firstMonthResult: firstMonthResult,
    secondMonthResult: secondMonthResult
  };
}

var _templateObject$L, _templateObject2$y, _templateObject3$o, _templateObject4$i, _templateObject5$d, _templateObject6$b, _templateObject7$5;
var memo$8 = React.memo;

function LifelabCalendarContent(_ref) {
  var _dates$fullDates;

  var dates = _ref.dates,
      selectDate = _ref.selectDate,
      _ref$previewScheduleD = _ref.previewScheduleDates,
      previewScheduleDates = _ref$previewScheduleD === void 0 ? [] : _ref$previewScheduleD,
      onSelectDate = _ref.onSelectDate;
  return /*#__PURE__*/React.createElement(Block$r, null, /*#__PURE__*/React.createElement(TitleArea, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "h5_b"
  }, dates.yearMonth)), /*#__PURE__*/React.createElement(GridBlock, null, (_dates$fullDates = dates.fullDates) === null || _dates$fullDates === void 0 ? void 0 : _dates$fullDates.map(function (v) {
    return /*#__PURE__*/React.createElement(Item, {
      key: v.formatDate,
      value: v.formatDate,
      available: v.available,
      selected: selectDate === v.formatDate,
      onClick: !v.available || v.today ? undefined : onSelectDate
    }, /*#__PURE__*/React.createElement(DayWrapper, {
      color: v.color,
      selected: selectDate === v.formatDate
    }, /*#__PURE__*/React.createElement("p", {
      className: "day"
    }, v.day), v.today && /*#__PURE__*/React.createElement(Today, null, "\uC624\uB298"), previewScheduleDates && previewScheduleDates.includes(v.formatDate) && /*#__PURE__*/React.createElement(RegularPointYoil, {
      isSelected: v.formatDate === selectDate
    })));
  })));
}

var Block$r = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 24px 0 16px 0;\n"])));
var GridBlock = styled.div(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral(["\n    width: calc(100% - 1rem);\n    display: grid;\n    grid-auto-rows: 3.125rem;\n    grid-template-columns: repeat(7, 1fr);\n"])));
var TitleArea = styled.div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral(["\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    h5 {\n        padding-left: 24px;\n        margin: 0;\n    }\n"])));
var Item = styled.button(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral(["\n    border: none;\n    outline: none;\n    background: none;\n    margin: 0;\n    padding: 0;\n    font-size: 20px;\n    font-weight: bold;\n    cursor: ", ";\n"])), function (props) {
  return props.available ? 'pointer' : 'not-allowed';
});
var DayWrapper = styled.div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral(["\n    flex: 1;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    .day {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 43px;\n        height: 43px;\n        border-radius: 100%;\n        font-size: 16px;\n        line-height: 1.4;\n        font-weight: 700;\n        background: ", ";\n        color: ", ";\n    }\n"])), function (props) {
  return props.selected ? BrandColor.BU : BackGroundColor.W100;
}, function (props) {
  return props.selected ? BackGroundColor.W100 : props.color;
});
var Today = styled.p(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: -20%;\n    width: 100%;\n    font-size: 0.6875rem;\n    color: ", ";\n    z-index: ", ";\n"])), TextColor.B60, zIndexes.calendarToday);
var RegularPointYoil = styled.div(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral(["\n    position: absolute;\n    bottom: ", ";\n    width: 6px;\n    height: 6px;\n    background: ", ";\n    border-radius: 100%;\n    z-index: ", ";\n"])), function (props) {
  return props.isSelected ? '-25%' : '-13.5%';
}, BrandColor.BU, zIndexes.calendarDot);
var LifelabCalendarContent$1 = memo$8(LifelabCalendarContent);

var _templateObject$K;

function LifelabCalendarBody(_ref) {
  var availableDates = _ref.availableDates,
      previewScheduleDates = _ref.previewScheduleDates,
      selectDate = _ref.selectDate,
      onSelectDate = _ref.onSelectDate;

  var _parseDates = parseDates(availableDates),
      firstMonthResult = _parseDates.firstMonthResult,
      secondMonthResult = _parseDates.secondMonthResult;

  return /*#__PURE__*/React.createElement(Block$q, null, /*#__PURE__*/React.createElement(LifelabCalendarContent$1, {
    dates: firstMonthResult,
    previewScheduleDates: previewScheduleDates,
    selectDate: selectDate,
    onSelectDate: onSelectDate
  }), secondMonthResult && /*#__PURE__*/React.createElement(LifelabCalendarContent$1, {
    dates: secondMonthResult,
    previewScheduleDates: previewScheduleDates,
    selectDate: selectDate,
    onSelectDate: onSelectDate
  }));
}

var Block$q = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n"])));

var _templateObject$J;

function LifelabCalendar(_ref) {
  var availableDates = _ref.availableDates,
      previewScheduleDates = _ref.previewScheduleDates,
      _ref$selectDate = _ref.selectDate,
      selectDate = _ref$selectDate === void 0 ? '' : _ref$selectDate,
      onSelectDate = _ref.onSelectDate;
  return /*#__PURE__*/React.createElement(Block$p, null, /*#__PURE__*/React.createElement(LifelabCalendarHeader, null), /*#__PURE__*/React.createElement(LifelabCalendarBody, {
    availableDates: availableDates,
    previewScheduleDates: previewScheduleDates,
    selectDate: selectDate,
    onSelectDate: onSelectDate
  }));
}

var Block$p = styled.div(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral(["\n    position: relative;\n    max-width: 414px;\n    display: flex;\n    flex-direction: column;\n    overflow: auto;\n    background: ", ";\n"])), BackGroundColor.W100);

var _templateObject$I, _templateObject2$x, _templateObject3$n, _templateObject4$h, _templateObject5$c, _templateObject6$a;
var LinedInput = function LinedInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onCancelClick = _ref.onCancelClick,
      _ref$searchIcon = _ref.searchIcon,
      searchIcon = _ref$searchIcon === void 0 ? false : _ref$searchIcon,
      placeholder = _ref.placeholder,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
      fontFamily = _ref.fontFamily;

  var _useState = useState$a(false),
      _useState2 = _slicedToArray(_useState, 2),
      focusedYn = _useState2[0],
      setFocusedYn = _useState2[1];

  var handleFocus = function handleFocus() {
    setFocusedYn(true);
  };

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(InputWrapper, {
    focused: focusedYn,
    value: value,
    errorMessage: errorMessage
  }, searchIcon && /*#__PURE__*/React.createElement(SearchIconWrapper, null, /*#__PURE__*/React.createElement(SvgIcSearchS16, null)), /*#__PURE__*/React.createElement(InputBox, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    fontFamily: fontFamily,
    onFocus: handleFocus
  }), (value != '' || focusedYn) && /*#__PURE__*/React.createElement(CancelButton, {
    onClick: onCancelClick
  }, /*#__PURE__*/React.createElement(SvgIcCancelS16, null))), errorMessage != '' && /*#__PURE__*/React.createElement(ErrorText, null, errorMessage));
};
var Wrapper = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
var InputWrapper = styled.div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-width: 312px;\n  height: 52px;\n  ", "\n  padding-right: 16px; \n"])), function (props) {
  if (props.errorMessage != '') {
    return "border-bottom: 2px solid ".concat(BrandColor.RED, ";");
  } else {
    if (props.value != '' || props.focused) {
      return "border-bottom: 2px solid ".concat(BrandColor.BU, ";");
    } else {
      return "border-bottom: 2px solid ".concat(TextColor.B20, ";");
    }
  }
});
var SearchIconWrapper = styled.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  margin-right: 12px;\n"])));
var InputBox = styled.input(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral(["\n  -webkit-appearance : none;\n  -moz-appearance:none;\n  appearance:none;\n  outline: none;\n  padding: 0;\n  width: 100%;\n  height: 24px;\n  caret-color: ", ";\n  margin-right: 12px;\n  border: none;\n  font-size: 17px;\n  color: ", ";\n  font-family: ", ";\n  font-weight: 400;\n  line-height: 24px;\n    \n  ::placeholder {\n    color: ", "\n  }\n\n  :focus{\n    outline: none;\n  }\n"])), BrandColor.BU, TextColor.B85, function (props) {
  return props.fontFamily ? props.fontFamily : 'system-ui';
}, TextColor.B40);
var CancelButton = styled.div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n"])));
var ErrorText = styled.span(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral(["\n  margin-top: 8px;\n  color: ", ";\n  font-size: 14px;\n  line-height: 17px;\n"])), BrandColor.RED);

var _templateObject$H;

function LoadingIcon(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#01BED6' : _ref$fill;
  return /*#__PURE__*/React__default.createElement(RotateSvg, {
    width: "50",
    height: "50",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12H17C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7V4Z",
    fill: fill
  }));
}

var RotateSvg = styled.svg(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral(["\n    animation: ", " 1.25s ease-in-out infinite;\n"])), transitions.rotation);

var _templateObject$G;

function Loading(props) {
  if (!props.visible) return null;
  return /*#__PURE__*/React__default.createElement(OpaqueLayer, {
    visible: props.visible
  }, /*#__PURE__*/React__default.createElement(Block$o, null, /*#__PURE__*/React__default.createElement(LoadingIcon, null)));
}

var Block$o = styled.div(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 12;\n    background: white;\n    border-radius: 100%;\n"])));

var _templateObject$F, _templateObject2$w, _templateObject3$m, _templateObject4$g;
var ManagerProfile = function ManagerProfile(_ref) {
  var imgUrl = _ref.imgUrl,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'type2' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'S66' : _ref$size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(React.Fragment, null, imgUrl ? {
    S66: _defineProperty({
      disabled: /*#__PURE__*/React.createElement(Img66, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%402x.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%403x.png 3x",
        alt: 'manager_profile'
      })
    }, type, /*#__PURE__*/React.createElement(ManagerProfile66, null, /*#__PURE__*/React.createElement(Img66, {
      src: imgUrl,
      alt: 'manager_profile'
    })))[type],
    S84: _defineProperty({
      disabled: /*#__PURE__*/React.createElement(Img84, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%402x.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%403x.png 3x",
        alt: 'manager_profile'
      })
    }, type, /*#__PURE__*/React.createElement(ManagerProfile84, null, /*#__PURE__*/React.createElement(Img84, {
      src: imgUrl,
      alt: 'manager_profile'
    })))[type]
  }[size] : {
    S66: {
      disabled: /*#__PURE__*/React.createElement(ManagerProfile66, null, /*#__PURE__*/React.createElement(Img66, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%402x.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%403x.png 3x",
        alt: 'manager_profile'
      })),
      type1: /*#__PURE__*/React.createElement(ManagerProfile66, null, /*#__PURE__*/React.createElement(Img66, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66-1.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%402x-1.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%403x-1.png 3x",
        alt: 'manager_profile'
      })),
      type2: /*#__PURE__*/React.createElement(ManagerProfile66, null, /*#__PURE__*/React.createElement(Img66, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66-2.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%402x-2.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%403x-2.png 3x",
        alt: 'manager_profile'
      })),
      type3: /*#__PURE__*/React.createElement(ManagerProfile66, null, /*#__PURE__*/React.createElement(Img66, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66-3.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%402x-3.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S66%403x-3.png 3x",
        alt: 'manager_profile'
      }))
    }[type],
    S84: {
      disabled: /*#__PURE__*/React.createElement(ManagerProfile84, null, /*#__PURE__*/React.createElement(Img84, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%402x.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%403x.png 3x",
        alt: 'manager_profile'
      })),
      type1: /*#__PURE__*/React.createElement(ManagerProfile84, null, /*#__PURE__*/React.createElement(Img84, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84-1.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%402x-1.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%403x-1.png 3x",
        alt: 'manager_profile'
      })),
      type2: /*#__PURE__*/React.createElement(ManagerProfile84, null, /*#__PURE__*/React.createElement(Img84, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84-2.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%402x-2.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%403x-2.png 3x",
        alt: 'manager_profile'
      })),
      type3: /*#__PURE__*/React.createElement(ManagerProfile84, null, /*#__PURE__*/React.createElement(Img84, {
        src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84-3.png',
        srcSet: "https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%402x-3.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/Manager_Profile_S84%403x-3.png 3x",
        alt: 'manager_profile'
      }))
    }[type]
  }[size]));
};
var Img66 = styled.img(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral(["\n    width: 66px;\n    height: 66px;\n    border-radius: 50%;\n    vertical-align: middle;\n"])));
var Img84 = styled.img(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral(["\n    width: 84px;\n    height: 84px;\n    border-radius: 50%;\n    vertical-align: middle;\n"])));
var ManagerProfile66 = styled.div(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral(["\n    display: inline-block;\n    width: 66px;\n    height: 66px;\n    border-radius: 50%;\n    vertical-align: middle;\n"])));
var ManagerProfile84 = styled.div(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral(["\n    display: inline-block;\n    width: 84px;\n    height: 84px;\n    border-radius: 50%;\n    vertical-align: middle;\n"])));

var _templateObject$E, _templateObject2$v, _templateObject3$l, _templateObject4$f, _templateObject5$b, _templateObject6$9;
var OptionSelect = function OptionSelect(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/React.createElement(OptionSelectStyle, null, options.map(function (e, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: "option_select".concat(i)
    }, e.run_yn ? /*#__PURE__*/React.createElement(Enabled, null, /*#__PURE__*/React.createElement(OptionItem, null, /*#__PURE__*/React.createElement("img", {
      src: e.icon_url,
      style: {
        width: '26px',
        height: '26px',
        marginRight: '10px'
      }
    }), /*#__PURE__*/React.createElement(TypeRule, {
      variant: 't3_sb'
    }, e.title), /*#__PURE__*/React.createElement(AlignRight, null, /*#__PURE__*/React.createElement(SvgIcCheckS24, {
      width: 16,
      height: 16,
      viewBox: '0 0 24 24'
    }))), e.guide && /*#__PURE__*/React.createElement(Guide, null, /*#__PURE__*/React.createElement(WordWrapper, {
      text: e.guide
    }))) : /*#__PURE__*/React.createElement(Disabled, null, /*#__PURE__*/React.createElement(OptionItem, null, /*#__PURE__*/React.createElement("img", {
      src: e.icon_url,
      style: {
        width: '26px',
        height: '26px',
        marginRight: '10px',
        filter: 'opacity(0.4)'
      }
    }), /*#__PURE__*/React.createElement(TypeRule, {
      variant: 't3_r',
      color: TextColor['B20']
    }, e.title))));
  }));
};
var OptionSelectStyle = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral(["\n    padding: 12px 24px;\n    border: ", " 1px solid;\n    border-radius: 10px;\n    background-color: ", ";\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])), BackGroundColor['B04'], BackGroundColor['W100']);
var Guide = styled.div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral(["\n    margin-top: 12px;\n    margin-left: 5px;\n"])));
var AlignRight = styled.div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral(["\n    margin-left: auto;\n"])));
var OptionItem = styled.div(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    margin: 16px 0;\n"])));
var Enabled = styled.div(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral([""])));
var Disabled = styled.div(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral([""])));

var _templateObject$D, _templateObject2$u;

function Paragraph(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/React.createElement(Block$n, {
    styles: styles
  });
}

var Block$n = styled.div(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral(["\n    display: block;\n    background: ", ";\n    animation: ", " 1s ease-in-out infinite;\n    ", ";\n"])), palette.gray1, transitions.shining, function (props) {
  return props.styles && css(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral(["\n            ", ";\n        "])), props.styles);
});

var _templateObject$C, _templateObject2$t, _templateObject3$k;
var memo$7 = React.memo;

function PopupBase(_ref) {
  var children = _ref.children,
      visible = _ref.visible;

  var _useState = useState$a(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  useEffect$b(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 250);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(OpaqueLayer, {
    visible: visible
  }, /*#__PURE__*/React.createElement(Block$m, {
    visible: visible
  }, children));
}

var Block$m = styled.div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral(["\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    background: ", ";\n    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1), 0px 2px 20px rgba(0, 0, 0, 0.05);\n    border-radius: 0.625rem;\n    ", ";\n"])), BackGroundColor.W100, function (props) {
  return props.visible ? css(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popInFromBottom) : css(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popOutToBottom);
});
var PopupBase$1 = memo$7(PopupBase);

var _templateObject$B;

function PopupWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Block$l, null, children);
}

var Block$l = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 19.5rem;\n"])));

var _templateObject$A;

function PopupTitleAndMessageWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Block$k, null, children);
}

var Block$k = styled.div(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 2.5rem;\n"])));

var _templateObject$z, _templateObject2$s;

function PopupNote(_ref) {
  var note = _ref.note;
  return /*#__PURE__*/React.createElement(Block$j, null, /*#__PURE__*/React.createElement(SvgIcBulluet01S16, null), /*#__PURE__*/React.createElement(NoteWrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "html-section",
    dangerouslySetInnerHTML: {
      __html: note
    }
  })));
}

var Block$j = styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  padding: 0 1.875rem 1.75rem 1.75rem;\n"])));
var NoteWrapper = styled.div(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  margin-left: 0.25rem;\n  .html-section {\n    width: 14.5625rem;\n    display: flex;\n    flex-flow: row wrap;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.2;\n    font-size: 0.9375rem;\n  }\n"])));

var _templateObject$y, _templateObject2$r, _templateObject3$j;
var useEffect$8 = React.useEffect;

function PopupCheck(_ref) {
  var check = _ref.check;
  var checkText = check.checkText,
      checked = check.checked,
      handleCheck = check.handleCheck,
      checkColor = check.checkColor;
  useEffect$8(function () {
    return function () {
      if (!check) return;
      if (!check.checked) return;
      handleCheck();
    };
  }, []);
  return /*#__PURE__*/React.createElement(Block$i, null, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(IconWrapper$3, null, checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledCheckedS28, {
    onClick: handleCheck,
    fill: checkColor
  }) : /*#__PURE__*/React.createElement(SvgCycleEnabledUnselectedFilledS28, {
    onClick: handleCheck
  })), /*#__PURE__*/React.createElement(TypeRule, {
    variant: "b1_r"
  }, checkText)));
}

var Block$i = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral(["\n  padding: 0 1.875rem 1.75rem 1.75rem;\n"])));
var Content = styled.div(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var IconWrapper$3 = styled.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral(["\n  margin-right: 0.5rem;\n  &:hover {\n    cursor: pointer;\n  }\n"])));

var _templateObject$x, _templateObject2$q, _templateObject3$i, _templateObject4$e;
var useMemo$2 = React.useMemo,
    memo$6 = React.memo;

function PopupCommon(_ref) {
  var title = _ref.title,
      message = _ref.message,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? '확인' : _ref$buttonText,
      visible = _ref.visible,
      onClick = _ref.onClick,
      note = _ref.note,
      check = _ref.check,
      _ref$messageType = _ref.messageType,
      messageType = _ref$messageType === void 0 ? 'common' : _ref$messageType;
  var messageStyle = useMemo$2(function () {
    var variant = 't2_r';
    var color = TextColor.B85;

    if (messageType === 'check') {
      variant = 'b1_r';
    }

    return {
      variant: variant,
      color: color
    };
  }, [messageType]);
  return /*#__PURE__*/React.createElement(PopupBase$1, {
    visible: visible
  }, /*#__PURE__*/React.createElement(PopupWrapper, null, /*#__PURE__*/React.createElement(PopupTitleAndMessageWrapper, null, title && /*#__PURE__*/React.createElement(Title$4, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "h5_b",
    color: TextColor.B85
  }, title)), /*#__PURE__*/React.createElement(Message$3, {
    title: title
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: messageStyle.variant,
    color: TextColor.B85
  }, message))), note && /*#__PURE__*/React.createElement(PopupNote, {
    note: note
  }), check && /*#__PURE__*/React.createElement(PopupCheck, {
    check: check
  }), /*#__PURE__*/React.createElement(ConfirmButton, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_sb",
    color: BrandColor.BU
  }, buttonText))));
}

var ConfirmButton = styled.button(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral(["\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    width: 100%;\n    height: 3.9375rem;\n    background: white;\n    border-bottom-left-radius: 0.625rem;\n    border-bottom-right-radius: 0.625rem;\n"])));
var Title$4 = styled.div(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    box-sizing: border-box;\n    padding: 1.5rem 1.875rem 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.3;\n"])));
var Message$3 = styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    padding: 1rem 1.875rem 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.5;\n    ", ";\n"])), function (props) {
  return !props.title && css(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral(["\n            margin-top: 1.5rem;\n        "])));
});
var PopupCommon$1 = memo$6(PopupCommon);

var _templateObject$w;

function PopupButtonWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Block$h, null, children);
}

var Block$h = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 3.9375rem;\n  background: white;\n  border-bottom-left-radius: 0.625rem;\n  border-bottom-right-radius: 0.625rem;\n"])));

var _templateObject$v, _templateObject2$p, _templateObject3$h, _templateObject4$d;

function PopupOkCancelButton(_ref) {
  var cancelText = _ref.cancelText,
      okText = _ref.okText,
      cancelTextColor = _ref.cancelTextColor,
      okTextColor = _ref.okTextColor,
      onCancel = _ref.onCancel,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(PopupButtonWrapper, null, /*#__PURE__*/React.createElement(Button$2, {
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_r",
    color: cancelTextColor
  }, cancelText)), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement(Button$2, {
    okButton: true,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_sb",
    color: okTextColor
  }, okText)));
}

var Button$2 = styled.button(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral(["\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: white;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n    ", "\n"])), function (props) {
  return props.okButton ? css(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral(["\n                  border-bottom-right-radius: 0.625rem;\n              "]))) : css(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral(["\n                  border-bottom-left-radius: 0.625rem;\n              "])));
});
var Separator = styled.div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral(["\n    height: 3.9375rem;\n    width: 1px;\n    color: 1px solid rgba(0, 0, 0, 0.1);\n    background: rgba(0, 0, 0, 0.1);\n"])));

var _templateObject$u, _templateObject2$o;
var useMemo$1 = React.useMemo,
    memo$5 = React.memo;

function PopupOkCancel(_ref) {
  var title = _ref.title,
      message = _ref.message,
      _ref$messageType = _ref.messageType,
      messageType = _ref$messageType === void 0 ? 'description' : _ref$messageType,
      _ref$okText = _ref.okText,
      okText = _ref$okText === void 0 ? '확인' : _ref$okText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? '취소' : _ref$cancelText,
      _ref$cancelTextColor = _ref.cancelTextColor,
      cancelTextColor = _ref$cancelTextColor === void 0 ? TextColor.B85 : _ref$cancelTextColor,
      _ref$okTextColor = _ref.okTextColor,
      okTextColor = _ref$okTextColor === void 0 ? BrandColor.BU : _ref$okTextColor,
      visible = _ref.visible,
      onClick = _ref.onClick,
      onCancel = _ref.onCancel,
      note = _ref.note,
      check = _ref.check;
  var messageStyle = useMemo$1(function () {
    var variant = 'btn1_r';
    var color = TextColor.B60;

    if (messageType === 'subTitle') {
      variant = 't2_r';
      color = TextColor.B85;
    }

    if (messageType === 'check') {
      variant = 'b1_r';
      color = TextColor.B85;
    }

    return {
      variant: variant,
      color: color
    };
  }, [messageType]);
  return /*#__PURE__*/React.createElement(PopupBase$1, {
    visible: visible
  }, /*#__PURE__*/React.createElement(PopupWrapper, null, /*#__PURE__*/React.createElement(PopupTitleAndMessageWrapper, null, /*#__PURE__*/React.createElement(Title$3, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "h5",
    color: TextColor.B85
  }, title)), /*#__PURE__*/React.createElement(Message$2, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: messageStyle.variant,
    color: messageStyle.color
  }, message))), note && /*#__PURE__*/React.createElement(PopupNote, {
    note: note
  }), check && /*#__PURE__*/React.createElement(PopupCheck, {
    check: check
  }), /*#__PURE__*/React.createElement(PopupOkCancelButton, {
    cancelText: cancelText,
    okText: okText,
    cancelTextColor: cancelTextColor,
    okTextColor: okTextColor,
    onCancel: onCancel,
    onClick: onClick
  })));
}

var Title$3 = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    box-sizing: border-box;\n    padding: 1.5rem 1.875rem 1rem 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.3;\n"])));
var Message$2 = styled.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    padding: 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.5;\n"])));
var PopupOkCancel$1 = memo$5(PopupOkCancel);

var _templateObject$t;
var memo$4 = React.memo;

function PopupOkCancelDescription(_ref) {
  var message = _ref.message,
      _ref$okText = _ref.okText,
      okText = _ref$okText === void 0 ? '확인' : _ref$okText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? '취소' : _ref$cancelText,
      _ref$cancelTextColor = _ref.cancelTextColor,
      cancelTextColor = _ref$cancelTextColor === void 0 ? TextColor.B85 : _ref$cancelTextColor,
      _ref$okTextColor = _ref.okTextColor,
      okTextColor = _ref$okTextColor === void 0 ? BrandColor.BU : _ref$okTextColor,
      visible = _ref.visible,
      onClick = _ref.onClick,
      onCancel = _ref.onCancel,
      note = _ref.note,
      check = _ref.check;
  return /*#__PURE__*/React.createElement(PopupBase$1, {
    visible: visible
  }, /*#__PURE__*/React.createElement(PopupWrapper, null, /*#__PURE__*/React.createElement(PopupTitleAndMessageWrapper, null, /*#__PURE__*/React.createElement(MessageWrapper, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn1_r",
    color: TextColor.B85
  }, message))), note && /*#__PURE__*/React.createElement(PopupNote, {
    note: note
  }), check && /*#__PURE__*/React.createElement(PopupCheck, {
    check: check
  }), /*#__PURE__*/React.createElement(PopupOkCancelButton, {
    okText: okText,
    cancelText: cancelText,
    onClick: onClick,
    onCancel: onCancel,
    cancelTextColor: cancelTextColor,
    okTextColor: okTextColor
  })));
}

var MessageWrapper = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    width: 100%;\n    box-sizing: border-box;\n    padding: 1.5rem 1.875rem 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.5;\n"])));
var PopupOkCancelDescription$1 = memo$4(PopupOkCancelDescription);

var _templateObject$s, _templateObject2$n, _templateObject3$g, _templateObject4$c, _templateObject5$a, _templateObject6$8;

function PopupDoubleButton(_ref) {
  var visible = _ref.visible,
      title = _ref.title,
      message = _ref.message,
      onClickText = _ref.onClickText,
      onCancelText = _ref.onCancelText,
      onClick = _ref.onClick,
      onCancel = _ref.onCancel,
      _ref$onClickTextColor = _ref.onClickTextColor,
      onClickTextColor = _ref$onClickTextColor === void 0 ? BrandColor.BU : _ref$onClickTextColor,
      _ref$onCancelTextColo = _ref.onCancelTextColor,
      onCancelTextColor = _ref$onCancelTextColo === void 0 ? TextColor.B85 : _ref$onCancelTextColo;
  return /*#__PURE__*/React.createElement(PopupBase$1, {
    visible: visible
  }, /*#__PURE__*/React.createElement(Block$g, null, /*#__PURE__*/React.createElement(PopupTitleAndMessageWrapper, null, title && /*#__PURE__*/React.createElement(Title$2, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "h5",
    color: TextColor.B85
  }, title)), /*#__PURE__*/React.createElement(Message$1, {
    title: title
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "t2_r"
  }, message))), /*#__PURE__*/React.createElement(ButtonWrapper$2, null, /*#__PURE__*/React.createElement(Button$1, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_r",
    color: onClickTextColor
  }, onClickText)), /*#__PURE__*/React.createElement(Button$1, {
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_r",
    color: onCancelTextColor
  }, onCancelText)))));
}

var Block$g = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));
var Title$2 = styled.div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    width: 15.75rem;\n    padding: 1.5rem 1.875rem 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.3;\n"])));
var Message$1 = styled.div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    width: 15.75rem;\n    padding: 1rem 1.875rem 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.5;\n    ", ";\n"])), function (props) {
  return !props.title && css(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral(["\n            margin-top: 1.5rem;\n        "])));
});
var ButtonWrapper$2 = styled.div(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    button:nth-of-type(2) {\n        border-bottom-left-radius: 0.625rem;\n        border-bottom-right-radius: 0.625rem;\n    }\n"])));
var Button$1 = styled.button(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral(["\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    height: 3.9375rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: white;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n"])));

var _templateObject$r, _templateObject2$m, _templateObject3$f, _templateObject4$b, _templateObject5$9, _templateObject6$7;

function PopupTripleButton(_ref) {
  var visible = _ref.visible,
      title = _ref.title,
      message = _ref.message,
      onClickText = _ref.onClickText,
      onClickSecondText = _ref.onClickSecondText,
      onCancelText = _ref.onCancelText,
      onClick = _ref.onClick,
      onClickSecond = _ref.onClickSecond,
      onCancel = _ref.onCancel,
      _ref$onClickTextColor = _ref.onClickTextColor,
      onClickTextColor = _ref$onClickTextColor === void 0 ? BrandColor.BU : _ref$onClickTextColor,
      _ref$onClickSecondTex = _ref.onClickSecondTextColor,
      onClickSecondTextColor = _ref$onClickSecondTex === void 0 ? TextColor.B85 : _ref$onClickSecondTex,
      _ref$onCancelTextColo = _ref.onCancelTextColor,
      onCancelTextColor = _ref$onCancelTextColo === void 0 ? TextColor.B85 : _ref$onCancelTextColo;
  return /*#__PURE__*/React.createElement(PopupBase$1, {
    visible: visible
  }, /*#__PURE__*/React.createElement(Block$f, null, /*#__PURE__*/React.createElement(PopupTitleAndMessageWrapper, null, title && /*#__PURE__*/React.createElement(Title$1, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "h5",
    color: TextColor.B85
  }, title)), /*#__PURE__*/React.createElement(Message, {
    title: title
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "t2_r"
  }, message))), /*#__PURE__*/React.createElement(ButtonWrapper$1, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_r",
    color: onClickTextColor
  }, onClickText)), /*#__PURE__*/React.createElement(Button, {
    onClick: onClickSecond
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_r",
    color: onClickSecondTextColor
  }, onClickSecondText)), /*#__PURE__*/React.createElement(Button, {
    onClick: onCancel
  }, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "btn2_r",
    color: onCancelTextColor
  }, onCancelText)))));
}

var Block$f = styled.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n"])));
var Title$1 = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    width: 15.75rem;\n    padding: 1.5rem 1.875rem 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.3;\n"])));
var Message = styled.div(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    width: 15.75rem;\n    padding: 1rem 1.875rem 0 1.875rem;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.5;\n    ", ";\n"])), function (props) {
  return !props.title && css(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral(["\n            margin-top: 1.5rem;\n        "])));
});
var ButtonWrapper$1 = styled.div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    button:nth-of-type(3) {\n        border-bottom-left-radius: 0.625rem;\n        border-bottom-right-radius: 0.625rem;\n    }\n"])));
var Button = styled.button(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral(["\n    border: none;\n    outline: none;\n    margin: 0;\n    padding: 0;\n    cursor: pointer;\n    height: 3.9375rem;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: white;\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n"])));

var _templateObject$q, _templateObject2$l;
var S20CheckBox = function S20CheckBox(_ref) {
  var value = _ref.value,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(S20CheckBoxStyle, null, !disabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox$1, {
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: onChange
  }), checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledCheckedS20, null) : /*#__PURE__*/React.createElement(SvgCycleEnabledUnselectedS20, null))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox$1, {
    type: "checkbox",
    value: value,
    checked: checked,
    readOnly: true
  }), checked ? /*#__PURE__*/React.createElement(SvgCycleDisabledSelectedS20, null) : /*#__PURE__*/React.createElement(SvgCycleDisabledUnselectedS20, null))));
};
var S20CheckBoxStyle = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral(["\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])));
var HiddenCheckBox$1 = styled.input(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"])));

var _templateObject$p, _templateObject2$k;
var S28CheckBox = function S28CheckBox(_ref) {
  var value = _ref.value,
      checked = _ref.checked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type;
  return /*#__PURE__*/React.createElement(S28CheckBoxStyle, null, !disabled ? /*#__PURE__*/React.createElement(React.Fragment, null, type === 'error' && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox, {
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: onChange
  }), checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledErrorSelectedS28, null) : /*#__PURE__*/React.createElement(SvgCycleEnabledErrorS28, null)), type === 'default' && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox, {
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: onChange
  }), checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledCheckedS28, null) : /*#__PURE__*/React.createElement(SvgCycleEnabledUnselectedS28, null)), type === 'fill' && /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox, {
    type: "checkbox",
    value: value,
    checked: checked,
    onChange: onChange
  }), checked ? /*#__PURE__*/React.createElement(SvgCycleEnabledCheckedS28, null) : /*#__PURE__*/React.createElement(SvgCycleEnabledUnselectedFilledS28, null))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(HiddenCheckBox, {
    type: "checkbox",
    value: value,
    checked: checked,
    readOnly: true
  }), checked ? /*#__PURE__*/React.createElement(SvgCycleDisabledSelectedS28, null) : /*#__PURE__*/React.createElement(SvgCycleDisabledUnselectedS28, null))));
};
var S28CheckBoxStyle = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral(["\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])));
var HiddenCheckBox = styled.input(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"])));

var _templateObject$o, _templateObject2$j, _templateObject3$e;

function SamanthaTextArea(_ref) {
  var _value$length;

  var height = _ref.height,
      name = _ref.name,
      value = _ref.value,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
      _onChange = _ref.onChange,
      disabled = _ref.disabled,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 200 : _ref$maxLength,
      _ref$autoHeight = _ref.autoHeight,
      autoHeight = _ref$autoHeight === void 0 ? true : _ref$autoHeight;

  var _useState = useState$a(false),
      _useState2 = _slicedToArray(_useState, 2),
      focus = _useState2[0],
      setFocus = _useState2[1];

  var onFocus = function onFocus() {
    return setFocus(true);
  };

  var onBlur = function onBlur() {
    return setFocus(false);
  };

  var initHeight = height;
  var textRef = useRef(null);
  var handleResizeHeight = useCallback$1(function () {
    if (textRef.current) {
      textRef.current.style.height = 'auto';
      var nextHeight = textRef.current.scrollHeight - 32;

      if (nextHeight < initHeight) {
        nextHeight = initHeight;
      }

      textRef.current.style.height = "".concat(nextHeight, "px");
    }
  }, []);
  useEffect$b(function () {
    handleResizeHeight();
  }, []);
  return /*#__PURE__*/React__default.createElement(Block$e, null, /*#__PURE__*/React__default.createElement(Samantha, {
    contentEditable: true,
    ref: textRef,
    height: height,
    name: name,
    value: value || '',
    placeholder: placeholder,
    onChange: function onChange(e) {
      e.target.value = e.target.value.slice(0, maxLength);

      _onChange(e);

      if (autoHeight) {
        handleResizeHeight();
      }
    },
    disabled: disabled,
    onBlur: onBlur,
    onFocus: onFocus,
    suppressContentEditableWarning: true,
    suppressHydrationWarning: true
  }), focus && /*#__PURE__*/React__default.createElement(TextCountArea, {
    count: (_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0,
    maxLength: maxLength
  }));
}

function TextCountArea(_ref2) {
  var count = _ref2.count,
      maxLength = _ref2.maxLength;
  return /*#__PURE__*/React__default.createElement(TextCountBlock, null, /*#__PURE__*/React__default.createElement(TypeRule, {
    variant: "b4_r",
    color: TextColor.B40
  }, count, " / ", maxLength));
}

var TextCountBlock = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral(["\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 8px;\n"])));
var Block$e = styled.div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral(["\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n"])));
var Samantha = styled.textarea(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral(["\n    border: none;\n    outline: none;\n    resize: none;\n    font-style: normal;\n    font-weight: normal;\n    padding: 16px;\n    margin: 0;\n    height: ", "px;\n    line-height: 1.4;\n    font-size: 17px;\n    font-family: 'system-ui';\n    overflow-y: auto;\n    color: ", ";\n    background: ", ";\n    caret-color: ", ";\n    border-radius: 10px;\n    ::placeholder {\n        color: ", ";\n    }\n    &:disabled {\n        background: ", ";\n        color: rgba(0, 0, 0, 0.6);\n        opacity: 1;\n        -webkit-text-fill-color: rgba(0, 0, 0, 0.6);\n    }\n"])), function (props) {
  return props.height;
}, TextColor.B85, BackGroundColor.B03, BrandColor.BU, TextColor.B40, BackGroundColor.B03);

var _templateObject$n, _templateObject2$i, _templateObject3$d, _templateObject4$a;
var heightMap = {
  t1: '65px',
  t2: '59px',
  t3: '52px'
};
var SectionTitleView = function SectionTitleView(_ref) {
  var variant = _ref.variant,
      title = _ref.title,
      leadingIcon = _ref.leadingIcon,
      tailing = _ref.tailing;
  return /*#__PURE__*/React.createElement(SectionTitleStyle, {
    height: heightMap[variant]
  }, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(Align, null, leadingIcon), /*#__PURE__*/React.createElement(Align, null, {
    t1: /*#__PURE__*/React.createElement(TypeRule, {
      variant: 't1_b'
    }, title),
    t2: /*#__PURE__*/React.createElement(TypeRule, {
      variant: 't2_sb'
    }, title),
    t3: /*#__PURE__*/React.createElement(TypeRule, {
      variant: 't3_sb'
    }, title)
  }[variant]), /*#__PURE__*/React.createElement(Tailing, null, /*#__PURE__*/React.createElement(Align, null, tailing))));
};
var Tailing = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral(["\n    margin-left: auto;\n    &:hover {\n        cursor: pointer;\n    }\n"])));
var Title = styled.div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral(["\n    height: 100%;\n    display: flex;\n"])));
var Align = styled.div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n"])));
var SectionTitleStyle = styled.div(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral(["\n    width: 100%;\n    background-color: ", ";\n    height: ", ";\n"])), BackGroundColor['W100'], function (props) {
  return props.height;
});

var _templateObject$m;

function SliderNote(_ref) {
  var note = _ref.note;
  if (!note) return null;

  if (typeof note === 'string') {
    return /*#__PURE__*/React.createElement(Block$d, {
      dangerouslySetInnerHTML: {
        __html: note
      }
    });
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, note);
}

var Block$d = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.2;\n    font-size: 0.9375rem;\n    margin: 1rem 0;\n"])));

var _templateObject$l;

function SliderTitle(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement(Block$c, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'h4',
    color: TextColor.B85
  }, title));
}

var Block$c = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.4;\n"])));

var _templateObject$k, _templateObject2$h, _templateObject3$c;

function SliderHeader(_ref) {
  var title = _ref.title,
      note = _ref.note,
      onClose = _ref.onClose,
      color = _ref.color,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'close' : _ref$icon;
  return /*#__PURE__*/React.createElement(Block$b, {
    color: color
  }, /*#__PURE__*/React.createElement(IconWrapper$2, {
    invert: invert
  }, icon === 'close' ? /*#__PURE__*/React.createElement(SvgIcTopbarCloseActionS24, {
    className: "close-icon",
    onClick: onClose
  }) : /*#__PURE__*/React.createElement(SvgIcTopbarBackActionS24, {
    className: "close-icon",
    onClick: onClose
  })), /*#__PURE__*/React.createElement(SliderTitle, {
    title: title
  }), /*#__PURE__*/React.createElement(SliderNote, {
    note: note
  }));
}

var Block$b = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  padding: 0 1.5rem;\n  ", "\n"])), function (props) {
  return props.color && css(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral(["\n    background: ", ";\n  "])), props.color);
});
var IconWrapper$2 = styled.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  filter: ", ";\n  height: 3.5rem;\n  .close-icon {\n    cursor: pointer;\n  }\n"])), function (props) {
  return props.invert ? "invert(100%)" : "invert(0)";
});

var _templateObject$j;

function SliderWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Block$a, {
    className: "slider-wrapper"
  }, children);
}

var Block$a = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100vh; \n  background: rgba(0, 0, 0, 0.3);\n  ", " {\n    width: 430px;\n  }\n"])), media.medium);

var _templateObject$i, _templateObject2$g, _templateObject3$b, _templateObject4$9, _templateObject5$8, _templateObject6$6, _templateObject7$4, _templateObject8$2;

function SliderContentWrapper(_ref) {
  var children = _ref.children,
      visible = _ref.visible,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100vh' : _ref$height,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? false : _ref$radius;
  return /*#__PURE__*/React.createElement(Block$9, {
    visible: visible,
    type: type,
    height: height,
    headRadius: radius,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, children);
}

var Block$9 = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral(["\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    ", " {\n        width: 430px;\n    }\n    /* media */\n    ", "\n    \n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    background: ", ";\n    ", "\n"])), media.medium, function (props) {
  if (props.type === 'default') {
    return css(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral(["\n                height: 100vh;\n            "])));
  }

  if (props.type === 'custom') {
    return css(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["\n                height: ", ";\n                ", "\n            "])), props.height, props.headRadius && css(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral(["\n                  border-top-left-radius: 13.2px;\n                  border-top-right-radius: 13.2px;\n                "]))));
  } else if (props.type === 'half') {
    return css(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral(["\n                max-height: 100%;\n                ", ";\n                border-top-left-radius: 13.2px;\n                border-top-right-radius: 13.2px;\n            "])), props.height != '100vh' && "height: ".concat(props.height));
  } else {
    return css(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral(["\n                height: 74vh;\n                border-top-left-radius: 13.2px;\n                border-top-right-radius: 13.2px;\n            "])));
  }
}, BackGroundColor.W100, function (props) {
  return props.visible ? css(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.slideUp) : css(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.slideDown);
});

var _templateObject$h, _templateObject2$f;

var _excluded = ["children", "padding"];

function SliderBody(_ref) {
  var children = _ref.children,
      padding = _ref.padding,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Block$8, Object.assign({
    padding: padding
  }, props), children);
}

var Block$8 = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral(["\n    flex: 1;\n    overflow-y: auto;\n    position: relative;\n    ", "\n"])), function (props) {
  return props.padding && css(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n            padding: 0 1.5rem;\n        "])));
});

var _templateObject$g, _templateObject2$e;

function SliderFooter(_ref) {
  var children = _ref.children,
      paddingFooter = _ref.paddingFooter;
  return /*#__PURE__*/React.createElement(Block$7, {
    paddingFooter: paddingFooter
  }, children);
}

var Block$7 = styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n"])), function (props) {
  return props.paddingFooter && css(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n    padding: 0 1.5rem;\n  "])));
});

var useState$7 = React.useState,
    useEffect$7 = React.useEffect,
    memo$3 = React.memo;

function SliderBase(_ref) {
  var children = _ref.children,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? false : _ref$padding,
      _ref$paddingFooter = _ref.paddingFooter,
      paddingFooter = _ref$paddingFooter === void 0 ? true : _ref$paddingFooter,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      footer = _ref.footer,
      note = _ref.note,
      visible = _ref.visible,
      onClose = _ref.onClose,
      color = _ref.color,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      height = _ref.height,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      radius = _ref.radius,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? 'close' : _ref$icon;

  var _useState = useState$7(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var _useBeforeunload = useBeforeunload(),
      _useBeforeunload2 = _slicedToArray(_useBeforeunload, 1),
      beforeunloadEvent = _useBeforeunload2[0];

  useEffect$7(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 250);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible]);
  useEffect$7(function () {
    if (closed) {
      window.removeEventListener('beforeunload', beforeunloadEvent);
      return;
    }

    window.addEventListener('beforeunload', beforeunloadEvent);
    return function () {
      window.removeEventListener('beforeunload', beforeunloadEvent);
    };
  }, [closed]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(OpaqueLayer, {
    visible: visible
  }, /*#__PURE__*/React.createElement(SliderWrapper, null, /*#__PURE__*/React.createElement(SliderContentWrapper, {
    visible: visible,
    type: type,
    height: height,
    radius: radius
  }, /*#__PURE__*/React.createElement(SliderHeader, {
    title: title,
    note: note,
    onClose: onClose,
    color: color,
    invert: invert,
    icon: icon
  }), /*#__PURE__*/React.createElement(SliderBody, {
    padding: padding
  }, children), footer && /*#__PURE__*/React.createElement(SliderFooter, {
    paddingFooter: paddingFooter
  }, footer))));
}

var SliderBase$1 = memo$3(SliderBase);

var _templateObject$f;
var useMemo = React.useMemo,
    memo$2 = React.memo;

function SliderHalfTitle(_ref) {
  var title = _ref.title,
      titlePosition = _ref.titlePosition;
  var variant = useMemo(function () {
    return titlePosition === 'top' ? 't3_sb' : 'h5_b';
  }, [titlePosition]);
  return /*#__PURE__*/React.createElement(Block$6, {
    titlePosition: titlePosition
  }, /*#__PURE__*/React.createElement(Pretendard, {
    variant: variant,
    color: TextColor.B85
  }, title));
}

var Block$6 = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n    display: flex;\n    flex-flow: row wrap;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    white-space: pre-line;\n    line-height: 1.3;\n    justify-content: ", ";\n"])), function (props) {
  return props.titlePosition === 'top' ? 'flex-start' : 'center';
});
var SliderHalfTitle$1 = memo$2(SliderHalfTitle);

var _templateObject$e, _templateObject2$d, _templateObject3$a, _templateObject4$8;

function SliderHalfHeader(_ref) {
  var title = _ref.title,
      _ref$titlePosition = _ref.titlePosition,
      titlePosition = _ref$titlePosition === void 0 ? 'top' : _ref$titlePosition,
      note = _ref.note,
      onClose = _ref.onClose,
      color = _ref.color,
      invert = _ref.invert,
      extraMargin = _ref.extraMargin;
  return /*#__PURE__*/React.createElement(Block$5, {
    color: color
  }, /*#__PURE__*/React.createElement(TitleAndIconWrapper, {
    titlePosition: titlePosition,
    extraMargin: extraMargin
  }, titlePosition === 'top' && /*#__PURE__*/React.createElement(SliderHalfTitle$1, {
    title: title,
    titlePosition: titlePosition
  }), /*#__PURE__*/React.createElement(IconWrapper$1, {
    invert: invert
  }, /*#__PURE__*/React.createElement(SvgIcTopbarCloseActionS24, {
    className: "close-icon",
    onClick: onClose
  }))), titlePosition !== 'top' && /*#__PURE__*/React.createElement(SliderHalfTitle$1, {
    title: title,
    titlePosition: titlePosition
  }), /*#__PURE__*/React.createElement(SliderNote, {
    note: note
  }));
}

var Block$5 = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 0 1.5rem;\n    border-top-left-radius: 0.825rem;\n    border-top-right-radius: 0.825rem;\n    ", "\n"])), function (props) {
  return props.color && css(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n            background: ", ";\n        "])), props.color);
});
var TitleAndIconWrapper = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n    align-items: center;\n"])), function (props) {
  return props.titlePosition === 'top' ? 'space-between' : 'flex-end';
}, function (props) {
  return props.extraMargin ? "".concat(props.extraMargin) : '0px';
}, function (props) {
  return props.extraMargin ? "".concat(props.extraMargin) : '0px';
});
var IconWrapper$1 = styled.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["\n    display: flex;\n    align-items: center;\n    filter: ", ";\n    height: 3.5rem;\n    .close-icon {\n        cursor: pointer;\n    }\n"])), function (props) {
  return props.invert ? 'invert(100%)' : 'invert(0)';
});

var useState$6 = React.useState,
    useEffect$6 = React.useEffect,
    memo$1 = React.memo;

function SliderHalfBase(_ref) {
  var children = _ref.children,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? false : _ref$padding,
      _ref$paddingFooter = _ref.paddingFooter,
      paddingFooter = _ref$paddingFooter === void 0 ? true : _ref$paddingFooter,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$titlePosition = _ref.titlePosition,
      titlePosition = _ref$titlePosition === void 0 ? 'top' : _ref$titlePosition,
      footer = _ref.footer,
      note = _ref.note,
      visible = _ref.visible,
      onClose = _ref.onClose,
      color = _ref.color,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      extraMargin = _ref.extraMargin,
      height = _ref.height,
      _ref$onOpaqueLayerCli = _ref.onOpaqueLayerClick,
      onOpaqueLayerClick = _ref$onOpaqueLayerCli === void 0 ? function () {} : _ref$onOpaqueLayerCli,
      _ref$disableHeader = _ref.disableHeader,
      disableHeader = _ref$disableHeader === void 0 ? false : _ref$disableHeader;

  var _useState = useState$6(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var _useBeforeunload = useBeforeunload(),
      _useBeforeunload2 = _slicedToArray(_useBeforeunload, 1),
      beforeunloadEvent = _useBeforeunload2[0];

  useEffect$6(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 250);
    }

    return function () {
      if (!timeoutId) return;
      clearTimeout(timeoutId);
    };
  }, [visible]);
  useEffect$6(function () {
    if (closed) {
      window.removeEventListener('beforeunload', beforeunloadEvent);
      return;
    }

    window.addEventListener('beforeunload', beforeunloadEvent);
    return function () {
      window.removeEventListener('beforeunload', beforeunloadEvent);
    };
  }, [closed]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(OpaqueLayer, {
    visible: visible,
    onOpaqueLayerClick: onOpaqueLayerClick
  }, /*#__PURE__*/React.createElement(SliderWrapper, null, /*#__PURE__*/React.createElement(SliderContentWrapper, {
    visible: visible,
    type: "half",
    height: height
  }, disableHeader ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(SliderHalfHeader, {
    title: title,
    titlePosition: titlePosition,
    note: note,
    onClose: onClose,
    color: color,
    invert: invert,
    extraMargin: extraMargin
  }), /*#__PURE__*/React.createElement(SliderBody, {
    padding: padding
  }, children), footer && /*#__PURE__*/React.createElement(SliderFooter, {
    paddingFooter: paddingFooter
  }, footer))));
}

var SliderHalfBase$1 = memo$1(SliderHalfBase);

var _templateObject$d, _templateObject2$c, _templateObject3$9, _templateObject4$7, _templateObject5$7, _templateObject6$5;
var useState$5 = React.useState,
    useEffect$5 = React.useEffect,
    memo = React.memo;

function ImgSliderBase(_ref) {
  var children = _ref.children,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? false : _ref$padding,
      _ref$paddingFooter = _ref.paddingFooter,
      paddingFooter = _ref$paddingFooter === void 0 ? true : _ref$paddingFooter,
      footer = _ref.footer,
      visible = _ref.visible,
      onClose = _ref.onClose,
      img = _ref.img,
      headerTailing = _ref.headerTailing,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;

  var _useState = useState$5(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var _useBeforeunload = useBeforeunload(),
      _useBeforeunload2 = _slicedToArray(_useBeforeunload, 1),
      beforeunloadEvent = _useBeforeunload2[0];

  useEffect$5(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 250);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible]);
  useEffect$5(function () {
    if (closed) {
      window.removeEventListener('beforeunload', beforeunloadEvent);
      return;
    }

    window.addEventListener('beforeunload', beforeunloadEvent);
    return function () {
      window.removeEventListener('beforeunload', beforeunloadEvent);
    };
  }, [closed]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(OpaqueLayer, {
    visible: visible
  }, /*#__PURE__*/React.createElement(SliderWrapper, null, /*#__PURE__*/React.createElement(ImgWrapper$1, null, /*#__PURE__*/React.createElement(IconWrapper, {
    invert: true,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(SvgIcTopbarCloseActionS24, null)), headerTailing && /*#__PURE__*/React.createElement(HeaderTailingWrapper, null, headerTailing), img), /*#__PURE__*/React.createElement(SliderContentWrapper, {
    visible: visible,
    type: 'img'
  }, title && /*#__PURE__*/React.createElement(TitleWrapper, null, /*#__PURE__*/React.createElement(SliderTitle, {
    title: title
  })), /*#__PURE__*/React.createElement(SliderBody, {
    padding: padding
  }, children), footer && /*#__PURE__*/React.createElement(SliderFooter, {
    paddingFooter: paddingFooter
  }, footer))));
}

var ImgWrapper$1 = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n    width: 100%;\n    position: relative;\n"])));
var IconWrapper = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 20px;\n    top: 10px;\n    align-items: center;\n    filter: ", ";\n    & {\n        cursor: pointer;\n    }\n"])), function (props) {
  return props.invert ? 'invert(100%)' : 'invert(0)';
});
var HeaderTailingWrapper = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["\n    position: absolute;\n    right: 20px;\n    top: 10px;\n    align-items: center;\n    & {\n        cursor: pointer;\n    }\n"])));
var TitleWrapper = styled.div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: column;\n    padding: 14px 24px 14px 1.5rem;\n    border-top-left-radius: 24px;\n    border-top-right-radius: 24px;\n    ", "\n"])), function (props) {
  return props.color ? css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["\n                  background: ", ";\n              "])), props.color) : css(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral(["\n                  background: ", ";\n              "])), BackGroundColor['W100']);
});
var ImgSliderBase$1 = memo(ImgSliderBase);

var _templateObject$c, _templateObject2$b, _templateObject3$8, _templateObject4$6, _templateObject5$6, _templateObject6$4, _templateObject7$3, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1;
function DataPicker(_ref) {
  var pickerList = _ref.pickerList,
      pickerUnit = _ref.pickerUnit,
      selectedIndex = _ref.selectedIndex,
      onChange = _ref.onChange;

  var _useState = useState$a([]),
      _useState2 = _slicedToArray(_useState, 2),
      list = _useState2[0],
      setList = _useState2[1];

  var cloneScroller = useRef(null);
  var pickerScroller = useRef(null);
  var listSize = list.length;
  var DEGREE = 30;
  var lineHeight = 50;
  var index = selectedIndex;
  var unit = 0;
  var isTouch = false;

  var clockWise = function clockWise(e) {
    if (!cloneScroller.current || !pickerScroller.current) return;
    var cloneScrollTop = e.currentTarget.scrollTop;
    var cloneHeight = lineHeight * listSize;
    var totalDeg = DEGREE * listSize;
    unit = totalDeg / cloneHeight * cloneScrollTop;
    index = Math.round(unit / DEGREE);
    pickerScroller.current.style.transform = "translateZ(-".concat(lineHeight * 3, "px) rotateX(").concat(unit, "deg)");

    if (!isTouch) {
      touchEndEvent();
    }
  };

  var touchEndEvent = function touchEndEvent() {
    var _cloneScroller$curren, _pickerScroller$curre;

    if (!cloneScroller.current || !pickerScroller.current) return;
    isTouch = false;
    onChange(index);
    (_cloneScroller$curren = cloneScroller.current) === null || _cloneScroller$curren === void 0 ? void 0 : _cloneScroller$curren.scrollTo(0, lineHeight * index);
    (_pickerScroller$curre = pickerScroller.current) === null || _pickerScroller$curre === void 0 ? void 0 : _pickerScroller$curre.scrollTo(0, lineHeight * index);
  };

  useEffect$b(function () {
    setList(pickerList.map(function (v, i) {
      return /*#__PURE__*/React__default.createElement(PickerOption, {
        show: true,
        degree: DEGREE,
        index: i,
        lineHeight: lineHeight,
        listSize: listSize,
        key: i
      }, v);
    }));
  }, []);
  useEffect$b(function () {
    var _document$querySelect, _document$querySelect2;

    (_document$querySelect = document.querySelector('.clone-scroller')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollTo(0, lineHeight * index);
    (_document$querySelect2 = document.querySelector('.picker-scroller')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.scrollTo(0, lineHeight * index);
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PickerWrapper, {
    lineHeight: lineHeight,
    listSize: listSize
  }, /*#__PURE__*/React__default.createElement(CloneScroller, {
    ref: cloneScroller,
    className: 'clone-scroller',
    lineHeight: lineHeight,
    listSize: listSize,
    selectedIndex: index,
    onScroll: clockWise,
    onTouchStart: function onTouchStart() {
      return isTouch = true;
    },
    onTouchEnd: touchEndEvent
  }, pickerList.map(function (v) {
    return /*#__PURE__*/React__default.createElement(CloneOption, {
      key: v
    }, v);
  })), /*#__PURE__*/React__default.createElement(PickerUpDiv, {
    lineHeight: lineHeight,
    listSize: listSize
  }), /*#__PURE__*/React__default.createElement(PickerDownDiv, {
    lineHeight: lineHeight,
    listSize: listSize
  }), /*#__PURE__*/React__default.createElement(PickerScroller, {
    ref: pickerScroller,
    className: 'picker-scroller',
    lineHeight: lineHeight,
    listSize: listSize,
    selectedIndex: index,
    unit: unit
  }, list), /*#__PURE__*/React__default.createElement(UnitDiv, null, /*#__PURE__*/React__default.createElement(Pretendard, {
    variant: 'b1_r'
  }, pickerUnit))));
}
var PickerWrapper = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n    font-family: 'Pretendard';\n    box-sizing: border-box;\n    -webkit-user-select: none;\n    text-align: center;\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    font-size: 42px;\n    font-weight: 700;\n    height: 230px;\n\n    ", "\n"])), function (props) {
  return css(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n        line-height: ", "px;\n    "])), props.lineHeight);
});
var CloneScroller = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["\n    -webkit-box-shadow: inset 0 20px 24px 3px white, inset 0 -20px 24px 3px white;\n    -ms-box-shadow: inset 0 10px 24px 3px white, inset 0 -20px 24px 3px white;\n    -moz-box-shadow: inset 0 10px 24px 3px white, inset 0 -20px 24px 3px white;\n    box-shadow: inset 0 10px 24px 3px white, inset 0 -20px 24px 3px white;\n    z-index: 5;\n    overflow: auto;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    box-sizing: border-box;\n    -webkit-user-select: none;\n    padding-top: 90px;\n    padding-bottom: 90px;\n"])));
var PickerUpDiv = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0;\n    z-index: 2;\n    background: rgba(256, 256, 256, 0.6);\n    width: 100%;\n    box-sizing: border-box;\n    -webkit-user-select: none;\n    height: 86px;\n"])));
var PickerDownDiv = styled.div(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n    position: absolute;\n    z-index: 2;\n    background: rgba(256, 256, 256, 0.6);\n    width: 100%;\n    box-sizing: border-box;\n    -webkit-user-select: none;\n    height: 200px;\n    top: 136px;\n"])));
var PickerScroller = styled.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["\n    -webkit-transition: -webkit-transform 100ms ease;\n    -webkit-transform-style: preserve-3d;\n    height: 100%;\n    box-sizing: border-box;\n    -webkit-user-select: none;\n    padding-top: 90px;\n    padding-bottom: 90px;\n"])));
var CloneOption = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n    visibility: hidden;\n"])));
var PickerOption = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n    position: absolute;\n    backface-visibility: hidden;\n    -webkit-backface-visibility: hidden;\n    width: 100%;\n    transition: all 300ms;\n    color: black;\n    transform-origin: 50% 50%;\n    -webkit-transform-style: preserve-3d;\n\n    ", "\n    ", "\n"])), function (props) {
  return props.show ? css(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n                  display: block;\n              "]))) : css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n                  display: none;\n              "])));
}, function (props) {
  return css(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n        -webkit-transform: rotateX(-", "deg) translateZ(", "px);\n    "])), props.degree * props.index, props.lineHeight * 3);
});
var UnitDiv = styled.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 104px;\n    transform: translateX(-50%);\n    left: calc(50% + 42px);\n"])));

var _templateObject$b, _templateObject2$a;
function SliderPicker(_ref) {
  _ref.children;
      var _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? false : _ref$padding;
      _ref.paddingFooter;
      var _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$titlePosition = _ref.titlePosition,
      titlePosition = _ref$titlePosition === void 0 ? 'top' : _ref$titlePosition;
      _ref.footer;
      var note = _ref.note,
      visible = _ref.visible,
      onClose = _ref.onClose,
      color = _ref.color,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      extraMargin = _ref.extraMargin,
      height = _ref.height,
      pickerList = _ref.pickerList,
      pickerUnit = _ref.pickerUnit,
      selectedIndex = _ref.selectedIndex,
      onChange = _ref.onChange,
      onComfirm = _ref.onComfirm;

  var _useState = useState$a(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  var _useBeforeunload = useBeforeunload(),
      _useBeforeunload2 = _slicedToArray(_useBeforeunload, 1),
      beforeunloadEvent = _useBeforeunload2[0];

  useEffect$b(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 250);
    }

    return function () {
      if (!timeoutId) return;
      clearTimeout(timeoutId);
    };
  }, [visible]);
  useEffect$b(function () {
    if (closed) {
      window.removeEventListener('beforeunload', beforeunloadEvent);
      return;
    }

    window.addEventListener('beforeunload', beforeunloadEvent);
    return function () {
      window.removeEventListener('beforeunload', beforeunloadEvent);
    };
  }, [closed]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React__default.createElement(OpaqueLayer, {
    visible: visible
  }, /*#__PURE__*/React__default.createElement(SliderWrapper, null, /*#__PURE__*/React__default.createElement(SliderContentWrapper, {
    visible: visible,
    type: "half",
    height: height
  }, /*#__PURE__*/React__default.createElement(SliderHalfHeader, {
    title: title,
    titlePosition: titlePosition,
    note: note,
    onClose: onClose,
    color: color,
    invert: invert,
    extraMargin: extraMargin
  }), /*#__PURE__*/React__default.createElement(SliderBodyDiv, {
    padding: padding
  }, /*#__PURE__*/React__default.createElement(DataPicker, {
    pickerList: pickerList,
    pickerUnit: pickerUnit,
    selectedIndex: selectedIndex,
    onChange: onChange
  })), /*#__PURE__*/React__default.createElement(ButtonDiv, null, /*#__PURE__*/React__default.createElement(Button$3, {
    type: 'rect',
    size: 'S_17_WS',
    onClick: onComfirm
  }, "\uD655\uC778")))));
}
var ButtonDiv = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: center;\n    margin: 5%;\n"])));
var SliderBodyDiv = styled(SliderBody)(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n    overflow: hidden;\n"])));

var _templateObject$a, _templateObject2$9, _templateObject3$7;
var useState$4 = React.useState,
    useEffect$4 = React.useEffect;

function Snackbar(_ref) {
  var visible = _ref.visible,
      message = _ref.message,
      handleVisible = _ref.handleVisible,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1500 : _ref$duration,
      width = _ref.width,
      maxWidth = _ref.maxWidth;

  var _useState = useState$4(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  useEffect$4(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
      timeoutId = setTimeout(function () {
        handleVisible();
      }, duration);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 1000);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible, message, handleVisible]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(Block$4, {
    visible: visible,
    width: width,
    maxWidth: maxWidth
  }, /*#__PURE__*/React.createElement("section", null, message));
}

var Block$4 = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    z-index: ", ";\n    & > section {\n        width: ", ";\n        max-width: ", ";\n        display: flex;\n        flex-flow: row wrap;\n        font-size: 15px;\n        padding: 16px 18px;\n        background: rgba(0, 0, 0, 0.85);\n        color: ", ";\n        border-radius: 8px;\n        white-space: pre-wrap;\n        box-sizing: border-box;\n    }\n    ", "\n"])), zIndexes.snackbar, function (props) {
  return props.width ? "".concat(props.width) : '320px';
}, function (props) {
  return props.maxWidth ? "".concat(props.maxWidth) : '';
}, BackGroundColor.W100, function (props) {
  return props.visible ? css(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popInFromBottomSnackbar) : css(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popOutToBottomSnackbar);
});

var _templateObject$9, _templateObject2$8, _templateObject3$6;
var useState$3 = React.useState,
    useEffect$3 = React.useEffect;

function SnackbarBase(_ref) {
  var visible = _ref.visible,
      children = _ref.children,
      handleHide = _ref.handleHide,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1500 : _ref$duration;

  var _useState = useState$3(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  useEffect$3(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
      timeoutId = setTimeout(function () {
        if (handleHide) {
          handleHide();
        }
      }, duration);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 1000);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible, children, handleHide]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(Block$3, {
    visible: visible
  }, children);
}

var Block$3 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n    position: fixed;\n    width: 100%;\n    bottom: 0;\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: center;\n    align-items: center;\n    margin: 0 auto;\n    z-index: ", ";\n    ", "\n"])), zIndexes.snackbar, function (props) {
  return props.visible ? css(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popInFromBottomSnackbar) : css(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popOutToBottomSnackbar);
});

var _templateObject$8, _templateObject2$7, _templateObject3$5, _templateObject4$5, _templateObject5$5;
var useState$2 = React.useState,
    useEffect$2 = React.useEffect;

function InfoImgSnackbar(_ref) {
  var visible = _ref.visible,
      message = _ref.message,
      handleVisible = _ref.handleVisible;

  var _useState = useState$2(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  useEffect$2(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
      timeoutId = setTimeout(function () {
        handleVisible();
      }, 3000);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 200);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible, message, handleVisible]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(Block$2, {
    visible: visible
  }, /*#__PURE__*/React.createElement(ContentWrapper$1, null, /*#__PURE__*/React.createElement(ImgWrapper, null, /*#__PURE__*/React.createElement("img", {
    src: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/char.png',
    srcSet: 'https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/char%402x.png 2x, https://cleanhome-prod.s3.ap-northeast-2.amazonaws.com/web_client/char%403x.png 3x',
    alt: 'manager_img'
  })), /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b2_sb',
    color: BackGroundColor['W100']
  }, message)));
}

var Block$2 = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n    position: fixed;\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    z-index: ", ";\n    & > section {\n        width: 220px;\n        display: flex;\n        margin: 0 auto;\n        justify-content: flex-end;\n        flex-flow: row wrap;\n        padding: 11px 21px;\n        background: ", ";\n        color: ", ";\n        border-radius: 40px;\n        white-space: pre-wrap;\n    }\n    ", "\n"])), zIndexes.snackbar, BrandColor['DarkBU'], BackGroundColor.W100, function (props) {
  return props.visible ? css(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popInFromBottomSnackbar) : css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popOutToBottomSnackbar);
});
var ContentWrapper$1 = styled.section(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["\n    position: relative;\n"])));
var ImgWrapper = styled.section(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n    position: absolute;\n    left: 11px;\n    bottom: -3px;\n"])));

var _templateObject$7, _templateObject2$6, _templateObject3$4, _templateObject4$4, _templateObject5$4;
var useState$1 = React.useState,
    useEffect$1 = React.useEffect;

function SnackbarWithButton(_ref) {
  var visible = _ref.visible,
      message = _ref.message,
      handleVisible = _ref.handleVisible,
      buttonMessage = _ref.buttonMessage,
      onClick = _ref.onClick,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 1500 : _ref$duration;

  var _useState = useState$1(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  useEffect$1(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
      timeoutId = setTimeout(function () {
        handleVisible();
      }, duration);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 200);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible, message, handleVisible, buttonMessage]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(Block$1, {
    visible: visible
  }, /*#__PURE__*/React.createElement(ContentWrapper, null, /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'b3_r',
    color: BackGroundColor['W100']
  }, message), /*#__PURE__*/React.createElement(Pretendard, {
    variant: 'b3_sb',
    color: BrandColor['BU']
  }, /*#__PURE__*/React.createElement(ButtonWrapper, {
    onClick: onClick
  }, buttonMessage))));
}

var Block$1 = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n    position: fixed;\n    width: 100%;\n    left: 0;\n    bottom: 25px;\n    display: flex;\n    flex-flow: row wrap;\n    align-items: center;\n    z-index: ", ";\n    & > section {\n        width: 317px;;\n        display: flex;\n        margin: 0 auto;\n        justify-content: space-between;\n        flex-flow: row wrap;\n        padding: 16px 20px;\n        background: rgba(0,0,0,0.85);\n        color: ", ";\n        border-radius: 8px;\n        white-space: pre-wrap;\n    }\n    ", "\n"])), zIndexes.snackbar, BackGroundColor.W100, function (props) {
  return props.visible ? css(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popInFromBottomSnackbar) : css(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.popOutToBottomSnackbar);
});
var ContentWrapper = styled.section(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["\n    position: relative;\n"])));
var ButtonWrapper = styled.section(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n    cursor:pointer;\n"])));

var _templateObject$6, _templateObject2$5, _templateObject3$3, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$2, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;
// @ts-ignore:next-line
var isAndroid = typeof window !== 'undefined' && !!/Android/g.exec(window.navigator.userAgent);
var fontWeight = {
  regular: '400',
  'semi-bold': isAndroid ? '500' : '600',
  bold: '700'
};
var Suit = function Suit(_ref) {
  var variant = _ref.variant,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? TextColor['B85'] : _ref$color,
      children = _ref.children,
      _ref$lineHeight = _ref.lineHeight,
      lineHeight = _ref$lineHeight === void 0 ? '1.4' : _ref$lineHeight,
      opacity = _ref.opacity;
  return /*#__PURE__*/React.createElement(React.Fragment, null, {
    h1: /*#__PURE__*/React.createElement(H1, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h2: /*#__PURE__*/React.createElement(H2, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h3: /*#__PURE__*/React.createElement(H3, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h4: /*#__PURE__*/React.createElement(H4, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h5: /*#__PURE__*/React.createElement(H5, {
      color: color,
      lineHeight: lineHeight,
      opacity: opacity
    }, ' ', children, ' '),
    h5_b: /*#__PURE__*/React.createElement(H5, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    b1_r: /*#__PURE__*/React.createElement(B1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    b1_sb: /*#__PURE__*/React.createElement(B1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    b1_b: /*#__PURE__*/React.createElement(B1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    b2_r: /*#__PURE__*/React.createElement(B2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    b2_sb: /*#__PURE__*/React.createElement(B2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    b2_b: /*#__PURE__*/React.createElement(B2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    b3_r: /*#__PURE__*/React.createElement(B3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    b3_sb: /*#__PURE__*/React.createElement(B3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    b3_b: /*#__PURE__*/React.createElement(B3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    b4_r: /*#__PURE__*/React.createElement(B4, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    b4_sb: /*#__PURE__*/React.createElement(B4, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    b4_b: /*#__PURE__*/React.createElement(B4, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    t1_r: /*#__PURE__*/React.createElement(T1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    t1_sb: /*#__PURE__*/React.createElement(T1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    t1_b: /*#__PURE__*/React.createElement(T1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    t2_r: /*#__PURE__*/React.createElement(T2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    t2_sb: /*#__PURE__*/React.createElement(T2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    t2_b: /*#__PURE__*/React.createElement(T2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    t3_r: /*#__PURE__*/React.createElement(T3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    t3_sb: /*#__PURE__*/React.createElement(T3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    t3_b: /*#__PURE__*/React.createElement(T3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.bold,
      opacity: opacity
    }, children),
    btn1_r: /*#__PURE__*/React.createElement(BTN1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    btn1_sb: /*#__PURE__*/React.createElement(BTN1, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    btn2_r: /*#__PURE__*/React.createElement(BTN2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    btn2_sb: /*#__PURE__*/React.createElement(BTN2, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children),
    btn3_r: /*#__PURE__*/React.createElement(BTN3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight.regular,
      opacity: opacity
    }, children),
    btn3_sb: /*#__PURE__*/React.createElement(BTN3, {
      color: color,
      lineHeight: lineHeight,
      fontWeight: fontWeight['semi-bold'],
      opacity: opacity
    }, children)
  }[variant]);
};
var H1 = styled.h1(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 33px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H2 = styled.h2(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 30px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H3 = styled.h3(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 27px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H4 = styled.h4(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 25px;\n    font-weight: 700;\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.opacity;
});
var H5 = styled.h5(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 23px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight ? props.fontWeight : 600;
}, function (props) {
  return props.opacity;
});
var T1 = styled.h1(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 21px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var T2 = styled.h2(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 19px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var T3 = styled.h3(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B1 = styled.section(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B2 = styled.section(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 16px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B3 = styled.section(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 15px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var B4 = styled.section(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 14px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var BTN1 = styled.section(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 17px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var BTN2 = styled.section(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 16px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
var BTN3 = styled.section(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n    color: ", ";\n    line-height: ", ";\n    font-size: 15px;\n    font-weight: ", ";\n    opacity: ", ";\n"])), function (props) {
  return props.color;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (props) {
  return props.opacity;
});
css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral([""])));

var _templateObject$5, _templateObject2$4, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$1;
var TimeLine = function TimeLine(_ref) {
  var steps = _ref.steps,
      currentStep = _ref.currentStep;

  if (currentStep > steps.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement(TimeLineStyle, null, /*#__PURE__*/React.createElement(BaseLine, null, /*#__PURE__*/React.createElement(Line, null), /*#__PURE__*/React.createElement(Dots, null, steps.map(function (e, i) {
    return i === currentStep ? /*#__PURE__*/React.createElement(ActiveDot, {
      key: "dot_".concat(i)
    }) : /*#__PURE__*/React.createElement(DimmedDot, {
      key: "dot_".concat(i)
    });
  }))), /*#__PURE__*/React.createElement(Text, null, steps.map(function (e, i) {
    return i === currentStep ? /*#__PURE__*/React.createElement(TypeRule, {
      variant: 'b3_sb',
      key: "text_".concat(i),
      color: BrandColor['BU']
    }, e) : /*#__PURE__*/React.createElement(TypeRule, {
      variant: 'b3_r',
      key: "text_".concat(i),
      color: TextColor['B20']
    }, e);
  })));
};
var TimeLineStyle = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n    width: 100%;\n"])));
var BaseLine = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n    width: 90%;\n    height: 14px;\n    position: relative;\n    margin: 0 auto;\n"])));
var Line = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n    display: flex;\n    position: absolute;\n    width: 100%;\n    border-top: 1px solid ", ";\n    top: 50%;\n"])), TextColor['B10']);
var Dots = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n"])));
var DimmedDot = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n    width: 8px;\n    height: 8px;\n    margin-top: 3.25px;\n    background: ", ";\n    border-radius: 50%;\n"])), TextColor['B10']);
var ActiveDot = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n    width: 14px;\n    height: 14px;\n    background: ", ";\n    border-radius: 50%;\n    z-index: 1;\n"])), BrandColor['BU']);
var Text = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n    margin-top: 12px;\n    display: flex;\n    justify-content: space-between;\n"])));

var _templateObject$4, _templateObject2$3, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7;

var isAble = function isAble(availableTime, targetTime) {
  return availableTime.some(function (e) {
    return e === targetTime;
  });
};

var TimePicker = function TimePicker(_ref) {
  var availableTime = _ref.availableTime,
      _ref$everyTimeCase = _ref.everyTimeCase,
      everyTimeCase = _ref$everyTimeCase === void 0 ? ['08:00', '08:30', '09:00', '09:30', '10:00', '14:00', '14:30', '15:00', '15:30', '16:00'] : _ref$everyTimeCase,
      value = _ref.value,
      setValue = _ref.setValue;
  var amList = everyTimeCase.filter(function (e) {
    return Number(e.substr(0, 2)) < 12;
  });
  var pmList = everyTimeCase.filter(function (e) {
    return Number(e.substr(0, 2)) >= 12;
  });
  return /*#__PURE__*/React.createElement(TimePickerStyle, null, /*#__PURE__*/React.createElement(TimeList, null, /*#__PURE__*/React.createElement(TimeTitle, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B60']
  }, "\uC624\uC804")), /*#__PURE__*/React.createElement(TimeBody, null, amList.reduce(function (acc, e, i) {
    if (i % 2 == 0) acc.push([]);
    if (acc[acc.length - 1]) acc[acc.length - 1].push(e);
    return acc;
  }, []).map(function (e, k) {
    return /*#__PURE__*/React.createElement(TimeList, {
      key: "am_list_".concat(k)
    }, e.map(function (o, l) {
      return isAble(availableTime, o) ? /*#__PURE__*/React.createElement(TimeItem, {
        key: "am_key_".concat(k, "_").concat(l),
        onClick: function onClick() {
          return setValue(o);
        }
      }, value === o ? /*#__PURE__*/React.createElement(Selected, null, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 't1_b',
        color: BrandColor['BU']
      }, o)) : /*#__PURE__*/React.createElement(UnSelected, null, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 't1_b'
      }, o))) : /*#__PURE__*/React.createElement(TimeItem, {
        key: "am_key_".concat(k, "_").concat(l)
      }, /*#__PURE__*/React.createElement(UnSelected, null, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 't1_b',
        color: TextColor['B20']
      }, o)));
    }));
  }))), /*#__PURE__*/React.createElement(TimeList, null, /*#__PURE__*/React.createElement(TimeTitle, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: 'b3_r',
    color: TextColor['B60']
  }, "\uC624\uD6C4")), /*#__PURE__*/React.createElement(TimeBody, null, pmList.reduce(function (acc, e, i) {
    if (i % 2 == 0) acc.push([]);
    if (acc[acc.length - 1]) acc[acc.length - 1].push(e);
    return acc;
  }, []).map(function (e, k) {
    return /*#__PURE__*/React.createElement(TimeList, {
      key: "pl_list_".concat(k)
    }, e.map(function (o, l) {
      return isAble(availableTime, o) ? /*#__PURE__*/React.createElement(TimeItem, {
        key: "pl_key_".concat(k, "_").concat(l),
        onClick: function onClick() {
          return setValue(o);
        }
      }, value === o ? /*#__PURE__*/React.createElement(Selected, null, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 't1_b',
        color: BrandColor['BU']
      }, o)) : /*#__PURE__*/React.createElement(UnSelected, null, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 't1_b'
      }, o))) : /*#__PURE__*/React.createElement(TimeItem, {
        key: "am_key_".concat(k, "_").concat(l)
      }, /*#__PURE__*/React.createElement(UnSelected, null, /*#__PURE__*/React.createElement(TypeRule, {
        variant: 't1_b',
        color: TextColor['B20']
      }, o)));
    }));
  }))));
};
var TimeTitle = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n    padding-top: 4px;\n    min-width: 74px;\n"])));
var TimeBody = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    margin-left: 30px;\n    width: 80%;\n"])));
var TimeList = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    display: flex;\n    text-align: center;\n    margin-bottom: 10px;\n"])));
var TimeItem = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n    width: 30%;\n    padding: 2px 15px 16px 5px;\n    &:hover {\n        cursor: pointer;\n    }\n"])));
var Selected = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n    text-decoration: underline;\n    text-underline-offset: 3px;\n    color: ", ";\n"])), BrandColor["BU"]);
var UnSelected = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n    border-bottom: 3px solid ", ";\n"])), BackGroundColor['W100']);
var TimePickerStyle = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])));

var _templateObject$3, _templateObject2$2;
var ScheduleTimeChangeViewer = function ScheduleTimeChangeViewer(_ref) {
  var prevTime = _ref.prevTime,
      nextTime = _ref.nextTime;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrevTime, null, " ", prevTime, " "), /*#__PURE__*/React.createElement(NextTime, null, " ", nextTime, " "));
};
var PrevTime = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  text-align: center;\n  color: gray;\n  "])));
var NextTime = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n  text-align: center;"])));

var _templateObject$2, _templateObject2$1;
var ScheduleTimeViewer = function ScheduleTimeViewer(_ref) {
  var date = _ref.date,
      time = _ref.time,
      color = _ref.color;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Date$1, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "h1",
    color: color
  }, " ", date, " ")), /*#__PURE__*/React.createElement(Time, null, /*#__PURE__*/React.createElement(TypeRule, {
    variant: "t1_r",
    color: color
  }, " ", time, " ")));
};
var Date$1 = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n  text-align: center;"])));
var Time = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  text-align: center;"])));

var _templateObject$1, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var useState = React.useState,
    useEffect = React.useEffect;

function ToolTipContent(_ref) {
  var visible = _ref.visible,
      message = _ref.message,
      handleVisible = _ref.handleVisible,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? BrandColor['DarkBU'] : _ref$color,
      _ref$showIcon = _ref.showIcon,
      showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1];

  useEffect(function () {
    var timeoutId = null;

    if (visible) {
      setClosed(false);
      timeoutId = setTimeout(function () {
        handleVisible();
      }, 3000);
    } else {
      timeoutId = setTimeout(function () {
        setClosed(true);
      }, 3000);
    }

    return function () {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [visible, message, handleVisible]);
  if (!visible && closed) return null;
  return /*#__PURE__*/React.createElement(Block, {
    visible: visible
  }, /*#__PURE__*/React.createElement(ToolTipBackground, {
    color: color
  }, showIcon && /*#__PURE__*/React.createElement(SvgIcWarningstrokeS16, {
    style: {
      filter: 'brightness(0) saturate(100%) invert(100%)',
      marginRight: '8px'
    }
  }), /*#__PURE__*/React.createElement("section", null, message), /*#__PURE__*/React.createElement(Tail, {
    color: color
  })));
}

var ToolTip = function ToolTip(_ref2) {
  var visible = _ref2.visible,
      message = _ref2.message,
      handleVisible = _ref2.handleVisible,
      children = _ref2.children,
      color = _ref2.color,
      showIcon = _ref2.showIcon;
  return /*#__PURE__*/React.createElement(ToolTipWrapper, null, /*#__PURE__*/React.createElement(ToolTipContent, {
    visible: visible,
    message: message,
    handleVisible: handleVisible,
    color: color,
    showIcon: showIcon
  }), children);
};

var Tail = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    position: absolute;\n    width: 0px;\n    height: 0px;\n    top: 39px;\n    left: 18px;\n    border-top: 14px solid ", ";\n    border-left: 14px solid transparent;\n    border-right: 14px solid transparent;\n    border-bottom: 14px solid transparent;\n"])), function (props) {
  return props.color;
});
var ToolTipBackground = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border-radius: 8px;\n    padding: 12px;\n    display: flex;\n    background-color: ", ";\n    align-items: center;\n    color: ", ";\n"])), function (props) {
  return props.color;
}, BackGroundColor['W100']);
var Block = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: -55px;\n    left: 0;\n    ", "\n"])), function (props) {
  return props.visible ? css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                  animation: ", " 0.25s forwards ease-in-out;\n              "])), transitions.fadeIn) : css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                  animation: ", " 1s forwards ease-in-out;\n              "])), transitions.fadeOut);
});
var ToolTipWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    position: relative;\n    width: fit-content;\n    height: fit-content;\n    z-index: ", ";\n"])), zIndexes.tooltip);

function isEmpty(value) {
  if (!value) {
    return true;
  }

  if (value.length === 0) {
    return true;
  }

  if (typeof value == "object" && Object.keys(value).length === 0) {
    return true;
  }

  return false;
}
var mergeObject = function mergeObject(obj, key, value) {
  var res = _objectSpread2({}, obj);

  res[key] = value;
  return res;
};
var deleteObject = function deleteObject(obj, key) {
  var res = _objectSpread2({}, obj);

  delete res[key];
  return res;
};

var _templateObject;
var noFlash = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n"])));

function CustomerIllustAS30(props) {
  var _props$width, _props$height;

  var width = (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 30;
  var height = (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 30;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: width,
    height: height,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6859_15384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6859_15384",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#6084DF"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6859_15384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3034 6.56384C23.8829 6.61199 23.2683 13.8884 22.9359 15.2536C22.5294 16.9256 23.8829 18.2705 23.8829 21.3119C23.8829 25.118 22.8169 25.8739 22.3622 28.4084C21.9076 30.9429 12.4386 28.4084 12.4386 28.4084C12.4386 28.4084 10.6957 28.4084 9.179 28.4084C7.66232 28.4084 6.1416 25.118 6.1416 21.8188C6.1416 17.7636 7.61182 16.9256 7.20532 15.2536C6.87297 13.891 6.57385 6.56384 12.4386 5.18585",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4385 14.6402C19.0755 15.4507 19.1062 16.7571 19.8757 17.046C20.6427 17.3349 21.5605 16.2918 21.9235 15.4839C22.2865 14.6735 22.0641 13.9704 21.2971 13.6815C20.5276 13.3901 19.8015 13.8298 19.4385 14.6402Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1208 15.8063C20.1029 15.8063 20.0875 15.8037 20.0696 15.7986C19.9674 15.7705 19.9086 15.6657 19.9367 15.5634C20.31 14.2059 21.3658 14.4692 21.3761 14.4718C21.4783 14.4999 21.5397 14.6047 21.5116 14.707C21.4834 14.8092 21.3786 14.868 21.2789 14.8425C21.2073 14.8246 20.5733 14.6993 20.3074 15.6657C20.2818 15.7526 20.2026 15.8063 20.1208 15.8063Z",
    fill: "#E19882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.303 6.56403C16.3728 4.25801 12.4382 5.18349 12.4382 5.18349L18.303 6.56403Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9267 17.6519H12.1387V27.5458H17.9267V17.6519Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6956 20.7015H15.368C16.3369 20.7015 17.2292 20.8395 17.9271 19.5996V21.4582C15.7106 23.5648 12.3512 21.6986 12.1442 21.5554L12.1416 19.5996C12.8344 20.8395 13.7267 20.7015 14.6956 20.7015Z",
    fill: "#E19882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6873 14.6401C11.0503 15.4505 11.0196 16.757 10.2501 17.0458C9.48314 17.3347 8.56533 16.2917 8.2023 15.4838C7.83927 14.6734 8.06169 13.9703 8.82866 13.6814C9.59819 13.39 10.3243 13.8297 10.6873 14.6401Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90492 15.908C9.82055 15.908 9.74386 15.8517 9.72085 15.7674C9.45496 14.801 8.81838 14.9263 8.74935 14.9442C8.64709 14.9697 8.54227 14.9084 8.5167 14.8061C8.49114 14.7038 8.54994 14.6016 8.6522 14.5734C8.66243 14.5709 9.71573 14.3076 10.0916 15.6651C10.1197 15.7674 10.0609 15.8722 9.95861 15.9003C9.94071 15.9054 9.92282 15.908 9.90492 15.908Z",
    fill: "#E19882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0513 6.03198C12.0576 6.03198 9.41406 8.34823 9.41406 11.2039L9.58535 14.6297C9.58535 14.6297 9.24533 19.4872 13.8574 20.9675C14.3687 21.1311 15.7288 21.1311 16.2401 20.9675C20.8522 19.4898 20.5121 14.6297 20.5121 14.6297L20.6834 11.2039C20.6885 8.34823 18.045 6.03198 15.0513 6.03198Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8411 13.2016C20.8411 13.2016 22.5926 11.3471 21.1558 8.82887C19.6858 6.25696 17.004 6.36689 17.004 6.36689C17.004 6.36689 16.8455 7.14153 17.2417 8.85699C17.8502 11.4979 20.5559 13.6095 20.5559 13.6095L20.8411 13.2016Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.194 17.202C13.8262 17.202 12.7422 16.4478 12.7269 16.4376C12.64 16.3762 12.6195 16.256 12.6809 16.1717C12.7422 16.0873 12.8624 16.0643 12.9468 16.1256C13.0362 16.1896 15.1812 17.6724 17.1472 16.1308C17.2316 16.0643 17.3517 16.0796 17.4156 16.164C17.4821 16.2484 17.4668 16.3685 17.3824 16.4324C16.6487 17.0102 15.8843 17.202 15.194 17.202Z",
    fill: "#E3867F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5928 14.3203C16.5928 14.6271 16.8433 14.8777 17.1501 14.8777C17.4569 14.8777 17.7074 14.6271 17.7074 14.3203C17.7074 14.0135 17.4569 13.763 17.1501 13.763C16.8433 13.763 16.5928 14.011 16.5928 14.3203Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9519 14.8776C13.2597 14.8776 13.5092 14.6281 13.5092 14.3203C13.5092 14.0125 13.2597 13.7629 12.9519 13.7629C12.6441 13.7629 12.3945 14.0125 12.3945 14.3203C12.3945 14.6281 12.6441 14.8776 12.9519 14.8776Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5709 12.9221C13.5684 12.9221 13.5658 12.9221 13.5607 12.9221L12.2236 12.8582C12.1342 12.8531 12.06 12.7892 12.0447 12.7022C12.0293 12.6153 12.0754 12.5284 12.1572 12.4926C12.193 12.4773 13.0162 12.127 13.6783 12.5744C13.7499 12.623 13.7806 12.7125 13.7525 12.7943C13.7269 12.8684 13.6528 12.9221 13.5709 12.9221Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5341 12.9299C16.4549 12.9299 16.3807 12.8787 16.3526 12.8021C16.3245 12.7202 16.3526 12.6308 16.4216 12.5822C17.0761 12.1194 17.907 12.4544 17.9402 12.4671C18.022 12.5004 18.0706 12.5873 18.0553 12.6742C18.0399 12.7611 17.9683 12.8276 17.8789 12.8353L16.5418 12.9299C16.5443 12.9299 16.5392 12.9299 16.5341 12.9299Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03333 14.4224C8.03333 14.4224 7.04394 10.8355 10.0581 7.86481C13.1183 4.8455 17.2421 6.10077 17.2421 6.10077C17.2421 6.10077 17.5719 8.12558 17.4441 8.85675C17.4441 8.85675 14.7622 8.29942 13.0468 10.8969C13.0468 10.8969 11.5052 14.3764 8.03333 14.4224Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6062 35.1924C23.8355 37.3578 24.1883 43.266 24.1883 43.266H32.4997C32.2364 25.6257 21.6062 24.2272 21.6062 24.2272V35.1924Z",
    fill: "#6084DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39355 35.1924C6.16422 37.3578 5.52507 43.266 5.52507 43.266H-2.5C-2.23667 25.6257 8.39355 24.2272 8.39355 24.2272V35.1924Z",
    fill: "#6084DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08887 43.2687V58.2885H17.726V23.5959H12.4237C10.4116 23.5959 8.68852 24.0126 7.21338 24.7029L5.08887 43.2687Z",
    fill: "#6084DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9887 43.2686V58.2885H12.3516V23.5958H17.6539C19.6659 23.5958 21.389 24.0125 22.8642 24.7028L24.9887 43.2686Z",
    fill: "#6084DF"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6859_15384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: width,
    height: width,
    fill: "white"
  }))));
}

function CustomerIllustBS30(props) {
  var _props$width, _props$height;

  var width = (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 30;
  var height = (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 30;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: width,
    height: height,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6859_15383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#FFF6EB"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6859_15383",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6859_15383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6339 9.29752C22.3935 10.4179 21.6631 15.2418 21.3934 16.3498C21.0635 17.7067 22.2835 18.4578 22.1196 19.823C21.8997 21.6426 19.7917 21.6467 19.7917 21.6467H12.8743H10.2289C10.2289 21.6467 8.11883 21.6426 7.90098 19.823C7.73707 18.4578 8.95705 17.7067 8.62716 16.3498C8.35743 15.2439 8.11468 9.29752 12.8743 8.1792",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48842 14.2612C8.48842 14.2612 6.54543 7.11811 12.1136 5.87562C12.1136 5.87562 14.6855 3.7281 18.7403 6.15939C22.795 8.59069 22.1865 10.7587 21.6368 14.2637",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4385 14.9825C19.0755 15.793 19.1062 17.0994 19.8757 17.3883C20.6427 17.6771 21.5605 16.6341 21.9235 15.8262C22.2865 15.0158 22.0641 14.3127 21.2971 14.0238C20.5276 13.7324 19.8015 14.1721 19.4385 14.9825Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1208 16.1507C20.1029 16.1507 20.0875 16.1482 20.0696 16.143C19.9674 16.1149 19.9086 16.0101 19.9367 15.9078C20.31 14.5503 21.3658 14.8136 21.3761 14.8162C21.4783 14.8443 21.5397 14.9491 21.5116 15.0514C21.4834 15.1537 21.3786 15.215 21.2789 15.1869C21.2048 15.169 20.5733 15.0437 20.3074 16.0101C20.2818 16.0945 20.2026 16.1507 20.1208 16.1507Z",
    fill: "#DDBBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9267 17.9937H12.1387V27.8876H17.9267V17.9937Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6959 21.0438H15.3682C16.3372 21.0438 17.2294 21.1819 17.9274 19.942V21.8006C15.7108 23.9072 12.3515 22.0409 12.1444 21.8977L12.1418 19.942C12.8347 21.1819 13.7269 21.0438 14.6959 21.0438Z",
    fill: "#E0BDB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.687 14.9824C11.0501 15.7928 11.0194 17.0992 10.2499 17.3881C9.4829 17.677 8.56509 16.6339 8.20206 15.8261C7.83902 15.0156 8.06144 14.3126 8.82841 14.0237C9.59794 13.7322 10.324 14.172 10.687 14.9824Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90444 16.2505C9.82007 16.2505 9.74337 16.1943 9.72036 16.1099C9.44681 15.1128 8.77699 15.279 8.74887 15.2867C8.64661 15.3148 8.54179 15.2534 8.51367 15.1512C8.48554 15.0489 8.5469 14.9441 8.64916 14.916C8.65939 14.9134 9.7127 14.6501 10.0885 16.0076C10.1166 16.1099 10.0578 16.2147 9.95557 16.2428C9.94023 16.2479 9.92233 16.2505 9.90444 16.2505Z",
    fill: "#E0BDB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0513 6.37427C12.0576 6.37427 9.41406 8.69052 9.41406 11.5462L9.58535 14.972C9.58535 14.972 9.24533 19.8295 13.8574 21.3097C14.3687 21.4733 15.7288 21.4733 16.2401 21.3097C20.8521 19.832 20.5121 14.972 20.5121 14.972L20.6834 11.5462C20.6885 8.69052 18.045 6.37427 15.0513 6.37427Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.194 17.544C13.8262 17.544 12.7422 16.7898 12.7269 16.7796C12.64 16.7182 12.6195 16.5981 12.6809 16.5137C12.7422 16.4268 12.8624 16.4063 12.9468 16.4677C13.0362 16.5316 15.1812 18.0144 17.1472 16.4728C17.229 16.4063 17.3517 16.4217 17.4156 16.506C17.4821 16.5904 17.4668 16.7106 17.3824 16.7745C16.6487 17.3523 15.8843 17.544 15.194 17.544Z",
    fill: "#DDBBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6484 14.6625C16.6484 14.9386 16.8734 15.1636 17.1495 15.1636C17.4256 15.1636 17.6506 14.9386 17.6506 14.6625C17.6506 14.3864 17.4256 14.1614 17.1495 14.1614C16.8734 14.1614 16.6484 14.3864 16.6484 14.6625Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.952 15.1634C13.2288 15.1634 13.4531 14.9391 13.4531 14.6623C13.4531 14.3856 13.2288 14.1613 12.952 14.1613C12.6753 14.1613 12.4509 14.3856 12.4509 14.6623C12.4509 14.9391 12.6753 15.1634 12.952 15.1634Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2388 13.2667C12.1545 13.2667 12.0778 13.2104 12.0548 13.1286C12.0292 13.0443 12.0675 12.9522 12.1442 12.9088C12.1775 12.8909 12.9598 12.4588 13.6654 12.8346C13.7421 12.8755 13.7804 12.9625 13.7625 13.0443C13.7447 13.1286 13.6705 13.19 13.5861 13.1951L12.2491 13.2667C12.2465 13.2667 12.2439 13.2667 12.2388 13.2667Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8628 13.2694C17.8577 13.2694 17.8552 13.2694 17.8501 13.2694L16.513 13.1799C16.4261 13.1748 16.3545 13.1134 16.3391 13.0291C16.3212 12.9447 16.3621 12.8603 16.4388 12.8194C17.1496 12.4487 17.9268 12.8936 17.96 12.9115C18.0367 12.9549 18.0725 13.047 18.0469 13.1339C18.0214 13.2131 17.9447 13.2694 17.8628 13.2694Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6064 35.5349C23.8358 37.7003 24.1886 43.6086 24.1886 43.6086H32.5C32.2366 25.9683 21.6064 24.5698 21.6064 24.5698V35.5349Z",
    fill: "#E3B880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39377 35.5349C6.16445 37.7003 5.52531 43.6085 5.52531 43.6085H-2.49976C-2.23643 25.9682 8.39377 24.5698 8.39377 24.5698V35.5349Z",
    fill: "#E3B880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08789 43.6108V58.6306H17.725V23.938H12.4227C10.4107 23.938 8.68754 24.3547 7.2124 25.045L5.08789 43.6108Z",
    fill: "#E3B880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9887 43.6108V58.6306H12.3516V23.938H17.6539C19.6659 23.938 21.389 24.3547 22.8642 25.045L24.9887 43.6108Z",
    fill: "#E3B880"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5274 15.7007H12.3769C11.8451 15.7007 11.4131 15.2686 11.4131 14.7369V14.586C11.4131 14.0543 11.8451 13.6222 12.3769 13.6222H13.5274C14.0591 13.6222 14.4912 14.0543 14.4912 14.586V14.7369C14.4912 15.2686 14.0591 15.7007 13.5274 15.7007ZM12.3769 13.8778C11.9858 13.8778 11.6687 14.1949 11.6687 14.586V14.7369C11.6687 15.128 11.9858 15.445 12.3769 15.445H13.5274C13.9185 15.445 14.2355 15.128 14.2355 14.7369V14.586C14.2355 14.1949 13.9185 13.8778 13.5274 13.8778H12.3769Z",
    fill: "#754B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7256 15.7006H16.5752C16.0434 15.7006 15.6113 15.2685 15.6113 14.7367V14.5859C15.6113 14.0541 16.0434 13.6221 16.5752 13.6221H17.7256C18.2574 13.6221 18.6894 14.0541 18.6894 14.5859V14.7367C18.6894 15.2685 18.2574 15.7006 17.7256 15.7006ZM16.5752 13.8777C16.184 13.8777 15.867 14.1947 15.867 14.5859V14.7367C15.867 15.1279 16.184 15.4449 16.5752 15.4449H17.7256C18.1168 15.4449 18.4338 15.1279 18.4338 14.7367V14.5859C18.4338 14.1947 18.1168 13.8777 17.7256 13.8777H16.5752Z",
    fill: "#754B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7415 14.4579H14.3635V14.7136H15.7415V14.4579Z",
    fill: "#754B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.149 9.19915C13.149 9.19915 15.0229 9.24261 14.9079 11.7199H19.883L20.5451 13.9237C20.5451 13.9237 22.8486 6.78064 15.7056 6.3767C15.7056 6.3767 10.9248 4.9936 9.19653 10.9274L9.52889 13.9518C9.52633 13.9518 13.149 12.5406 13.149 9.19915Z",
    fill: "#49391C"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6859_15383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: width,
    height: width,
    fill: "white"
  }))));
}

function CustomerIllustCS30(props) {
  var _props$width, _props$height;

  var width = (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 30;
  var height = (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 30;
  return /*#__PURE__*/React.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6859_15382)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6859_15382",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6859_15382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30Z",
    fill: "#F3EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9985 12.7045C21.6525 15.4368 22.5386 22.3193 23.2715 25.5648L15.9576 26.9532L15.8148 16.9503L16.1959 14.7526L20.5317 12.7046C21.1274 12.6051 21.4973 12.5869 21.9985 12.7045Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28717 12.7046C8.43407 15.3718 7.76813 22.3194 7.03515 25.5649L14.349 26.9533L14.4919 16.9504L14.1108 14.7527L9.77498 12.7047C9.17927 12.6052 8.78836 12.587 8.28717 12.7046Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4385 15.1805C19.0755 15.991 19.1062 17.2974 19.8757 17.5863C20.6427 17.8751 21.5605 16.8321 21.9235 16.0242C22.2865 15.2138 22.0641 14.5107 21.2971 14.2218C20.5276 13.9304 19.8015 14.3701 19.4385 15.1805Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1208 16.3465C20.1029 16.3465 20.0875 16.344 20.0696 16.3388C19.9674 16.3107 19.9086 16.2059 19.9367 16.1036C20.31 14.7461 21.3658 15.0094 21.3761 15.012C21.4783 15.0401 21.5397 15.1449 21.5116 15.2472C21.4834 15.3495 21.3786 15.4083 21.2789 15.3827C21.2073 15.3648 20.5733 15.2395 20.3074 16.2059C20.2818 16.2928 20.2026 16.3465 20.1208 16.3465Z",
    fill: "#E0BDB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3032 7.10432C16.373 4.79829 12.4385 5.72377 12.4385 5.72377L18.3032 7.10432Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9267 18.1921H12.1387V28.0861H17.9267V18.1921Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6956 21.2418H15.368C16.3369 21.2418 17.2292 21.3798 17.9271 20.1399V21.9985C15.7106 24.1051 12.3512 22.2388 12.1442 22.0957L12.1416 20.1399C12.8344 21.3798 13.7267 21.2418 14.6956 21.2418Z",
    fill: "#E0BDB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6873 15.1806C11.0503 15.9911 11.0196 17.2975 10.2501 17.5864C9.48314 17.8753 8.56533 16.8322 8.2023 16.0243C7.83927 15.2139 8.06169 14.5108 8.82866 14.2219C9.59819 13.9305 10.3243 14.3702 10.6873 15.1806Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90492 16.4482C9.82055 16.4482 9.74386 16.392 9.72085 16.3076C9.45496 15.3412 8.81838 15.4665 8.74935 15.4844C8.64709 15.5099 8.54227 15.4486 8.5167 15.3463C8.49114 15.2441 8.54994 15.1418 8.6522 15.1137C8.66243 15.1111 9.71573 14.8478 10.0916 16.2053C10.1197 16.3076 10.0609 16.4124 9.95861 16.4405C9.94071 16.4456 9.92282 16.4482 9.90492 16.4482Z",
    fill: "#E0BDB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0513 6.57251C12.0576 6.57251 9.41406 8.88876 9.41406 11.7445L9.58535 15.1703C9.58535 15.1703 9.24533 20.0277 13.8574 21.508C14.3687 21.6716 15.7288 21.6716 16.2401 21.508C20.8522 20.0303 20.5121 15.1703 20.5121 15.1703L20.6834 11.7445C20.6885 8.88876 18.045 6.57251 15.0513 6.57251Z",
    fill: "#F7DDD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3479 7.10199C19.1045 5.84955 15.8358 4.36026 12.1542 5.77783C10.2347 6.51691 8.78598 8.1327 8.26863 9.95432C7.79407 11.6265 8.00364 13.6353 8.19722 14.7084C8.40705 14.3453 9.03289 14.0625 9.3591 13.9903C9.38777 13.3697 9.30182 13.5165 9.3591 12.9709C9.81371 12.725 10.525 12.5031 11.4366 12.3885C11.3433 11.5125 11.8179 10.7699 11.9084 10.7599C12.004 10.7494 11.8967 12.3365 11.9951 12.3272C12.4954 12.2796 13.364 12.247 13.9137 12.2268C14.1452 12.2183 14.065 11.1633 14.3002 11.1592C14.5516 11.1548 14.3848 12.2009 14.6371 12.2011C16.1899 12.2024 17.584 12.2691 18.7933 12.3946C18.8386 12.3993 18.9066 11.6807 18.9633 10.7657C19.1925 10.9144 19.3532 11.6553 19.4792 12.4614C20.2723 12.5594 20.7957 12.6759 20.8408 12.794C21.1728 13.6642 21.2509 13.8277 21.9233 14.4664C22.2028 13.5971 22.2724 11.5851 21.6014 9.76144C21.1541 8.54567 20.403 7.65919 19.3479 7.10199Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.194 17.7422C13.8262 17.7422 12.7422 16.9881 12.7269 16.9778C12.64 16.9165 12.6195 16.7963 12.6809 16.712C12.7422 16.6276 12.8624 16.6046 12.9468 16.6659C13.0362 16.7298 15.1812 18.2127 17.1472 16.671C17.2316 16.6046 17.3517 16.6199 17.4156 16.7043C17.4821 16.7886 17.4668 16.9088 17.3824 16.9727C16.6487 17.5505 15.8843 17.7422 15.194 17.7422Z",
    fill: "#ECB7B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5928 14.8606C16.5928 15.1673 16.8433 15.4179 17.1501 15.4179C17.4569 15.4179 17.7074 15.1673 17.7074 14.8606C17.7074 14.5538 17.4569 14.3032 17.1501 14.3032C16.8433 14.3032 16.5928 14.5512 16.5928 14.8606Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9519 15.4179C13.2597 15.4179 13.5092 15.1684 13.5092 14.8606C13.5092 14.5527 13.2597 14.3032 12.9519 14.3032C12.6441 14.3032 12.3945 14.5527 12.3945 14.8606C12.3945 15.1684 12.6441 15.4179 12.9519 15.4179Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6006 13.3785C13.5981 13.3788 13.5956 13.3791 13.5905 13.3797L12.2556 13.4798C12.1662 13.4856 12.0848 13.4313 12.0589 13.3469C12.0331 13.2625 12.0681 13.1706 12.145 13.125C12.1786 13.1054 12.9528 12.6572 13.6647 13.0203C13.7417 13.0597 13.7831 13.1448 13.7652 13.2294C13.7489 13.3061 13.6818 13.3685 13.6006 13.3785Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4992 13.3788C16.4206 13.3683 16.354 13.3077 16.3363 13.2279C16.3193 13.1431 16.3591 13.0582 16.434 13.0192C17.1443 12.6479 17.9232 13.0905 17.9544 13.1076C18.0311 13.1515 18.0676 13.2441 18.0408 13.3282C18.014 13.4123 17.9342 13.4686 17.8445 13.4643L16.5068 13.3798C16.5093 13.3802 16.5042 13.3795 16.4992 13.3788Z",
    fill: "#49391C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6062 35.7326C23.8355 37.898 24.1883 43.8062 24.1883 43.8062H32.4997C32.2364 26.1659 21.6062 24.7675 21.6062 24.7675V35.7326Z",
    fill: "#C385C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39355 35.7326C6.16422 37.8981 5.52507 43.8063 5.52507 43.8063H-2.5C-2.23667 26.166 8.39355 24.7675 8.39355 24.7675V35.7326Z",
    fill: "#C385C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08887 43.809V58.8288H17.726V24.1362H12.4237C10.4116 24.1362 8.68852 24.5529 7.21338 25.2432L5.08887 43.809Z",
    fill: "#C385C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9887 43.8089V58.8288H12.3516V24.1361H17.6539C19.6659 24.1361 21.389 24.5528 22.8642 25.2431L24.9887 43.8089Z",
    fill: "#C385C9"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6859_15382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: width,
    height: width,
    fill: "white"
  }))));
}

function CustomerIllustDS30(props) {
  var _props$width, _props$height;

  var width = (_props$width = props.width) !== null && _props$width !== void 0 ? _props$width : 30;
  var height = (_props$height = props.height) !== null && _props$height !== void 0 ? _props$height : 30;
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: width,
    height: height,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6859_15381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6859_15381",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6859_15381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#EAF5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9357 21.1504C21.7494 22.1475 24.0324 23.7479 23.8305 25.4301C23.5595 27.6722 20.962 27.6773 20.962 27.6773H9.17876C9.17876 27.6773 6.57873 27.6722 6.31029 25.4301C6.10833 23.7479 8.31209 22.0835 7.20509 21.1504",
    fill: "#1A0C09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17924 21.8021C9.17924 21.8021 6.5792 21.797 6.31077 19.5549C6.1088 17.8727 7.61206 16.9472 7.20556 15.2752C6.87321 13.9126 5.6435 6.75928 12.8786 5.78523C12.8786 5.78523 15.3585 4.28452 18.1144 5.43242C23.6775 7.74867 23.2685 13.9126 22.9387 15.2752C22.5322 16.9472 24.0355 17.8727 23.8335 19.5549C23.5625 21.797 20.965 21.8021 20.965 21.8021H9.17924Z",
    fill: "#1A0C09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4385 14.6642C19.0755 15.4746 19.1062 16.781 19.8757 17.0699C20.6427 17.3588 21.5605 16.3157 21.9235 15.5078C22.2865 14.6974 22.0641 13.9943 21.2971 13.7055C20.5276 13.414 19.8015 13.8537 19.4385 14.6642Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1208 15.8322C20.1029 15.8322 20.0875 15.8297 20.0696 15.8246C19.9674 15.7964 19.9086 15.6916 19.9367 15.5894C20.31 14.2318 21.3658 14.4951 21.3761 14.4977C21.4783 14.5258 21.5397 14.6306 21.5116 14.7329C21.4834 14.8352 21.3786 14.894 21.2789 14.8684C21.2048 14.8505 20.5733 14.7252 20.3074 15.6916C20.2818 15.776 20.2026 15.8322 20.1208 15.8322Z",
    fill: "#E19882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9277 17.6758H12.1396V27.5697H17.9277V17.6758Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6956 20.7257H15.368C16.3369 20.7257 17.2292 20.8638 17.9271 19.6238V21.4825C15.7106 23.5891 12.3512 21.7228 12.1442 21.5796L12.1416 19.6238C12.8344 20.8638 13.7267 20.7257 14.6956 20.7257Z",
    fill: "#E19882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.687 14.6642C11.0501 15.4747 11.0194 16.7811 10.2499 17.07C9.4829 17.3588 8.56509 16.3158 8.20206 15.5079C7.83902 14.6975 8.06144 13.9944 8.82842 13.7055C9.59794 13.4141 10.324 13.8538 10.687 14.6642Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90492 15.932C9.82055 15.932 9.74386 15.8757 9.72085 15.7914C9.45496 14.825 8.81838 14.9502 8.74935 14.9681C8.64709 14.9937 8.54227 14.9323 8.5167 14.8301C8.49114 14.7278 8.54994 14.6256 8.6522 14.5974C8.66243 14.5949 9.71573 14.3316 10.0915 15.6891C10.1197 15.7914 10.0609 15.8962 9.95861 15.9243C9.94071 15.9294 9.92282 15.932 9.90492 15.932Z",
    fill: "#E19882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0513 6.05615C12.0576 6.05615 9.41406 8.3724 9.41406 11.2281L9.58535 14.6539C9.58535 14.6539 9.24533 19.5114 13.8574 20.9916C14.3687 21.1552 15.7288 21.1552 16.2401 20.9916C20.8522 19.5139 20.5121 14.6539 20.5121 14.6539L20.6834 11.2281C20.6885 8.3724 18.045 6.05615 15.0513 6.05615Z",
    fill: "#F5C6B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.194 17.2259C13.8262 17.2259 12.7422 16.4717 12.7269 16.4615C12.64 16.4001 12.6195 16.28 12.6809 16.1956C12.7422 16.1112 12.8624 16.0882 12.9468 16.1496C13.0362 16.2135 15.1812 17.6963 17.1472 16.1547C17.229 16.0882 17.3517 16.1036 17.4156 16.1879C17.4796 16.2723 17.4668 16.3924 17.3824 16.4564C16.6487 17.0341 15.8843 17.2259 15.194 17.2259Z",
    fill: "#E19882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5928 14.3444C16.5928 14.6512 16.8433 14.9018 17.1501 14.9018C17.4569 14.9018 17.7074 14.6512 17.7074 14.3444C17.7074 14.0377 17.4569 13.7871 17.1501 13.7871C16.8433 13.7871 16.5928 14.0351 16.5928 14.3444Z",
    fill: "#231814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9519 14.9018C13.2597 14.9018 13.5092 14.6522 13.5092 14.3444C13.5092 14.0366 13.2597 13.7871 12.9519 13.7871C12.6441 13.7871 12.3945 14.0366 12.3945 14.3444C12.3945 14.6522 12.6441 14.9018 12.9519 14.9018Z",
    fill: "#231814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5712 12.9462C13.5686 12.9462 13.5661 12.9462 13.561 12.9462L12.2239 12.8823C12.1344 12.8772 12.0603 12.8133 12.0449 12.7263C12.0296 12.6394 12.0756 12.5525 12.1574 12.5167C12.1932 12.5014 13.0164 12.1511 13.6786 12.5985C13.7502 12.6471 13.7808 12.7366 13.7527 12.8184C13.7271 12.8951 13.653 12.9462 13.5712 12.9462Z",
    fill: "#231814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5341 12.9538C16.4549 12.9538 16.3807 12.9027 16.3526 12.826C16.3245 12.7442 16.3526 12.6547 16.4216 12.6061C17.0761 12.1434 17.907 12.4783 17.9428 12.4911C18.0246 12.5243 18.0732 12.6112 18.0578 12.6981C18.0425 12.7851 17.9709 12.8515 17.8814 12.8592L16.5443 12.9538C16.5443 12.9538 16.5392 12.9538 16.5341 12.9538Z",
    fill: "#231814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6064 35.216C23.8358 37.3815 24.1886 43.2897 24.1886 43.2897H32.5C32.2367 25.6494 21.6064 24.2509 21.6064 24.2509V35.216Z",
    fill: "#61C09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39354 35.216C6.16421 37.3815 5.52507 43.2897 5.52507 43.2897H-2.5C-2.23667 25.6494 8.39354 24.2509 8.39354 24.2509V35.216Z",
    fill: "#61C09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08789 43.2924V58.3122H17.725V23.6196H12.4227C10.4107 23.6196 8.68754 24.0363 7.2124 24.7266L5.08789 43.2924Z",
    fill: "#61C09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9887 43.2923V58.3121H12.3516V23.6195H17.6539C19.6659 23.6195 21.389 24.0362 22.8642 24.7265L24.9887 43.2923Z",
    fill: "#61C09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5236 13.634C9.5236 13.634 11.2748 12.3532 11.2748 9.70456C11.2748 9.70456 11.8731 10.175 11.4896 11.5836H13.2408C13.2408 11.5836 13.6857 10.2159 13.3431 9.23415C13.3431 9.23415 14.3044 9.27761 14.3044 11.5836H17.7251C17.7251 11.5836 18.0191 9.53327 17.2521 8.76374C17.2521 8.76374 18.6122 9.36709 18.7503 11.5836C18.8858 13.7439 20.5705 13.6366 20.5705 13.6366L21.0588 9.27761C21.0588 9.27761 17.881 3.21343 12.0035 6.58554C7.68798 9.06286 9.5236 13.634 9.5236 13.634Z",
    fill: "#1A0C09"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6859_15381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: width,
    height: width,
    fill: "white"
  }))));
}

export { BackGroundColor, BottomSheet$1 as BottomSheet, BottomSheetCustom$1 as BottomSheetCustom, BoxSingleView, BrandColor, Button$3 as Button, CheckBoxWithImg, SvgCheckDisabledSelectedS28 as CheckDisabledSelectedS28, SvgCheckDisabledUnselectedS28 as CheckDisabledUnselectedS28, SvgCheckEnabledCheckedS28 as CheckEnabledCheckedS28, SvgCheckEnabledUnselectedFilledS20 as CheckEnabledUnselectedFilledS20, SvgCheckEnabledUnselectedFilledS28 as CheckEnabledUnselectedFilledS28, SvgCheckEnabledUnselectedS28 as CheckEnabledUnselectedS28, SvgCheckboxEnabledSelectedDarkBuS20 as CheckboxEnabledSelectedDarkBuS20, SvgCheckboxEnabledSelectedDarkBuS28 as CheckboxEnabledSelectedDarkBuS28, SvgCheckboxEnabledUnselectedB06S20 as CheckboxEnabledUnselectedB06S20, SvgCheckboxEnabledUnselectedB06S28 as CheckboxEnabledUnselectedB06S28, ContentWithLabel, Counter, CounterCommerce, CounterWithNoTitle, CustomButton, CustomerIllustAS30, CustomerIllustBS30, CustomerIllustCS30, CustomerIllustDS30, SvgCycleDisabledSelectedS20 as CycleDisabledSelectedS20, SvgCycleDisabledSelectedS28 as CycleDisabledSelectedS28, SvgCycleDisabledUnselectedS20 as CycleDisabledUnselectedS20, SvgCycleDisabledUnselectedS28 as CycleDisabledUnselectedS28, SvgCycleEnabledCheckedCircleS28 as CycleEnabledCheckedCircleS28, SvgCycleEnabledCheckedS20 as CycleEnabledCheckedS20, SvgCycleEnabledCheckedS28 as CycleEnabledCheckedS28, SvgCycleEnabledErrorS20 as CycleEnabledErrorS20, SvgCycleEnabledErrorS28 as CycleEnabledErrorS28, SvgCycleEnabledErrorSelectedS28 as CycleEnabledErrorSelectedS28, SvgCycleEnabledUnselectedFilledS20 as CycleEnabledUnselectedFilledS20, SvgCycleEnabledUnselectedFilledS28 as CycleEnabledUnselectedFilledS28, SvgCycleEnabledUnselectedS20 as CycleEnabledUnselectedS20, SvgCycleEnabledUnselectedS28 as CycleEnabledUnselectedS28, DropDown$1 as DropDown, SvgEnabledCheckedRedS20John as EnabledCheckedRedS20John, GrayBox, SvgIc11S48 as Ic11S48, SvgIcAfternoonS24 as IcAfternoonS24, SvgIcAlaramstrokeS16 as IcAlaramstrokeS16, SvgIcAlramS24 as IcAlramS24, SvgIcAlramstrokeS24 as IcAlramstrokeS24, SvgIcAmountS24 as IcAmountS24, SvgIcAptDimS48 as IcAptDimS48, SvgIcAptS48 as IcAptS48, SvgIcArrowDownincircleS16 as IcArrowDownInCircleS16, SvgIcArrowDownincircleS24 as IcArrowDownInCircleS24, SvgIcArrowDropSmallB85S16V01 as IcArrowDropSmallB85S16V01, SvgIcArrowFillrightincircleS24 as IcArrowFillrightInCircleS24, SvgIcArrowModalS16 as IcArrowModalS16, SvgIcArrowRightW100 as IcArrowRightW100, SvgIcArrowUpincircleS16 as IcArrowUpInCircleS16, SvgIcArrowUpincircleS24 as IcArrowUpInCircleS24, SvgIcArrowUpS16B85 as IcArrowUpS16B85, SvgIcArrowdropS16 as IcArrowdropS16, SvgIcArrowdropSmallS16 as IcArrowdropSmallS16, SvgIcArrowfilldownS16 as IcArrowfilldownS16, SvgIcArrowfilldownSmallS16 as IcArrowfilldownSmallS16, SvgIcArrowfillrightS16 as IcArrowfillrightS16, SvgIcArrowfillrightSmallS16 as IcArrowfillrightSmallS16, SvgIcArrowleftS16 as IcArrowleftS16, SvgIcArrowleftSmallS16 as IcArrowleftSmallS16, SvgIcArrowrightS10 as IcArrowrightS10, SvgIcArrowrightS16 as IcArrowrightS16, SvgIcArrowrightSmallS16 as IcArrowrightSmallS16, SvgIcArrowtailfillrightS16 as IcArrowtailfillrightS16, SvgIcArrowupS16 as IcArrowupS16, SvgIcArrowupSmallS16 as IcArrowupSmallS16, SvgIcAssignS48 as IcAssignS48, SvgIcBabyDimS48 as IcBabyDimS48, SvgIcBabyNoneS48 as IcBabyNoneS48, SvgIcBabyS48 as IcBabyS48, SvgIcBadgeS16 as IcBadgeS16, SvgIcBadgeS24 as IcBadgeS24, SvgIcBalanceS48 as IcBalanceS48, SvgIcBalconyDimS48 as IcBalconyDimS48, SvgIcBalconyS24 as IcBalconyS24, SvgIcBalconyS48 as IcBalconyS48, SvgIcBedroomDimS48 as IcBedroomDimS48, SvgIcBedroomS48 as IcBedroomS48, SvgIcBookS16 as IcBookS16, SvgIcBoxS48 as IcBoxS48, SvgIcBulbReviewS24 as IcBulbReviewS24, SvgIcBulluet01S16 as IcBulluet01S16, SvgIcBulluet01S16R as IcBulluet01S16R, SvgIcBundleS16 as IcBundleS16, SvgIcBusS24 as IcBusS24, SvgIcCalendarS48 as IcCalendarS48, SvgIcCallS16 as IcCallS16, SvgIcCallS16W as IcCallS16W, SvgIcCallS48 as IcCallS48, SvgIcCancelCalendarS24 as IcCancelCalendarS24, SvgIcCancelS16 as IcCancelS16, SvgIcCarS24 as IcCarS24, SvgIcCardS16 as IcCardS16, SvgIcCartStokeB85S24V01 as IcCartStokeB85S24V01, SvgIcCctvDimS48 as IcCctvDimS48, SvgIcCctvNoneS48 as IcCctvNoneS48, SvgIcCctvS48 as IcCctvS48, SvgIcCheckCalendarS24 as IcCheckCalendarS24, SvgIcCheckincircleS16 as IcCheckInCircleS16, SvgIcCheckincircleS24 as IcCheckInCircleS24, SvgIcCheckS16 as IcCheckS16, SvgIcCheckS24 as IcCheckS24, SvgIcCircleArrowrightS24 as IcCircleArrowrightS24, SvgIcCleanDoneB85S16V01 as IcCleanDoneB85S16V01, SvgIcCleanDoneS16 as IcCleanDoneS16, SvgIcCleanDoneS24 as IcCleanDoneS24, SvgIcCleanReviewS24 as IcCleanReviewS24, SvgIcCleanerS24 as IcCleanerS24, SvgIcCleaningS48 as IcCleaningS48, SvgIcCleaninglabS48 as IcCleaninglabS48, SvgIcCollarS56 as IcCollarS56, SvgIcCommaEnd as IcCommaEnd, SvgIcCommaStart as IcCommaStart, SvgIcCompanyS48 as IcCompanyS48, SvgIcCompletionS48 as IcCompletionS48, SvgIcCouponTypeAFillS24 as IcCouponTypeAFillS24, SvgIcCouponTypeAS24 as IcCouponTypeAS24, SvgIcCouponTypeAS48 as IcCouponTypeAS48, SvgIcCouponTypeBS24 as IcCouponTypeBS24, SvgIcCouponTypeBS48 as IcCouponTypeBS48, SvgIcCsS16 as IcCsS16, SvgIcCsS48 as IcCsS48, SvgIcCycleEnabledCheckedS20 as IcCycleEnabledCheckedS20, SvgIcDatechangeS48 as IcDatechangeS48, SvgIcDeleteS16 as IcDeleteS16, SvgIcDeliverB80S24V01 as IcDeliverB80S24V01, SvgIcDeliverB85S16V01 as IcDeliverB85S16V01, SvgIcDeliverFillS16 as IcDeliverFillS16, SvgIcDeliverFillS24V01 as IcDeliverFillS24V01, SvgIcDeliverS48 as IcDeliverS48, SvgIcDoIroningDimS48 as IcDoIroningDimS48, SvgIcDoIroningS24 as IcDoIroningS24, SvgIcDoIroningS48 as IcDoIroningS48, SvgIcDoWashingDimS48 as IcDoWashingDimS48, SvgIcDoWashingS48 as IcDoWashingS48, SvgIcDot3S16 as IcDot3S16, SvgIcDowashingS24 as IcDowashingS24, SvgIcDownloadS16 as IcDownloadS16, SvgIcDuplexNoneS48 as IcDuplexNoneS48, SvgIcDuplexS48 as IcDuplexS48, SvgIcEditS16 as IcEditS16, SvgIcEvaluationS24 as IcEvaluationS24, SvgIcEvaluationS48 as IcEvaluationS48, SvgIcEventS24 as IcEventS24, SvgIcEventS48 as IcEventS48, SvgIcExchangeS16 as IcExchangeS16, SvgIcFastReviewS24 as IcFastReviewS24, SvgIcFavoriteS16 as IcFavoriteS16, SvgIcFavoriteStrokeS16 as IcFavoriteStrokeS16, SvgIcFingerS48 as IcFingerS48, SvgIcFoodwastDimS48 as IcFoodwastDimS48, SvgIcFoodwastS48 as IcFoodwastS48, SvgIcFoodwasteS24 as IcFoodwasteS24, SvgIcFriendRecommandS48 as IcFriendRecommandS48, SvgIcFriendrecomcodeS48 as IcFriendrecomcodeS48, SvgIcGiftS24V001 as IcGiftS24V001, SvgIcGiftS48 as IcGiftS48, SvgIcGloveS24 as IcGloveS24, SvgIcGuidebookS48 as IcGuidebookS48, SvgIcHeartReviewS24 as IcHeartReviewS24, SvgIcHeartfillS16 as IcHeartfillS16, SvgIcHeartstrokeS16 as IcHeartstrokeS16, SvgIcHomeOffS24 as IcHomeOffS24, SvgIcHomeOffS24V01 as IcHomeOffS24V01, SvgIcHomeOnS24 as IcHomeOnS24, SvgIcHomeS16 as IcHomeS16, SvgIcHomeS24 as IcHomeS24, SvgIcHouseDimS48 as IcHouseDimS48, SvgIcHouseS48 as IcHouseS48, SvgIcHousecleanS48 as IcHousecleanS48, SvgIcInfoFilB80S16V01 as IcInfoFilB80S16V01, SvgIcInfoFilS16V01 as IcInfoFilS16V01, SvgIcInfoS16 as IcInfoS16, SvgIcInfoS16G as IcInfoS16G, SvgIcInfoS16W100 as IcInfoS16W100, SvgIcInfoS48 as IcInfoS48, SvgIcInvestigationS48 as IcInvestigationS48, SvgIcKitchenDimS48 as IcKitchenDimS48, SvgIcKitchenS48 as IcKitchenS48, SvgIcLineCouponTypeBS24 as IcLineCouponTypeBS24, SvgIcListmanagerS16 as IcListmanagerS16, SvgIcLivingroomDimS48 as IcLivingroomDimS48, SvgIcLivingroomS48 as IcLivingroomS48, SvgIcLocalS16 as IcLocalS16, SvgIcLocalS16W as IcLocalS16W, SvgIcLocalWS16 as IcLocalWS16, SvgIcMapSearchS16 as IcMapSearchS16, SvgIcMatchingS48 as IcMatchingS48, SvgIcMeS48 as IcMeS48, SvgIcMembershipFirstGradeS24 as IcMembershipFirstGradeS24, SvgIcMembershipForthGradeS24 as IcMembershipForthGradeS24, SvgIcMembershipS48 as IcMembershipS48, SvgIcMembershipSecondGradeS24 as IcMembershipSecondGradeS24, SvgIcMembershipThirdGradeS24 as IcMembershipThirdGradeS24, SvgIcMemoS24 as IcMemoS24, SvgIcMenuS16 as IcMenuS16, SvgIcMinusS16 as IcMinusS16, SvgIcMinusS24 as IcMinusS24, SvgIcMinusSmallB20S16V01 as IcMinusSmallB20S16V01, SvgIcMinusSmallS16 as IcMinusSmallS16, SvgIcMopS24 as IcMopS24, SvgIcMoreOffS24 as IcMoreOffS24, SvgIcMoreOnS24 as IcMoreOnS24, SvgIcMorningS24 as IcMorningS24, SvgIcMovingcleanS48 as IcMovingcleanS48, SvgIcMyPageS24 as IcMyPageS24, SvgIcMyreservOffS24 as IcMyreservOffS24, SvgIcMyreservOnS24 as IcMyreservOnS24, SvgIcNightDimS48 as IcNightDimS48, SvgIcNightS48 as IcNightS48, SvgIcNoteS56 as IcNoteS56, SvgIcNoticeOffS24 as IcNoticeOffS24, SvgIcNoticeOnS24 as IcNoticeOnS24, SvgIcNoticeS24 as IcNoticeS24, SvgIcNoticeS48 as IcNoticeS48, SvgIcNumberingS24 as IcNumberingS24, SvgIcOfficetelDimS48 as IcOfficetelDimS48, SvgIcOfficetelS48 as IcOfficetelS48, SvgIcOneCalendarS16 as IcOneCalendarS16, SvgIcOpensourceS48 as IcOpensourceS48, SvgIcOrderS24 as IcOrderS24, SvgIcParkingDimS48 as IcParkingDimS48, SvgIcParkingIdontS48 as IcParkingIdontS48, SvgIcParkingNoneS48 as IcParkingNoneS48, SvgIcParkingS16 as IcParkingS16, SvgIcParkingS48 as IcParkingS48, SvgIcPayS48 as IcPayS48, SvgIcPaymentB85S24V01 as IcPaymentB85S24V01, SvgIcPensS24 as IcPensS24, SvgIcPestsCatDimS48 as IcPestsCatDimS48, SvgIcPestsCatS48 as IcPestsCatS48, SvgIcPestsDogDimS48 as IcPestsDogDimS48, SvgIcPestsDogS48 as IcPestsDogS48, SvgIcPestsEtcDimS48 as IcPestsEtcDimS48, SvgIcPestsEtcS48 as IcPestsEtcS48, SvgIcPetsNoneDimS48 as IcPetsNoneDimS48, SvgIcPetsNoneS48 as IcPetsNoneS48, SvgIcPlusincircleS24 as IcPlusInCircleS24, SvgIcPlusS16 as IcPlusS16, SvgIcPlusS24 as IcPlusS24, SvgIcPlusSmallB20S16V01 as IcPlusSmallB20S16V01, SvgIcPlusSmallS16 as IcPlusSmallS16, SvgIcPlusWS16 as IcPlusWS16, SvgIcPointS48 as IcPointS48, SvgIcPrivacyS48 as IcPrivacyS48, SvgIcPrivatestrokeS24 as IcPrivatestrokeS24, SvgIcPwdS48 as IcPwdS48, SvgIcQmarkS16 as IcQmarkS16, SvgIcQmarkStrokeB20S16V01 as IcQmarkStrokeB20S16V01, SvgIcQsmarkstrokeS16 as IcQsmarkstrokeS16, SvgIcQuickCalendarS16 as IcQuickCalendarS16, SvgIcQuickCalendarS24 as IcQuickCalendarS24, SvgIcQuickS16 as IcQuickS16, SvgIcRecyclablewasteS24 as IcRecyclablewasteS24, SvgIcRecyclablewasteS48 as IcRecyclablewasteS48, SvgIcRecycleDimS48 as IcRecycleDimS48, SvgIcRecycleS48 as IcRecycleS48, SvgIcRefreshS16 as IcRefreshS16, SvgIcRefriDimS48 as IcRefriDimS48, SvgIcRefriS16 as IcRefriS16, SvgIcRefriS24 as IcRefriS24, SvgIcRefriS48 as IcRefriS48, SvgIcRegularCalendarS16 as IcRegularCalendarS16, SvgIcRegularCalendarW as IcRegularCalendarW, SvgIcReminderOffS24 as IcReminderOffS24, SvgIcReminderOnS24 as IcReminderOnS24, SvgIcReportS48 as IcReportS48, SvgIcReserChangeS24 as IcReserChangeS24, SvgIcReviewS16 as IcReviewS16, SvgIcReviewS48 as IcReviewS48, SvgIcRodmopS24 as IcRodmopS24, SvgIcRulerReviewS24 as IcRulerReviewS24, SvgIcSafetyGateS56 as IcSafetyGateS56, SvgIcSchduleOffS24 as IcSchduleOffS24, SvgIcSchduleOnS24 as IcSchduleOnS24, SvgIcScrubberS24 as IcScrubberS24, SvgIcSearchS16 as IcSearchS16, SvgIcServicecoverageS16 as IcServicecoverageS16, SvgIcServicecoverageS48 as IcServicecoverageS48, SvgIcSettingFaqS48 as IcSettingFaqS48, SvgIcShirtDimS48 as IcShirtDimS48, SvgIcShirtS48 as IcShirtS48, SvgIcSignatureS48 as IcSignatureS48, IcSmallCircleS16, SvgIcSpaceDimS48 as IcSpaceDimS48, SvgIcSpaceS48 as IcSpaceS48, SvgIcStandardtimeS24 as IcStandardtimeS24, SvgIcStayathomeS48 as IcStayathomeS48, SvgIcSubwayS16 as IcSubwayS16, SvgIcTalkS16 as IcTalkS16, SvgIcTermsofUseS48 as IcTermsofUseS48, SvgIcTimeS16 as IcTimeS16, SvgIcTimeS24 as IcTimeS24, SvgIcTimechangeS16 as IcTimechangeS16, SvgIcTimechangeS16Db as IcTimechangeS16Db, SvgIcTimerS24 as IcTimerS24, SvgIcToiletDimS48 as IcToiletDimS48, SvgIcToiletS16 as IcToiletS16, SvgIcToiletS48 as IcToiletS48, SvgIcTopbarBackActionS24 as IcTopbarBackActionS24, SvgIcTopbarCloseActionS16 as IcTopbarCloseActionS16, SvgIcTopbarCloseActionS24 as IcTopbarCloseActionS24, SvgIcTopbarCloseActionS24W as IcTopbarCloseActionS24W, SvgIcTrashDimS48 as IcTrashDimS48, SvgIcTrialS48 as IcTrialS48, SvgIcUserFillS16V01 as IcUserFillS16V01, SvgIcUserS16 as IcUserS16, SvgIcVacuumcleanerS24 as IcVacuumcleanerS24, SvgIcVersionS48 as IcVersionS48, SvgIcVillaDimS48 as IcVillaDimS48, SvgIcVillaS48 as IcVillaS48, SvgIcWalkS24 as IcWalkS24, SvgIcWarningS16 as IcWarningS16, SvgIcWarningS16R as IcWarningS16R, SvgIcWarningstrokeS16 as IcWarningstrokeS16, SvgIcWarningstrokeS24 as IcWarningstrokeS24, SvgIcWasteS24 as IcWasteS24, SvgIcWasteS48 as IcWasteS48, SvgIcWindowDimS48 as IcWindowDimS48, SvgIcWindowS24 as IcWindowS24, SvgIcWindowS48 as IcWindowS48, SvgIcWindowdustS48 as IcWindowdustS48, SvgIcWonS24 as IcWonS24, SvgIcWonS48 as IcWonS48, SvgIcWonSolidB85S24V01 as IcWonSolidB85S24V01, SvgIcWonSolidDarkBuS24V01 as IcWonSolidDarkBuS24V01, SvgIcWorkS24 as IcWorkS24, SvgIcWorkTimeDimS48 as IcWorkTimeDimS48, SvgIcWorkTimeS24 as IcWorkTimeS24, SvgIcWorkTimeS48 as IcWorkTimeS48, SvgIcWorkdetailS16 as IcWorkdetailS16, SvgIcWorklistOffS24 as IcWorklistOffS24, SvgIcWorklistOnS24 as IcWorklistOnS24, SvgIcZoominReviewS24 as IcZoominReviewS24, SvgIcZoominS24 as IcZoominS24, SvgIconHome as IconHome, ImgSliderBase$1 as ImgSliderBase, InfoImgSnackbar, Input, LifelabCalendar, LinedInput, Loading, ManagerProfile, OpaqueLayer, OptionSelect, Paragraph, SvgPlusInCircleS28 as PlusInCircleS28, PopupBase$1 as PopupBase, PopupCommon$1 as PopupCommon, PopupDoubleButton, PopupOkCancel$1 as PopupOkCancel, PopupOkCancelDescription$1 as PopupOkCancelDescription, PopupTripleButton, Pretendard, S20CheckBox, S28CheckBox, SamanthaTextArea, ScheduleTimeChangeViewer, ScheduleTimeViewer, SectionTitleView, SliderBase$1 as SliderBase, SliderHalfBase$1 as SliderHalfBase, SliderPicker, Snackbar, SnackbarBase, SnackbarWithButton, Suit, SupportColor, Svg1CycleEnabledCheckedRedS20, Svg2CycleEnabledUnselectedS20, Svg3CycleDisabledSelectedS20, Svg4CycleDisabledUnselectedS20, Svg5CycleEnabledErrorS20, Svg5CycleEnabledErrorS28, TextColor, TimeLine, TimePicker, ToolTip, TypeRule, WordWrapper, deleteObject, isEmpty, mergeObject, noFlash, useBeforeunload };
